import { createHttpLink as RA, InMemoryCache as HA, ApolloClient as kA, from as UA, gql as f } from "@apollo/client/core";
import { fetch as gt, getAttributesFromArrayBuffer as Ot, AssetType as At, StepType as M, getFrameData as lt, frameDataCache as GA, modifySVGColors as bA, svgToDataUrl as JA, GroupCommand as k, UpdateFramePattern as Lt, UpdateFrameThresholdSettingsCommand as TA, calculateOffsets as Bt, LayoutElementType as G, generate as J, CreateElementCommand as L, generateSVGWithUnknownColors as Le, svgObjectURL as ve, fetchAsString as _, DeleteElementCommand as ne, generateDefaultRectangleFrameSvg as yt, GetSVGDimensions as OA, patternImageDataCache as Mt, fetchAsArrayBuffer as LA, findElement as Re, modifySVGWithElementProperties as zA, IllustrationColorCommand as at, IllustrationCacheCommand as KA, getFontMetrics as jA, getPatternImageData as nt, FontAlignmentCommand as VA, FontColorCommand as WA, FontImageFillCommand as Xe, applyTextTransformations as it, determineCorrectFontSizeAndLines as xe, FontSourceCommand as St, loadFont as dt, TextChangeCommand as XA, FontSizeCommand as qA, createElementNS as ZA, createElement as Ie, _loadFontExternalDataURL as Ct, UpdateWorkflowStateCommand as Yt, CommandContext as $A, createCanvas as He, getSvgElement as zt, LayoutRenderingPurpose as Kt, renderPapyrusComponentAsString as jt, loadImage as Vt, getDomParser as Wt, toBase64 as Pt, getVariant as _A, generateFrameSVG as ea, getDefaultVariant as ze, domParser as Xt, sanitizeSvgTree as qt, traverse as ta, xmlSerializer as Zt, CreateLayoutCommand as Aa, AspectType as $, rehydrateSerializedLayout as se } from "@spiffcommerce/papyrus";
import { AspectType as Ns, AssetType as vs, BringForwardCommand as Rs, BringToBackCommand as Hs, BringToFrontCommand as ks, CanvasCommand as Us, CommandContext as Gs, CreateElementCommand as bs, CreateLayoutCommand as Js, DeleteElementCommand as Ts, FontAlignmentCommand as Os, FontColorCommand as Ls, FontSizeCommand as zs, FontSourceCommand as Ks, GroupCommand as js, LayoutElementFactory as Vs, LayoutElementType as Ws, MoveCommand as Xs, ResizeCommand as qs, RotateCommand as Zs, SendBackwardsCommand as $s, StepAspectType as _s, StepType as eo, TextChangeCommand as to, UnitOfMeasurement as Ao, UpdateImageSourceCommand as ao, dataUrlFromExternalUrl as no, determineCorrectFontSizeAndLines as io, findElement as so, frameDataCache as oo, generate as ro, generateSVGWithUnknownColors as co, getAttributesFromArrayBuffer as go, getAxisAlignedBoundingBox as lo, getFrameData as Bo, getSvgElement as Co, loadFont as wo, patternImageDataCache as ho, registerFetchImplementation as Eo, registerWindowImplementation as uo, rehydrateSerializedLayout as mo, setCanvasModule as Qo, svgToDataUrl as po } from "@spiffcommerce/papyrus";
import { setContext as aa } from "@apollo/client/link/context";
import { onError as na } from "@apollo/client/link/error";
import { Pith as $t } from "pith";
import _t from "lodash.debounce";
import eA from "lodash.isequal";
import ge from "lodash.clonedeep";
import { toString as tA } from "qrcode";
import ia from "fuse.js";
import { split as st } from "unicode-default-word-boundary";
import wt from "svg-path-bbox";
import xt from "lodash.chunk";
class AA extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
class pe extends AA {
  constructor(e) {
    super(`ConfigurationError - ${e}`);
  }
}
class ke extends pe {
  constructor(e) {
    super(`Option not Configured: ${e.stepTitle}`), this.optionId = (e == null ? void 0 : e.optionId) || "N/A";
  }
}
class z extends pe {
  constructor(e) {
    super(`Panel not Found: ${e.panelId}`), this.panelId = (e == null ? void 0 : e.panelId) || "N/A";
  }
}
class ie extends pe {
  constructor(e) {
    super(`Asset not found for variant: ${e.name}`), this.variant = e;
  }
}
class ue extends pe {
  constructor(e) {
    super(`Resource not found for asset: ${e.name}`), this.asset = e;
  }
}
class Ue extends pe {
  constructor(e, t) {
    super(`Workflow Misconfiguration: ${e.stepName} - ${t}`), this.step = e;
  }
}
class Ke extends AA {
  constructor(e) {
    super(`ImplementationError - ${e}`);
  }
}
class b extends Ke {
  constructor(e) {
    super(`Unhandled Behavior Encountered: ${e}`);
  }
}
class he extends Ke {
  constructor(e) {
    super(`Parsing Error: ${e}`);
  }
}
class H extends Ke {
  constructor(e) {
    super(`Client Error: ${e}`);
  }
}
class je extends Ke {
  constructor(e) {
    super(`Resource Generation Failed: ${e}`);
  }
}
class sa {
  get(e) {
    return localStorage.getItem(e) || void 0;
  }
  set(e, t) {
    localStorage.setItem(e, t);
  }
  remove(e) {
    localStorage.removeItem(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const A = JSON.stringify([...t.entries()]);
    this.set(e, A);
  }
}
class Nt {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  get(e) {
    return this.storage.get(e) || void 0;
  }
  set(e, t) {
    this.storage.set(e, t);
  }
  remove(e) {
    this.storage.delete(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const A = JSON.stringify([...t.entries()]);
    this.set(e, A);
  }
}
const oa = () => {
  try {
    return localStorage ? new sa() : new Nt();
  } catch {
    return console.warn("Local storage was unavilable due to browser security settings. Using in-memory storage instead."), new Nt();
  }
}, P = oa();
class ra {
  constructor() {
    this.defaultServerUrl = "https://api.spiff.com.au", this.defaultServicesApiUrl = "https://services.spiff.com.au", this.defaultHubUrl = "https://hub.spiff.com.au", this.serverUrl = this.defaultServerUrl, this.servicesApiUrl = this.defaultServicesApiUrl, this.hubUrl = this.defaultHubUrl, this.serverUrlCallbacks = [];
  }
  getServerUrl() {
    return this.serverUrl;
  }
  getServicesApiUrl() {
    return this.servicesApiUrl;
  }
  getHubUrl() {
    return this.hubUrl;
  }
  setServerUrl(e) {
    this.serverUrl = e, this.serverUrlCallbacks.forEach((t) => t());
  }
  setServicesApiUrl(e) {
    this.servicesApiUrl = e;
  }
  setHubUrl(e) {
    this.hubUrl = e;
  }
  addServerUrlCallback(e) {
    this.serverUrlCallbacks.push(e);
  }
}
const q = new ra();
let aA;
const vt = (g) => {
  aA = g;
};
let ht;
const ca = (g) => {
  ht = g;
}, ga = () => ht;
let nA;
const la = (g) => {
  nA = g;
}, Ba = () => new Promise((g) => {
  const e = q.getHubUrl(), t = (A) => {
    A.origin === e && (window.removeEventListener("message", t), g(A.data));
  };
  window.parent !== window && (window.addEventListener("message", t, !1), window.parent.postMessage("ready", e));
}), da = async () => {
  const g = {
    applicationKey: ht,
    customerToken: aA,
    bearer: nA
  };
  return typeof window < "u" && (window.location.href.includes("/workflows/product/") || window.location.href.includes("hub=true")) ? { ...await Ba(), ...g } : g;
};
class Ca {
  constructor() {
    this.shadowGraphqlClient = this.constructShadowGraphqlClient(), q.addServerUrlCallback(() => {
      this.shadowGraphqlClient = this.constructShadowGraphqlClient();
    });
  }
  getShadowGraphqlClient() {
    return this.shadowGraphqlClient;
  }
  constructShadowGraphqlClient() {
    const e = RA({
      uri: `${q.getServerUrl()}/graphql`,
      fetch: gt
    }), t = aa(async (i, s) => {
      const { headers: o } = s, r = o || {}, c = await da(), B = s.bearer ?? c.bearer, l = s.partnerId ?? c.partnerId, d = s.activeIntegration ?? c.activeIntegration, C = s.transactionOwnerId, w = s.customerToken ?? c.customerToken, h = s.applicationKey ?? c.applicationKey, u = s.bundleOwnerId;
      try {
        if (window && window.__SENTRY__) {
          const E = window.__SENTRY__.hub;
          if (E) {
            const D = E.traceHeaders();
            Object.entries(D).forEach(([Q, p]) => {
              r[Q] = p;
            });
          }
        }
      } catch {
      }
      return B && (r.Authorization = `Bearer ${B}`), l && (r.partnerId = l), d && (r.activeIntegration = d), C && (r.transactionOwnerId = C), w && (r.customerToken = w), h && (r["X-Application-Key"] = h), u && (r.bundleOwnerId = u), {
        headers: r
      };
    }), A = na(({ operation: i, graphQLErrors: s, networkError: o }) => {
      const r = s || [];
      o && console.log("GraphQL Network error"), r.forEach(() => console.log("GraphQL Error: " + i.operationName));
    });
    function a() {
      return {
        read(i = null) {
          return i;
        },
        merge(i, s) {
          return s || i || null;
        }
      };
    }
    const n = new HA({
      addTypename: !1,
      typePolicies: {
        Transaction: {
          fields: {
            transactionOwnerId: a(),
            customLogoLink: a(),
            workflowFooterLogoLink: a(),
            workflowState: a(),
            externalDesignProductId: a(),
            externalDesignProductVariantId: a(),
            externalCartProductId: a(),
            externalCartProductVariantId: a(),
            lastSyncedAt: a(),
            quantity: a(),
            lineItem: a()
          }
        },
        WorkflowProduct: {
          fields: {
            isPresent: a()
          }
        },
        Product: {
          fields: {
            imageUrl: a(),
            overlayImageUrl: a(),
            preloadImageUrl: a(),
            weight: a(),
            conversionConfiguration: a()
          }
        }
      }
    });
    return new kA({
      link: UA([A, t, e]),
      cache: n,
      name: "Core"
    });
  }
}
const x = new Ca(), wa = f`
    fragment AssetMetadataFields on Asset {
        metadata {
            key
            value
        }
    }
`, De = (g) => f`
        ${g && wa || ""}
        fragment AssetFields on Asset {
            name
            key
            type
            createdAt
            mimeType
            fileLink
            versions {
                name
                link
            }
            ${g && "...AssetMetadataFields" || ""}
        }
    `, ha = f`
    ${De(!1)}
    query GetAssets($keys: [String]!) {
        assets(keys: $keys) {
            ...AssetFields
        }
    }
`, Et = f`
    fragment MaterialFields on Material {
        id
        name
        createdAt
        clearCoat
        clearCoatIor
        refractionIntensity
        reflectionIntensity
        reflectionRotation
        albedoMap {
            key
            fileLink
        }
        alphaMap {
            key
            fileLink
        }
        ambientMap {
            key
            fileLink
        }
        emissionMap {
            key
            fileLink
        }
        metallicMap {
            key
            fileLink
        }
        normalMap {
            key
            fileLink
        }
        refractionMap {
            key
            fileLink
        }
        reflectionMap {
            key
            fileLink
        }
        roughnessMap {
            key
            fileLink
        }
    }
`, Ea = f`
    ${Et}
    query GetMaterials($ids: [String]) {
        materials(id: $ids) {
            ...MaterialFields
        }
    }
`, ua = f`
    mutation CreateAsset($name: String!, $type: String!, $mimeType: String!, $anonymous: Boolean, $temporary: Boolean) {
        assetCreate(name: $name, type: $type, mimeType: $mimeType, anonymous: $anonymous, temporary: $temporary) {
            uploadUrl
            asset {
                name
                key
                type
                createdAt
                mimeType
                fileLink
            }
        }
    }
`, ma = f`
    ${De(!1)}
    mutation RemoveBackgroundFromAsset($key: String!) {
        assetRemoveBackground(key: $key) {
            ...AssetFields
        }
    }
`, ot = async (g) => (await x.getShadowGraphqlClient().query({
  query: ha,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    keys: g
  }
})).data.assets, Qa = async (g) => (await x.getShadowGraphqlClient().query({
  query: Ea,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    ids: g
  }
})).data.materials, pa = async (g, e, t, A, a) => {
  var i;
  return (i = (await x.getShadowGraphqlClient().mutate({
    mutation: ua,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      name: g,
      type: e,
      mimeType: t,
      anonymous: A,
      temporary: a
    }
  })).data) == null ? void 0 : i.assetCreate;
};
class Da {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.bgrmProcessCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map(), this.loadImageAsFileInfo = async (e) => {
      const t = await e.arrayBuffer(), A = await Ot(t), a = (n, i) => {
        const s = atob(n.split(",")[1]), o = [];
        for (let r = 0; r < s.length; r++)
          o.push(s.charCodeAt(r));
        return new Blob([new Uint8Array(o)], { type: i });
      };
      return {
        name: e.name.substring(e.name.lastIndexOf("/") + 1),
        blob: a(A.dataUrl, e.type)
      };
    };
  }
  /**
   * Allows for retrieving an asset, returns the option from a cache if possible.
   */
  async getLocalOrFromServer(e) {
    if (this.cache.has(e)) {
      const a = this.cache.get(e);
      if (!a)
        throw new b("Failed to get asset from cache!");
      return a;
    }
    const A = (async () => (await ot([e]))[0])();
    return this.cache.set(e, A), A;
  }
  /**
   * Retrieves the asset from the server, bypassing cache (but still writing the result to cache)
   */
  async getFromServer(e) {
    const A = (async () => (await ot([e]))[0])();
    return this.cache.set(e, A), A;
  }
  keyFromURL(e) {
    let t;
    try {
      t = new URL(e).pathname;
    } catch {
      t = void 0;
    }
    return t !== void 0 && t.startsWith("/") && (t = t.replace("/", "")), t == null ? void 0 : t.split("?")[0];
  }
  /**
   * Caches an asset if it doesn't already exist.
   */
  cacheAsset(e) {
    if (!e.key)
      throw new b("Asset has no key!");
    this.cache.has(e.key) || this.cache.set(e.key, Promise.resolve(e));
  }
  /**
   * Caches a material if it doesn't already exist.
   */
  cacheMaterial(e) {
    if (!e.id)
      throw new b("Material has no id!");
    this.materialCache.has(e.id) || this.materialCache.set(e.id, Promise.resolve(e));
  }
  /**
   * Allows for retrieving a material, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getMaterialLocalOrFromServer(e) {
    if (this.materialCache.has(e))
      return this.materialCache.get(e);
    const A = (async () => (await Qa([e]))[0])();
    return this.materialCache.set(e, A), A;
  }
  /**
   * Upload a user asset to the server. Using callbacks to notify important events.
   * The asset will be stored via the persistence service for future access, if available.
   */
  async uploadAssetWithProgress(e, t, A, a, n) {
    const i = await this.dispatchCreateAssetRequest(e, t, a, n);
    if (!i)
      throw new Error("Failed to create asset.");
    return await new Promise((s, o) => {
      const r = new XMLHttpRequest();
      r.open("PUT", i.assetResponse.uploadUrl, !0), r.setRequestHeader("Content-Type", i.mimeType), r.setRequestHeader("Cache-Control", "public,max-age=31536000,immutable"), r.upload.onprogress = (c) => {
        c.lengthComputable && A(c.loaded * 100 / c.total);
      }, r.onload = () => {
        const c = i.assetResponse.asset;
        oe.add(i.assetResponse.asset), s(c);
      }, r.onerror = o, r.send(e.blob);
    }), this.cacheAsset(i.assetResponse.asset), i.assetResponse.asset;
  }
  async uploadAsset(e, t, A, a) {
    return this.uploadAssetWithProgress(e, t, () => {
    }, A, a);
  }
  async uploadFile(e, t) {
    const A = !(e.type === "image/svg+xml" || e.type === "application/pdf" || e.type === "application/postscript"), a = A ? At.Image : At.Illustration;
    if (A) {
      const n = await this.loadImageAsFileInfo(e);
      return await this.uploadAssetWithProgress(n, a, t, !0);
    } else {
      const n = {
        name: e.name,
        blob: new Blob([e], { type: e.type })
      };
      return await this.uploadAssetWithProgress(n, a, t, !0);
    }
  }
  async removeBackgroundFromAsset(e) {
    const t = e.key;
    if (this.bgrmProcessCache.has(t))
      return this.bgrmProcessCache.get(t);
    if (K.has(t)) {
      const n = this.getLocalOrFromServer(K.get(t));
      return this.bgrmProcessCache.set(t, n), n;
    }
    const a = (async () => {
      var i, s;
      const n = await x.getShadowGraphqlClient().mutate({
        mutation: ma,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: t
        }
      });
      if (this.bgrmProcessCache.delete(t), !((s = (i = n.data) == null ? void 0 : i.assetRemoveBackground) != null && s.key))
        throw new Error("Failed to remove background from image");
      return oe.add(n.data.assetRemoveBackground), K.add(t, n.data.assetRemoveBackground.key), this.cache.set(
        n.data.assetRemoveBackground.key,
        Promise.resolve(n.data.assetRemoveBackground)
      ), n.data.assetRemoveBackground;
    })();
    return this.bgrmProcessCache.set(t, a), a;
  }
  removePersistedAsset(e) {
    oe.remove(e), K.delete(e), K.deleteForBgRemovedKey(e);
  }
  getPersistedAssets() {
    return oe.list();
  }
  registerPersistedAssetListener(e) {
    oe.addCallback(e);
  }
  unRegisterPersistedAssetListener(e) {
    oe.removeCallback(e);
  }
  /**
   * Handles mimeType resolution & asset creation request
   * @param file A file info object containing data about the file and its name
   * @param assetType The type of asset we're expecting to upload
   */
  async dispatchCreateAssetRequest(e, t, A, a) {
    const n = e.blob.type ? e.blob.type : this.guessMIME(e.name), i = await pa(e.name, t, n, A, a);
    if (i)
      return {
        assetResponse: i,
        mimeType: n
      };
  }
  guessMIME(e) {
    const t = e.split(".").pop();
    switch (t) {
      case "glb":
        return "model/gltf-binary";
      case "ttf":
        return "font/ttf";
      case "mkv":
        return "video/x-matroska";
      default:
        throw new b("Unexpected mimetype: " + t);
    }
  }
}
const de = "persistentAssets", iA = class te {
  /**
   * Add a new asset to persistence
   * @param asset The asset to add.
   */
  static add(e) {
    if (!e.fileLink) {
      console.error("Failed to find cdn link on asset, cannot persist!");
      return;
    }
    const t = /* @__PURE__ */ new Map();
    t.set(e.key || "", e.fileLink);
    const A = P.getMap(de);
    A && A.forEach((a, n) => {
      t.set(n, a);
    }), P.setMap(de, t), te.executeCallbacks();
  }
  /**
   * Remove an existing asset from persistence. Noop if the asset doesn't exist.
   * @param assetKey The key to remove.
   */
  static remove(e) {
    const t = P.getMap(de);
    if (!t)
      return;
    const A = Array.from(t.entries()).find((a) => a[0] === e);
    A && (t.delete(A[0]), P.setMap(de, t), te.executeCallbacks());
  }
  /**
   * Get a list of all persisted assets.
   */
  static list() {
    const e = P.getMap(de);
    return e ? Array.from(e.entries()).map((t) => ({ assetKey: t[0], src: t[1] })) : [];
  }
  /**
   * Adds a callback that will be called whenever assets are added/removed from persistence.
   */
  static addCallback(e) {
    te.callbacks.push(e);
  }
  /**
   * Removes an existing callback.
   */
  static removeCallback(e) {
    te.callbacks = te.callbacks.filter((t) => t !== e);
  }
  static executeCallbacks() {
    te.callbacks.forEach((e) => e());
  }
};
iA.callbacks = [];
let oe = iA;
const Rt = "bgrmPersistentAssets";
class K {
  static has(e) {
    return K.getMap().has(e);
  }
  static get(e) {
    return K.getMap().get(e);
  }
  static keys() {
    return K.getMap().keys();
  }
  static values() {
    return K.getMap().values();
  }
  static add(e, t) {
    const A = K.getMap();
    A.set(e, t), K.setMap(A);
  }
  static delete(e) {
    const t = K.getMap();
    t.delete(e), K.setMap(t);
  }
  static deleteForBgRemovedKey(e) {
    const t = K.getMap(), A = Array.from(t.keys()).find((a) => t.get(a) === e);
    A && (t.delete(A), K.setMap(t));
  }
  static getMap() {
    return P.getMap(Rt) || /* @__PURE__ */ new Map();
  }
  static setMap(e) {
    P.setMap(Rt, e);
  }
}
const U = new Da();
class Ia {
  constructor() {
    this.cache = {}, this.disabled = !1;
  }
  /**
   * Gets a promise from the cache, or undefined if it doesn't exist.
   */
  get(e) {
    if (this.disabled)
      return;
    const t = JSON.stringify(e);
    return this.cache[t];
  }
  /**
   * Sets a promise in the cache and returns it.
   */
  set(e, t) {
    if (this.disabled)
      return t;
    const A = JSON.stringify(e);
    return this.cache[A] = t, t;
  }
  /**
   * Some environments don't want workflows to be cached. An example is a server
   * that doesn't launch a fresh instance per request. This method allows disabling
   * caching in a transparent way.
   */
  disable(e) {
    this.disabled = e;
  }
}
const me = new Ia(), sA = f`
    fragment OptionFields on Option {
        id
        name
        public
        currencyCode
        type
        workflowId
        displayType
        variants {
            id
            name
            enabled
            color
            namedColor
            priceModifier
            asset {
                ...AssetFields
            }
            thumbnail {
                ...AssetFields
            }
            material {
                ...MaterialFields
            }
        }
        defaultVariant {
            id
            name
            asset {
                ...AssetFields
            }
        }
        colorProfile {
            ...AssetFields
        }
    }
`, fa = f`
    ${De(!1)}
    ${Et}
    ${sA}
    query GetOptions($ids: [String]!) {
        options(ids: $ids) {
            ...OptionFields
        }
    }
`, Fa = async (g) => {
  const e = await x.getShadowGraphqlClient().query({
    query: fa,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      ids: g
    }
  });
  return e.data.options.forEach((t) => {
    var A, a;
    (A = t.defaultVariant) != null && A.asset && U.cacheAsset(t.defaultVariant.asset), t.colorProfile && U.cacheAsset(t.colorProfile), (a = t.variants) == null || a.forEach((n) => {
      n.asset && U.cacheAsset(n.asset), n.thumbnail && U.cacheAsset(n.thumbnail), n.material && U.cacheMaterial(n.material);
    });
  }), e.data.options;
}, ya = async (g, e) => (await e).find((A) => A.id === g), Ma = async (g) => {
  const e = g.map((i) => me.get({ id: i })), t = g.filter((i, s) => e[s] === void 0);
  if (t.length === 0)
    return Promise.all(e);
  const A = Fa(t), a = t.map(
    (i) => me.set({ id: i }, ya(i, A))
  ), n = e.filter((i) => i !== void 0);
  return await Promise.all(n.concat(a));
};
class Sa {
  constructor() {
    this.getSelectedVariant = (e, t) => {
      var A;
      if (!(!e || t.length === 0))
        return (A = e.variants) == null ? void 0 : A.find((a) => a.id === t[0]);
    };
  }
  /**
   * Allows for retrieving an option, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getOption(e) {
    return (async () => {
      const a = (await Ma([e]))[0];
      if (a)
        return a;
    })();
  }
  async getAssetTileImageForVariant(e) {
    var a, n;
    const t = e.thumbnail;
    if (t) {
      const i = (a = t.versions) == null ? void 0 : a.find((o) => o.name === "thumbnail"), s = t.fileLink;
      return (i == null ? void 0 : i.link) || s;
    }
    const A = e.asset;
    if (A) {
      const i = (n = A.versions) == null ? void 0 : n.find((o) => o.name === "thumbnail"), s = A.fileLink;
      return (i == null ? void 0 : i.link) || s;
    }
    return e.material ? e.material.id : "";
  }
  getDefaultVariant(e) {
    const t = e.variants;
    if (t) {
      if (t.length === 1)
        return t[0];
      if (e.defaultVariant !== void 0)
        return t.find((A) => {
          var a;
          return A.id === ((a = e.defaultVariant) == null ? void 0 : a.id);
        });
    }
  }
}
const V = new Sa();
var Ya = /* @__PURE__ */ ((g) => (g.Hyperlink = "Hyperlink", g.Edit = "Edit", g.Approve = "Approve", g))(Ya || {}), Pa = /* @__PURE__ */ ((g) => (g.Hub = "Hub", g.Shopify = "Shopify", g))(Pa || {}), ut = /* @__PURE__ */ ((g) => (g.BackgroundRemover = "BackgroundRemover", g.ConversionAccelerator = "Conversion Accelerator", g.ProcessBuilder = "ProcessBuilder", g))(ut || {}), xa = /* @__PURE__ */ ((g) => (g[g.Orbit = 0] = "Orbit", g[g.Pan = 1] = "Pan", g))(xa || {}), Na = /* @__PURE__ */ ((g) => (g.Manual = "Manual", g.OnStart = "OnStart", g.OnQuit = "OnQuit", g.OnEnd = "OnEnd", g))(Na || {}), va = /* @__PURE__ */ ((g) => (g.Email = "Email", g.FirstName = "FirstName", g.LastName = "LastName", g.Phone = "Phone", g))(va || {}), Ge = /* @__PURE__ */ ((g) => (g.Owner = "Owner", g.Approver = "Approver", g.Editor = "Editor", g.Viewer = "Viewer", g))(Ge || {});
const oA = f`
    fragment ActiveIntegrationFields on Integration {
        id
        logo
        theme {
            id
            configuration
            primaryColor
            secondaryColor
            textColor
        }
        partner {
            id
            name
            activeAddons
        }
    }
`, Ra = f`
    ${oA}
    query GetCurrentIntegration {
        currentIntegration {
            ...ActiveIntegrationFields
        }
    }
`, Be = f`
    fragment AdditionalIntegrationProductFields on IntegrationProduct {
        id
        product {
            id
            basePrice
            enabled
            name
            description
            sku
            skuCode
            weight
            imageUrl
            modelUrl
            overlayImageUrl
            preloadImageUrl
        }
    }
`, Ht = f`
    ${Be}
    mutation CreateTransaction(
        $integrationProductId: String
        $externalIntegrationId: String
        $externalProductId: String
        $claim: Boolean
        $workflowId: String
        $designName: String
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
    ) {
        transactionCreate(
            integrationProductId: $integrationProductId
            externalIntegrationId: $externalIntegrationId
            externalProductId: $externalProductId
            claim: $claim
            workflowId: $workflowId
            designName: $designName
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
        ) {
            id
            designName
            transactionOwnerId
            workflowId
            customLogoLink
            workflowFooterLogoLink
            restApiIntegrationLink
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            product {
                id
                basePrice
                enabled
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    id
                    name
                    locations
                    requestedData
                    requestedDataItems {
                        type
                        mandatory
                    }
                    mandatory
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
                additionalIntegrationProduct {
                    ...AdditionalIntegrationProductFields
                }
            }
        }
    }
`, Ha = f`
    ${Be}
    mutation CreateTransactions(
        $inputs: [TransactionCreateInput]!
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
    ) {
        transactionCreateMany(
            inputs: $inputs
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
        ) {
            id
            designName
            transactionOwnerId
            workflowId
            customLogoLink
            workflowFooterLogoLink
            restApiIntegrationLink
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            product {
                id
                basePrice
                enabled
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    id
                    name
                    locations
                    requestedData
                    requestedDataItems {
                        type
                        mandatory
                    }
                    mandatory
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
                additionalIntegrationProduct {
                    ...AdditionalIntegrationProductFields
                }
            }
        }
    }
`, ka = f`
    ${Be}
    mutation ClaimTransaction($id: String!) {
        transactionClaim(id: $id) {
            id
            designName
            transactionOwnerId
            workflowId
            customLogoLink
            workflowFooterLogoLink
            restApiIntegrationLink
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            product {
                id
                basePrice
                enabled
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    id
                    name
                    locations
                    requestedData
                    requestedDataItems {
                        type
                        mandatory
                    }
                    mandatory
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
                additionalIntegrationProduct {
                    ...AdditionalIntegrationProductFields
                }
            }
        }
    }
`, rA = f`
    fragment StakeholderFields on Stakeholder {
        id
        type
        authorizationDate
        authorizationNote
        authorizationStatus
    }
`, cA = f`
    fragment TransactionShareActionFields on TransactionShareAction {
        id
        title
        type
        stakeholderType
        precedence
        url
    }
`, fe = f`
    ${Be}
    ${rA}
    ${cA}
    ${oA}
    query ReadTransactions($ids: [String]!) {
        transactions(ids: $ids) {
            customLogoLink
            designName
            externalDesignProductId
            externalDesignProductVariantId
            externalCartProductId
            externalCartProductVariantId
            id
            lastSyncedAt
            priceModifierTotal
            restApiIntegrationLink
            workflowFooterLogoLink
            workflowId
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            previewImageLink
            isOrdered
            quantity
            printFileUrl1
            printFileUrl2
            printFileUrl3
            printFileUrl4
            printFileUrl5
            printFileName1
            printFileName2
            printFileName3
            printFileName4
            printFileName5
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
            product {
                id
                basePrice
                enabled
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                productImages {
                    id
                    precedence
                    asset {
                        key
                        fileLink
                        name
                        type
                        versions {
                            name
                            link
                        }
                    }
                }
                integrationProducts {
                    id
                    integration {
                        id
                        type
                    }
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    id
                    name
                    locations
                    requestedData
                    requestedDataItems {
                        type
                        mandatory
                    }
                    mandatory
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
                additionalIntegrationProduct {
                    ...AdditionalIntegrationProductFields
                }
                integration {
                    ...ActiveIntegrationFields
                }
            }
        }
    }
`, Ua = f`
    mutation UpdateTransactionWorkflowState($id: String!, $workflowState: String!) {
        transactionUpdate(id: $id, workflowState: $workflowState) {
            id
        }
    }
`, Ga = f`
    mutation UpdateTransactionWorkflowId($id: String!, $workflowId: String!) {
        transactionUpdate(id: $id, workflowId: $workflowId) {
            id
        }
    }
`, ba = f`
    mutation UpdateTransactionQuantity($id: String!, $quantity: Int) {
        transactionUpdate(id: $id, quantity: $quantity) {
            id
        }
    }
`;
f`
    query ReadTransactionForDesignCreation($id: String!) {
        transactions(ids: [$id]) {
            id
            designName
            product {
                basePrice
                promptForCustomerDetails
                partner {
                    id
                    name
                    customerDetailsPromptMarkdown
                }
                conversionConfiguration {
                    id
                    name
                    locations
                    requestedData
                    requestedDataItems {
                        type
                        mandatory
                    }
                    mandatory
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            priceModifierTotal
            externalDesignProductId
            externalDesignProductVariantId
            externalCartProductId
            externalCartProductVariantId
            workflowViewerLink
            workflowViewerReadOnlyLink
            lastSyncedAt
            quantity
        }
    }
`;
const Ja = f`
    ${cA}
    query ReadTransactionForShareActions($id: String!) {
        transactions(ids: [$id]) {
            id
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
        }
    }
`, gA = f`
    query ReadWorkflowStates($ids: [String]!) {
        transactions(ids: $ids) {
            id
            workflowState
        }
    }
`, lA = f`
    ${Be}
    fragment IntegrationProductFields on IntegrationProduct {
        id
        externalProductId
        externalVariantId
        additionalExternalProductId
        additionalExternalVariantId
        additionalIntegrationProduct {
            ...AdditionalIntegrationProductFields
        }
        integration {
            id
            enabled
            externalIntegrationId
            type
        }
        product {
            id
            basePrice
            enabled
            imageUrl
            modelUrl
            name
            description
            overlayImageUrl
            preloadImageUrl
            sku
            skuCode
            workflows {
                id
                index
                friendlyName
                isPresent
                workflowName
                imageUrl
            }
            productTags {
                id
                name
            }
            productImages {
                id
                precedence
                asset {
                    key
                    fileLink
                    name
                    type
                    versions {
                        name
                        link
                    }
                }
            }
            priceBreaks {
                id
                minQty
                percentage
            }
        }
    }
`, Ta = f`
    ${lA}
    query GetIntegrationProducts($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            ...IntegrationProductFields
        }
    }
`, Oa = f`
    ${lA}
    query GetIntegrationProductFromExternalIds($externalIntegrationId: String!, $externalProductId: String!) {
        integrationProductFromExternalIds(
            externalIntegrationId: $externalIntegrationId
            externalProductId: $externalProductId
        ) {
            ...IntegrationProductFields
        }
    }
`, La = f`
    ${rA}
    query ReadTransactionForStakeholders($id: String!) {
        transactions(ids: [$id]) {
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
        }
    }
`, Ce = [M.SilentIllustration, M.ProductOverlay], za = async (g) => {
  const e = [];
  g.introduction && e.push({
    name: "Introduction",
    title: g.name,
    renderableSteps: [
      {
        type: M.Introduction,
        stepName: "Introduction",
        stepTitle: g.name,
        helpText: g.introduction,
        data: {},
        conditions: []
      }
    ],
    silentSteps: []
  });
  for (const A of g.steps) {
    const a = Ka(A.stepName, g.stepGroups);
    if (!a)
      e.push({
        name: A.stepName,
        title: A.stepTitle,
        renderableSteps: Ce.includes(A.type) ? [] : [A],
        silentSteps: Ce.includes(A.type) ? [A] : []
      });
    else {
      const n = e.find((i) => i.name === a.name);
      n ? Ce.includes(A.type) ? n.silentSteps.push(A) : n.renderableSteps.push(A) : e.push({
        name: a.name,
        title: a.name,
        renderableSteps: Ce.includes(A.type) ? [] : [A],
        silentSteps: Ce.includes(A.type) ? [A] : []
      });
    }
  }
  const t = "workflow.steps.finish.confirmDesign";
  return e.push({
    name: "Finish",
    title: t,
    renderableSteps: [
      {
        type: M.Finish,
        stepName: "Finish",
        stepTitle: t,
        helpText: "",
        data: {
          modelAnimation: g.finalizeStepConfig ? g.finalizeStepConfig.modelAnimation : void 0,
          lookAtAnimation: g.finalizeStepConfig ? g.finalizeStepConfig.lookAtAnimation : void 0
        },
        conditions: []
      }
    ],
    silentSteps: []
  }), e;
}, Ka = (g, e) => e.find((t) => t.stepNames.includes(g)), ae = (g, e) => (g.conditions || []).every((t) => {
  const A = e[t.targetStepName];
  if (A && A.selectedVariants) {
    const a = A.selectedVariants;
    return t.requiredVariantSelections.some(
      (n) => a.find((i) => i.id === n) !== void 0
    );
  }
  return !1;
}), ja = (g, e) => {
  const t = {
    name: g.name,
    title: g.title,
    renderableSteps: g.renderableSteps.filter((A) => ae(A, e)),
    silentSteps: g.silentSteps.filter((A) => ae(A, e))
  };
  return t.silentSteps.length === 0 && t.renderableSteps.length === 0 ? null : t;
}, ce = (g, e) => g.map((t) => ja(t, e)).filter((t) => t !== null), Va = async (g, e, t = !1) => {
  var i;
  const A = ce(g, e), a = [];
  for (const s of A)
    for (const o of s.renderableSteps) {
      const r = (((i = o.option) == null ? void 0 : i.variants) || []).length;
      o.silent || (o.type === M.Model || o.type === M.Material || o.type === M.Picture || o.type === M.Shape ? (r > 1 || t) && a.push(o.stepName) : a.push(o.stepName));
    }
  const n = A.filter((s) => s.renderableSteps.filter(
    (r) => a.includes(r.stepName)
  ).length > 0);
  for (const s of n)
    s.renderableSteps = s.renderableSteps.filter(
      (o) => a.includes(o.stepName)
    );
  return n;
};
class BA {
  constructor() {
    this.timestamp = Date.now();
  }
}
class dA {
  /**
   * Constructs a new promise queue.
   * @param queueMaxSize An optional maximum size, when the max size is hit.
   *                     The older promises will be discarded.
   * @param enabled When false, the queue will not process any jobs. Assign `enabled` to true to start processing.
   */
  constructor(e, t = !0) {
    this.queue = [], this.activePromise = void 0, this.queueMaxSize = void 0, this.queueMaxSize = e, this.isEnabled = t;
  }
  /**
   * Enqueue a new promise.
   * @param promise A new promise to add to the queue.
   */
  enqueue(e) {
    if (this.queue.push(e), this.queueMaxSize !== void 0 && this.queue.length > this.queueMaxSize) {
      const t = this.queue.length - 1;
      for (let A = 0; A < t; ++A)
        this.queue.shift();
    }
    this.isEnabled && (this.activePromise || (this.activePromise = this.dequeue()));
  }
  get enabled() {
    return this.isEnabled;
  }
  /**
   * Enable or disable the queue. When disabled, the queue will not process any jobs.
   * Disabling processing will not cancel any active promises.
   */
  set enabled(e) {
    !this.isEnabled && e && !this.activePromise && this.getRemainingQueueSize() > 0 && (this.activePromise = this.dequeue()), this.isEnabled = e;
  }
  /**
   * @returns Returns true when work is being actively processed by this queue.
   */
  hasActivePromise() {
    return !!this.activePromise;
  }
  /**
   * @returns The number of unexecuted jobs remaining in the queue. Not including the active job.
   */
  getRemainingQueueSize() {
    return this.queue.length;
  }
  /**
   * Finalize the queue, any jobs that come in while this is in progress will result
   * in the promise being extended.
   */
  async finalize() {
    return this.activePromise ? this.activePromise : Promise.resolve();
  }
  /**
   * Once called will recursively resolve the jobs in the
   * queue until no more are available.
   */
  async dequeue() {
    const e = this.queue.shift();
    if (!e) {
      this.activePromise = void 0;
      return;
    }
    try {
      await e.execute();
    } catch (t) {
      console.log(t);
    } finally {
      await this.dequeue();
    }
  }
}
function Wa(g, e, t, A) {
  const a = t.width * g.zoom, n = t.height * g.zoom;
  if (A) {
    const s = g, o = Math.max(e.width / t.width, e.height / t.height);
    s.zoom = Math.max(o, g.zoom);
    const r = t.width * s.zoom, c = t.height * s.zoom;
    return s.x = Fe(g.x, e.width - r, 0), s.y = Fe(g.y, e.height - c, 0), s;
  }
  const i = g;
  return i.x = Fe(i.x, -a, e.width), i.y = Fe(i.y, -n, e.height), i;
}
function Fe(g, e, t) {
  return Math.min(Math.max(g, e), t);
}
class Xa {
  constructor(e) {
    this.minZoomScale = [0.03], this.maxZoomScale = [20], this._debouncedUpdateFrameOffsets = _t(this.updateFrameOffsets, 200), this.targetElements = [], this.onFrameDataChangeListeners = [], this.onZoomChangeListeners = [], this.forceImageCover = e, this.thresholdSettings = {
      useThreshold: !1,
      invertThreshold: !1,
      threshold: 128,
      thresholdSaturation: 0.5
    };
  }
  /**
   * When we want to connect a workflow manager to the state of the image cropper we
   * can pass it to this function. Inside we'll attach any required event listeners.
   * @param workflowManager The workflow manager to attach.
   * @param stepName The specific step we want to attach to within the manager.
   */
  connectWorkflowManager(e, t) {
    t && e.addStepSpecificStorageCallback(async (A) => {
      if (A) {
        const a = A;
        if (a.currentFrameSources) {
          let n = !1;
          for (let i = 0; i < a.currentFrameSources.length; i++) {
            const s = a.currentFrameSources[i], o = await lt(s), r = this.frameData ? this.frameData[i] : void 0;
            eA(o, r) || (this.frameData || (this.frameData = new Array(a.currentFrameSources.length)), this.frameData[i] = o, n = !0);
          }
          n && (this.onFrameDataChangeListeners.forEach(
            (i) => i(this.frameData)
          ), this.frameData && this.imageData && (this.recalculateOffsets(this.imageData), this.updateOffsets(this.offsets), this.recalculateZoomLimits(this.imageData, this.frameData)));
        }
      }
    }, t), this.workflowManager = e, this.stepName = t;
  }
  /**
   * Sets the elements that should be update when changes are made to
   * the cropper that owns this service.
   * @param targetElements A list of element Ids to track
   */
  setTargetElements(e) {
    this.targetElements = e;
  }
  /**
   * Gets the current calculated frame data
   * @returns A FrameData object or undefined if no frame has been set.
   */
  getFrameData() {
    return this.frameData;
  }
  /**
   * Sets the current frame data. Note:
   * @param paths The paths to lookup in our frame data cache.
   */
  setFrameData(e) {
    if (!e) {
      this.frameData = void 0;
      return;
    }
    e.forEach((t, A) => {
      const a = GA.get(t);
      a && (this.frameData || (this.frameData = new Array(e.length)), this.frameData[A] = a);
    });
  }
  /**
   * Gets the currently set image of the frame..
   * @returns A PatternImageData object, or undefined if no image is set.
   */
  getImageData() {
    return this.imageData;
  }
  /**
   * Helper function to get the src of the image of the frame, since it can be an svg with modified colors.
   * @returns A url (a data url if svg), or undefined if no image is set.
   */
  getImageSrc() {
    if (this.imageData) {
      if (this.imageData.svg) {
        const e = bA(this.imageData.svg, this.imageData.colors || {}, !1);
        return JA(e);
      }
      return this.imageData.src;
    }
  }
  /**
   * Gets the current calculated offsets of the pattern within the frame.
   * @returns A FrameOffsets object or undefined if no offsets are defined.
   */
  getOffsets() {
    return this.offsets;
  }
  /**
   * Updates the frame offsets explicitly.
   */
  setOffsets(e) {
    this.offsets = e;
  }
  /**
   * Sets the zoom of the cropper that owns this service.
   * @param zoom The new zoom value, per frame.
   * @param cX The center of zoom on x axis, per frame.
   * @param cY The center of zoom on Y axis, per frame.
   * @param onComplete A function to call when zoom changes have been completed
   */
  setZoom(e, t, A, a) {
    if (this.imageData && this.offsets && this.frameData) {
      (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length));
      const n = this.frameData.map((i, s) => {
        const o = (t[s] - this.offsets[s].x) / this.offsets[s].zoom, r = (A[s] - this.offsets[s].y) / this.offsets[s].zoom, c = t[s] - o * e[s], B = A[s] - r * e[s];
        return {
          x: c,
          y: B,
          zoom: this.imageData.width * e[s] / this.imageData.width
        };
      });
      this.updateOffsets(n, a), this.onZoomChangeListeners.forEach((i) => i(e));
    }
  }
  /**
   * Sets the image currently contained by this frame.
   * @param value The new image as an ImageData property
   * @param [recalculateOffsets=true] Optional: Enable/disable re-calculating of frame offsets. Default: `true`.
   * Note: Will always calculate when offsets have not been calculated.
   */
  setPatternData(e, t = !0) {
    this.imageData = e, e && this.frameData && ((t || !this.offsets) && this.recalculateOffsets(e), this.updateOffsets(this.offsets, void 0, !0)), this.imageData && this.frameData && this.recalculateZoomLimits(this.imageData, this.frameData);
  }
  /**
   * Modify the offsets of the frame.
   * @param value The new FrameOffsets objects.
   * @param onComplete A callback, called when the modification is complete
   * @param forceUpdate When true the offsets will be updated even if they haven't changed.
   */
  updateOffsets(e, t, A) {
    const a = this.imageData;
    if (!a || !this.frameData)
      return;
    if (this.frameData.length !== e.length)
      throw new b(
        "Frame data and offsets are not the same length. This is a bug. Please report it."
      );
    if (!this.offsets.some((i, s) => !(e[s].x === i.x && e[s].y === i.y && e[s].zoom === i.zoom)) && !A) {
      t && t();
      return;
    }
    (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((i, s) => {
      this.offsets[s] = Wa(e[s], i, this.imageData, this.forceImageCover);
    }), this._debouncedUpdateFrameOffsets(
      this.offsets,
      a,
      this.frameData,
      this.thresholdSettings,
      t
    );
  }
  getThresholdSettings() {
    return this.thresholdSettings;
  }
  setThresholdSettings(e) {
    this.thresholdSettings = e, this.imageData && this.frameData && this._debouncedUpdateFrameOffsets(this.offsets, this.imageData, this.frameData, e);
  }
  // Allows users of the frame service to listen to frame data changes.
  onFrameDataChanged(e) {
    e(this.frameData), this.onFrameDataChangeListeners.push(e);
  }
  /**
   * Append a new listener to zoom events on this frame.
   * @param newListener
   */
  onZoom(e) {
    this.onZoomChangeListeners.push(e);
  }
  /**
   * Updates the offsets of the frame
   * @param newOffsets New offset object
   * @param imageData The image data
   * @param frameData The frame data
   * @param targetElements A list of elements that need updating, by ID
   * @param onComplete A callback when the operation is completed.
   */
  updateFrameOffsets(e, t, A, a, n) {
    if (!A || A.length === 0 || A.some((s) => !s))
      throw new b("Frame data not set. This is a bug");
    if (!this.workflowManager)
      throw new b("No workflow manager set, cannot update offsets.");
    const i = this.workflowManager.getCommandDispatcher();
    this.targetElements.forEach((s, o) => {
      i(
        new k([
          new Lt(s, t, e[o]),
          new TA(
            s,
            a.useThreshold,
            a.invertThreshold,
            a.threshold,
            a.thresholdSaturation
          )
        ])
      );
    }), this.stepName && this.workflowManager.updateStorage(this.stepName, {
      frameOffsetsList: e
    }), n && n();
  }
  /**
   * Determines limitations of zoom based on relative size of image and frame.
   * @param imageData The image to include in calculations
   * @param frameData The frame to include in calculations.
   */
  recalculateZoomLimits(e, t) {
    (this.minZoomScale.length !== t.length || this.maxZoomScale.length !== t.length) && (this.minZoomScale = new Array(t.length), this.maxZoomScale = new Array(t.length)), t.forEach((A, a) => {
      const n = Math.max(A.width / e.width, A.height / e.height);
      this.forceImageCover ? (this.minZoomScale[a] = n, this.maxZoomScale[a] = n * 2.5) : (this.minZoomScale[a] = n / 10, this.maxZoomScale[a] = n * 2.5);
    });
  }
  recalculateOffsets(e) {
    this.frameData && ((!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((t, A) => {
      this.offsets[A] = Bt(e, t);
    }), this._debouncedUpdateFrameOffsets(this.offsets, e, this.frameData, this.thresholdSettings));
  }
}
class kt {
  constructor(e, t, A) {
    this.processRegion = async (a) => {
      var o, r, c, B;
      const n = this.layouts.find((l) => l.panelId === a.panelId);
      if (!n)
        throw new z(a);
      let i = "";
      if (this.configuration.type === M.ProductOverlay) {
        let l = "";
        if ((o = this.product) != null && o.overlayImageUrl && (l = this.product.overlayImageUrl), i = l, !l)
          throw new Ue(this.configuration, "Couldn't find an asset for product overlay step");
      }
      const s = this.evaluateAssetType();
      if (s === G.Image) {
        const l = this.configuration.type === M.SilentIllustration ? (r = this.configuration.data.asset) == null ? void 0 : r.fileLink : (c = this.product) == null ? void 0 : c.overlayImageUrl;
        if (!l)
          throw new Error("Undefined raster silent step source");
        const d = {
          stepName: this.configuration.stepName,
          id: J(),
          src: l,
          type: s,
          y: a.top,
          x: a.left,
          width: a.width,
          height: a.height,
          layer: a.layer,
          layerIndex: a.layerIndex,
          immutable: a.immutable,
          productOverlay: this.configuration.type === M.ProductOverlay ? !0 : void 0,
          rotation: a.rotation,
          excludeFromExport: this.configuration.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        return {
          regionElement: {
            id: d.id,
            region: a
          },
          command: new L(d, n)
        };
      } else {
        const l = this.configuration.type === M.SilentIllustration ? (B = this.configuration.data.asset) == null ? void 0 : B.fileLink : i, C = await Le(await (async () => new Promise((h, u) => {
          if (!l) {
            u("Undefined vector silent step source");
            return;
          }
          _(l, !0).then((E) => {
            h(E);
          }).catch((E) => console.error(E));
        }))()), w = {
          stepName: this.configuration.stepName,
          id: J(),
          cachedObjectURL: await ve(C.svg),
          src: l,
          svg: C.svg,
          colors: C.colors,
          type: s,
          y: a.top,
          x: a.left,
          width: a.width,
          height: a.height,
          layer: a.layer,
          layerIndex: a.layerIndex,
          rotation: a.rotation,
          immutable: a.immutable,
          productOverlay: this.configuration.type === M.ProductOverlay ? !0 : void 0,
          excludeFromExport: this.configuration.data.excludeFromPrint
        };
        return {
          regionElement: {
            id: w.id,
            region: a
          },
          command: new L(w, n)
        };
      }
    }, this.configuration = e, this.layouts = t, this.product = A || void 0;
  }
  async trigger() {
    if (!this.configuration.data.regions)
      throw new Ue(this.configuration, "Missing regions.");
    if (this.configuration.type === M.SilentIllustration) {
      const e = this.configuration.data.regions.map(this.processRegion);
      return Promise.all(e);
    } else
      return this.configuration.type === M.ProductOverlay ? Promise.all(
        this.configuration.data.regions.map((e) => {
          if (!this.layouts.find((A) => e.panelId === A.panelId))
            throw new z(e);
          return this.processRegion(e);
        })
      ) : Promise.reject("Unknown silent step. This is a bug");
  }
  evaluateAssetType() {
    var t, A, a;
    const e = this.configuration.type === M.ProductOverlay && ((t = this.product) != null && t.overlayImageUrl) ? this.product.overlayImageUrl.toLowerCase() : (a = (A = this.configuration.data.asset) == null ? void 0 : A.fileLink) == null ? void 0 : a.toLowerCase().split("?")[0];
    return e != null && e.startsWith("data:image/png") || e != null && e.endsWith(".jpeg") || e != null && e.endsWith(".jpg") || e != null && e.endsWith(".png") ? G.Image : e != null && e.endsWith(".svg") || e != null && e.startsWith("image/svg+xml") ? G.Illustration : G.Illustration;
  }
}
const qa = async (g) => {
  const e = `${q.getServicesApiUrl()}/shortener`;
  try {
    return (await (await fetch(e, {
      method: "POST",
      body: JSON.stringify({ longUrl: g }),
      headers: {
        "Content-Type": "application/json"
      }
    })).json()).shortUrl;
  } catch (t) {
    throw console.error(t), new je("Failed to shorten URL, see console.");
  }
};
class CA {
  async poll() {
    try {
      if (await this.predicate()) {
        this.onSuccess(), this.pollingId > -1 && window.clearInterval(this.pollingId);
        return;
      }
    } catch {
    }
    this.attempts += 1, this.attempts < this.maxAttempts ? this.pollingId = window.setTimeout(this.poll.bind(this), this.interval) : this.onFailure();
  }
  /**
   * Constructs a new polling service.
   * @param predicate An async function that returns true when polling has returned a successful result.
   * @param onSuccess The callback to be called when polling has returned a successful result.
   * @param onFailure The callback to be called when polling has returned a failed result.
   * @param interval The number of milliseconds to wait between each poll.
   * @param maxAttempts The maximum amount of times to check the condition.
   */
  constructor(e, t, A, a = 3e3, n = 10) {
    this.onSuccess = t, this.onFailure = A, this.predicate = e, this.attempts = 0, this.pollingId = -1, this.interval = a, this.maxAttempts = n, this.poll();
  }
}
class Za {
  async init(e, t, A) {
    return A && await this.reload(e, t, A), null;
  }
  async reload(e, t, A) {
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), o = Object.values(A.layouts).map((r) => r.elements).flat().filter((r) => r.stepName === e.stepName).map((r) => ({ id: r.id, region: r.stepRegion }));
    await t.setSelectionsAndElements(e.stepName, [], o, async () => {
      var B, l;
      const r = (B = a == null ? void 0 : a.storage) == null ? void 0 : B.videoShortUrl, c = (l = a == null ? void 0 : a.storage) == null ? void 0 : l.videoUrl;
      t.updateStorage(e.stepName, {
        videoShortUrl: r,
        videoUrl: c
      });
    });
  }
  async regenerateQRCode(e, t, A, a) {
    const n = async () => {
      var w, h;
      const d = (await ot([t]))[0], C = (h = (w = d == null ? void 0 : d.versions) == null ? void 0 : w.find((u) => u.name === "mpeg4")) == null ? void 0 : h.link;
      return { asset: d, link: C };
    }, i = await new Promise((d, C) => {
      new CA(
        async () => !!(await n()).link,
        async () => {
          const w = await n();
          if (!w.link || !w.link)
            throw new ue(w.asset);
          d({
            rel: "mpeg4",
            href: w.link
          });
        },
        () => {
          C("Poller timed out with 40 attempts @ 3 second interval");
        },
        3e3,
        40
      );
    });
    e.forEach((d) => A.getCommandDispatcher()(new ne(d.id)));
    const s = a.data.baseUrl.slice(0, 4) === "http" ? "" : "https://", o = new URL(s + a.data.baseUrl);
    o.searchParams.append("video", btoa(JSON.stringify([i]))), o.pathname = o.pathname + (o.pathname.slice(-1) === "/" ? "" : "/");
    const r = o.toString();
    if (r.length >= 2e3)
      throw new je("Cannot create QR code, URL too long.");
    const c = await qa(r);
    if (!a.data || !a.data.regions)
      throw new Ue(a, "Missing regions.");
    const B = await this.regionElements(a), l = await this.command(c, B, A, a.stepName);
    return l && (l.command && A.getCommandDispatcher()(l.command), l.followup && await l.followup()), await A.setSelectionsAndElements(a.stepName, [], B, async () => {
      A.updateStorage(a.stepName, {
        videoShortUrl: c,
        videoUrl: i.href
      });
    }), c;
  }
  async regionElements(e) {
    const t = (A) => ({ id: J(), region: A });
    return e.data.regions.map(t);
  }
  async command(e, t, A, a) {
    const n = A.getLayouts(), s = `data:image/svg+xml;base64,${btoa(await tA(e, { type: "svg" }))}`, o = t.map((r) => {
      const c = r.region, B = n.find((l) => l.panelId === (c == null ? void 0 : c.panelId));
      if (!B && c)
        throw new z(c);
      if (B && !c)
        throw new Error("Region not found");
      if (!B || !c)
        throw new Error("Neither a region or layout found!");
      return new L(
        {
          stepRegion: c,
          stepName: a,
          id: r.id,
          src: s,
          type: G.Image,
          y: c.top,
          x: c.left,
          width: c.width,
          height: c.height,
          rotation: 0
        },
        B
      );
    });
    return { command: new k(o), followup: async () => {
    } };
  }
}
const wA = new Za(), Qe = [
  "Yellow C",
  "Yellow 012 C",
  "Orange 021 C",
  "Warm Red C",
  "Red 032 C",
  "Rubine Red C",
  "Rhodamine Red C",
  "Purple C",
  "Violet C",
  "Blue 072 C",
  "Reflex Blue C",
  "Process Blue C",
  "Green C",
  "Black C",
  "Yellow 0131 C",
  "Red 0331 C",
  "Magenta 0521 C",
  "Violet 0631 C",
  "Blue 0821 C",
  "Green 0921 C",
  "Black 0961 C",
  "801 C",
  "802 C",
  "803 C",
  "804 C",
  "805 C",
  "806 C",
  "807 C",
  "871 C",
  "872 C",
  "873 C",
  "874 C",
  "875 C",
  "876 C",
  "877 C",
  "Medium Yellow C",
  "Bright Orange C",
  "Bright Red C",
  "Strong Red C",
  "Pink C",
  "Medium Purple C",
  "Dark Blue C",
  "Medium Blue C",
  "Bright Green C",
  "Neutral Black C",
  "100 C",
  "101 C",
  "102 C",
  "103 C",
  "104 C",
  "105 C",
  "7401 C",
  "7402 C",
  "7403 C",
  "7404 C",
  "7405 C",
  "7406 C",
  "7407 C",
  "106 C",
  "107 C",
  "108 C",
  "109 C",
  "110 C",
  "111 C",
  "112 C",
  "113 C",
  "114 C",
  "115 C",
  "116 C",
  "117 C",
  "118 C",
  "119 C",
  "127 C",
  "128 C",
  "129 C",
  "130 C",
  "131 C",
  "132 C",
  "133 C",
  "1205 C",
  "1215 C",
  "1225 C",
  "1235 C",
  "1245 C",
  "1255 C",
  "1265 C",
  "120 C",
  "121 C",
  "122 C",
  "123 C",
  "124 C",
  "125 C",
  "126 C",
  "7548 C",
  "7549 C",
  "7550 C",
  "7551 C",
  "7552 C",
  "7553 C",
  "7554 C",
  "7555 C",
  "7556 C",
  "7557 C",
  "7558 C",
  "7559 C",
  "7560 C",
  "7561 C",
  "134 C",
  "135 C",
  "136 C",
  "137 C",
  "138 C",
  "139 C",
  "140 C",
  "1345 C",
  "1355 C",
  "1365 C",
  "1375 C",
  "1385 C",
  "1395 C",
  "1405 C",
  "141 C",
  "142 C",
  "143 C",
  "144 C",
  "145 C",
  "146 C",
  "147 C",
  "7408 C",
  "7409 C",
  "7410 C",
  "7411 C",
  "7412 C",
  "7413 C",
  "7414 C",
  "7562 C",
  "7563 C",
  "7564 C",
  "7565 C",
  "7566 C",
  "7567 C",
  "7568 C",
  "7569 C",
  "7570 C",
  "7571 C",
  "7572 C",
  "7573 C",
  "7574 C",
  "7575 C",
  "712 C",
  "713 C",
  "714 C",
  "715 C",
  "716 C",
  "717 C",
  "718 C",
  "148 C",
  "149 C",
  "150 C",
  "151 C",
  "152 C",
  "153 C",
  "154 C",
  "155 C",
  "156 C",
  "157 C",
  "158 C",
  "159 C",
  "160 C",
  "161 C",
  "1485 C",
  "1495 C",
  "1505 C",
  "1525 C",
  "1535 C",
  "1545 C",
  "1555 C",
  "1565 C",
  "1575 C",
  "1585 C",
  "1595 C",
  "1605 C",
  "1615 C",
  "162 C",
  "163 C",
  "164 C",
  "165 C",
  "166 C",
  "167 C",
  "168 C",
  "7576 C",
  "7577 C",
  "7578 C",
  "7579 C",
  "7580 C",
  "7581 C",
  "7582 C",
  "1625 C",
  "1635 C",
  "1645 C",
  "1655 C",
  "1665 C",
  "1675 C",
  "1685 C",
  "169 C",
  "170 C",
  "171 C",
  "172 C",
  "173 C",
  "174 C",
  "175 C",
  "7583 C",
  "7584 C",
  "7585 C",
  "7586 C",
  "7587 C",
  "7588 C",
  "7589 C",
  "7590 C",
  "7591 C",
  "7592 C",
  "7593 C",
  "7594 C",
  "7595 C",
  "7596 C",
  "7597 C",
  "7598 C",
  "7599 C",
  "7600 C",
  "7601 C",
  "7602 C",
  "7603 C",
  "7604 C",
  "7605 C",
  "7606 C",
  "7607 C",
  "7608 C",
  "7609 C",
  "7610 C",
  "7611 C",
  "7612 C",
  "7613 C",
  "7614 C",
  "7615 C",
  "7616 C",
  "7617 C",
  "7520 C",
  "7521 C",
  "7522 C",
  "7523 C",
  "7524 C",
  "7525 C",
  "7526 C",
  "489 C",
  "488 C",
  "487 C",
  "486 C",
  "485 C",
  "484 C",
  "483 C",
  "176 C",
  "177 C",
  "178 C",
  "179 C",
  "180 C",
  "181 C",
  "1765 C",
  "1775 C",
  "1785 C",
  "1788 C",
  "1795 C",
  "1805 C",
  "1815 C",
  "1767 C",
  "1777 C",
  "1787 C",
  "1797 C",
  "1807 C",
  "1817 C",
  "7618 C",
  "7619 C",
  "7620 C",
  "7621 C",
  "7622 C",
  "7623 C",
  "7624 C",
  "7625 C",
  "7626 C",
  "7627 C",
  "7628 C",
  "7629 C",
  "7630 C",
  "7631 C",
  "7415 C",
  "7416 C",
  "7417 C",
  "7418 C",
  "7419 C",
  "7420 C",
  "7421 C",
  "182 C",
  "183 C",
  "184 C",
  "185 C",
  "186 C",
  "187 C",
  "188 C",
  "196 C",
  "197 C",
  "198 C",
  "199 C",
  "200 C",
  "201 C",
  "202 C",
  "189 C",
  "190 C",
  "191 C",
  "192 C",
  "193 C",
  "194 C",
  "195 C",
  "1895 C",
  "1905 C",
  "1915 C",
  "1925 C",
  "1935 C",
  "1945 C",
  "1955 C",
  "705 C",
  "706 C",
  "707 C",
  "708 C",
  "709 C",
  "710 C",
  "711 C",
  "698 C",
  "699 C",
  "700 C",
  "701 C",
  "702 C",
  "703 C",
  "704 C",
  "203 C",
  "204 C",
  "205 C",
  "206 C",
  "207 C",
  "208 C",
  "209 C",
  "210 C",
  "211 C",
  "212 C",
  "213 C",
  "214 C",
  "215 C",
  "216 C",
  "7422 C",
  "7423 C",
  "7424 C",
  "7425 C",
  "7426 C",
  "7427 C",
  "7428 C",
  "7632 C",
  "7633 C",
  "7634 C",
  "7635 C",
  "7636 C",
  "7637 C",
  "7638 C",
  "217 C",
  "218 C",
  "219 C",
  "220 C",
  "221 C",
  "222 C",
  "7639 C",
  "7640 C",
  "7641 C",
  "7642 C",
  "7643 C",
  "7644 C",
  "7645 C",
  "223 C",
  "224 C",
  "225 C",
  "226 C",
  "227 C",
  "228 C",
  "229 C",
  "230 C",
  "231 C",
  "232 C",
  "233 C",
  "234 C",
  "235 C",
  "670 C",
  "671 C",
  "672 C",
  "673 C",
  "674 C",
  "675 C",
  "676 C",
  "677 C",
  "678 C",
  "679 C",
  "680 C",
  "681 C",
  "682 C",
  "683 C",
  "684 C",
  "685 C",
  "686 C",
  "687 C",
  "688 C",
  "689 C",
  "690 C",
  "510 C",
  "509 C",
  "508 C",
  "507 C",
  "506 C",
  "505 C",
  "504 C",
  "7429 C",
  "7430 C",
  "7431 C",
  "7432 C",
  "7433 C",
  "7434 C",
  "7435 C",
  "691 C",
  "692 C",
  "693 C",
  "694 C",
  "695 C",
  "696 C",
  "697 C",
  "496 C",
  "495 C",
  "494 C",
  "493 C",
  "492 C",
  "491 C",
  "490 C",
  "503 C",
  "502 C",
  "501 C",
  "500 C",
  "499 C",
  "498 C",
  "497 C",
  "5035 C",
  "5025 C",
  "5015 C",
  "5005 C",
  "4995 C",
  "4985 C",
  "4975 C",
  "236 C",
  "237 C",
  "238 C",
  "239 C",
  "240 C",
  "241 C",
  "242 C",
  "2365 C",
  "2375 C",
  "2385 C",
  "2395 C",
  "2405 C",
  "2415 C",
  "2425 C",
  "243 C",
  "244 C",
  "245 C",
  "246 C",
  "247 C",
  "248 C",
  "249 C",
  "7646 C",
  "7647 C",
  "7648 C",
  "7649 C",
  "7650 C",
  "7651 C",
  "7652 C",
  "250 C",
  "251 C",
  "252 C",
  "253 C",
  "254 C",
  "255 C",
  "517 C",
  "516 C",
  "515 C",
  "514 C",
  "513 C",
  "512 C",
  "511 C",
  "7436 C",
  "7437 C",
  "7438 C",
  "7439 C",
  "7440 C",
  "7441 C",
  "7442 C",
  "2562 C",
  "2572 C",
  "2582 C",
  "2592 C",
  "2602 C",
  "2612 C",
  "2622 C",
  "7653 C",
  "7654 C",
  "7655 C",
  "7656 C",
  "7657 C",
  "7658 C",
  "7659 C",
  "524 C",
  "523 C",
  "522 C",
  "521 C",
  "520 C",
  "519 C",
  "518 C",
  "5245 C",
  "5235 C",
  "5225 C",
  "5215 C",
  "5205 C",
  "5195 C",
  "5185 C",
  "5175 C",
  "5165 C",
  "5155 C",
  "5145 C",
  "5135 C",
  "5125 C",
  "5115 C",
  "531 C",
  "530 C",
  "529 C",
  "528 C",
  "527 C",
  "526 C",
  "525 C",
  "256 C",
  "257 C",
  "258 C",
  "259 C",
  "260 C",
  "261 C",
  "262 C",
  "2563 C",
  "2573 C",
  "2583 C",
  "2593 C",
  "2603 C",
  "2613 C",
  "2623 C",
  "7660 C",
  "7661 C",
  "7662 C",
  "7663 C",
  "7664 C",
  "7665 C",
  "7666 C",
  "2567 C",
  "2577 C",
  "2587 C",
  "2597 C",
  "2607 C",
  "2617 C",
  "2627 C",
  "263 C",
  "264 C",
  "265 C",
  "266 C",
  "267 C",
  "268 C",
  "269 C",
  "2635 C",
  "2645 C",
  "2655 C",
  "2665 C",
  "2685 C",
  "2695 C",
  "270 C",
  "271 C",
  "272 C",
  "273 C",
  "274 C",
  "275 C",
  "276 C",
  "2705 C",
  "2715 C",
  "2725 C",
  "2735 C",
  "2745 C",
  "2755 C",
  "2765 C",
  "7667 C",
  "7668 C",
  "7669 C",
  "7670 C",
  "7671 C",
  "7672 C",
  "7673 C",
  "7443 C",
  "7444 C",
  "7445 C",
  "7446 C",
  "7447 C",
  "7448 C",
  "7449 C",
  "7674 C",
  "7675 C",
  "7676 C",
  "7677 C",
  "7678 C",
  "7679 C",
  "7680 C",
  "663 C",
  "664 C",
  "665 C",
  "666 C",
  "667 C",
  "668 C",
  "669 C",
  "5315 C",
  "5305 C",
  "5295 C",
  "5285 C",
  "5275 C",
  "5265 C",
  "5255 C",
  "538 C",
  "537 C",
  "536 C",
  "535 C",
  "534 C",
  "533 C",
  "532 C",
  "7541 C",
  "7542 C",
  "7543 C",
  "7544 C",
  "7545 C",
  "7546 C",
  "7547 C",
  "552 C",
  "551 C",
  "550 C",
  "549 C",
  "548 C",
  "547 C",
  "546 C",
  "5455 C",
  "5445 C",
  "5435 C",
  "5425 C",
  "5415 C",
  "5405 C",
  "5395 C",
  "642 C",
  "643 C",
  "644 C",
  "645 C",
  "646 C",
  "647 C",
  "648 C",
  "649 C",
  "650 C",
  "651 C",
  "652 C",
  "653 C",
  "654 C",
  "655 C",
  "656 C",
  "657 C",
  "658 C",
  "659 C",
  "660 C",
  "661 C",
  "662 C",
  "7450 C",
  "7451 C",
  "7452 C",
  "7453 C",
  "7454 C",
  "7455 C",
  "7456 C",
  "2706 C",
  "2716 C",
  "2726 C",
  "2736 C",
  "2746 C",
  "2756 C",
  "2766 C",
  "2708 C",
  "2718 C",
  "2728 C",
  "2738 C",
  "2748 C",
  "2758 C",
  "2768 C",
  "2707 C",
  "2717 C",
  "2727 C",
  "2747 C",
  "2757 C",
  "2767 C",
  "277 C",
  "278 C",
  "279 C",
  "280 C",
  "281 C",
  "282 C",
  "283 C",
  "284 C",
  "285 C",
  "286 C",
  "287 C",
  "288 C",
  "289 C",
  "7681 C",
  "7682 C",
  "7683 C",
  "7684 C",
  "7685 C",
  "7686 C",
  "7687 C",
  "545 C",
  "544 C",
  "543 C",
  "542 C",
  "541 C",
  "540 C",
  "539 C",
  "290 C",
  "291 C",
  "292 C",
  "293 C",
  "294 C",
  "295 C",
  "296 C",
  "2905 C",
  "2915 C",
  "2925 C",
  "2935 C",
  "2945 C",
  "2955 C",
  "2965 C",
  "297 C",
  "298 C",
  "299 C",
  "300 C",
  "301 C",
  "302 C",
  "303 C",
  "7688 C",
  "7689 C",
  "7690 C",
  "7691 C",
  "7692 C",
  "7693 C",
  "7694 C",
  "2975 C",
  "2985 C",
  "2995 C",
  "3005 C",
  "3015 C",
  "3025 C",
  "3035 C",
  "7695 C",
  "7696 C",
  "7697 C",
  "7698 C",
  "7699 C",
  "7700 C",
  "7701 C",
  "7457 C",
  "7458 C",
  "7459 C",
  "7460 C",
  "7461 C",
  "7462 C",
  "7463 C",
  "304 C",
  "305 C",
  "306 C",
  "307 C",
  "308 C",
  "309 C",
  "635 C",
  "636 C",
  "637 C",
  "638 C",
  "639 C",
  "640 C",
  "641 C",
  "7702 C",
  "7703 C",
  "7704 C",
  "7705 C",
  "7706 C",
  "7707 C",
  "7708 C",
  "628 C",
  "629 C",
  "630 C",
  "631 C",
  "632 C",
  "633 C",
  "634 C",
  "310 C",
  "311 C",
  "312 C",
  "313 C",
  "314 C",
  "315 C",
  "316 C",
  "3105 C",
  "3115 C",
  "3125 C",
  "3135 C",
  "3145 C",
  "3155 C",
  "3165 C",
  "7709 C",
  "7710 C",
  "7711 C",
  "7712 C",
  "7713 C",
  "7714 C",
  "7715 C",
  "317 C",
  "318 C",
  "319 C",
  "320 C",
  "321 C",
  "322 C",
  "323 C",
  "7464 C",
  "7465 C",
  "7466 C",
  "7467 C",
  "7468 C",
  "7469 C",
  "7470 C",
  "7471 C",
  "7472 C",
  "7473 C",
  "7474 C",
  "7475 C",
  "7476 C",
  "7477 C",
  "5523 C",
  "5513 C",
  "5503 C",
  "5493 C",
  "5483 C",
  "5473 C",
  "5463 C",
  "7716 C",
  "7717 C",
  "7718 C",
  "7719 C",
  "7720 C",
  "7721 C",
  "7722 C",
  "324 C",
  "325 C",
  "326 C",
  "327 C",
  "328 C",
  "329 C",
  "330 C",
  "3242 C",
  "3252 C",
  "3262 C",
  "3272 C",
  "3282 C",
  "3292 C",
  "3302 C",
  "3245 C",
  "3255 C",
  "3265 C",
  "3275 C",
  "3285 C",
  "3295 C",
  "3305 C",
  "3248 C",
  "3258 C",
  "3268 C",
  "3278 C",
  "3288 C",
  "3298 C",
  "3308 C",
  "566 C",
  "565 C",
  "564 C",
  "563 C",
  "562 C",
  "561 C",
  "560 C",
  "573 C",
  "572 C",
  "571 C",
  "570 C",
  "569 C",
  "568 C",
  "567 C",
  "559 C",
  "558 C",
  "557 C",
  "556 C",
  "555 C",
  "554 C",
  "553 C",
  "5595 C",
  "5585 C",
  "5575 C",
  "5565 C",
  "5555 C",
  "5545 C",
  "5535 C",
  "5665 C",
  "5655 C",
  "5645 C",
  "5635 C",
  "5625 C",
  "5615 C",
  "5605 C",
  "5527 C",
  "5517 C",
  "5507 C",
  "5497 C",
  "5487 C",
  "5477 C",
  "5467 C",
  "621 C",
  "622 C",
  "623 C",
  "624 C",
  "625 C",
  "626 C",
  "627 C",
  "331 C",
  "332 C",
  "333 C",
  "334 C",
  "335 C",
  "336 C",
  "337 C",
  "338 C",
  "339 C",
  "340 C",
  "341 C",
  "342 C",
  "343 C",
  "7723 C",
  "7724 C",
  "7725 C",
  "7726 C",
  "7727 C",
  "7728 C",
  "7729 C",
  "3375 C",
  "3385 C",
  "3395 C",
  "3405 C",
  "3415 C",
  "3425 C",
  "3435 C",
  "344 C",
  "345 C",
  "346 C",
  "347 C",
  "348 C",
  "349 C",
  "350 C",
  "351 C",
  "352 C",
  "353 C",
  "354 C",
  "355 C",
  "356 C",
  "357 C",
  "7478 C",
  "7479 C",
  "7480 C",
  "7481 C",
  "7482 C",
  "7483 C",
  "7484 C",
  "7730 C",
  "7731 C",
  "7732 C",
  "7733 C",
  "7734 C",
  "7735 C",
  "7736 C",
  "7737 C",
  "7738 C",
  "7739 C",
  "7740 C",
  "7741 C",
  "7742 C",
  "7743 C",
  "358 C",
  "359 C",
  "360 C",
  "361 C",
  "362 C",
  "363 C",
  "364 C",
  "7485 C",
  "7486 C",
  "7487 C",
  "7488 C",
  "7489 C",
  "7490 C",
  "7491 C",
  "365 C",
  "366 C",
  "367 C",
  "368 C",
  "369 C",
  "370 C",
  "371 C",
  "372 C",
  "373 C",
  "374 C",
  "375 C",
  "376 C",
  "377 C",
  "378 C",
  "580 C",
  "579 C",
  "578 C",
  "577 C",
  "576 C",
  "575 C",
  "574 C",
  "5807 C",
  "5797 C",
  "5787 C",
  "5777 C",
  "5767 C",
  "5757 C",
  "5747 C",
  "5875 C",
  "5865 C",
  "5855 C",
  "5845 C",
  "5835 C",
  "5825 C",
  "5815 C",
  "5803 C",
  "5793 C",
  "5783 C",
  "5773 C",
  "5763 C",
  "5753 C",
  "5743 C",
  "7492 C",
  "7493 C",
  "7494 C",
  "7495 C",
  "7496 C",
  "7497 C",
  "7498 C",
  "7744 C",
  "7745 C",
  "7746 C",
  "7747 C",
  "7748 C",
  "7749 C",
  "7750 C",
  "379 C",
  "380 C",
  "381 C",
  "382 C",
  "383 C",
  "384 C",
  "385 C",
  "386 C",
  "387 C",
  "388 C",
  "389 C",
  "390 C",
  "391 C",
  "392 C",
  "587 C",
  "586 C",
  "585 C",
  "584 C",
  "583 C",
  "582 C",
  "581 C",
  "393 C",
  "394 C",
  "395 C",
  "396 C",
  "397 C",
  "398 C",
  "399 C",
  "3935 C",
  "3945 C",
  "3955 C",
  "3965 C",
  "3975 C",
  "3985 C",
  "3995 C",
  "600 C",
  "601 C",
  "602 C",
  "603 C",
  "604 C",
  "605 C",
  "606 C",
  "607 C",
  "608 C",
  "609 C",
  "610 C",
  "611 C",
  "612 C",
  "613 C",
  "461 C",
  "460 C",
  "459 C",
  "458 C",
  "457 C",
  "456 C",
  "455 C",
  "614 C",
  "615 C",
  "616 C",
  "617 C",
  "618 C",
  "619 C",
  "620 C",
  "7751 C",
  "7752 C",
  "7753 C",
  "7754 C",
  "7755 C",
  "7756 C",
  "7757 C",
  "7758 C",
  "7759 C",
  "7760 C",
  "7761 C",
  "7762 C",
  "7763 C",
  "7764 C",
  "7765 C",
  "7766 C",
  "7767 C",
  "7768 C",
  "7769 C",
  "7770 C",
  "7771 C",
  "4545 C",
  "4535 C",
  "4525 C",
  "4515 C",
  "4505 C",
  "4495 C",
  "4485 C",
  "454 C",
  "453 C",
  "452 C",
  "451 C",
  "450 C",
  "449 C",
  "448 C",
  "7499 C",
  "7500 C",
  "7501 C",
  "7502 C",
  "7503 C",
  "7504 C",
  "7505 C",
  "468 C",
  "467 C",
  "466 C",
  "465 C",
  "464 C",
  "463 C",
  "462 C",
  "7506 C",
  "7507 C",
  "7508 C",
  "7509 C",
  "7510 C",
  "7511 C",
  "7512 C",
  "719 C",
  "720 C",
  "721 C",
  "722 C",
  "723 C",
  "724 C",
  "725 C",
  "475 C",
  "474 C",
  "473 C",
  "472 C",
  "471 C",
  "470 C",
  "469 C",
  "726 C",
  "727 C",
  "728 C",
  "729 C",
  "730 C",
  "731 C",
  "732 C",
  "4685 C",
  "4675 C",
  "4665 C",
  "4655 C",
  "4645 C",
  "4635 C",
  "4625 C",
  "7513 C",
  "7514 C",
  "7515 C",
  "7516 C",
  "7517 C",
  "7518 C",
  "7519 C",
  "4755 C",
  "4745 C",
  "4735 C",
  "4725 C",
  "4715 C",
  "4705 C",
  "4695 C",
  "482 C",
  "481 C",
  "480 C",
  "479 C",
  "478 C",
  "477 C",
  "476 C",
  "7527 C",
  "7528 C",
  "7529 C",
  "7530 C",
  "7531 C",
  "7532 C",
  "7533 C",
  "7534 C",
  "7535 C",
  "7536 C",
  "7537 C",
  "7538 C",
  "7539 C",
  "7540 C",
  "427 C",
  "428 C",
  "429 C",
  "430 C",
  "431 C",
  "432 C",
  "433 C",
  "420 C",
  "421 C",
  "422 C",
  "423 C",
  "424 C",
  "425 C",
  "426 C",
  "441 C",
  "442 C",
  "443 C",
  "444 C",
  "445 C",
  "446 C",
  "447 C",
  "413 C",
  "414 C",
  "415 C",
  "416 C",
  "417 C",
  "418 C",
  "419 C",
  "400 C",
  "401 C",
  "402 C",
  "403 C",
  "404 C",
  "405 C",
  "406 C",
  "407 C",
  "408 C",
  "409 C",
  "410 C",
  "411 C",
  "412 C",
  "434 C",
  "435 C",
  "436 C",
  "437 C",
  "438 C",
  "439 C",
  "440 C",
  "Warm Gray 1 C",
  "Warm Gray 2 C",
  "Warm Gray 3 C",
  "Warm Gray 4 C",
  "Warm Gray 5 C",
  "Warm Gray 6 C",
  "Warm Gray 7 C",
  "Warm Gray 8 C",
  "Warm Gray 9 C",
  "Warm Gray 10 C",
  "Warm Gray 11 C",
  "Cool Gray 1 C",
  "Cool Gray 2 C",
  "Cool Gray 3 C",
  "Cool Gray 4 C",
  "Cool Gray 5 C",
  "Cool Gray 6 C",
  "Cool Gray 7 C",
  "Cool Gray 8 C",
  "Cool Gray 9 C",
  "Cool Gray 10 C",
  "Cool Gray 11 C",
  "Black 2 C",
  "Black 3 C",
  "Black 4 C",
  "Black 5 C",
  "Black 6 C",
  "Black 7 C"
], le = [
  "FEDD00",
  "FFD700",
  "FE5000",
  "F9423A",
  "EF3340",
  "CE0058",
  "E10098",
  "BB29BB",
  "440099",
  "10069F",
  "001489",
  "0085CA",
  "00AB84",
  "2D2926",
  "F2F0A1",
  "FCAEBB",
  "F1B2DC",
  "BF9BDE",
  "74D1EA",
  "9DE7D7",
  "9E978E",
  "009ACE",
  "44D62C",
  "FFE900",
  "FFAA4D",
  "FF7276",
  "FF3EB5",
  "EA27C2",
  "84754E",
  "85714D",
  "866D4B",
  "8B6F4E",
  "87674F",
  "8B634B",
  "8A8D8F",
  "FFD900",
  "FF5E00",
  "F93822",
  "CE0056",
  "D62598",
  "4E008E",
  "00239C",
  "0084CA",
  "00B08B",
  "222223",
  "F6EB61",
  "F7EA48",
  "FCE300",
  "C5A900",
  "AF9800",
  "897A27",
  "F5E1A4",
  "ECD898",
  "EED484",
  "F4DA40",
  "F2CD00",
  "F1C400",
  "CBA052",
  "F9E547",
  "FBE122",
  "FEDB00",
  "FFD100",
  "DAAA00",
  "AA8A00",
  "9C8412",
  "FAE053",
  "FBDD40",
  "FDDA24",
  "FFCD00",
  "C99700",
  "AC8400",
  "897322",
  "F3DD6D",
  "F3D54E",
  "F3D03E",
  "F2A900",
  "CC8A00",
  "A07400",
  "6C571B",
  "F8E08E",
  "FBD872",
  "FFC845",
  "FFB81C",
  "C69214",
  "AD841F",
  "886B25",
  "FBDB65",
  "FDD757",
  "FED141",
  "FFC72C",
  "EAAA00",
  "B58500",
  "9A7611",
  "FFC600",
  "FFB500",
  "D19000",
  "B47E00",
  "73531D",
  "5A4522",
  "4B3D2A",
  "D29F13",
  "B78B20",
  "9F7D23",
  "967126",
  "8F6A2A",
  "7D622E",
  "6C5D34",
  "FDD26E",
  "FFC658",
  "FFBF3F",
  "FFA300",
  "DE7C00",
  "AF6D04",
  "74531C",
  "FDD086",
  "FFC56E",
  "FFB549",
  "FF9E1B",
  "D57800",
  "996017",
  "6E4C1E",
  "F2C75C",
  "F1BE48",
  "F1B434",
  "ED8B00",
  "CF7F00",
  "A76D11",
  "715C2A",
  "F6BE00",
  "F0B323",
  "FEAD77",
  "E6A65D",
  "D38235",
  "DC8633",
  "C16C18",
  "BD9B60",
  "D69A2D",
  "DB8A06",
  "CD7925",
  "AD6433",
  "89532F",
  "775135",
  "D78825",
  "D3832B",
  "C67D30",
  "B67233",
  "A7662B",
  "9E6A38",
  "835D32",
  "FCC89B",
  "FDBE87",
  "FDAA63",
  "F68D2E",
  "EA7600",
  "D45D00",
  "BE4D00",
  "FECB8B",
  "FFC27B",
  "FFB25B",
  "FF8200",
  "E57200",
  "BE6A14",
  "9B5A1A",
  "EFD19F",
  "EFBE7D",
  "ECA154",
  "E87722",
  "CB6015",
  "A1561C",
  "603D20",
  "FFAE62",
  "FF8F1C",
  "FF6900",
  "B94700",
  "94450B",
  "653819",
  "FFB990",
  "FFA06A",
  "FF7F32",
  "FF6A13",
  "D86018",
  "A65523",
  "8B4720",
  "FFBE9F",
  "FF9D6E",
  "FF7F41",
  "FF671F",
  "E35205",
  "BE531C",
  "73381D",
  "DB864E",
  "E07E3C",
  "DC6B2F",
  "DC582A",
  "C05131",
  "864A33",
  "674736",
  "FFA38B",
  "FF8D6D",
  "FF6A39",
  "FC4C02",
  "DC4405",
  "A9431E",
  "833921",
  "FFB3AB",
  "FF8674",
  "FF5C39",
  "FA4616",
  "CF4520",
  "963821",
  "6B3529",
  "C4622D",
  "BA5826",
  "AF5C37",
  "9E5330",
  "924C2E",
  "7B4D35",
  "5C4738",
  "D4B59E",
  "C07D59",
  "B15533",
  "9D432C",
  "7C3A2D",
  "6B3D2E",
  "5C3D31",
  "D14124",
  "BD472A",
  "B33D26",
  "8D3F2B",
  "83412C",
  "7B4931",
  "674230",
  "E4D5D3",
  "E1BBB4",
  "D6938A",
  "C26E60",
  "A4493D",
  "823B34",
  "683431",
  "DDBCB0",
  "CA9A8E",
  "BC8A7E",
  "A37F74",
  "866761",
  "6B4C4C",
  "583D3E",
  "EABEB0",
  "C09C83",
  "B46A55",
  "AB5C57",
  "A45248",
  "9A6A4F",
  "8A391B",
  "ECC3B2",
  "ECBAA8",
  "EAA794",
  "E8927C",
  "DA291C",
  "9A3324",
  "653024",
  "FFB1BB",
  "FF808B",
  "FF585D",
  "E03C31",
  "BE3A34",
  "81312F",
  "FFA3B5",
  "FF8DA1",
  "F8485E",
  "EE2737",
  "D22630",
  "AF272F",
  "7C2529",
  "FCAFC0",
  "FB637E",
  "F4364C",
  "CB333B",
  "A4343A",
  "643335",
  "C66E4E",
  "C04C36",
  "B7312C",
  "AB2328",
  "93272C",
  "8A2A2B",
  "802F2D",
  "E1523D",
  "C63527",
  "A72B2A",
  "9E2A2B",
  "6D3332",
  "633231",
  "572D2D",
  "E6BAA8",
  "E56A54",
  "E04E39",
  "CD545B",
  "B04A5A",
  "9B2242",
  "651D32",
  "FABBCB",
  "FC9BB3",
  "F65275",
  "E4002B",
  "C8102E",
  "A6192E",
  "76232F",
  "ECC7CD",
  "E89CAE",
  "DF4661",
  "D50032",
  "BA0C2F",
  "9D2235",
  "862633",
  "F8A3BC",
  "F67599",
  "EF426F",
  "E40046",
  "BF0D3E",
  "9B2743",
  "782F40",
  "F5B6CD",
  "F59BBB",
  "EF4A81",
  "E0004D",
  "C5003E",
  "A6093D",
  "8A1538",
  "F5DADF",
  "F7CED7",
  "F9B5C4",
  "F890A5",
  "EF6079",
  "E03E52",
  "CB2C30",
  "F2D4D7",
  "F4C3CC",
  "F2ACB9",
  "E68699",
  "D25B73",
  "B83A4B",
  "9E2A2F",
  "ECB3CB",
  "E782A9",
  "E0457B",
  "CE0037",
  "A50034",
  "861F41",
  "6F263D",
  "F99FC9",
  "F57EB6",
  "F04E98",
  "E31C79",
  "CE0F69",
  "AC145A",
  "7D2248",
  "F4CDD4",
  "E06287",
  "E24585",
  "B52555",
  "A4123F",
  "971B2F",
  "6A2C3E",
  "D6C9CA",
  "C4A4A7",
  "C16784",
  "C63663",
  "BC204B",
  "912F46",
  "7E2D40",
  "EABEDB",
  "E56DB1",
  "DA1884",
  "A50050",
  "910048",
  "6C1D45",
  "936D73",
  "934054",
  "8E2C48",
  "732E4A",
  "672E45",
  "582D40",
  "502B3A",
  "EF95CF",
  "EB6FBD",
  "DF1995",
  "D0006F",
  "AA0061",
  "890C58",
  "672146",
  "F4A6D7",
  "F277C6",
  "E93CAC",
  "C6007E",
  "A20067",
  "840B55",
  "EAD3E2",
  "E6BCD8",
  "DFA0C9",
  "D986BA",
  "C6579A",
  "AE2573",
  "960051",
  "E5CEDB",
  "E3C8D8",
  "DEBED2",
  "C996B6",
  "B06C96",
  "994878",
  "7C2855",
  "E4C6D4",
  "DCB6C9",
  "D0A1BA",
  "BE84A3",
  "A76389",
  "893B67",
  "612141",
  "EBBECB",
  "E8B3C3",
  "E4A9BB",
  "D592AA",
  "84344E",
  "6F2C3F",
  "572932",
  "E2BCCB",
  "DCA9BF",
  "C9809E",
  "B55C80",
  "A73A64",
  "9B3259",
  "872651",
  "E9CDD0",
  "E4BEC3",
  "D7A3AB",
  "C48490",
  "B46B7A",
  "984856",
  "893C47",
  "F2C6CF",
  "F1BDC8",
  "E9A2B2",
  "DC8699",
  "8F3237",
  "7F3035",
  "5D2A2C",
  "E9C4C7",
  "E5BAC1",
  "DAA5AD",
  "C6858F",
  "7A3E3A",
  "6A3735",
  "512F2E",
  "DFC2C3",
  "DBB7BB",
  "CCA1A6",
  "B07C83",
  "9C6169",
  "874B52",
  "3F2021",
  "F1A7DC",
  "EC86D0",
  "E45DBF",
  "DB3EB1",
  "C5299B",
  "AF1685",
  "80225F",
  "EFBAE1",
  "E277CD",
  "D539B5",
  "C800A1",
  "B0008E",
  "9E007E",
  "830065",
  "EAB8E4",
  "E59BDC",
  "DD7FD3",
  "C724B1",
  "BB16A3",
  "A51890",
  "80276C",
  "A56E87",
  "A83D72",
  "991E66",
  "8A1B61",
  "722257",
  "6A2A5B",
  "5E2751",
  "E7BAE4",
  "DD9CDF",
  "C964CF",
  "AD1AAC",
  "981D97",
  "72246C",
  "EBC6DF",
  "E6BEDD",
  "E2ACD7",
  "D48BC8",
  "93328E",
  "833177",
  "612C51",
  "EEDAEA",
  "CCAED0",
  "D59ED7",
  "B288B9",
  "A277A6",
  "9F5CC0",
  "963CBD",
  "D7A9E3",
  "C98BDB",
  "AC4FC6",
  "9B26B6",
  "87189D",
  "772583",
  "653165",
  "948794",
  "A2789C",
  "A15A95",
  "8E3A80",
  "6E2B62",
  "6A3460",
  "5D3754",
  "D5C2D8",
  "C9B1D0",
  "BA9CC5",
  "A57FB2",
  "642F6C",
  "59315F",
  "4B3048",
  "DBCDD3",
  "D0BEC7",
  "C6B0BC",
  "AF95A6",
  "86647A",
  "66435A",
  "4A3041",
  "D8C8D1",
  "D3C0CD",
  "BFA5B8",
  "9B7793",
  "7E5475",
  "693C5E",
  "512A44",
  "DFC8E7",
  "D7B9E4",
  "CAA2DD",
  "B580D1",
  "8031A7",
  "702F8A",
  "572C5F",
  "D6BFDD",
  "C6A1CF",
  "8C4799",
  "6D2077",
  "642667",
  "5D285F",
  "51284F",
  "CBA3D8",
  "B884CB",
  "A05EB5",
  "84329B",
  "702082",
  "671E75",
  "5F2167",
  "9991A4",
  "8D6E97",
  "7A4183",
  "6B3077",
  "653279",
  "5E366E",
  "5C4E63",
  "C1A0DA",
  "A77BCA",
  "8246AF",
  "5C068C",
  "500778",
  "470A68",
  "3C1053",
  "D7C6E6",
  "C1A7E2",
  "9063CD",
  "753BBD",
  "5F259F",
  "582C83",
  "512D6D",
  "C5B4E3",
  "AD96DC",
  "9678D3",
  "7D55C7",
  "330072",
  "2E1A47",
  "B4B5DF",
  "9595D2",
  "7474C1",
  "24135F",
  "211551",
  "201747",
  "221C35",
  "A7A4E0",
  "8B84D7",
  "685BC7",
  "2E008B",
  "280071",
  "250E62",
  "201547",
  "6E7CA0",
  "686E9F",
  "615E9B",
  "565294",
  "514689",
  "4C4184",
  "535486",
  "DDDAE8",
  "B6B8DC",
  "A7A2C3",
  "8986CA",
  "5D4777",
  "4B384C",
  "41273B",
  "878CB4",
  "7C7FAB",
  "7566A0",
  "6F5091",
  "68478D",
  "563D82",
  "523178",
  "E5E1E6",
  "E0DBE3",
  "C6BCD0",
  "A192B2",
  "7C6992",
  "614B79",
  "3F2A56",
  "D8D7DF",
  "C6C4D2",
  "B3B0C4",
  "8D89A5",
  "595478",
  "403A60",
  "1E1A34",
  "C5CFDA",
  "BBC7D6",
  "A2B2C8",
  "8E9FBC",
  "1B365D",
  "1F2A44",
  "1C1F2A",
  "D9E1E2",
  "A4BCC2",
  "98A4AE",
  "768692",
  "425563",
  "253746",
  "131E29",
  "B9D3DC",
  "A3C7D2",
  "8DB9CA",
  "6BA4B8",
  "003D4C",
  "00313C",
  "072B31",
  "BFCED6",
  "B7C9D3",
  "A6BBC8",
  "7A99AC",
  "5B7F95",
  "4F758B",
  "081F2C",
  "D1DDE6",
  "C6D6E3",
  "9BB8D3",
  "7DA1C4",
  "5E8AB4",
  "236192",
  "002E5D",
  "DBE2E9",
  "CED9E5",
  "A7BCD6",
  "7D9BC1",
  "326295",
  "003A70",
  "002554",
  "DDE5ED",
  "C8D8EB",
  "B1C9E8",
  "7BA4DB",
  "407EC9",
  "003594",
  "001A70",
  "BDC5DB",
  "89ABE3",
  "8094DD",
  "7BA6DE",
  "5F8FB4",
  "3A5DAE",
  "606EB2",
  "CBD3EB",
  "9FAEE5",
  "485CC7",
  "1E22AA",
  "171C8F",
  "151F6D",
  "141B4D",
  "B8CCEA",
  "5C88DA",
  "0047BB",
  "06038D",
  "001871",
  "001E62",
  "071D49",
  "C3D7EE",
  "A7C6ED",
  "307FE2",
  "001A72",
  "001E60",
  "13294B",
  "ABCAE9",
  "8BB8E8",
  "418FDE",
  "012169",
  "00205B",
  "041E42",
  "92C1E9",
  "6CACE4",
  "0072CE",
  "0033A0",
  "003087",
  "002D72",
  "0C2340",
  "94A9CB",
  "6787B7",
  "426DA9",
  "385E9D",
  "2C5697",
  "1D4F91",
  "1D428A",
  "C6DAE7",
  "BDD6E6",
  "A4C8E1",
  "7BAFD4",
  "003C71",
  "003057",
  "00263A",
  "B9D9EB",
  "9BCBEB",
  "69B3E7",
  "003DA5",
  "002F6C",
  "002855",
  "041C2C",
  "8DC8E8",
  "62B5E5",
  "009CDE",
  "0057B8",
  "004C97",
  "003865",
  "00263E",
  "71C5E8",
  "41B6E6",
  "00A3E0",
  "005EB8",
  "004B87",
  "003B5C",
  "002A3A",
  "4698CB",
  "298FC2",
  "0076A8",
  "006298",
  "005587",
  "004976",
  "01426A",
  "99D6EA",
  "5BC2E7",
  "00A9E0",
  "0077C8",
  "00629B",
  "004F71",
  "003E51",
  "7BA7BC",
  "6399AE",
  "4E87A0",
  "41748D",
  "34657F",
  "165C7D",
  "005776",
  "BBDDE6",
  "71B2C9",
  "4298B5",
  "0086BF",
  "007DBA",
  "00558C",
  "002B49",
  "9ADBE8",
  "59CBE8",
  "00B5E2",
  "006BA6",
  "00587C",
  "003B49",
  "A4DBE8",
  "8BD3E6",
  "4EC3E0",
  "00AFD7",
  "0095C8",
  "0082BA",
  "0067A0",
  "48A9C5",
  "009CBD",
  "0085AD",
  "007096",
  "006A8E",
  "00617F",
  "005670",
  "B8DDE1",
  "9BD3DD",
  "77C5D5",
  "3EB1C8",
  "0093B2",
  "007396",
  "005F83",
  "6AD1E3",
  "05C3DE",
  "00A9CE",
  "0092BC",
  "007FA3",
  "00677F",
  "004851",
  "68D2DF",
  "00C1D5",
  "00AEC7",
  "008EAA",
  "00778B",
  "006272",
  "004F59",
  "63B1BC",
  "00A7B5",
  "0097A9",
  "00859B",
  "007D8A",
  "007680",
  "006269",
  "B1E4E3",
  "88DBDF",
  "2DCCD3",
  "009CA6",
  "008C95",
  "007377",
  "005F61",
  "A0D1CA",
  "40C1AC",
  "00B0B9",
  "00A3AD",
  "007398",
  "005F86",
  "005A70",
  "7EDDD3",
  "5CB8B2",
  "279989",
  "007681",
  "487A7B",
  "0D5257",
  "244C5A",
  "B6CFD0",
  "ABC7CA",
  "94B7BB",
  "7FA9AE",
  "4F868E",
  "115E67",
  "07272D",
  "00968F",
  "00857D",
  "007672",
  "006D68",
  "00635B",
  "005E5D",
  "005151",
  "9CDBD9",
  "64CCC9",
  "00B2A9",
  "008675",
  "007367",
  "00685E",
  "00534C",
  "71DBD4",
  "2AD2C9",
  "00BFB3",
  "00A499",
  "008578",
  "00594F",
  "004C45",
  "7CE0D3",
  "2CD5C4",
  "00C7B1",
  "00B398",
  "009681",
  "007864",
  "004E42",
  "6DCDB8",
  "49C5B1",
  "00AB8E",
  "009B77",
  "008264",
  "006A52",
  "034638",
  "B9DCD2",
  "A1D6CA",
  "86C8BC",
  "6BBBAE",
  "006F62",
  "00594C",
  "1D3C34",
  "B5E3D8",
  "A5DFD3",
  "98DBCE",
  "6BCABA",
  "00816D",
  "006C5B",
  "173F35",
  "ADCAB8",
  "9ABEAA",
  "85B09A",
  "6FA287",
  "28724F",
  "205C40",
  "284734",
  "BFCEC2",
  "A7BDB1",
  "92ACA0",
  "7F9C90",
  "5C7F71",
  "43695B",
  "183028",
  "BAC5B9",
  "B0BDB0",
  "A3B2A4",
  "94A596",
  "708573",
  "5E7461",
  "22372B",
  "BCC9C5",
  "B1C0BC",
  "9DB0AC",
  "829995",
  "5D7975",
  "3E5D58",
  "18332F",
  "D1E0D7",
  "B7CDC2",
  "9AB9AD",
  "789F90",
  "507F70",
  "285C4D",
  "13322B",
  "A7E6D7",
  "8CE2D0",
  "3CDBC0",
  "009775",
  "007B5F",
  "00664F",
  "8FD6BD",
  "6ECEB2",
  "00B388",
  "00965E",
  "007A53",
  "006747",
  "115740",
  "50A684",
  "00966C",
  "008755",
  "007B4B",
  "006F44",
  "006845",
  "005844",
  "7AE1BF",
  "47D7AC",
  "00C389",
  "00AF66",
  "007749",
  "006341",
  "154734",
  "A0DAB3",
  "91D6AC",
  "71CC98",
  "009A44",
  "00843D",
  "046A38",
  "2C5234",
  "A2E4B8",
  "8FE2B0",
  "80E0A7",
  "00B140",
  "009639",
  "007A33",
  "215732",
  "9BE3BF",
  "26D07C",
  "00BF6F",
  "00B74F",
  "009F4D",
  "275D38",
  "00573F",
  "4B9560",
  "228848",
  "007A3E",
  "007041",
  "286140",
  "36573B",
  "395542",
  "6BA539",
  "48A23F",
  "319B42",
  "3A913F",
  "44883E",
  "4A773C",
  "44693D",
  "ADDC91",
  "A1D884",
  "6CC24A",
  "43B02A",
  "509E2F",
  "4C8C2B",
  "4A7729",
  "D0DEBB",
  "BCE194",
  "8EDD65",
  "78D64B",
  "74AA50",
  "719949",
  "79863C",
  "C2E189",
  "B7DD79",
  "A4D65E",
  "78BE20",
  "64A70B",
  "658D1B",
  "546223",
  "D4EB8E",
  "CDEA80",
  "C5E86C",
  "97D700",
  "84BD00",
  "7A9A01",
  "59621D",
  "C4D6A4",
  "BCD19B",
  "B7CE95",
  "A9C47F",
  "789D4A",
  "67823A",
  "4E5B31",
  "D0D1AB",
  "C6C89B",
  "BABD8B",
  "A2A569",
  "8A8D4A",
  "6D712E",
  "3D441E",
  "D2CE9E",
  "CBC793",
  "C0BB87",
  "AFA96E",
  "A09958",
  "89813D",
  "555025",
  "C3C6A8",
  "B3B995",
  "A3AA83",
  "899064",
  "737B4C",
  "5E6738",
  "3E4827",
  "BFCC80",
  "BBC592",
  "9CAF88",
  "8F993E",
  "76881D",
  "7A7256",
  "5B6236",
  "BABC16",
  "ABAD23",
  "999B30",
  "888D30",
  "7C8034",
  "727337",
  "656635",
  "E2E868",
  "DBE442",
  "CEDC00",
  "C4D600",
  "A8AD00",
  "949300",
  "787121",
  "E9EC6B",
  "E3E935",
  "E0E721",
  "D0DF00",
  "B5BD00",
  "9A9500",
  "827A04",
  "E3E48D",
  "E0E27C",
  "DBDE70",
  "D2D755",
  "B7BF10",
  "8E8C13",
  "625D20",
  "F0EC74",
  "EDE939",
  "ECE81A",
  "E1E000",
  "BFB800",
  "ADA400",
  "A09200",
  "F3EA5D",
  "F3E500",
  "EFDF00",
  "EEDC00",
  "BBA600",
  "9A8700",
  "685C20",
  "F1EB9C",
  "F0E991",
  "F0E87B",
  "EDE04B",
  "EADA24",
  "E1CD00",
  "CFB500",
  "EBE49A",
  "E9E186",
  "E6DE77",
  "E1D555",
  "D7C826",
  "C4B000",
  "B39B00",
  "E9DF97",
  "E4D77E",
  "DECD63",
  "D9C756",
  "B89D18",
  "A28E2A",
  "695B24",
  "DCD59A",
  "D6CF8D",
  "D0C883",
  "C0B561",
  "AC9F3C",
  "9F912A",
  "8A7B19",
  "CAB64B",
  "CFB023",
  "C1A01E",
  "A08629",
  "897630",
  "736635",
  "675E33",
  "D4C304",
  "C4B200",
  "91852C",
  "747136",
  "5D6439",
  "585C3B",
  "535435",
  "BBB323",
  "B4A91F",
  "AA9D2E",
  "8F7E35",
  "716135",
  "635939",
  "4E4934",
  "D5CB9F",
  "CFC493",
  "C5B783",
  "B3A369",
  "998542",
  "8C7732",
  "614F25",
  "CAC7A7",
  "BFBB98",
  "B0AA7E",
  "9B945F",
  "594A25",
  "524727",
  "4A412A",
  "F1E6B2",
  "DFD1A7",
  "D9C89E",
  "CEB888",
  "A89968",
  "94795D",
  "816040",
  "DDCBA4",
  "D3BC8D",
  "C6AA76",
  "B9975B",
  "8B5B29",
  "744F28",
  "5C462B",
  "EFDBB2",
  "FCD299",
  "E1B87F",
  "D6A461",
  "C6893F",
  "B77729",
  "A6631B",
  "EDC8A3",
  "E7B78A",
  "DDA46F",
  "C88242",
  "B36924",
  "934D11",
  "7D3F16",
  "F3CFB3",
  "F1C6A7",
  "F0BF9B",
  "E59E6D",
  "B86125",
  "A45A2A",
  "693F23",
  "E0C09F",
  "D9B48F",
  "CDA077",
  "B58150",
  "9E652E",
  "774212",
  "623412",
  "E0C6AD",
  "DCBFA6",
  "CDA788",
  "BF9474",
  "AD7C59",
  "946037",
  "4F2C1D",
  "E1B7A7",
  "D5A286",
  "C58B68",
  "99552B",
  "85431E",
  "6D4F47",
  "5E4B3C",
  "D7C4B7",
  "CDB5A7",
  "C0A392",
  "AE8A79",
  "956C58",
  "7C4D3A",
  "5B3427",
  "DBC8B6",
  "D3BBA8",
  "C6A992",
  "AA8066",
  "703F2A",
  "623B2A",
  "4E3629",
  "D6D2C4",
  "C5B9AC",
  "B7A99A",
  "A39382",
  "7A6855",
  "63513D",
  "473729",
  "D1CCBD",
  "B7B09C",
  "A69F88",
  "A7ACA2",
  "949A90",
  "8E9089",
  "4B4F54",
  "D0D3D4",
  "C1C6C8",
  "A2AAAD",
  "7C878E",
  "5B6770",
  "333F48",
  "1D252D",
  "C7C9C7",
  "B2B4B2",
  "9EA2A2",
  "898D8D",
  "707372",
  "54585A",
  "25282A",
  "BEC6C4",
  "A2ACAB",
  "919D9D",
  "717C7D",
  "505759",
  "3F4444",
  "373A36",
  "BABBB1",
  "A8A99E",
  "919388",
  "7E7F74",
  "65665C",
  "51534A",
  "212322",
  "C4BFB6",
  "AFA9A0",
  "9D968D",
  "8C857B",
  "776E64",
  "696158",
  "C4BCB7",
  "B2A8A2",
  "978C87",
  "857874",
  "746661",
  "5E514D",
  "382F2D",
  "D0C4C5",
  "C1B2B6",
  "AB989D",
  "7B6469",
  "584446",
  "453536",
  "382E2C",
  "D7D2CB",
  "CBC4BC",
  "BFB8AF",
  "B6ADA5",
  "ACA39A",
  "A59C94",
  "968C83",
  "8C8279",
  "83786F",
  "796E65",
  "6E6259",
  "D9D9D6",
  "D0D0CE",
  "C8C9C7",
  "BBBCBC",
  "B1B3B3",
  "A7A8AA",
  "97999B",
  "888B8D",
  "75787B",
  "63666A",
  "53565A",
  "332F21",
  "212721",
  "31261D",
  "3E2B2E",
  "101820",
  "3D3935"
], qe = le.map((g) => [
  parseInt(g.substring(0, 2), 16),
  parseInt(g.substring(2, 4), 16),
  parseInt(g.substring(4, 6), 16)
]);
function Ds(g) {
  const e = Qe.indexOf(g);
  return e >= 0 ? le[e] : "";
}
function $a(g) {
  const e = le.indexOf(g);
  return e >= 0 ? Qe[e] : "";
}
function Is(g, e = 64) {
  const t = [], A = [], a = $a(g);
  a && t.push({
    pms: a,
    hex: g,
    distance: 0
  });
  const n = parseInt(g.substring(0, 2), 16), i = parseInt(g.substring(2, 4), 16), s = parseInt(g.substring(4, 6), 16);
  let o, r, c;
  for (let B = 0; B < le.length; B++) {
    o = qe[B][0], r = qe[B][1], c = qe[B][2];
    const l = Math.sqrt(Math.pow(n - o, 2) + Math.pow(i - r, 2) + Math.pow(s - c, 2));
    A.push(l);
  }
  for (let B = 0; B < A.length; B++)
    A[B] <= e && !t.some((l) => l.pms === Qe[B]) && t.push({ pms: Qe[B], hex: le[B], distance: A[B] });
  return t.sort((B, l) => B.distance - l.distance);
}
const _a = Qe.map((g, e) => ({ pms: g, hex: le[e] })), en = new ia(_a, { keys: ["pms"] });
function fs(g, e) {
  return en.search(g, e ? { limit: e } : void 0);
}
let we = null;
function tn(g) {
  if (g.startsWith("#"))
    return Ut(g);
  if (!document)
    throw new Error("browserColorToHex is only supported on browsers");
  if (we || (we = document.createElement("canvas").getContext("2d")), !we)
    throw new Error("Failed to create canvas context required to convert colors");
  we.fillStyle = g;
  const e = Ut(we.fillStyle);
  return e || console.error(`Unknown browser color ${g}`), e;
}
function Ut(g) {
  const e = g.substring(1).toUpperCase();
  return e.length === 6 ? e : e.length === 3 ? `${e[0]}${e[0]}${e[1]}${e[1]}${e[2]}${e[2]}` : "";
}
class An {
  constructor() {
    this.frameSourceSvg = async (e, t) => {
      if (!e)
        return yt(t);
      const A = e.asset;
      if (!A)
        throw new ie(e);
      const a = A.fileLink;
      if (a)
        return _(a, !0);
      throw new ue(A);
    };
  }
  async init(e, t, A) {
    if (A)
      return await this.reload(e, t, A), null;
    e.mandatory && t.setMandatoryFulfilled(e.stepName, !1), t.markStepsAsInitialised([e.stepName]);
    let a;
    const n = t.getWorkflowExperience().getBundle();
    if (n && e.globalPropertyAspectConfigurations) {
      const i = n.getGlobalPropertyStateManager(), s = e.globalPropertyAspectConfigurations[0], o = i.getAspectStorage(s.aspectName);
      o && o.originalAssetKey && (a = (await U.getLocalOrFromServer(o.originalAssetKey)).fileLink);
    }
    if (e.option && e.option.variants && e.option.variants.length > 0) {
      const i = e.option, s = V.getDefaultVariant(i);
      return s ? this.selectVariantCommand(
        e,
        s,
        [],
        t,
        void 0,
        a || e.data.placeholderImageUrl
      ) : null;
    }
    return this.selectVariantCommand(
      e,
      void 0,
      [],
      t,
      void 0,
      a || e.data.placeholderImageUrl
    );
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), o = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName).map((c) => ({ id: c.id, region: c.stepRegion }));
    if (!e.option || (e.option.variants || []).length === 0) {
      const c = e.data.regions.map((B) => yt(B));
      t.updateStorage(e.stepName, {
        currentFrameSources: c
      });
    }
    if (a) {
      const c = async () => {
        var C, w, h, u, E;
        const B = (C = a.storage) == null ? void 0 : C.colors, l = (w = a.storage) == null ? void 0 : w.framePatternSrc, d = (h = a.storage) == null ? void 0 : h.frameOffsetsList;
        if (t.updateMetadata(e.stepName, {
          frameOffsetsList: d,
          framePatternSrc: l
        }), l) {
          const D = (u = t.getStepSpecificServices(e.stepName)) == null ? void 0 : u.frameService;
          if (!D)
            throw new Error("Frame service unavailable, cannot load pattern!");
          await this.loadPatternFromString(l, D, !0, B), t.updateMetadata(e.stepName, { image: l }), t.updateStorage(e.stepName, {
            framePatternSrc: l
          }), this.validateColorCount(e, t);
        }
        if (d != null && d.some((D) => D.zoom)) {
          const D = (E = t.getStepSpecificServices(e.stepName)) == null ? void 0 : E.frameService;
          if (!D)
            throw new Error("Frame service unavailable, cannot load pattern!");
          D.updateOffsets(d);
        }
        t.setMandatoryFulfilled(e.stepName, !0);
      };
      if (a.selectedVariants && a.selectedVariants.length > 0) {
        const B = a.selectedVariants[0].id;
        if (e.option && B) {
          const l = (r = e.option.variants) == null ? void 0 : r.find((d) => d.id === B);
          l && await t.setSelectionsAndElements(
            e.stepName,
            [l],
            o,
            async () => {
              const d = await Promise.all(
                e.data.regions.map((C) => this.frameSourceSvg(l, C))
              );
              t.updateStorage(e.stepName, { currentFrameSources: d }), await c();
            }
          );
        }
      } else
        await t.setSelectionsAndElements(e.stepName, [], o, c);
    }
  }
  async availableColors(e, t) {
    var a;
    const A = e.data.colorOption;
    return ((a = A == null ? void 0 : A.variants) == null ? void 0 : a.map((n) => ({
      fill: n.color,
      stroke: n.color,
      variant: n,
      pmsValue: n.name
    }))) ?? [];
  }
  selectImage(e, t, A, a = !0) {
    var o;
    const n = this.patternSource(t), i = (o = A.getStepStorage(e.stepName)) == null ? void 0 : o.framePatternSrc;
    if (i && i === n)
      return Promise.resolve();
    A.setEditedStatus(e.stepName, !0);
    const s = t.fileLink || "";
    return s.endsWith(".pdf") || s.endsWith(".eps") || s.endsWith(".ai") ? new Promise((r) => {
      A.addPoller(
        new CA(
          async () => {
            var d;
            const B = (d = (await U.getFromServer(t.key || "")).versions) == null ? void 0 : d.find((C) => C.name === "svg");
            return B ? (await fetch(B.link)).status === 200 : !1;
          },
          () => {
            U.getLocalOrFromServer(t.key || "").then((c) => {
              this.loadPatternFromAsset(c, e, A, a).then(
                r
              );
            });
          },
          () => {
            throw new je("Failed to resolve transcoded PDF");
          }
        )
      );
    }) : this.loadPatternFromAsset(t, e, A, a);
  }
  async selectVariant(e, t, A, a, n) {
    const i = await this.selectVariantCommand(
      e,
      t,
      A,
      a,
      n
    );
    i && (i.command && a.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  getCreateElementCommand(e, t, A, a) {
    return new L(
      {
        id: e,
        type: G.Frame,
        x: t.left,
        y: t.top,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        rotation: t.rotation,
        scaleX: t.width / a.frameData.width,
        scaleY: t.height / a.frameData.height,
        path: a.frameData.path,
        dataWidth: a.frameData.width,
        dataHeight: a.frameData.height,
        stepRegion: t,
        stepName: a.stepName,
        disablePlaceholder: a.disablePlaceholder,
        pattern: a.pattern,
        immutable: t.immutable
      },
      A
    );
  }
  async loadPatternFromString(e, t, A = !0, a = void 0, n) {
    if (e.endsWith("svg")) {
      const i = await OA(e), s = i.width, o = i.height, r = await _(e);
      if (n) {
        const l = r.match(/<(image|linearGradient|radialGradient)(\s|>|\/>)/gim);
        if (l && l.length > 0)
          throw new Error(
            "Vector files may not include images or gradients when a color limit is specified."
          );
      }
      const c = await Le(r), B = {
        src: e,
        width: s,
        height: o,
        aspect: s / o,
        svg: c.svg,
        colors: a ?? c.colors
      };
      Mt.set(e, B), t.setPatternData(B, A);
    } else {
      const i = await LA(e, !0), s = await Ot(i), o = {
        src: e,
        width: s.width,
        height: s.height,
        aspect: s.width / s.height,
        svg: void 0,
        colors: void 0
      };
      Mt.set(e, o), t.setPatternData(o, A);
    }
  }
  changeColors(e, t, A) {
    var i, s;
    const a = (i = t.getStepSpecificServices(e.stepName)) == null ? void 0 : i.frameService;
    if (!a || !((s = a.getImageData()) != null && s.svg)) {
      console.warn("changeColors was called without an SVG being assigned to a frame step");
      return;
    }
    const n = this.calculateColorMetadata(a, e, A);
    t.updateMetadata(e.stepName, { colors: n.metadataColors }), t.updateStorage(e.stepName, {
      colors: n.storageColors
    }), a.setPatternData(
      {
        ...a.getImageData(),
        colors: n.newColors
      },
      !1
    ), this.validateColorCount(e, t);
  }
  getUniqueColorCount(e, t) {
    var i, s;
    const A = (i = t.getStepSpecificServices(e.stepName)) == null ? void 0 : i.frameService;
    if (!A)
      return 0;
    const a = ((s = A.getImageData()) == null ? void 0 : s.colors) ?? {}, n = [];
    for (const o in a) {
      const r = a[o];
      if (r.pmsValue) {
        const c = r.pmsValue.trim().toLocaleLowerCase();
        n.includes(c) || n.push(c);
      } else if (r.browserValue) {
        const c = tn(r.browserValue);
        n.includes(c) || n.push(c);
      }
    }
    return n.length;
  }
  calculateColorMetadata(e, t, A) {
    var o, r;
    if (!((o = e.getImageData()) != null && o.svg))
      return {
        newColors: void 0,
        metadataColors: void 0,
        storageColors: void 0
      };
    const a = { ...e.getImageData().colors ?? {} }, n = {};
    Object.entries(a).forEach(([c, B]) => {
      const l = { browserValue: B.browserValue };
      n[c] = l;
    });
    for (const [c, B] of A.entries())
      a[c] = { browserValue: B.browserValue, pmsValue: B.pmsValue }, n[c] = B;
    let i = Array.from(Object.values(a)).map((c) => c.browserValue);
    const s = t.data.colorOption;
    return s && ((r = s.variants) == null || r.forEach((c) => {
      i = i.map((B) => {
        var l;
        return B.toLowerCase() === ((l = c.color) == null ? void 0 : l.toLowerCase()) ? c.name : B;
      });
    })), {
      newColors: a,
      metadataColors: i,
      storageColors: n
    };
  }
  validateColorCount(e, t) {
    const A = e.data.colorPickerEnabled ? e.data.maxColors ?? 0 : 0;
    t.setStepError(
      e.stepName,
      "colors",
      A > 0 && this.getUniqueColorCount(e, t) > A ? "workflow.steps.frame.tooManyColors" : void 0
    );
  }
  async selectVariantCommand(e, t, A, a, n, i) {
    var l;
    const s = (l = a.getStepSpecificServices(e.stepName)) == null ? void 0 : l.frameService;
    if (!s)
      throw new Error("Frame service unavailable, cannot load pattern!");
    const o = await Promise.all(
      e.data.regions.map((d) => this.frameSourceSvg(t, d))
    );
    n && n(!0);
    const r = await Promise.all(
      e.data.regions.map(async (d, C) => {
        const w = await lt(o[C]), h = s.getImageData(), u = A.map((I) => new ne(I.id)), E = h ? Bt(h, w) : void 0, D = h ? {
          id: J(),
          src: h.src,
          x: (E == null ? void 0 : E.x) || 0,
          y: (E == null ? void 0 : E.y) || 0,
          width: h.width,
          height: h.height,
          scaleX: (E == null ? void 0 : E.zoom) || 1,
          scaleY: (E == null ? void 0 : E.zoom) || 1,
          rotation: 0
        } : void 0, Q = J(), m = a.getLayouts().find((I) => I.panelId === d.panelId);
        if (!m)
          throw new z(d);
        return {
          command: this.getCreateElementCommand(Q, d, m, {
            frameData: w,
            pattern: D,
            disablePlaceholder: e.data.disablePlaceholder,
            stepName: e.stepName
          }),
          regionEl: {
            id: Q,
            region: d
          },
          removeExistingCommands: u
        };
      })
    ), c = r.map((d) => d.command), B = r.map((d) => d.removeExistingCommands).flat();
    return {
      command: new k([...c, ...B]),
      followup: async () => {
        n && n(!1), await a.setSelectionsAndElements(
          e.stepName,
          t ? [t] : [],
          [...r.map((d) => d.regionEl)],
          async () => {
            var d;
            if (a.updateStorage(e.stepName, { currentFrameSources: o }), i) {
              const C = (d = a.getStepSpecificServices(
                e.stepName
              )) == null ? void 0 : d.frameService;
              if (!C)
                throw new Error("Frame service unavailable, cannot load pattern!");
              await this.loadPatternFromString(i, C, !0);
            }
          }
        );
      }
    };
  }
  /**
   * Grab the source to be used for a frame from the variant or throw otherwise.
   */
  patternSource(e) {
    var a;
    const t = (a = e.versions) == null ? void 0 : a.find((n) => n.name === "svg");
    if (t)
      return t.link;
    const A = e.fileLink;
    if (A)
      return A;
    throw new ue(e);
  }
  async loadPatternFromAsset(e, t, A, a) {
    var r, c;
    const n = this.patternSource(e), i = A.markUpdatePending(), s = (r = A.getStepSpecificServices(t.stepName)) == null ? void 0 : r.frameService;
    if (!s)
      throw A.markUpdateCompleted(i), new Error("Frame service unavailable, cannot load pattern!");
    try {
      await this.loadPatternFromString(
        n,
        s,
        a,
        void 0,
        t.data.colorPickerEnabled && !!t.data.maxColors && t.data.maxColors > 0
      );
    } catch (B) {
      throw A.markUpdateCompleted(i), B;
    }
    const o = this.calculateColorMetadata(
      s,
      t,
      new Map(Object.entries(((c = s.getImageData()) == null ? void 0 : c.colors) ?? {}))
    );
    A.updateMetadata(t.stepName, { image: n, colors: o.metadataColors }), A.updateStorage(t.stepName, {
      framePatternSrc: n,
      colors: o.storageColors
    }), A.markUpdateCompleted(i), A.setMandatoryFulfilled(t.stepName, !0), A.setInformationResults(
      A.getInformationResults().filter((B) => B.stepID === t.stepName)
    ), this.validateColorCount(t, A);
  }
}
const Ae = new An();
class an {
  async getIllustrationBody(e) {
    return new Promise((t) => {
      _(e, !0).then((A) => {
        t(A);
      }).catch((A) => console.error(A));
    });
  }
  getCreateElementCommand(e, t, A, a) {
    return new L(
      {
        stepRegion: t,
        stepName: a.stepName,
        colors: a.svg.colors,
        id: e,
        src: a.src,
        svg: a.svg.svg,
        cachedObjectURL: a.objectURL,
        type: G.Illustration,
        y: t.top,
        x: t.left,
        rotation: t.rotation,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        immutable: t.immutable
      },
      A
    );
  }
  getColors(e, t) {
    const A = t.getRegionElements(e.stepName) || [];
    if (A.length === 0)
      return [];
    try {
      return Re(
        A[0].id,
        t.getAllLayoutData()
      ).colors;
    } catch {
      return [];
    }
  }
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      return null;
    if (A)
      return this.reload(e, t, A);
    {
      const n = V.getDefaultVariant(a);
      if (n)
        return await this.selectVariantCommand(e, n, [], () => {
        }, t);
    }
    return null;
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName), o = e.option;
    if (a != null && a.selectedVariants) {
      const c = a.selectedVariants[0].id;
      if (o && c) {
        const B = (r = o.variants) == null ? void 0 : r.find((l) => l.id === c);
        if (B) {
          const l = s.map((d) => ({ id: d.id, region: d.stepRegion }));
          await t.setSelectionsAndElements(
            e.stepName,
            [B],
            l,
            async () => {
              var d;
              t.updateMetadata(e.stepName, {
                colors: (d = a.storage) == null ? void 0 : d.colors
              }), t.setMandatoryFulfilled(e.stepName, !0);
            }
          );
        }
      } else
        throw new Error("Required illustration variant no longer available");
    }
    return null;
  }
  async availableColors(e, t) {
    var a;
    const A = e.data.colorOption;
    return A ? A ? (a = A.variants) == null ? void 0 : a.map((n) => ({
      fill: n.color,
      stroke: n.color,
      variant: n
    })) : [] : [];
  }
  async changeColorsCommand(e, t, A, a, n) {
    var c;
    const i = {};
    for (const [B, l] of n.entries())
      i[B] = { browserValue: l, spotColor: (c = i[B]) == null ? void 0 : c.spotColor };
    const s = zA(e, t, A, i), o = await ve(s), r = [];
    for (const B of a) {
      for (const [l, d] of n.entries())
        r.push(new at(B, l, d));
      r.push(new KA(B, s, o));
    }
    return new k(r);
  }
  async changeColors(e, t, A, a, n) {
    var d, C;
    if (t.length === 0)
      return;
    const i = Re(
      t[0].id,
      a().map((w) => w.layoutState)
    ), s = { ...i.colors }, o = {};
    Object.entries(s).forEach(([w, h]) => {
      const u = { browserValue: h.browserValue }, E = h.spotColor;
      E && (u.spotColor = { profileName: E.profileName, namedColor: E.namedColor }), o[w] = u;
    });
    for (const [w, h] of n.entries())
      s[w] = { browserValue: h, spotColor: (d = s[w]) == null ? void 0 : d.spotColor }, o[w] = { browserValue: h };
    let r = Array.from(Object.values(s)).map((w) => w.browserValue);
    const c = e.data.colorOption;
    c && ((C = c.variants) == null || C.forEach((w) => {
      r = r.map((h) => {
        var u;
        return h.toLowerCase() === ((u = w.color) == null ? void 0 : u.toLowerCase()) ? w.name : h;
      });
    })), A.updateMetadata(e.stepName, { colors: r });
    const B = /* @__PURE__ */ new Map();
    if (Object.entries(s).forEach(([w, h]) => {
      B.set(w, h.browserValue);
    }), !i.svg)
      throw new Error("Colors changed before SVG loaded. This should never happen!");
    const l = await this.changeColorsCommand(
      i.svg,
      i.width,
      i.height,
      t.map((w) => w.id),
      B
    );
    A.updateStorage(e.stepName, {
      colors: o
    }), A.getCommandDispatcher()(l);
  }
  async selectVariant(e, t, A, a, n) {
    const i = await this.selectVariantCommand(e, t, A, a, n);
    i && (i.command && n.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  async selectVariantCommand(e, t, A, a, n) {
    var u;
    if (!e.data || !e.data.regions)
      throw new Ue(e, "Missing regions.");
    a(!0);
    const i = A.map((E) => new ne(E.id));
    e.mandatory && n.setMandatoryFulfilled(e.stepName, !1);
    const s = t.asset;
    if (!s)
      throw new ie(t);
    const o = s.fileLink;
    if (!o)
      throw new ue(s);
    const r = await Le(await this.getIllustrationBody(o)), c = await ve(r.svg), B = (E) => {
      const D = n.getLayouts().find((p) => p.panelId === E.panelId);
      if (!D)
        throw new z(E);
      const Q = J();
      return {
        regionElement: { id: Q, region: E },
        command: this.getCreateElementCommand(Q, E, D, {
          stepName: e.stepName,
          src: o,
          objectURL: c,
          svg: r
        })
      };
    }, l = e.data.regions.map(B), C = [...l.map((E) => E.command), ...i];
    let w = Array.from(Object.values(r.colors)).map((E) => E.browserValue);
    const h = e.data.colorOption;
    return h && ((u = h.variants) == null || u.forEach((E) => {
      w = w.map((D) => {
        var Q;
        return D.toLowerCase() === ((Q = E.color) == null ? void 0 : Q.toLowerCase()) ? E.name : D;
      });
    })), n.updateMetadata(e.stepName, { colors: w }), {
      command: new k(C),
      followup: async () => {
        await n.setSelectionsAndElements(
          e.stepName,
          [t],
          l.map((Q) => Q.regionElement),
          async () => {
            n.setMandatoryFulfilled(e.stepName, !0), a(!1);
          }
        );
        const E = await this.availableColors(e, n) || [], D = Object.keys(r.colors);
        if (e.data.colorPickerEnabled && E.length === 1 && D.length === 1) {
          const Q = E[0], p = D[0];
          await this.changeColors(
            e,
            l.map((m) => m.regionElement),
            n,
            () => n.getCommandContext().getAllLayouts(),
            /* @__PURE__ */ new Map([[p, Q.variant.color]])
          );
        } else
          e.data.colorPickerEnabled && await this.changeColors(
            e,
            l.map((Q) => Q.regionElement),
            n,
            () => n.getCommandContext().getAllLayouts(),
            /* @__PURE__ */ new Map()
          );
      }
    };
  }
}
const Ne = new an();
class nn {
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      throw new ke(e);
    if (A)
      await this.reload(e, t, A);
    else {
      const n = V.getDefaultVariant(a);
      if (n)
        return await this.selectVariantLambda(e, n, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName), o = e.option;
    if (!o)
      throw new ke(e);
    if (a != null && a.selectedVariants) {
      const c = a.selectedVariants[0].id;
      if (c) {
        const B = (r = o.variants) == null ? void 0 : r.find((l) => l.id === c);
        if (B) {
          const l = B.material, d = s.map((C) => ({ id: C.id, region: C.stepRegion }));
          await t.setSelectionsAndElements(
            e.stepName,
            [B],
            d,
            async () => {
              const C = t.getModelContainer();
              if (C) {
                const w = e.data.targetMaterials.map((h) => C.applyMaterialVariant(
                  h,
                  o.id || "",
                  l || {}
                ));
                Promise.all(w).then(
                  () => t.setMandatoryFulfilled(e.stepName, !0)
                );
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, A, a) {
    const n = await this.selectVariantLambda(e, t, A, a);
    n && (n.command && A.getCommandDispatcher()(n.command), n.followup && await n.followup());
  }
  async selectVariantLambda(e, t, A, a) {
    const n = A.getModelContainer();
    a(!0);
    const i = t.material;
    if (!i)
      throw a(!1), new ie(t);
    return {
      command: void 0,
      followup: async () => {
        await A.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            n && e.data.targetMaterials.forEach((s) => {
              e.option && n.applyMaterialVariant(s, e.option.id || "", i);
            }), A.setMandatoryFulfilled(e.stepName, !0);
          } finally {
            a(!1);
          }
        });
      }
    };
  }
}
const hA = new nn();
class sn {
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      throw new ke(e);
    if (A)
      await this.reload(e, t, A);
    else {
      const n = V.getDefaultVariant(a);
      if (n)
        return await this.selectVariantLambda(e, n, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName), o = e.option;
    if (a != null && a.selectedVariants) {
      const c = a.selectedVariants[0].id;
      if (o && c) {
        const B = (r = o.variants) == null ? void 0 : r.find((l) => l.id === c);
        if (B) {
          const l = s.map((d) => ({ id: d.id, region: d.stepRegion }));
          await t.setSelectionsAndElements(
            e.stepName,
            [B],
            l,
            async () => {
              var C;
              const d = t.getModelContainer();
              if (d && e.option) {
                const w = (C = B.asset) == null ? void 0 : C.fileLink;
                if (!w)
                  throw new ie(B);
                await d.applyModelVariant(
                  e.stepName || "",
                  {
                    model: w,
                    contextService: t.getLayoutPreviewService()
                  },
                  e.data.replaceProductModel || !1
                ), t.setMandatoryFulfilled(e.stepName, !0);
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, A, a) {
    const n = await this.selectVariantLambda(e, t, A, a);
    n && (n.command && A.getCommandDispatcher()(n.command), n.followup && await n.followup());
  }
  async selectVariantLambda(e, t, A, a) {
    var i;
    a(!0);
    const n = (i = t.asset) == null ? void 0 : i.fileLink;
    if (!n)
      throw new ie(t);
    return {
      command: void 0,
      followup: async () => {
        await A.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            const s = A.getModelContainer();
            s && await s.applyModelVariant(
              e.stepName,
              {
                model: n,
                contextService: A.getLayoutPreviewService()
              },
              e.data.replaceProductModel || !1
            ), A.setMandatoryFulfilled(e.stepName, !0);
          } finally {
            a(!1);
          }
        });
      }
    };
  }
}
const EA = new sn();
class on {
  async init(e, t, A) {
    if (A)
      await this.reload(e, t, A);
    else
      return t.updateMetadata(e.stepName, { text: "" }), this.changeTextCommand(e, "", t, "", () => {
      });
    return null;
  }
  async reload(e, t, A) {
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), o = Object.values(A.layouts).map((r) => r.elements).flat().filter((r) => r.stepName === e.stepName).map((r) => ({ id: r.id, region: r.stepRegion }));
    await t.setSelectionsAndElements(e.stepName, [], o, async () => {
      var r, c;
      t.updateStorage(e.stepName, { text: (r = a == null ? void 0 : a.storage) == null ? void 0 : r.text }), t.setMandatoryFulfilled(e.stepName, ((c = a == null ? void 0 : a.storage) == null ? void 0 : c.text) !== "");
    });
  }
  async changeText(e, t, A, a, n) {
    const i = await this.changeTextCommand(e, t, A, a, n);
    i && (i.command && A.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  async changeTextCommand(e, t, A, a, n) {
    var c;
    const i = A.getRegionElements(e.stepName), s = (c = A.getStepSpecificServices(e.stepName)) == null ? void 0 : c.module;
    if (!s)
      return console.error("Missing module."), null;
    const o = A.getProfanities();
    if (!this.validateInput(e, t, o, n))
      return A.setMandatoryFulfilled(e.stepName, !1), console.error(a), null;
    if (A.setMandatoryFulfilled(e.stepName, t !== ""), !e.data || !e.data.regions || e.data.regions.length <= 0)
      return console.error("Missing configuration."), null;
    A.updateStorage(e.stepName, { text: t }), A.updateMetadata(e.stepName, { text: t });
    const r = (B, l, d) => {
      const C = d || J(), h = A.getLayouts().find((E) => E.panelId === l.panelId);
      if (!h)
        return console.error(`Can not find layout for region: ${l.panelId}`), null;
      const u = [];
      return d && u.push(new ne(C)), u.push(
        new L(
          {
            stepRegion: l,
            stepName: e.stepName,
            colors: {},
            id: C,
            svg: B,
            type: G.Illustration,
            y: l.top,
            x: l.left,
            rotation: l.rotation,
            width: l.width,
            height: l.height,
            layer: l.layer,
            layerIndex: l.layerIndex,
            immutable: l.immutable
          },
          h
        )
      ), {
        id: C,
        region: l,
        command: new k(u)
      };
    };
    if (i.length > 0) {
      const l = i.map((d) => {
        if (!d.region)
          return null;
        const C = s.svgPrint(t, d.region);
        return r(C, d.region, d.id);
      }).filter((d) => !!d).filter((d) => !!d).map((d) => d && d.command);
      return {
        command: new k(l),
        followup: async () => {
        }
      };
    } else {
      const B = e.data.regions.map(
        (d) => r(s.svgPrint(t, d), d)
      ), l = B.filter((d) => !!d).map((d) => d && d.command);
      return {
        command: new k(l),
        followup: async () => {
          const d = B.filter((C) => C).map((C) => C && { id: C.id, region: C.region });
          await A.setSelectionsAndElements(
            e.stepName,
            [],
            d
          );
        }
      };
    }
  }
  validateInput(e, t, A, a) {
    if (e.data && e.data.maxLength) {
      const i = e.data.maxLength;
      if (t.length > i)
        return a("Too many characters."), !1;
    }
    if (!/^$|^[a-zA-Z0-9 ]+$/.test(t))
      return a("Unsupported characters."), !1;
    const n = st(t.toLowerCase());
    for (const i of n)
      for (const s in A) {
        const o = A[s].toLowerCase().replace(/\s/g, "");
        if (i === o)
          return a("Blocked profanity."), !1;
      }
    return a(""), !0;
  }
}
const uA = new on();
class rn {
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      return null;
    if (A)
      await this.reload(e, t, A);
    else if (a.defaultVariant)
      return t.markStepsAsInitialised([e.stepName]), this.selectVariantCommand(e, a.defaultVariant, t, () => {
      });
    return t.markStepsAsInitialised([e.stepName]), null;
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName), o = e.option;
    if (a != null && a.selectedVariants) {
      const c = a.selectedVariants[0].id;
      if (o && c) {
        const B = (r = o.variants) == null ? void 0 : r.find((l) => l.id === c);
        if (B) {
          const l = s.map((d) => ({ id: d.id, region: d.stepRegion }));
          await t.setSelectionsAndElements(
            e.stepName,
            [B],
            l,
            async () => {
              t.setMandatoryFulfilled(e.stepName, !0);
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, A, a) {
    const n = await this.selectVariantCommand(e, t, A, a);
    n && (n.command && A.getCommandDispatcher()(n.command), n.followup && await n.followup());
  }
  async selectVariantCommand(e, t, A, a) {
    const n = t.asset;
    if (!n)
      throw new ie(t);
    const i = n == null ? void 0 : n.fileLink;
    if (!i)
      return console.error("No URL for picture!"), null;
    a(!0), e.mandatory && A.setMandatoryFulfilled(e.stepName, !1);
    const o = A.getRegionElements(e.stepName).map((B) => new ne(B.id)), r = (B) => {
      const d = A.getLayouts().find((w) => w.panelId === B.panelId);
      if (!d)
        throw new z(B);
      const C = J();
      return {
        regionElement: { id: C, region: B },
        command: new L(
          {
            stepName: e.stepName,
            stepRegion: B,
            id: C,
            src: i,
            type: G.Image,
            y: B.top,
            x: B.left,
            rotation: B.rotation,
            width: B.width,
            height: B.height,
            layer: B.layer,
            layerIndex: B.layerIndex,
            immutable: B.immutable,
            preserveAspectRatio: "none"
          },
          d
        )
      };
    }, c = e.data.regions.map(r);
    return {
      command: new k([...o, ...c.map((B) => B.command)]),
      followup: async () => {
        await A.setSelectionsAndElements(
          e.stepName,
          [t],
          c.map((B) => B.regionElement),
          async () => {
            A.setMandatoryFulfilled(e.stepName, !0), a(!1);
          }
        );
      }
    };
  }
}
const mA = new rn();
class cn {
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      return null;
    if (A)
      await this.reload(e, t, A);
    else {
      const n = a.variants;
      if (V.getDefaultVariant(a)) {
        const s = n == null ? void 0 : n.find((o) => {
          var r;
          return o.id === ((r = a.defaultVariant) == null ? void 0 : r.id);
        });
        return this.selectVariantLambda(e, (s == null ? void 0 : s.id) || "", t);
      }
    }
    return null;
  }
  async reload(e, t, A) {
    var i;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), n = e.option;
    if (a != null && a.selectedVariants) {
      const s = a.selectedVariants[0].id;
      if (n && s) {
        const o = (i = n.variants) == null ? void 0 : i.find((r) => r.id === s);
        o && await t.setSelectionsAndElements(e.stepName, [o], []);
      }
    }
  }
  async selectVariant(e, t, A) {
    await A.getInitializationPromise();
    const a = await this.selectVariantLambda(e, t, A);
    a && (a.command && A.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantLambda(e, t, A) {
    const a = e.option;
    if (!a)
      return null;
    const n = a.variants;
    if (!n)
      return null;
    const i = n.length > 1 ? n.find((s) => s.id === t) : n[0];
    if (!i)
      throw new Error("Failed to find selected variant in step variants, this should never happen!");
    return {
      command: void 0,
      followup: async () => {
        await A.setSelectionsAndElements(e.stepName, [i], [], async () => {
          A.setMandatoryFulfilled(e.stepName, !0);
        });
      }
    };
  }
}
const QA = new cn();
class gn {
  constructor() {
    this.shapeFillId = "spiff-fill-shape";
  }
  // Get the step's options.
  async availableColours(e) {
    var A;
    const t = e.option;
    return t ? ((A = t.variants) == null ? void 0 : A.map((a) => ({
      fill: a.color,
      stroke: a.color,
      variant: a
    }))) || [] : [];
  }
  setCustomColor(e, t, A) {
    const a = A.getLayouts(), i = (A.getRegionElements(t.stepName) || []).map((s) => {
      const o = s.region;
      if (!a.find((c) => c.panelId === (o == null ? void 0 : o.panelId)))
        throw new z(o);
      return new at(s.id, this.shapeFillId, e);
    }).filter((s) => !!s);
    A.getCommandDispatcher()(new k(i)), A.updateStorage(t.stepName, { colour: e });
  }
  async init(e, t, A) {
    const a = e.option;
    if (!a)
      throw new ke(e);
    if (A)
      await this.reload(e, t, A);
    else {
      const n = V.getDefaultVariant(a);
      return n ? this.selectVariantCommand(
        e,
        {
          fill: n.color,
          stroke: n.color,
          variant: n
        },
        [],
        t
      ) : null;
    }
    return null;
  }
  async selectVariant(e, t, A, a) {
    const n = await this.selectVariantCommand(e, t, A, a);
    n && (n.command && a.getCommandDispatcher()(n.command), n.followup && await n.followup());
  }
  async reload(e, t, A) {
    var r;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName), o = e.option;
    if (a != null && a.selectedVariants) {
      const c = a.selectedVariants[0].id;
      if (o && c) {
        const B = (r = o.variants) == null ? void 0 : r.find((l) => l.id === c);
        if (B) {
          const l = s.map((d) => ({ id: d.id, region: d.stepRegion }));
          await t.setSelectionsAndElements(
            e.stepName,
            [B],
            l,
            async () => {
              var d;
              t.updateStorage(e.stepName, {
                colour: ((d = a == null ? void 0 : a.storage) == null ? void 0 : d.colour) || ""
              }), t.setMandatoryFulfilled(e.stepName, !0);
            }
          );
        }
      }
    }
  }
  async selectVariantCommand(e, t, A, a) {
    var o;
    const n = a.getLayouts(), i = (o = a.getStepStorage(e.stepName)) == null ? void 0 : o.colour, s = () => {
      var r, c;
      if (((r = t.variant) == null ? void 0 : r.color) === "#custom")
        return i || "#FFFFFF";
      if ((c = t.variant) != null && c.color)
        return t.variant.color;
      throw new Error("Failed to resolve color for shape step.");
    };
    if (A.length > 0) {
      const r = (B) => {
        const l = B.region;
        if (!n.find((w) => w.panelId === (l == null ? void 0 : l.panelId)))
          throw new z(l);
        const C = s();
        return new at(B.id, this.shapeFillId, C);
      }, c = A.map(r).filter((B) => !!B);
      return {
        command: new k(c),
        followup: async () => {
          await a.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            A
          ), a.updateStorage(e.stepName, { colour: s() });
        }
      };
    } else {
      const r = (d) => {
        const C = n.find((D) => D.panelId === d.panelId);
        if (!C)
          throw new z(d);
        const w = s(), h = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="${this.shapeFillId}"
                            fill="${w}"
                        />
                    </svg>
                `, u = {};
        u[this.shapeFillId] = { browserValue: w };
        const E = J();
        return {
          id: E,
          region: d,
          command: new L(
            {
              stepRegion: d,
              stepName: e.stepName,
              colors: u,
              id: E,
              svg: h,
              type: G.Illustration,
              y: d.top,
              x: d.left,
              rotation: d.rotation,
              width: d.width,
              height: d.height,
              layer: d.layer,
              layerIndex: d.layerIndex,
              immutable: d.immutable,
              excludeFromExport: e.data.excludeFromPrint
            },
            C
          )
        };
      }, c = e.data.regions.map(r), B = c.filter((d) => !!d).map((d) => d == null ? void 0 : d.command), l = c.filter((d) => !!d).map((d) => ({ id: d.id, region: d.region }));
      return {
        command: new k(B),
        followup: async () => {
          await a.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            l,
            async () => {
              a.updateStorage(e.stepName, { colour: s() });
            }
          );
        }
      };
    }
  }
}
const Ee = new gn();
class ln {
  constructor() {
    this.latestToast = null, this.toastType = null, this.toastCallbacks = [];
  }
  addToastCallback(e) {
    e({
      toastMessage: this.latestToast,
      toastType: this.toastType
    }), this.toastCallbacks.push(e);
  }
  removeToastCallback(e) {
    this.toastCallbacks = this.toastCallbacks.filter((t) => t !== e);
  }
  setLatestToast(e, t) {
    this.latestToast = e, this.toastType = t, this.onToastChange();
  }
  onToastChange() {
    this.toastCallbacks.forEach(
      (e) => e({
        toastMessage: this.latestToast,
        toastType: this.toastType
      })
    );
  }
}
const Bn = new ln(), Ze = 30;
class be extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = be.name;
  }
}
const dn = ["‘", "’", "“", "”", `
`];
class Je extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = Je.name;
  }
}
class Cn {
  constructor() {
    this.cachedColors = /* @__PURE__ */ new Map(), this.filterUnsupportedCharacters = (e, t) => {
      let A = e.replace(
        /(\r\n|\r|(\u2665|\u00a9|\u00ae|[\u2000-\u2017]|[\u201E-\u3300]]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]))/gm,
        ""
      );
      const a = [], n = t ? jA(t.assetUrl) : void 0;
      if (n) {
        const i = A.split("").filter((o) => !dn.includes(o)).join(""), s = i.split("").map((o) => n.getFont().charToGlyph(o));
        for (let o = 0; o < s.length; o++)
          s[o].name === ".notdef" && a.push(String.fromCharCode(i.charCodeAt(o)));
      }
      for (let i = 0; i < a.length; i++)
        A = A.replaceAll(a[i], "");
      return A;
    }, this.textAlign = (e) => e.vertical ? "center" : e.textAlign || "center", this.getErrorsForText = (e, t, A) => {
      let a;
      t.data && t.data.maxLength && e.length > t.data.maxLength && (a || (a = {}), a.hitCharacterLimit = !0);
      const n = A.getProfanities(), i = st(e.toLowerCase());
      for (const o of i)
        for (const r in n) {
          const c = n[r].toLowerCase().replace(/\s/g, "");
          if (o === c) {
            a || (a = {}), a.blockedProfanity = !0;
            break;
          }
        }
      return !t.data.allowNewlines && (e.includes(`
`) || e.includes("\r")) && (a || (a = {}), a.illegalMultipleLines = !0), a;
    };
  }
  async init(e, t, A) {
    var n, i, s;
    const a = e.option;
    if (!a)
      return null;
    if (A)
      await this.reload(e, t, A);
    else {
      const o = this.getDefaultImageFillVariant(e.data), r = (n = o == null ? void 0 : o.asset) == null ? void 0 : n.fileLink, c = r ? await nt(r) : void 0, B = c ? {
        src: c.src,
        height: c.height,
        width: c.width,
        scale: e.data.imageFillScale || 1
      } : void 0;
      t.updateStorage(e.stepName, {
        text: e.data.defaultText || "",
        inputText: e.data.defaultText || "",
        color: ((i = await this.getDefaultColorVariant(e.data)) == null ? void 0 : i.color) || await this.getDefaultColor(e.data),
        fillImage: B
      }), t.updateMetadata(e.stepName, {
        text: e.data.defaultText || "",
        color: ((s = await this.getDefaultColorVariant(e.data)) == null ? void 0 : s.name) || await this.getDefaultColor(e.data),
        fillImage: o == null ? void 0 : o.name
      });
      const l = V.getDefaultVariant(a);
      if (l)
        return this.selectVariantCommand(
          e,
          l,
          {},
          [],
          t,
          () => {
          },
          () => {
          },
          B
        );
    }
    return null;
  }
  findLayoutElements(e, t) {
    return e.getRegionElements(t.stepName).map((n) => Re(n.id, e.getAllLayoutData()));
  }
  /**
   * Get the colors that can be used for a given text step.
   * @param stepData The text step to get colors for.
   * @returns A list of color objects containg fill, stroke and variant if available.
   */
  availableFillColors(e) {
    var a;
    const t = this.cachedColors.get(e.stepName);
    if (t)
      return t;
    const A = e.data.colorOption;
    if (A) {
      const n = ((a = A.variants) == null ? void 0 : a.map((i) => ({
        fill: i.color,
        stroke: i.color,
        variant: i
      }))) || [];
      return this.cachedColors.set(e.stepName, n), n;
    }
    return [];
  }
  changeAlignment(e, t, A, a) {
    if (!e.data || !e.data.regions)
      return;
    const n = a.getCommandDispatcher();
    for (const i of A) {
      const s = new VA(i.id, t);
      n(s);
    }
  }
  async changeFillColor(e, t, A, a) {
    var o;
    if (!e.data || !e.data.regions)
      return;
    const n = a.getCommandDispatcher();
    t.variant ? a.updateMetadata(e.stepName, { color: t.variant.name }) : a.updateMetadata(e.stepName, { color: t.fill });
    const i = e.data.colorOption, s = i ? this.createTextFillSpotColor(i, t.variant) : void 0;
    i ? a.updateStorage(e.stepName, {
      color: t.fill,
      colorProfileAssetKey: (o = i.colorProfile) == null ? void 0 : o.key
    }) : a.updateStorage(e.stepName, {
      color: t.fill
    });
    for (const r of A) {
      if (!t.fill)
        throw new Error("Fill not set on new color selection!");
      const c = new WA(r.id, t.fill, s);
      n(c);
    }
  }
  async availableFillImages(e) {
    var A, a;
    const t = e.data.imageFillOption;
    if (t) {
      const n = ((a = (A = t.variants) == null ? void 0 : A.map((i) => {
        var s;
        return (s = i.asset) == null ? void 0 : s.fileLink;
      })) == null ? void 0 : a.filter((i) => !!i)) || [];
      return Promise.all(
        n.map(async (i) => {
          const s = await nt(i);
          return {
            src: i,
            width: s.width,
            height: s.height,
            scale: e.data.imageFillScale || 1
          };
        })
      );
    }
    return Promise.resolve([]);
  }
  async changeFillImage(e, t, A, a) {
    var s, o;
    if (!e.data || !e.data.regions)
      return;
    const n = a.getCommandDispatcher(), i = (o = (s = e.option) == null ? void 0 : s.variants) == null ? void 0 : o.find((r) => {
      var c;
      return ((c = r.asset) == null ? void 0 : c.fileLink) === t.src;
    });
    a.updateMetadata(e.stepName, { fillImage: i == null ? void 0 : i.name }), a.updateStorage(e.stepName, {
      fillImage: t
    });
    for (const r of A) {
      const c = new Xe(r.id, t);
      n(c);
    }
  }
  getProcessedInput(e, t, A) {
    const a = A ? e : this.injectReplaceableText(e, t);
    return it(a, {
      vertical: t.vertical,
      uppercase: t.uppercase
    });
  }
  updateInputText(e, t, A, a) {
    const n = a.getStepStorage(A.stepName), i = this.getProcessedInput(e, A.data, !!n.customiseAllText), s = {
      command: void 0,
      helperData: {},
      errorData: this.getErrorsForText(e, A, a)
    };
    if (s.errorData)
      return s;
    s.helperData.charactersRemaining = A.data.maxLength - i.length;
    const o = [], r = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
    for (const B of t) {
      if (!B.fontData)
        throw new b("Failed to resolve font data for text.");
      const [l, d] = xe(
        B.fontSize,
        B.fontData,
        { left: B.x, top: B.y, width: B.width, height: B.height, rotation: B.rotation, panelId: "" },
        [i],
        { size: A.data.size, minSize: A.data.minSize, maxSize: A.data.maxSize }
      );
      r.set(B.id, l), c.set(B.id, d);
      const C = A.data.curved ? i : (d || []).join(`
`);
      o.push(this.generateTextChangeCommandsForRegion(l, A.data, B.id, C));
    }
    return !A.data.curved && t.length > 0 && !Array.from(c.values()).every((l) => l) ? (s.errorData || (s.errorData = {}), s.errorData.doesNotFit = !0, s) : (a.updateStorage(A.stepName, { text: e }), a.updateMetadata(A.stepName, {
      text: i
    }), (n.defaultCleared || !A.data.deleteDefaultOnFocus) && a.setMandatoryFulfilled(A.stepName, !0), s.command = new k(o), s);
  }
  async selectVariant(e, t, A, a, n) {
    const i = await this.selectVariantCommand(
      e,
      t,
      A.getStepStorage(e.stepName) || {},
      A.getRegionElements(e.stepName),
      A,
      a,
      n
    );
    i && (i.command && A.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  createTextFillSpotColor(e, t) {
    const A = e.colorProfile;
    if (A) {
      const a = (A.name || "").replace(/\s/g, "-"), n = a.lastIndexOf("/"), s = a.slice(n + 1).slice(0, -4);
      if (!t.namedColor)
        throw new Error("variant named color not set!");
      return {
        profileName: s,
        namedColor: t.namedColor
      };
    }
  }
  async reload(e, t, A) {
    var r, c, B;
    const a = t.getSerializedStep(
      e.stepName,
      A.serializableWorkflow.steps
    ), s = Object.values(A.layouts).map((l) => l.elements).flat().filter((l) => l.stepName === e.stepName), o = e.option;
    if (a != null && a.selectedVariants) {
      const l = a.selectedVariants[0].id;
      if (o && l) {
        const d = (r = o.variants) == null ? void 0 : r.find((C) => C.id === l);
        if (d) {
          const C = await this.fontDataFromVariant(d), w = s.map((D) => ({ id: D.id, region: D.stepRegion })), h = (c = a.storage) == null ? void 0 : c.color, u = (B = a.storage) == null ? void 0 : B.text;
          await t.setSelectionsAndElements(
            e.stepName,
            [d],
            w,
            async () => {
              t.updateMetadata(e.stepName, { color: h, text: u }), t.updateStorage(e.stepName, { text: u, inputText: u });
              const D = s.map((p) => new St(p.id, C)), Q = new k(D);
              t.getCommandDispatcher()(Q);
            }
          );
          const { command: E } = j.updateInputText(
            u || "",
            s,
            e,
            t
          );
          E && t.getCommandDispatcher()(E);
        }
      }
    }
  }
  async getDefaultColorVariant(e) {
    const t = e.colorOption;
    if (t)
      return V.getDefaultVariant(t);
  }
  async getDefaultColor(e) {
    const t = e.colorOption;
    if (!t)
      return;
    const A = V.getDefaultVariant(t);
    return A == null ? void 0 : A.color;
  }
  getDefaultImageFillVariant(e) {
    const t = e.imageFillOption;
    if (t)
      return V.getDefaultVariant(t);
  }
  async fontDataFromVariant(e) {
    const t = e.asset;
    if (!t)
      throw new ie(e);
    const A = t.fileLink;
    if (!A)
      throw new ue(t);
    const a = await dt(A);
    return {
      assetUrl: A,
      name: a.names.fullName.en
    };
  }
  async selectVariantCommand(e, t, A, a, n, i, s, o) {
    var B;
    const r = n.markUpdatePending(), c = await this.fontDataFromVariant(t);
    if (a.length > 0) {
      const l = a.map((w) => new St(w.id, c));
      if (o) {
        const w = a.map((h) => new Xe(h.id, o));
        l.push(...w);
      }
      const d = await this.changeInputTextWithRegion(
        e,
        e.data.size || Ze,
        c,
        A.text || "",
        A,
        n,
        !!A.customiseAllText,
        i,
        s
      );
      return d && l.push(d), {
        command: new k(l),
        followup: async () => {
          n.markUpdateCompleted(r), await n.setSelectionsAndElements(e.stepName, [t], a);
        }
      };
    } else {
      const l = await this.createTextboxRegions(
        e.stepName,
        t,
        e.data,
        c,
        A,
        n
      ), d = await this.changeInputTextWithRegion(
        e,
        e.data.size || Ze,
        c,
        ((B = l[0]) == null ? void 0 : B.newElement.input) || A.text || e.data.defaultText || "",
        A,
        n,
        !!A.customiseAllText,
        i,
        s
      ), C = l.flatMap((h) => h.commands);
      if (o) {
        const h = l.map(
          (u) => new Xe(u.regionElement.id, o)
        );
        C.push(...h);
      }
      return d && C.push(d), {
        command: new k(C),
        followup: async () => {
          n.markUpdateCompleted(r);
        }
      };
    }
  }
  /**
   * When a text step specifies replaceable text, the text input by the user will replace
   * a specific token within a larger string of text specified in the step configuration. Otherwise
   * this function will just return the text it's given when the feature is disabled.
   */
  injectReplaceableText(e, t) {
    return t.replaceableText ? t.replaceableText.replace("{{}}", e) : e;
  }
  async createTextboxRegions(e, t, A, a, n, i) {
    if (!A || !A.regions)
      throw new Error("Step data not supplied");
    const s = n.text || A.defaultText || "", o = this.getProcessedInput(s, A, !1), r = async (B) => {
      var w;
      const d = i.getLayouts().find((h) => h.panelId === B.panelId), C = J();
      try {
        if (!d)
          throw new Je("Failed to find layout for region: " + B.panelId);
        const h = A.colorOption;
        let u;
        if (h && h.variants) {
          const S = h.variants.find((T) => {
            var R;
            return T.id === ((R = h.defaultVariant) == null ? void 0 : R.id);
          }) || h.variants[0];
          u = this.createTextFillSpotColor(h, S), i.updateStorage(e, {
            colorProfileAssetKey: (w = h.colorProfile) == null ? void 0 : w.key
          });
        }
        const E = await this.getDefaultColor(A), D = E || "#000000", Q = {
          stepRegion: B,
          stepName: e,
          align: this.textAlign(A),
          fill: n.color ? n.color : D,
          fontSize: A.size || Ze,
          fontData: a,
          id: C,
          layer: B.layer,
          layerIndex: B.layerIndex,
          rotation: B.rotation,
          text: o,
          input: s,
          type: G.Textbox,
          vertical: A.vertical,
          x: B.left,
          y: B.top,
          height: B.height,
          width: B.width,
          immutable: B.immutable,
          verticalAlign: A.verticalAlign || "middle",
          curved: A.curved,
          paths: A.paths,
          fillSpotColorDefinition: u
        }, p = [], m = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map();
        if (!Q.fontData)
          throw new b("Failed to resolve font data for text.");
        const [F, y] = xe(
          Q.fontSize,
          Q.fontData,
          {
            left: Q.x,
            top: Q.y,
            width: Q.width,
            height: Q.height,
            rotation: Q.rotation,
            panelId: ""
          },
          [o],
          { size: A.size, minSize: A.minSize, maxSize: A.maxSize }
        );
        m.set(Q.id, F), I.set(Q.id, y);
        const Y = A.curved || A.vertical ? o : (y || []).join(`
`);
        p.push(
          this.generateTextChangeCommandsForRegion(F, A, Q.id, Y)
        );
        const N = new L(Q, d);
        return {
          regionElement: { id: C, region: B },
          commands: [N, ...p],
          newElement: Q,
          fontData: a
        };
      } catch (h) {
        throw console.log(h), new be("Error adding font to region");
      }
    }, c = await Promise.all(A.regions.map(r)).catch((B) => {
      throw B instanceof be ? (Bn.setLatestToast("Failed to load font.", Ve.Error), B) : B instanceof Je ? B : new Error(B);
    });
    return await i.setSelectionsAndElements(
      e,
      [t],
      c.map((B) => B.regionElement),
      async () => {
        i.updateMetadata(e, {
          text: s
        }), i.updateStorage(e, {
          text: s
        });
      }
    ), c;
  }
  generateTextChangeCommandsForRegion(e, t, A, a) {
    const n = [], i = new XA(A, a);
    if (n.push(i), !t.size) {
      const o = new qA(A, e);
      n.push(o);
    }
    return new k(n);
  }
  /**
   * @deprecated
   */
  async changeInputTextWithRegion(e, t, A, a, n, i, s, o, r, c) {
    const B = (a || "").replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, ""), l = this.getProcessedInput(B, e.data, s), d = i.getRegionElements(e.stepName), C = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map();
    for (const Q of d)
      if (Q.region) {
        const [p, m] = xe(
          t,
          A,
          Q.region,
          [l],
          { size: e.data.size, minSize: e.data.minSize, maxSize: e.data.maxSize }
        );
        C.set(Q.id, p), w.set(Q.id, m);
      }
    const u = (() => {
      if (e.data && e.data.maxLength && l.length > e.data.maxLength)
        return c && c(!0), { info: "0" };
      const Q = i.getProfanities(), p = st(l.toLowerCase());
      for (const m of p)
        for (const I in Q) {
          const F = Q[I].toLowerCase().replace(/\s/g, "");
          if (m === F)
            return o(!0), { error: "Blocked profanity." };
        }
      return !e.data.vertical && !e.data.allowNewlines && (l.includes(`
`) || l.includes("\r")) ? (o(!0), { error: "Cannot span multiple lines." }) : !e.data.curved && !Array.from(w.values()).every((I) => I) ? (o(!0), { error: "Does not fit." }) : (o(!1), { info: (e.data.maxLength - l.length).toString() });
    })();
    if (u.error) {
      r(u.error);
      return;
    }
    if (r(`${u.info} characters remaining` || ""), c)
      return;
    i.updateStorage(e.stepName, { text: B }), i.updateMetadata(e.stepName, {
      text: this.injectReplaceableText(B, e.data)
    }), (n.defaultCleared || !e.data.deleteDefaultOnFocus) && i.setMandatoryFulfilled(e.stepName, !0);
    const E = [];
    for (const Q of d) {
      const p = e.data.curved ? l : (w.get(Q.id) || []).join(`
`);
      E.push(
        this.generateTextChangeCommandsForRegion(
          C.get(Q.id) || 1,
          e.data,
          Q.id,
          p
        )
      );
    }
    return new k(E);
  }
}
const j = new Cn();
class mt {
}
const wn = "data:application/font-woff;base64,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", hn = `<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="289.691px" height="204.059px" viewBox="0 0 289.691 204.059" enable-background="new 0 0 289.691 204.059"
	 xml:space="preserve">
<g id="Layer_3">
	<g>
		<g>
			<defs>
				<path id="SVGID_1_" d="M132.799,0L132.799,0c-2.85,0-5.611,0.376-8.204,1.119c-6.512,1.865-14.407,8.455-17.575,17.447
					c-5.374,1.759-16.263,6.039-18.474,16.876c-12.301,4.695-59.215,23.718-76.41,46.864c-1.783,2.067-14.076,17.86-11.873,42.198
					c2.083,23.017,14.66,39.637,20.03,46.733c0.496,0.655,0.925,1.223,1.271,1.697c3.272,4.502,16.448,20.198,29.967,27.96
					c0.985,0.565,2.526,1.337,3.598,1.671c9.286,2.898,13.053,0.684,13.053,0.684l-5.734-6.704
					c-0.113-0.047-1.555-2.104-2.024-3.528c-0.401-1.1-0.683-3.708,1.941-8.822c1.92-3.74,8.466-11.905,30.74-24.556
					c19.286-10.953,45.665-22.672,78.404-34.831c0.384-0.138,43.36-15.521,71.448-17.843l0.084-0.007l0.084-0.01
					c0.056-0.006,5.722-0.659,11.761-0.659c7.122,0,10.06,0.898,11.094,1.355l0.378,9.638c0,0,5.87-4.852,7.88-7.117
					c2.01-2.264,12.031-11.822,14.79-47.407c0.084-0.941,1.244-14.374,0.202-25.831c-0.428-4.706-2.167-9.042-5.03-12.54
					c-4.914-6.004-15.065-13.686-35.521-16.2c-0.84-0.118-8.692-1.176-21.503-1.176c-14.431,0-29.204,1.305-43.952,3.882
					c-1.858-1.395-4.78-2.782-9.053-2.782c-0.427,0-0.861,0.014-1.303,0.043c-1.604-2.318-4.231-4.531-8.237-5.259
					c-0.396-0.076-1.797-0.315-3.752-0.315c-0.897,0-1.798,0.051-2.676,0.152h-0.001c-0.244,0.007-1.149-0.008-2.428-0.517
					c-0.623-0.317-2.157-1.062-3.567-1.46c-0.945-0.267-2.142-0.54-3.842-0.54c-1.387,0-2.951,0.186-4.78,0.569l-0.214,0.045
					l-0.073,0.023c-0.141,0.032-0.727,0.154-1.455,0.154c-0.378,0-0.727-0.033-1.036-0.098C139.516,0.637,136.489,0,132.799,0z"/>
			</defs>
			<clipPath id="SVGID_2_">
				<use xlink:href="#SVGID_1_"  overflow="visible"/>
			</clipPath>
			
				<radialGradient id="SVGID_3_" cx="0.6661" cy="211.1478" r="1" gradientTransform="matrix(196.7466 -33.1074 59.2188 355.3871 -12531.9229 -75128.1562)" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style="stop-color:#31006F"/>
				<stop  offset="0.7044" style="stop-color:#31006F"/>
				<stop  offset="0.9025" style="stop-color:#8663A8"/>
				<stop  offset="0.9837" style="stop-color:#380874"/>
			</radialGradient>
			<path clip-path="url(#SVGID_2_)" fill="url(#SVGID_3_)" d="M289.231,36.928c0-15.893-21.025-34.603-52.712-35.045
				c-15.771-0.22-99.017-1.969-102.404-3.731C132.43-2.669,102,8.514,99.071,14.978c-1.352,2.989-12.46,12.774-12.087,16.225
				C43.908,47.213,14.509,73.752,3.19,93.894c-4.256,7.574-5.912,24.772,1.863,48.426c7.171,21.815,39.719,65.369,55.762,70.653
				c34.873-19.08-3.701-15.168,25.189-33.173c37.467-23.352,96.365-43.82,128.896-51.007c51.454-11.366,72.09-9.938,70.905-8.055
				C293.781,108.06,291.07,57.024,289.231,36.928z"/>
		</g>
		<path fill="#F4F5F5" d="M273.502,102.985c0,0-0.484,7.046-0.92,8.889l-0.856,0.768l-1.487,1.343c0,0,0.746-3.28,0.676-7.538
			L273.502,102.985z"/>
		<g>
			<defs>
				<path id="SVGID_4_" d="M273.495,103.048l-0.914,8.826l-6.223,5.407l-0.378-9.638c-3.51-1.84-20.124-1.91-40.523,1.965
					c-20.398,3.875-55.726,13.5-108.591,37.875c-52.865,24.375-56.042,40.035-56.3,41.165c-0.258,1.129-0.609,2.871-0.246,4.106
					c0.363,1.234,1.566,3.062,1.566,3.062c0.622,0.875,6.294,7.434,6.294,7.434c-0.243,0.139-0.713,0.296-0.713,0.296
					c-3.776-1.363-10.024-5.048-12.507-6.55c-0.105-0.059-0.211-0.109-0.316-0.168c-0.213-0.126-0.425-0.267-0.634-0.411
					l-0.127-0.079l-0.016-0.022c-4.346-3.133-7.493-10.523,1.153-21.838c7.623-9.975,16.641-15.494,27.199-21.737
					c35.97-21.271,88.653-41.928,128.445-51.065c20.468-4.7,37.871-6.713,47.404-5.994
					C270.766,96.641,274.312,100.216,273.495,103.048z M103.152,50.182c-0.754,0.298-4.411,1.78-5.162,2.081
					c-46.711,18.73-75.543,39.262-85.429,55.22c-4.89,7.894-6.183,14.713-7.333,23.376c-0.528,3.979-0.264,9.917,0.182,13.905
					c0.098,0.872,0.196,1.558,0.285,1.837c-6.447-20.414-0.184-36.278,3.696-43.319c10.903-19.787,49.756-42.606,92.09-58.743
					C101.625,47.168,102.123,48.443,103.152,50.182z M289.642,46.027c0,0-1.68-8.208-8.18-16.932
					C281.44,29.064,260.598,16,235.788,15.96c-15.584-0.025-35.217,2.462-56.404,6.836c0.858,0.69,2.004,2.132,1.76,4.812
					c21.139-4.514,40.632-7.022,56.269-6.997c16.325,0.026,32.385,3.661,38.959,8.397c2.862,2.062,6.187,5.337,8.039,8.968
					c0.562,1.011,3.167,5.866,5.214,12.307C289.626,50.282,289.762,47.693,289.642,46.027z"/>
			</defs>
			<clipPath id="SVGID_5_">
				<use xlink:href="#SVGID_4_"  overflow="visible"/>
			</clipPath>
			<rect x="282.522" y="30.129" clip-path="url(#SVGID_5_)" fill="#95979A" width="7.146" height="21.322"/>
			
				<radialGradient id="SVGID_6_" cx="0.6661" cy="211.1478" r="1" gradientTransform="matrix(270.0389 19.3946 -19.0497 267.9429 3989.5959 -56677.875)" gradientUnits="userSpaceOnUse">
				<stop  offset="0" style="stop-color:#000000"/>
				<stop  offset="0.0996" style="stop-color:#242425"/>
				<stop  offset="0.2741" style="stop-color:#4E4F51"/>
				<stop  offset="0.5029" style="stop-color:#757779"/>
				<stop  offset="0.7746" style="stop-color:#A6A8AB"/>
				<stop  offset="0.8165" style="stop-color:#E2E3E4"/>
				<stop  offset="0.8338" style="stop-color:#ECEDED"/>
				<stop  offset="0.8581" style="stop-color:#F2F2F3"/>
				<stop  offset="0.9255" style="stop-color:#F3F4F4"/>
				<stop  offset="0.9497" style="stop-color:#85878A"/>
				<stop  offset="0.9601" style="stop-color:#77787B"/>
				<stop  offset="0.9911" style="stop-color:#C8CACC"/>
			</radialGradient>
			<path clip-path="url(#SVGID_5_)" fill="url(#SVGID_6_)" d="M274.97,104.208c-1.015,1.477-1.895,7.095-2.389,7.667
				c0.266-0.396-6.223,5.407-6.223,5.407S53.633,196.961,60.248,199.321c-1.672-0.501-3.655-1.4-5.602-2.491
				c-4.713-2.786-8.78-10.369,0.376-22.35c7.623-9.975,16.641-15.494,27.199-21.736c35.97-21.271,88.653-41.929,128.445-51.066
				c20.468-4.7,37.871-6.713,47.404-5.994C271.591,96.703,276.421,101.309,274.97,104.208z M101.481,44.54
				c-42.334,16.137-81.187,38.956-92.09,58.743c-3.88,7.042-10.143,22.905-3.696,43.319c-0.089-0.279-0.188-0.965-0.285-1.837
				c-0.446-3.989-0.711-9.927-0.182-13.905c1.15-8.662,2.444-15.482,7.333-23.376c9.886-15.959,38.718-36.49,85.429-55.219
				c0.752-0.301,4.408-1.784,5.162-2.081C102.123,48.443,101.625,47.168,101.481,44.54z M235.789,15.959
				c-15.583-0.025-35.217,2.462-56.404,6.835c0.858,0.69,2.004,2.132,1.76,4.812c21.139-4.514,40.632-7.022,56.269-6.997
				c16.325,0.026,32.385,3.661,38.959,8.397c2.862,2.062,7.305,5.886,8.059,9.237c-0.04-1.016-0.352-2.27-0.408-2.911
				C283.11,25.107,267.1,16.009,235.789,15.959z"/>
		</g>
		<path fill="#DCDDDE" d="M60.273,199.427l7.908,3.825l-5.24-6.101C62.941,197.152,58.272,198.786,60.273,199.427"/>
		
			<radialGradient id="SVGID_7_" cx="0.6661" cy="211.1478" r="1" gradientTransform="matrix(270.0424 19.3949 -19.05 267.9464 3989.6995 -56678.5859)" gradientUnits="userSpaceOnUse">
			<stop  offset="0" style="stop-color:#000000"/>
			<stop  offset="0.0996" style="stop-color:#242425"/>
			<stop  offset="0.2741" style="stop-color:#4E4F51"/>
			<stop  offset="0.5029" style="stop-color:#757779"/>
			<stop  offset="0.7746" style="stop-color:#A6A8AB"/>
			<stop  offset="0.8338" style="stop-color:#ECEDED"/>
			<stop  offset="0.8581" style="stop-color:#F2F2F3"/>
			<stop  offset="0.9255" style="stop-color:#F3F4F4"/>
			<stop  offset="0.9601" style="stop-color:#77787B"/>
			<stop  offset="0.9911" style="stop-color:#C8CACC"/>
		</radialGradient>
		<path fill="url(#SVGID_7_)" d="M273.283,103.591c-1.014,1.477-1.926,2.342-2.419,2.914c1.213-1.808-4.269-10.909-55.135-0.044
			c-20.898,4.464-58.364,17.017-91.77,32.224c-14.657,6.627-44.582,21.095-57.613,32.959c-12.456,11.341-14.277,24.658-5.817,27.676
			c-1.672-0.501-3.937-1.4-5.884-2.491c-4.713-2.786-8.78-10.369,0.376-22.35c7.623-9.975,16.641-15.494,27.199-21.737
			c35.97-21.271,88.653-41.928,128.445-51.065c20.468-4.7,37.871-6.713,47.404-5.994
			C271.591,96.703,274.735,100.692,273.283,103.591z M101.481,44.54c-42.334,16.137-81.187,38.956-92.09,58.743
			c-3.88,7.042-10.143,22.905-3.696,43.319c-0.089-0.279-0.188-0.965-0.285-1.837c-0.446-3.989-0.711-9.927-0.182-13.905
			c1.15-8.662,2.444-15.482,7.333-23.376c9.886-15.959,38.718-36.49,85.429-55.219c0.752-0.301,4.408-1.784,5.162-2.081
			C102.123,48.443,101.625,47.168,101.481,44.54z M235.789,15.959c-15.583-0.025-35.217,2.462-56.404,6.835
			c0.858,0.69,2.004,2.132,1.76,4.812c21.139-4.514,40.632-7.022,56.269-6.997c16.325,0.026,32.385,3.661,38.959,8.397
			c2.862,2.062,6.771,6.064,8.179,9.197c-0.546-1.213-0.441-2.314-0.498-2.954C283.141,25.023,267.1,16.009,235.789,15.959z"/>
	</g>
</g>
<g id="Layer_2">
	<g opacity="0.7">
		<defs>
			
				<rect id="SVGID_8_" x="112.559" y="3.607" transform="matrix(0.1079 -0.9942 0.9942 0.1079 82.6225 182.4761)" opacity="0.7" width="60.856" height="83.188"/>
		</defs>
		<clipPath id="SVGID_9_">
			<use xlink:href="#SVGID_8_"  overflow="visible"/>
		</clipPath>
		<g clip-path="url(#SVGID_9_)">
			<g>
				<defs>
					
						<rect id="SVGID_10_" x="112.559" y="3.607" transform="matrix(0.1079 -0.9942 0.9942 0.1079 82.6225 182.4761)" width="60.856" height="83.188"/>
				</defs>
				<clipPath id="SVGID_11_">
					<use xlink:href="#SVGID_10_"  overflow="visible"/>
				</clipPath>
				<g transform="matrix(1 0 7.450581e-09 1 -7.629395e-06 0)" clip-path="url(#SVGID_11_)">
					
						<image overflow="visible" enable-background="new    " width="636" height="465" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnwAAAHRCAYAAADwh2T7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(0.13 0.0141 -0.0141 0.1301 104.926 10.4696)">
					</image>
				</g>
			</g>
		</g>
	</g>
	<g>
		<path fill="#ED1C24" d="M174.957,30.203c-0.284-0.646-1.032-1.349-2.281-1.388c-0.213-0.007-0.435,0.007-0.667,0.04
			c-0.904,0.135-1.788,0.676-2.397,1.515c-0.402-0.719-1.081-1.196-1.905-1.321c-0.113-0.015-0.225-0.023-0.335-0.027
			c-0.035-0.001-0.07-0.002-0.105-0.002c0.172-0.292,0.28-0.589,0.333-0.87c0.131-0.693-0.072-1.291-0.545-1.601
			c-0.191-0.125-0.416-0.196-0.65-0.203c-0.414-0.013-0.742,0.159-1.09,0.342c-0.158,0.083-0.322,0.169-0.491,0.236
			c-0.302,0.121-0.62,0.221-0.948,0.31c-0.029-0.454-0.146-0.885-0.436-1.223c-0.197-0.229-0.553-0.506-1.131-0.524
			c-0.063-0.002-0.128-0.001-0.194,0.004c-0.966,0.063-1.745,0.958-2.372,2.727c-0.002-0.19-0.031-0.381-0.09-0.567
			c-0.244-0.763-0.938-1.273-1.766-1.299c-0.319-0.01-0.649,0.055-0.953,0.188c-1.049,0.458-1.616,1.61-1.291,2.623
			c0.025,0.077,0.057,0.15,0.091,0.222c-1.238,0.182-2.105,1.065-2.674,1.944c-0.238-0.137-0.515-0.227-0.835-0.237
			c-0.169-0.005-0.339,0.014-0.506,0.058c-0.744,0.195-1.028,0.664-1.142,1.25c-0.255-0.728-0.738-1.205-1.626-1.278
			c-0.04-0.003-0.08-0.006-0.119-0.007c-0.921-0.029-2.08,0.433-2.367,2.796c-0.036,0.299-0.063,0.607-0.082,0.909
			c-0.185-0.607-0.511-1.198-1.091-1.689c-0.646-0.547-1.254-0.676-1.651-0.689c-0.637-0.02-1.129,0.236-1.377,0.481
			c-0.597,0.589-0.39,1.317-0.29,1.724c0.101,0.407,0.175,0.841,0.148,1.094c-0.193-0.645-0.454-1.168-0.971-1.624
			c-0.483-0.427-1.119-0.664-1.84-0.686c-0.187-0.006-0.378,0.003-0.569,0.027c-1.897,0.236-3.379,1.794-4.103,4.067
			c-0.137-0.23-0.291-0.438-0.46-0.621c-0.752-0.814-1.642-1.242-2.643-1.273c-0.282-0.009-0.576,0.014-0.874,0.068l-0.035,0.007
			c-0.416,0.089-1.162,0.321-1.482,0.869c-0.247,0.423-0.376,1.01,0.169,1.614c-0.218-0.108-0.428-0.184-0.624-0.236
			c-0.283-0.076-0.568-0.119-0.846-0.128c-0.847-0.026-1.578,0.258-1.956,0.761c-0.202,0.269-0.366,0.639-0.279,1.093
			c-0.423-0.205-0.899-0.324-1.389-0.34c-0.248-0.008-0.501,0.011-0.752,0.055c-1.608,0.242-2.789,1.427-3.544,3.038
			c-0.073-0.026-0.149-0.046-0.227-0.059l-0.102-0.013l-0.051-0.002c-0.585-0.018-0.94,0.353-1.176,0.599
			c-0.035,0.036-0.07,0.073-0.108,0.111c-0.072-0.797-0.11-1.449-0.109-2.219c0.002-1.13,0.277-1.776,0.46-2.081l0.108-0.037
			c0.742-0.252,1.458-0.494,2.075-0.713c1.449-0.513,2.455-0.881,3.21-1.315c1.468-0.844,2.565-2.057,2.934-3.245
			c0.274-0.882,0.244-1.625-0.086-2.15c-0.22-0.35-0.557-0.574-0.947-0.631l-0.09-0.012l-0.063-0.002
			c-0.458-0.014-0.795,0.195-1.15,0.417c-0.257,0.16-0.576,0.359-1.07,0.584c-1.027,0.468-2.291,0.943-4.226,1.588
			c-2.061,0.687-4.653,1.655-6.419,3.049c-1.906,1.505-2.48,3.077-2.625,4.121c-0.222,1.504,0.493,1.941,0.939,2.068
			c0.108,0.03,0.218,0.048,0.329,0.051c0.725,0.023,1.146-0.487,1.453-0.86l0.116-0.139c0.058-0.068,0.217-0.242,0.521-0.483
			c-0.311,1.478-0.287,3.07-0.178,4.325c-0.914,0.725-1.319,1.77-1.384,2.545c-0.083,1.003,0.31,1.736,1.028,1.915l0.123,0.029
			l0.115,0.004c0.321,0.01,0.567-0.108,0.757-0.244c0.609,4.554,0.717,8.077,0.29,9.801l-0.016,0.064
			c-0.387,1.52,0.233,2.055,0.822,2.236l0.046,0.014l0.047,0.01c0.123,0.026,0.251,0.042,0.379,0.046
			c1.267,0.04,2.568-0.992,3.313-2.627c0.805-1.768,0.616-5.234,0.038-9.882c0.532,3.639,2.059,5.666,4.39,5.738
			c0.124,0.004,0.251,0.001,0.368-0.009c0.849-0.062,1.602-0.463,2.178-1.159c0.355-0.43,0.617-0.941,0.809-1.457
			c0.11,0.087,0.225,0.168,0.344,0.243c0.554,0.365,1.192,0.568,1.845,0.588c1.091,0.034,2.317-0.442,2.439-1.389
			c0.013-0.096,0.022-0.263-0.018-0.454c1.075-0.184,2.154-1.507,2.94-3.632c0.244-0.61,0.524-1.38,0.754-2.37
			c0.905,1.882,2.357,2.659,3.709,2.702c0.195,0.006,0.395-0.002,0.594-0.025c1.006-0.116,1.957-0.705,2.679-1.659
			c0.437-0.578,0.776-1.268,1.008-2.029c0.451,0.709,1.149,1.203,2.224,1.267l0.046,0.002c1.327,0.023,2.306-0.963,2.955-2.236
			c0.959,1.074,1.995,1.336,2.721,1.359c0.829,0.026,1.462-0.254,1.695-0.376c0.59-0.307,0.946-0.813,0.963-1.342
			c1.498-0.553,1.303-2.42,1.236-3.064c-0.027-0.256-0.048-0.613-0.06-1.022c0.391,3.088,2.039,3.501,2.788,3.524l0,0
			c0.15,0.005,0.304-0.004,0.458-0.026c1.034-0.145,1.704-0.783,1.915-1.46c0.426,0.451,0.991,0.741,1.74,0.764
			c0.067,0.002,0.133,0.002,0.199-0.001c0.842-0.031,1.792-0.53,2.195-1.222c0.463,0.425,1.031,0.713,1.71,0.813
			c0.143,0.021,0.287,0.034,0.429,0.039c1.101,0.034,1.976-0.421,2.642-1.037c0.006,0.012,0.012,0.024,0.018,0.035
			c0.269,0.491,0.752,0.65,0.988,0.699c0.12,0.028,0.256,0.044,0.408,0.049c1.154,0.036,2.81-0.562,3.673-2.358
			c0.97-1.986,0.067-3.915-0.472-5.068c-0.1-0.213-0.194-0.414-0.246-0.554c-0.098-0.265-0.126-0.473-0.126-0.618
			c0.146,0.07,0.336,0.137,0.569,0.144l0,0c0.134,0.004,0.268-0.012,0.4-0.05c0.389-0.113,0.702-0.386,0.881-0.77
			C175.21,31.395,175.199,30.754,174.957,30.203z"/>
		<g opacity="0.5">
			<g>
				<g>
					<defs>
						
							<rect id="SVGID_12_" x="122.62" y="13.483" transform="matrix(0.1079 -0.9942 0.9942 0.1079 82.8799 180.6859)" width="38.995" height="61.358"/>
					</defs>
					<clipPath id="SVGID_13_">
						<use xlink:href="#SVGID_12_"  overflow="visible"/>
					</clipPath>
					<path clip-path="url(#SVGID_13_)" fill="#595959" d="M157.669,27.744c0.539-0.235,1.102-0.034,1.257,0.45
						c0.155,0.484-0.156,1.067-0.695,1.302s-1.102,0.034-1.257-0.45C156.819,28.563,157.13,27.98,157.669,27.744z M119.826,43.655
						c-0.307-0.039-0.601,0.927-2.176,1.357c-0.184-1.752-0.28-2.686-0.278-3.95c0.003-1.842,0.643-2.734,0.871-2.994
						c0.889-0.302,1.761-0.595,2.492-0.854c1.426-0.504,2.373-0.855,3.031-1.233c1.285-0.739,2.168-1.752,2.44-2.628
						c0.263-0.848,0.108-1.352-0.159-1.391c-0.268-0.04-0.628,0.384-1.766,0.903c-1.137,0.518-2.508,1.022-4.332,1.63
						c-1.822,0.608-4.417,1.551-6.091,2.872c-1.67,1.319-2.117,2.651-2.225,3.43c-0.095,0.645,0.021,0.83,0.164,0.871
						c0.261,0.074,0.47-0.245,0.779-0.608c0.34-0.4,1.422-1.42,3.907-2.374c-2.038,1.607-1.804,5.732-1.598,7.467
						c-1.159,0.567-1.417,1.691-1.45,2.084c-0.032,0.393,0.058,0.739,0.21,0.777c0.161,0.04,0.533-0.636,1.571-0.962
						c0.69,4.555,1.107,9.428,0.505,11.861c-0.075,0.302-0.256,0.905,0.074,1.007c0.727,0.155,1.8-0.473,2.483-1.972
						c0.704-1.547,0.439-5.103-0.081-9.294c-0.117-0.94-0.224-1.812-0.321-2.628c1.211-0.291,1.874-1.491,2.028-1.952
						C120.088,44.523,120.118,43.702,119.826,43.655z M130.074,51.611c-0.265-0.039-0.868-0.51-1.296-1.466
						c-0.428-0.956-0.667-2.03-0.996-4.399c-0.33-2.376-0.494-2.793-1.161-2.785c-1.585,0.11-1.332,3.047-1.225,4.474
						c-0.121,2.203-0.473,3.913-1.194,3.923c-0.693,0.009-1.276-0.779-1.295-4.642c0.132-5.085,2.759-4.477,3.032-4.377
						c0.26,0.095,0.382,0.213,0.49,0.129c0.164-0.13-0.002-0.695-0.34-1.104s-1.109-0.875-2.144-0.688
						c-2.001,0.292-3.796,3.05-3.633,7.367c0.164,4.356,1.895,6.263,3.668,6.12c2.348-0.172,2.497-4.137,2.494-4.163
						c0.1,0.365,0.627,1.421,1.498,1.957c1.252,0.833,2.599,0.21,2.629-0.029C130.633,51.688,130.339,51.65,130.074,51.611z
						 M131.157,36.977c-0.397,0.085-0.709,0.243-0.775,0.358c-0.29,0.497,0.606,0.526,1.43,1.498
						c0.597,0.704,1.088,1.814,1.094,4.28c0.007,2.777-0.854,4.389-0.854,4.389s-0.213-3.202-0.935-5.373
						c-0.606-1.823-1.491-2.673-2.404-2.919c-0.85-0.228-1.487,0.01-1.658,0.238s-0.076,0.389,0.168,0.665
						c0.244,0.276,1.377,1.501,2.216,4.524c0.789,2.842,0.893,3.765,1.024,4.472s0.258,1.386,0.905,1.443
						c0.46,0.04,1.424-0.8,2.219-2.96c0.423-1.054,0.808-2.278,1.011-3.944c0.381-3.08-0.149-4.973-0.91-5.796
						C133.158,37.278,132.392,36.753,131.157,36.977z M139.529,47.213c1.948-0.224,3.569-3.052,2.982-6.673
						c-0.106-0.653-0.375-1.867-0.943-2.583c-0.426-0.538-0.973-0.891-1.403-0.615c-0.26,0.236-0.128,0.378,0.164,1.215
						c0.292,0.836,0.412,1.987,0.38,3.117c-0.039,1.394-0.291,2.961-1.279,2.961c-1.021,0-1.49-1.887-1.492-3.975
						c-0.002-2.093,0.829-4.31,2.061-4.3c0.628,0.012,0.855,0.441,1.052,0.375c0.272-0.091,0.413-0.952-0.313-1.592
						c-0.413-0.365-1.001-0.466-1.56-0.397c-2.419,0.301-3.811,3.434-3.624,6.951C135.752,45.425,137.38,47.46,139.529,47.213z
						 M145.628,44.787c1.515,0.026,2.403-2.327,2.68-3.779c0.203,0.594,0.482,1.172,0.864,1.664c1.306,1.69,2.804,1.247,3.31,0.984
						c0.268-0.139,0.403-0.329,0.379-0.45c-0.014-0.073-0.086-0.121-0.221-0.12c-0.761-0.005-1.35-0.307-1.926-1.249
						c-0.545-0.911-0.744-3.102-0.662-6.233c0.076-2.898-0.336-3.145-0.888-3.191c-0.947-0.078-1.215,0.941-1.324,1.842
						c-0.15,1.235-0.122,2.681-0.105,3.1c0.01,0.243,0.023,0.688,0.077,1.236c-0.174,1.228-0.597,3.492-1.341,3.448
						c-0.899-0.054-0.589-3.584-0.614-4.841c-0.02-1.043-0.045-2.252-0.962-3.028c-0.822-0.696-1.46-0.372-1.57-0.263
						c-0.175,0.173-0.065,0.431,0.043,0.857c0.12,0.474,0.2,2.01,0.238,4.057C143.646,40.891,143.24,44.643,145.628,44.787z
						 M157.653,33.034c-1.42-0.098-1.575,2.98-1.534,4.971c0.052,2.5,0.824,3.789,2.097,3.61c0.758-0.106,1.073-0.619,1.056-0.869
						c-0.025-0.362-0.44-0.311-0.717-1.207c-0.34-1.504-0.41-2.85-0.249-4.672C158.452,33.225,158.059,33.062,157.653,33.034z
						 M159.146,31.495c0.26,0.093,0.283-0.215,1.269-0.659c0.037-0.016,0.075-0.029,0.111-0.043
						c-0.167,0.823-0.362,2.163-0.43,4.646c-0.122,4.802,1.093,5.506,2.084,5.469c0.708-0.026,1.348-0.566,1.35-0.83
						c0.003-0.321-0.308-0.301-0.523-0.704c-0.487-0.802-0.629-2.096-0.625-4.917c0.044-1.726,0.21-3.044,0.374-4.116
						c0.462-0.075,1.018-0.172,1.714-0.317c2.379-0.495,2.569-2.178,2.294-2.358c-0.195-0.128-0.631,0.233-1.238,0.475
						c-0.829,0.331-1.742,0.524-2.532,0.685c0.024-0.163,0.046-0.321,0.064-0.473c0.165-1.38-0.145-1.597-0.572-1.57
						c-0.738,0.048-1.35,1.713-1.615,2.592c-0.501,0.186-0.913,0.419-1.261,0.725C159.065,30.582,158.878,31.4,159.146,31.495z
						 M169.767,37.669c-0.163,0.581-1.266,3.171-3.484,2.843c-2.028-0.3-2.627-3.201-2.293-5.576
						c0.252-1.79,1.569-4.898,3.883-4.603c1.266,0.193,1.987,1.876,0.644,4.281c-0.739,1.323-1.79,2.002-2.322,2.279
						c0.213,0.858,0.64,1.375,1.301,1.421c0.713,0.049,1.354-0.274,1.843-0.843c0.154-0.18,0.277-0.33,0.393-0.312
						C169.872,37.181,169.841,37.405,169.767,37.669z M166.053,35.928c0.386-0.343,1.023-1.013,1.459-2.014
						c0.637-1.461,0.445-2.312,0.018-2.358c-0.569-0.061-1.407,1.512-1.485,3.318C166.029,35.25,166.031,35.602,166.053,35.928z
						 M174.271,30.85c-0.17-0.386-0.72-0.87-1.799-0.714c-1.189,0.178-2.432,1.418-2.263,3.34c0.164,1.861,0.986,2.894,1.051,4.055
						c0.06,1.08-0.326,1.672-0.87,2.138c-0.257,0.219-0.283,0.328-0.229,0.428c0.054,0.099,0.193,0.148,0.274,0.163
						c0.317,0.085,2.019,0.054,2.875-1.728c0.914-1.871-0.402-3.806-0.759-4.771c-0.391-1.049-0.161-1.942,0.416-2.143
						c0.642-0.224,0.869,0.281,1.138,0.203C174.391,31.739,174.445,31.245,174.271,30.85z M153.379,42.311
						c0.913-0.181,0.801-1.27,0.726-1.99c-0.097-0.932-0.125-3.023,0.072-4.446c0.223-1.611,0.891-3.178,2.191-3.604
						c1.146-0.376,1.619,0.165,1.894-0.117c0.232-0.238-0.183-1.484-1.721-1.509c-1.773-0.029-2.703,2.153-2.97,2.93
						c0,0-0.437-1.385-1.277-1.166c-0.465,0.122-0.385,0.411-0.432,2.009c-0.047,1.596-0.18,3.627,0.031,5.384
						C152.104,41.557,152.467,42.492,153.379,42.311z"/>
				</g>
			</g>
		</g>
		<path fill="#FFF200" d="M157.366,27.533c0.539-0.235,1.102-0.034,1.257,0.45c0.155,0.484-0.156,1.067-0.695,1.302
			c-0.539,0.236-1.102,0.034-1.257-0.45C156.515,28.351,156.827,27.768,157.366,27.533z M119.523,43.443
			c-0.307-0.039-0.601,0.927-2.176,1.357c-0.184-1.752-0.28-2.686-0.278-3.95c0.003-1.842,0.643-2.734,0.871-2.994
			c0.889-0.302,1.761-0.595,2.492-0.854c1.426-0.504,2.373-0.854,3.031-1.233c1.285-0.739,2.168-1.752,2.44-2.628
			c0.263-0.848,0.108-1.352-0.159-1.391c-0.268-0.04-0.628,0.384-1.766,0.902c-1.137,0.518-2.508,1.022-4.332,1.63
			c-1.822,0.608-4.417,1.551-6.091,2.872c-1.67,1.319-2.117,2.651-2.225,3.43c-0.095,0.645,0.021,0.83,0.164,0.871
			c0.261,0.074,0.47-0.245,0.779-0.608c0.34-0.4,1.422-1.42,3.907-2.374c-2.038,1.607-1.804,5.732-1.598,7.467
			c-1.159,0.567-1.417,1.691-1.45,2.084c-0.032,0.393,0.058,0.739,0.21,0.777c0.161,0.04,0.533-0.636,1.571-0.962
			c0.69,4.555,1.107,9.428,0.505,11.861c-0.075,0.302-0.256,0.905,0.074,1.007c0.727,0.155,1.8-0.473,2.483-1.972
			c0.704-1.547,0.439-5.103-0.081-9.294c-0.117-0.94-0.224-1.812-0.321-2.628c1.211-0.291,1.874-1.491,2.028-1.952
			C119.785,44.311,119.815,43.491,119.523,43.443z M129.771,51.4c-0.265-0.039-0.868-0.51-1.296-1.466
			c-0.428-0.956-0.666-2.03-0.996-4.399c-0.33-2.376-0.494-2.793-1.161-2.785c-1.585,0.11-1.332,3.047-1.225,4.474
			c-0.121,2.203-0.473,3.913-1.194,3.923c-0.693,0.009-1.276-0.779-1.295-4.642c0.132-5.085,2.759-4.477,3.032-4.377
			c0.26,0.094,0.382,0.213,0.49,0.129c0.164-0.13-0.002-0.695-0.34-1.104s-1.109-0.875-2.144-0.688
			c-2.001,0.292-3.796,3.05-3.633,7.367c0.164,4.356,1.895,6.263,3.668,6.12c2.348-0.172,2.497-4.137,2.494-4.163
			c0.1,0.365,0.627,1.421,1.498,1.957c1.252,0.833,2.599,0.21,2.629-0.029C130.33,51.477,130.036,51.439,129.771,51.4z
			 M130.853,36.765c-0.397,0.085-0.709,0.243-0.775,0.358c-0.29,0.497,0.606,0.526,1.43,1.498c0.597,0.704,1.088,1.814,1.094,4.28
			c0.007,2.777-0.854,4.389-0.854,4.389s-0.213-3.202-0.935-5.373c-0.606-1.823-1.491-2.673-2.404-2.919
			c-0.85-0.228-1.487,0.01-1.658,0.238s-0.076,0.389,0.168,0.665c0.244,0.276,1.377,1.501,2.216,4.524
			c0.789,2.842,0.893,3.765,1.024,4.472c0.131,0.706,0.258,1.386,0.905,1.443c0.46,0.04,1.424-0.8,2.219-2.96
			c0.423-1.054,0.808-2.278,1.011-3.944c0.381-3.08-0.149-4.973-0.91-5.796C132.854,37.066,132.088,36.542,130.853,36.765z
			 M139.225,47.001c1.948-0.224,3.569-3.052,2.982-6.673c-0.106-0.653-0.375-1.867-0.943-2.583
			c-0.426-0.538-0.973-0.891-1.403-0.615c-0.26,0.236-0.128,0.378,0.164,1.215c0.292,0.836,0.412,1.987,0.38,3.117
			c-0.039,1.394-0.291,2.961-1.279,2.961c-1.021,0-1.49-1.887-1.492-3.975c-0.002-2.093,0.829-4.31,2.061-4.3
			c0.628,0.012,0.855,0.441,1.052,0.375c0.272-0.091,0.412-0.951-0.313-1.592c-0.413-0.365-1.001-0.466-1.56-0.397
			c-2.419,0.301-3.811,3.434-3.624,6.951C135.449,45.214,137.077,47.248,139.225,47.001z M145.325,44.575
			c1.515,0.026,2.403-2.327,2.68-3.779c0.203,0.594,0.482,1.172,0.864,1.664c1.306,1.69,2.804,1.247,3.31,0.984
			c0.268-0.139,0.403-0.329,0.379-0.451c-0.014-0.073-0.086-0.121-0.221-0.12c-0.761-0.005-1.35-0.307-1.926-1.249
			c-0.545-0.911-0.744-3.102-0.662-6.232c0.076-2.898-0.336-3.145-0.888-3.191c-0.947-0.078-1.215,0.941-1.324,1.842
			c-0.15,1.235-0.122,2.68-0.105,3.1c0.01,0.243,0.023,0.688,0.077,1.236c-0.174,1.228-0.597,3.492-1.341,3.448
			c-0.899-0.053-0.589-3.584-0.614-4.841c-0.02-1.043-0.045-2.252-0.962-3.028c-0.822-0.696-1.46-0.372-1.57-0.263
			c-0.175,0.173-0.065,0.431,0.043,0.857c0.12,0.474,0.2,2.01,0.238,4.057C143.342,40.679,142.937,44.431,145.325,44.575z
			 M157.349,32.822c-1.42-0.098-1.575,2.98-1.534,4.971c0.052,2.5,0.824,3.789,2.097,3.61c0.757-0.106,1.073-0.619,1.056-0.869
			c-0.025-0.362-0.44-0.311-0.717-1.207c-0.34-1.504-0.41-2.85-0.249-4.672C158.149,33.014,157.756,32.85,157.349,32.822z
			 M158.843,31.284c0.26,0.093,0.283-0.215,1.269-0.659c0.037-0.016,0.074-0.029,0.111-0.043c-0.167,0.823-0.362,2.163-0.43,4.646
			c-0.122,4.802,1.093,5.506,2.084,5.469c0.708-0.026,1.348-0.566,1.35-0.83c0.003-0.321-0.308-0.301-0.523-0.704
			c-0.487-0.802-0.629-2.096-0.625-4.917c0.044-1.726,0.21-3.044,0.374-4.116c0.462-0.075,1.018-0.172,1.715-0.317
			c2.379-0.495,2.569-2.178,2.294-2.358c-0.195-0.128-0.631,0.233-1.238,0.475c-0.829,0.331-1.742,0.524-2.532,0.685
			c0.024-0.163,0.046-0.321,0.064-0.473c0.165-1.38-0.145-1.597-0.572-1.57c-0.738,0.048-1.35,1.713-1.615,2.592
			c-0.501,0.186-0.914,0.419-1.261,0.725C158.762,30.371,158.575,31.188,158.843,31.284z M169.464,37.457
			c-0.163,0.581-1.266,3.171-3.484,2.843c-2.028-0.3-2.627-3.201-2.293-5.576c0.252-1.79,1.569-4.898,3.883-4.603
			c1.266,0.193,1.987,1.876,0.644,4.281c-0.739,1.323-1.79,2.002-2.322,2.279c0.213,0.858,0.64,1.375,1.301,1.421
			c0.713,0.049,1.354-0.274,1.843-0.843c0.154-0.18,0.277-0.33,0.393-0.312C169.569,36.97,169.538,37.194,169.464,37.457z
			 M165.75,35.716c0.386-0.343,1.023-1.013,1.459-2.014c0.637-1.461,0.445-2.312,0.018-2.358c-0.569-0.061-1.407,1.512-1.485,3.318
			C165.725,35.038,165.728,35.391,165.75,35.716z M173.968,30.638c-0.17-0.386-0.72-0.87-1.799-0.714
			c-1.189,0.178-2.432,1.418-2.263,3.34c0.164,1.861,0.986,2.894,1.051,4.055c0.06,1.08-0.326,1.672-0.87,2.138
			c-0.257,0.219-0.283,0.328-0.228,0.428c0.054,0.099,0.193,0.148,0.274,0.163c0.317,0.085,2.019,0.054,2.875-1.728
			c0.914-1.871-0.402-3.805-0.759-4.77c-0.391-1.049-0.161-1.943,0.416-2.143c0.642-0.224,0.869,0.281,1.138,0.203
			C174.087,31.527,174.141,31.033,173.968,30.638z M153.075,42.099c0.913-0.181,0.801-1.27,0.726-1.99
			c-0.097-0.932-0.125-3.023,0.072-4.446c0.223-1.611,0.891-3.178,2.191-3.604c1.146-0.376,1.619,0.165,1.894-0.117
			c0.232-0.238-0.183-1.484-1.721-1.509c-1.773-0.029-2.703,2.153-2.97,2.93c0,0-0.437-1.385-1.277-1.166
			c-0.465,0.122-0.385,0.411-0.432,2.009c-0.047,1.596-0.18,3.627,0.031,5.384C151.801,41.345,152.163,42.28,153.075,42.099z"/>
	</g>
	
		<linearGradient id="cadbury_logo_2_" gradientUnits="userSpaceOnUse" x1="151.1472" y1="251.8356" x2="178.1811" y2="232.0889" gradientTransform="matrix(0.99 0.1407 0.1407 -0.99 -56.0405 236.3141)">
		<stop  offset="0" style="stop-color:#986E3A"/>
		<stop  offset="0.511" style="stop-color:#D6B37C"/>
		<stop  offset="1" style="stop-color:#9A673B"/>
	</linearGradient>
	<path id="cadbury_logo_1_" fill="url(#cadbury_logo_2_)" d="M160.872,15.197c0.086-0.372,0.157-0.937-0.174-1.216
		c-0.116-0.072-0.243-0.08-0.381-0.036c-0.196,0.076-0.326,0.259-0.39,0.459c-0.353,0.937-0.622,1.924-1.184,2.793
		c-0.168,0.259-0.395,0.583-0.658,0.576c-0.065-0.004-0.117-0.039-0.155-0.17c-0.175-0.763,0.2-1.636,0.454-2.383
		c0.091-0.22,0.15-0.53,0.046-0.738c-0.059-0.109-0.167-0.174-0.284-0.184c-0.334-0.017-0.534,0.258-0.7,0.522
		c-0.606,1.125-1.099,2.418-1.915,3.445c-0.122,0.126-0.242,0.298-0.432,0.28c-0.082-0.012-0.148-0.077-0.178-0.183
		c-0.106-0.462,0.035-1.152,0.243-1.692c0.152-0.393,0.327-0.638,0.402-1.033c0.03-0.212-0.035-0.402-0.231-0.509
		c-0.105-0.045-0.209-0.066-0.358,0.006c-0.282,0.153-0.53,0.382-0.862,0.444c0.066-0.236,0.151-0.459,0.136-0.708
		c-0.02-0.211-0.089-0.449-0.284-0.531c-0.189-0.069-0.423-0.018-0.597,0.134c-0.499,0.5-0.529,1.315-0.303,1.961
		c-0.157,0.821-0.547,1.604-0.992,2.3c-0.166,0.224-0.328,0.479-0.608,0.514c-0.188,0.001-0.279-0.133-0.327-0.364
		c0.275-0.536,0.607-1.127,0.758-1.694c0.119-0.441,0.282-1.121,0.01-1.539c-0.058-0.102-0.194-0.172-0.338-0.161
		c-0.27,0.011-0.47,0.209-0.628,0.407c-0.595,0.865-0.739,1.875-0.754,2.904c-0.107,0.328-0.283,0.666-0.545,0.914
		c-0.124,0.123-0.334,0.24-0.5,0.161c-0.094-0.062-0.15-0.161-0.169-0.275c-0.096-0.637,0.147-1.258,0.35-1.852
		c0.362-1.059,0.739-1.311,0.551-1.759c-0.073-0.165-0.239-0.27-0.407-0.277c-0.219-0.021-0.469,0.105-0.604,0.312
		c-0.295,0.49-0.602,1.004-1.025,1.409c-0.249,0.222-0.459,0.429-0.829,0.589c-0.023-0.205-0.069-0.415-0.131-0.603
		c-0.197-0.605-0.578-1.196-1.284-1.15c-0.245,0.015-0.485,0.143-0.651,0.244c0.09-0.875,0.321-1.735,0.74-2.5
		c0.255-0.467,0.664-0.939,0.713-1.334c0.026-0.212-0.065-0.419-0.243-0.524c-0.186-0.096-0.374-0.096-0.583,0.004
		c-0.423,0.242-0.674,0.708-0.888,1.135c-0.402,0.443-1.005,0.643-1.614,0.777c-0.808,0.21-1.324-0.023-1.864-0.518
		c-0.147-0.116-0.328-0.243-0.541-0.226c-0.222-0.002-0.444,0.199-0.531,0.354c-0.114,0.182-0.118,0.435-0.006,0.61
		c0.457,0.663,1.038,1.173,1.296,2.062c0.059,0.206,0.106,0.411,0.107,0.626c-1.579,0.918-2.489,2.841-2.42,4.606
		c-0.157,0.514-0.311,1.399-0.913,1.365c-0.304-0.063-0.729-1.071,0.118-4.043c0.044-0.447,0.176-0.92-0.058-1.35
		c-0.134-0.242-0.449-0.288-0.698-0.28c-1.978,0.201-3.175,2.511-4.069,4.116c-1.125,1.8-2.473,2.883-3.843,3.561
		c-3.361,1.665-7.159,1.041-7.425-2.664c-0.255-3.531,1.91-7.598,6.584-9.522c3.61-1.485,5.994-0.295,5.953,1.836
		c-0.02,1.037-0.719,4.227-5.229,5.846c-0.775,0.278-2.187,0.391-2.762-0.277c-0.902-1.064-0.583-2.368-0.007-3.289
		c1.005-1.489,2.717-2.402,4.498-2.85c0.146-0.029,0.267-0.096,0.342-0.259c0.044-0.111,0.042-0.214-0.014-0.355
		c-0.096-0.19-0.278-0.234-0.459-0.215c-1.623,0.229-3.108,0.916-4.264,1.891c-1.366,1.243-2.38,2.854-2.253,4.68
		c0.092,1.191,0.898,2.265,2.078,2.571c1.308,0.292,3.093-0.317,4.279-0.927c2.478-1.401,4.552-3.835,4.883-6.584
		c0.121-1.23-0.477-2.475-1.557-3.129c-1.735-0.995-5.294-0.958-8.865,1.322c-1.286,0.823-3.225,2.255-4.59,4.855
		c-1.364,2.601-1.449,6.171,0.654,8.159c1.531,1.447,4.03,1.905,6.552,1.207c1.826-0.506,3.653-1.959,5.125-3.85
		c-0.081,1.148,0.661,1.663,1.375,1.677c1.581,0.02,2.267-1.975,2.267-1.975c0.19,0.575,0.264,0.837,0.872,0.994
		c1.026,0.261,1.476-0.572,1.657-1.215c0.175,0.408,0.636,0.79,1.117,0.739c0.759-0.073,1.291-0.769,1.577-1.373
		c1.009-2.136,1.002-4.585,0.396-6.807c0.431-0.025,0.712-0.134,1.084-0.257c0.21-0.068,0.373-0.122,0.579-0.205
		c-0.345,1.389-0.567,2.831-0.558,4.315c0.044,0.98,0.096,2.118,0.788,2.783c0.298,0.306,0.729,0.407,1.152,0.268
		c0.539-0.158,0.988-0.897,1.171-1.439c0.132-0.331,0.325-1.121,0.373-1.659c0.214-0.151,0.435-0.286,0.641-0.451
		c0.085-0.069,0.13-0.101,0.212-0.169c-0.101,0.607-0.207,1.302-0.064,1.912c0.091,0.424,0.355,0.799,0.773,0.9
		c0.688,0.142,1.395-0.759,1.801-1.273c0.137,0.243,0.307,0.499,0.589,0.593c0.332,0.109,0.784-0.029,1.067-0.36
		c0.826-0.967,1.176-2.288,1.596-3.486l0.045-0.125c0.215-0.056,0.397-0.136,0.595-0.257c-0.181,0.503-0.33,1.025-0.396,1.563
		c-0.089,0.655,0.013,1.49,0.571,1.83c0.286,0.15,0.666-0.028,0.87-0.193c0.658-0.565,1.088-1.383,1.492-2.119l0.031-0.05
		c-0.014,0.404,0.055,0.946,0.254,1.288c0.114,0.201,0.361,0.368,0.583,0.35c0.677-0.078,1.008-0.707,1.391-1.23
		c0.066-0.09,0.136-0.209,0.177-0.266c-0.169,0.857-0.485,1.799-0.675,2.663c-0.049,0.22-0.204,0.705-0.125,0.998
		c0.089,0.332,0.34,0.563,0.83,0.614c0.091,0.008,0.139-0.037,0.148-0.106c-0.116-0.546,0.002-0.992,0.22-1.791
		C160.065,18.438,160.489,16.803,160.872,15.197z M137.211,19.107c-0.455,1.511-1.221,3.579-1.733,4.151
		c-0.694,0.776-1.06-0.081-0.88-0.598c0.272-1.31,0.914-3.001,1.948-3.999c0.137-0.115,0.473-0.4,0.664-0.182
		C137.279,18.616,137.261,18.942,137.211,19.107z M141.501,20.641c-0.125,0.378-0.278,0.806-0.557,1.127
		c-0.081,0.099-0.235,0.216-0.368,0.117c-0.328-0.263-0.291-0.978-0.222-1.421c0.131-0.847,0.558-1.744,1.347-2.201l0.043-0.022
		C141.852,19.053,141.705,19.865,141.501,20.641z M145.322,20.76c-0.086,0.025-0.165,0.006-0.233-0.034
		c-0.314-0.245-0.397-0.973-0.422-1.517c-0.02-0.431,0.041-1.236,0.425-1.577c0.242-0.179,0.531-0.126,0.629,0.136
		c0.209,0.505,0.213,1.379,0.116,1.958C145.779,20.072,145.676,20.676,145.322,20.76z"/>
</g>
</svg>

`, v = (g) => ZA("http://www.w3.org/2000/svg", g), Qt = (g, e) => {
  const t = v("rect");
  return t.setAttribute("height", `${g}`), t.setAttribute("width", `${e}`), t;
}, En = () => {
  const g = v("svg");
  return g.setAttribute("xmlns", "http://www.w3.org/2000/svg"), g.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), g.setAttribute("version", "1.1"), g;
}, un = (g) => {
  const e = v("use");
  return e.setAttribute("xlink:href", g), e.setAttribute("href", g), e;
};
function pA(g) {
  const e = En(), t = /viewBox="0 0 (.+?) (.+?)"/.exec(g) || ["0", "0"], A = parseFloat(t[1]), a = parseFloat(t[2]);
  return e.setAttribute("height", `${a}`), e.setAttribute("width", `${A}`), [e, a, A];
}
const mn = (g, e, t) => {
  const A = v("g");
  g.appendChild(A), A.setAttribute("id", t), A.innerHTML = e;
};
function DA(g, e, t) {
  const A = J();
  mn(e, t, `bgdef-${A}`), g.appendChild(un(`#bgdef-${A}`));
}
const IA = (g, e, t, A) => {
  const a = Ie("filter");
  a.setAttribute("id", A), a.setAttribute("height", "200%"), a.setAttribute("width", "200%"), a.setAttribute("x", "-50%"), a.setAttribute("y", "-50%");
  const n = Ie("feOffset");
  a.appendChild(n), n.setAttribute("result", "offOut"), n.setAttribute("in", "SourceAlpha"), n.setAttribute("dx", `${g}`), n.setAttribute("dy", `${e}`);
  const i = Ie("feGaussianBlur");
  a.appendChild(i), i.setAttribute("result", "blurOut"), i.setAttribute("in", "offOut"), i.setAttribute("stdDeviation", `${t}`);
  const s = Ie("feBlend");
  return a.appendChild(s), s.setAttribute("in", "SourceGraphic"), s.setAttribute("in2", "blurOut"), s.setAttribute("mode", "normal"), a;
}, fA = (g) => {
  let e = g;
  return e = e.replace(/feoffset/gi, "feOffset"), e = e.replace(/fegaussianblur/gi, "feGaussianBlur"), e = e.replace(/feblend/gi, "feBlend"), e = e.replace(/lineargradient/gi, "linearGradient"), e = e.replace(/stddeviation/gi, "stdDeviation"), e;
};
function pt(g, e, t, A, a, n) {
  const i = a || 1, s = n || 1, o = {
    x: e[0],
    y: e[1],
    width: e[2] - e[0],
    height: e[3] - e[1]
  };
  if (o.width <= 0)
    return;
  const r = Qn(o.height, o.width, t * i, A * s), c = (A - r * o.width) / 2 - r * o.x, B = (t - r * o.height) / 2 - r * o.y;
  g.setAttribute("transform", `translate(${c} ${B}) scale(${r} ${r})`);
}
function Qn(g, e, t, A) {
  const a = t / g, n = A / e;
  return a > 1 && n > 1 ? Math.min(a, n) : a > 1 && n < 1 ? n : a < 1 && n > 1 ? a : Math.min(a, n);
}
const Gt = {
  m: ["x", "y"],
  z: [],
  l: ["x", "y"],
  h: ["x"],
  v: ["y"],
  c: ["x1", "y1", "x2", "y2", "x", "y"],
  s: ["x2", "y2", "x", "y"],
  q: ["x1", "y1", "x", "y"],
  t: ["x", "y"],
  a: ["rx", "ry", "xRotation", "largeArc", "sweep", "x", "y"]
};
class Dt {
  constructor(e) {
    const t = Array.from(e.querySelectorAll("path"));
    this.paths = t.map((A) => {
      const a = A.getAttribute("d") || "", n = this.parsePath(a);
      return { pathElement: A, pathData: n };
    });
  }
  transform(e) {
    for (const t of this.paths)
      t.pathData = this.runTransformer(t.pathData, e);
    this.update();
  }
  encodePath(e) {
    let t = "";
    const a = (n) => {
      const i = [], s = n.relative ? n.type : n.type.toUpperCase();
      let o = t !== s;
      const r = Gt[n.type];
      o && (i.push(s), t = s);
      for (const c of r) {
        const B = n[c];
        let l;
        switch (typeof B) {
          case "boolean":
            l = B | 0;
            break;
          case "number":
            l = (B * 100 | 0) / 100;
            break;
          default:
            throw new he("Failed to encode path.");
        }
        o || i.push(" "), i.push(l), o = !1;
      }
      return i.join("");
    };
    return e.map(a).join("");
  }
  parsePath(e) {
    const t = /([mzlhvcsqta])([^mzlhvcsqta]*)/gi, A = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi, a = [];
    let n;
    for (t.lastIndex = 0; n = t.exec(e); ) {
      const i = n[1].toLowerCase(), s = (n[2].match(A) || []).map(parseFloat), o = i === n[1], r = Gt[i];
      if (s.length < r.length)
        throw new he(
          `Path type "${i}" given ${s.length} arguments, expected ${r.length}.`
        );
      if (r.length > 0) {
        if (s.length % r.length !== 0)
          throw new he(
            `Path type "${i}" given ${s.length} arguments, not divisible by ${r.length}`
          );
        for (let c = 0; c < s.length / r.length; c++) {
          const B = { type: i, relative: o };
          for (let l = 0; l < r.length; l++)
            B[r[l]] = s[c * r.length + l];
          a.push(B);
        }
      } else
        a.push({ type: i, relative: o });
    }
    return a;
  }
  runTransformer(e, t) {
    const A = [
      ["x1", "y1"],
      ["x2", "y2"],
      ["x", "y"]
    ], a = (n) => {
      for (let i = 0; i < A.length; i++) {
        const [s, o] = A[i];
        if (s in n && o in n) {
          const r = [n[s], n[o]], c = t(r);
          if (c.length < 2)
            throw new he("Transformer must return at least 2 points.");
          n[s] = c[0], n[o] = c[1];
        }
      }
      return n;
    };
    return this.transformPath(e, a);
  }
  transformPath(e, t) {
    const A = [];
    for (let a = 0; a < e.length; a++) {
      const n = JSON.parse(JSON.stringify(e[a])), i = t(n);
      Array.isArray(i) ? A.push(...i) : i && A.push(i);
    }
    return A;
  }
  update() {
    for (const { pathElement: e, pathData: t } of this.paths) {
      const A = this.encodePath(t);
      e.setAttribute("d", A);
    }
  }
}
class pn extends mt {
  constructor() {
    super(...arguments), this.moduleName = "Favourites";
  }
  svgPreview(e) {
    return this.svg(e);
  }
  svgPrint(e) {
    return this.svg(e);
  }
  svg(e) {
    const t = Ct(wn), a = e !== "" ? ((i) => i.charAt(0).toUpperCase() + i.substr(1).toLowerCase())(e) : "", n = t.getPath(a, 0, 72, 72);
    return this.brandSvg(n, hn);
  }
  brandSvg(e, t) {
    const A = e.toSVG(2), a = e.getBoundingBox(), n = a.x2 - a.x1, i = e.toPathData(3), s = () => {
      const p = v("g"), m = v("defs");
      p.appendChild(m), m.appendChild(IA(3, 7, 4, "shadow"));
      const I = v("g");
      p.appendChild(I), I.setAttribute("filter", "url(#shadow)"), I.innerHTML = A;
      const F = v("g");
      p.appendChild(F), F.setAttribute("fill", "red"), F.setAttribute("stroke", "red"), F.setAttribute("stroke-width", "9"), F.innerHTML = A;
      const y = v("g");
      p.appendChild(y), y.setAttribute("fill", "#9d2621"), y.setAttribute("transform", "translate(1,1)"), y.innerHTML = A;
      const Y = v("g");
      return p.appendChild(Y), Y.setAttribute("fill", "yellow"), Y.innerHTML = A, new Dt(p).transform(([S, T]) => [S, T + (n / 2 - S) ** 2 / (n * 2.9)]), p;
    }, [o, r, c] = pA(t);
    if (!o)
      return "";
    const B = v("defs");
    o.appendChild(B), DA(o, B, t);
    const l = r * 0.23, d = c * 0.94, C = c * 0.04, w = r * 0.53, h = v("g");
    o.appendChild(h), h.setAttribute("transform", `translate(${C} ${w}) rotate(-21)`);
    const u = Qt(l, d);
    u.setAttribute("opacity", "0"), h.appendChild(u);
    const E = v("g");
    h.appendChild(E);
    const D = s();
    E.appendChild(D);
    const Q = wt(i);
    return pt(E, Q, l, d), fA(o.outerHTML);
  }
}
const Dn = "data:application/octet-stream;base64,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";
class In extends mt {
  constructor(e, t) {
    super(), this.moduleName = "Maltesers", this.shortLength = 5, this.indicator = (A) => A ? 1 : 0, this.backgroundSvg = e, this.backgroundShortSvg = t;
  }
  svgPreview(e) {
    return this.svg(e);
  }
  svgPrint(e) {
    return this.svg(e);
  }
  svg(e) {
    const t = Ct(Dn), a = e !== "" ? ((o) => o.charAt(0).toUpperCase() + o.substr(1).toLowerCase())(e) : "", n = t.getPath(a, 0, 72, 72), i = e.length < this.shortLength, s = i ? this.backgroundShortSvg : this.backgroundSvg;
    return this.brandSvg(n, s, i);
  }
  brandSvg(e, t, A) {
    const a = e.toSVG(2), n = e.getBoundingBox(), i = n.y2 - n.y1, s = n.x2 - n.x1, o = e.toPathData(3), r = () => {
      const I = v("g"), F = v("g");
      I.appendChild(F), F.setAttribute("stroke", "#5C1A0D"), F.setAttribute("stroke-width", "4"), F.setAttribute("transform", "translate(1,1)"), F.innerHTML = a;
      const y = v("g");
      I.appendChild(y), y.setAttribute("fill", "#FFE386"), y.setAttribute("transform", "translate(1,1)"), y.innerHTML = a;
      const Y = v("g");
      I.appendChild(Y), Y.setAttribute("fill", "white"), Y.innerHTML = a;
      const N = new Dt(I);
      return N.transform(([S, T]) => [S, T + ((s - S) * T) ** 2 / (s * 5e4)]), N.transform(([S, T]) => [
        S,
        T + (s / 3 - S) ** 2 / s * this.indicator(S < s / 3)
      ]), N.transform(([S, T]) => [S - (i - T) * (s - S) / 800, T]), I;
    }, [c, B, l] = pA(t);
    if (!c)
      return "";
    const d = v("defs");
    c.appendChild(d), DA(c, d, t);
    let C, w, h, u;
    A ? (C = B * 0.25 * (1 + 0.1), w = l / 2 * (1 + 0.1), h = l * 0.22, u = B * 0.32) : (C = B * 0.22 * (1 + 0.1), w = l * 0.8, h = l * 0.067, u = B * 0.33);
    const E = v("g");
    c.appendChild(E), E.setAttribute("transform", `translate(${h} ${u}) rotate(-10)`);
    const D = Qt(C, w);
    D.setAttribute("opacity", "0"), E.appendChild(D);
    const Q = v("g");
    E.appendChild(Q);
    const p = r();
    Q.appendChild(p);
    const m = wt(o);
    return pt(Q, m, C, w), c.outerHTML;
  }
  // 1 if true, 0 if false.
}
const fn = "data:application/octet-stream;base64,AAEAAAAPAIAAAwBwRkZUTYdHeHoAAElcAAAAHEdERUYAJwBUAAAe2AAAAB5HUE9TkNtcVAAAHygAACoyR1NVQrj/uP4AAB74AAAAME9TLzJoWmUcAAABeAAAAGBjbWFwtkIacAAAAxAAAAJWZ2FzcP//AAMAAB7QAAAACGdseWY27KOUAAAGCAAAFcRoZWFkFPal0gAAAPwAAAA2aGhlYQU0Ar0AAAE0AAAAJGhtdHiADw6qAAAB2AAAAThsb2Nh5CzfJAAABWgAAACebWF4cACVAEwAAAFYAAAAIG5hbWXeIPPyAAAbzAAAAiJwb3N0ABeZTwAAHfAAAADdAAEAAAABAAAZ9vREXw889QALA+gAAAAA2ZexNAAAAADZl7E0ADL/yQJ2ArwAAAAIAAIAAAAAAAAAAQAAArz/wwAAAqsAAAAAAnYAAQAAAAAAAAAAAAAAAAAAAE4AAQAAAE4ASQAFAAAAAAACAAAAAQABAAAAQAAAAAAAAAAEAbsBkAAFAAACigK7AAAAjAKKArsAAAHfADEBAgAAAAAAAAAAAAAAAAAAAAcAAAAAAAAAAAAAAABYWFhYAEAACgCtArz/wwAAAqkANgAAAAMAAAAAAmQCZAAAACAAAgIPADIAAAAAAU0AAAAAAAAAAAAAALQAAAD3ADUCfQA1AcoANQKrADUCDQA1AX4ANQHYADUBNQA1AcgANQHUADUB8AA1AeEANQHpADUBqQA1AdAANQHpADUCqgA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUB3AA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUAtAAAAAAAAAAAAAMAAAADAAAAHAABAAAAAAFQAAMAAQAAABwABAE0AAAALgAgAAQADgAAAAoADQAhACYAKgA5AFoAXgB6AKAArQDFAM8A1gDdAOUA7wD2AP0A/wF4//8AAAAAAAoADQAgACMAKgAwAEAAXgBhAKAArQDAAMcA0QDYAOAA5wDxAPgA/wF4//8AAf/5//f/5f/k/+H/3P/W/9P/0f+s/6AAAAAAAAAAAAAAAAAAAAAA/0v+twABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYAIAAwADoARABOAF4AaAAAAAAAAAAXABcAFwAXABcAFwAZABsAGwAbABsAHwAfAB8AHwAkACUAJQAlACUAJQAlACsAKwArACsALwAyADIAMgAyADIAMgA0ADYANgA2ADYAOgA6ADoAOgA/AEAAQABAAEAAQABAAEYARgBGAEYASgAAAQYAAAEAAAAAAAAAAQIDAAAEAAAAAAAAAAAAAAAAAAAAAQAABQYABwgJCgAAAAsAAAAAAAwNDg8QERITFBUAAAAAAAAWFxgZGhscHR4fICEiIyQlJicoKSorLC0uLzAAAAAxAAAyMzQ1Njc4OTo7PD0+P0BBQkNERUZHSElKSwAAAAAAFxcZGyQlKzIyMjIyMjQ2NjY2Ojo6Oj9AQEBAQEZGRkYAAAAAAAAAAAAAAAAAAAAlAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAABMFxclAAAAAAAAAAAAAEovAAAAAAAAAAAAAAAXGxcbGx8fHx8lJQAlKysrAAAAAAAAAAAAAAAAAAAAACgAKAAoACgAKAAoADwAbgC0AQgBbgGQAcYB1AIGAkYCYAKSAtAC4gMoA2ADyAPgBBoEUAR4BI4EogTWBOoE9gUiBToFSAViBXoFqgXWBjAGWgaaBqwG2AbqBwYHIAc2B0wHXgd2B7AH5ggOCCQIOAhsCIAIjAi4CNAI3gj4CRAJQAlsCcYJ8AowCkIKbgqACpwKtgrMCuIK4griAAAABQAyAAAB3QK8AAMABgAJAAwADwAAEyERIRsCCwEREwMhAxMRMgGr/lUcubrGtMG5AXKttQK8/UQCqP7LATX+tgEs/acBGP7MAUn+0QJdAAACADUABQDCAmoAAwAHAAATESMRExUjNcGLi4sCaf5mAZr+KY2NAAAAAgA1AAACSAJkABsAHwAAJQcjNyMHIzcjNzM3IzczNzMHMzczBzMHIwczByc3IwcBthdrFkoXbBdeDl8KYA9fFWwVShVtFWoPagpqDscJSgqqqqqqqmxHbJqamppsR2xsR0cAAAEANf/JAZUCqgAwAAABFR4BByM0LgEjIgYVFBYXHgMVFA4BBxUjNS4BNTMUFjMyNjU0LgInJjU0Njc1ARwwPAF3CBQOExcsPCEwFgkZNyhnPkGDGRQTGBElHBprRzQCqkQNV0INGBIdFB8hGw4tMCkUJkU7EENDCmk8GiUgFBIeGA4LKXpKVxBEAAAABQA1/+8CdgJrAAwAGAAcACkAOAAAEzQ2MzIeARUUBiMiJjcVFBYzMjY1NCYiBiUDIxMDNTQ+ATMyFhQGIyImNxUUHgEzMjY1NC4BIyIGNk02JD0jTTc2TVEeFBUeHiodAWjhVeEtIz0kN01ONjZOUQ4YDRUeDhcOFR4B1j5XKEUoPldXPgEXISEYGCEhcf2dAmP+JgEoRChXfFdWPwEPGhAiGBAbDyIAAwA1AAAB2AJnACQAOQBIAAAlFwcnDgEjIiY1ND4CNyY1NDYzMhYVFA4IBxc3MyciBhUUHgQXPgU1NCYjAxY+ATcnDgUVFBYBmT8qQgdUMk1cDyETFDVTNzdPAwUJBw0HDgUMATUabPULGQQFCgUKAQENBAsEBBYNAQ8bEQRRAQ4ECwUEIbFNZEERMGJKHzMqEhFDQD9ZVjsLFxITDRAJDgULAUFBtRgSBw4LDwcOAQEQBg8LDwcPGf58AQsOB2IBDQUOCg8IGyQAAAAAAQA1ATwBSQJtABEAABMHNxcHFwcnFyM3Byc3JzcXJ+YXVSVnZyhTGE0WUShnZyVWGAJselJLJSVOVXp7Vk4nI0tReQACADUAAAGjAmQAFwAmAAA3NTQ+AzMyHgMdARQOAiMiLgI3FRQeATMyPQE0IyIOAjYZJzIvFxQtMicaIjc9Hh09OiR8CBsXOTkSGAsF4KQxTzEhDQwhMFAypDtaMhkYMlvjrBUkH1isVxEeGgABADUAAAEAAmEABQAAMxEjNTMRhE7KAd6D/Z8AAQA1AAMBkwJmACEAADc1Njc+AzU0JiMiByM+Ajc+AzMyFhUUBgcGBzMVOi5WFxkaCx0XMQJ2AQINDQ4qLCIQTlkjLkAargN3L1kYHCcoFyIhXhsgNxccJxIHbU04WDRHHYEAAAEANQAAAZ8CZAAtAAATNjc2MzIWFRQOAwcWFRQGIyImJyYnMxYXMjY1NC4DKwE1MzI1NCYjIgdDAjktP0RVCw0VCwlca0otVRYVBn4KLhobCg8UDQcsFT0RESQCAaxgMCdfQRcoGBcIBiVpTWwrKCRENgElHRAYCwcCbzsVHjMAAgA1//8BuwJjAAoADQAAITUjNRMzETMVIxUnMzUBDdfadDY20WJrcgGF/oN6a+XAAAAAAAEANf//AawCYwAgAAABFSMHNjMyHgIVFA4CIyIuASczFjMyNjU0JiMiBycTAX+uCxsnKUIlExYrSy8zUS8HfRYjGygkHy4SZSoCYoBSEic+QyEkSkIqL00xJi8hHy80HwFTAAACADUAAAG0AmIAFgAoAAABMhYVFAYjIiYnJjU0PwEzBw4BBzAyNgMyPgE1NC4EIyIGFRQeAQEaO19vTy9QGCksepBYAw4CCA0kEx8TBAgLDxQLHSUVHQGvbF9kgConOV1LVdqUBRYFAv7XFCYXChMSEAwHLyEaJxIAAAAAAQA1//8BdAJjAAYAABMhFQMjEyM2AT6sibS9AmJ3/hUB3wAAAwA1AAABmwJkABkAJAAuAAATNTQ2MhYVFA4BBxYVFA4BIi4BNTQ3LgMXFRQWMjY1NCYiBjcVFBYyNjQmIgZCVqBWFBAMPC1RaFEtPAkLEgpwHjAdHTAeCRskGxskGwG/AUJhYkIeMxINJGU5WjMzWjllJAkNHSbhARgqKhkaKirTARcfHy8fHwAAAAACADUAAAG0AmQAFgAkAAA/AT4BNyYOASMiJjU0NjMyFhcWFRQPARM1NC4BIyIGFRQWMzI2fVgDDQQBCA0EO15uTy9QGCoteSsVHhAcKCUfHiUBlAQWBgEBAWxfZIAqJzldTFXaAYkBGiYSLiIgMi4AAgA1/8wCdQJtADgASAAAAQcGBwYzMjY1NCYjIgYHBh4DFxY3FQYnLgQ3ND4CMzIWFRQGIyInBicuATU0NjMyFhc3BzY1NC4CJyYGHQEUFjc2AfscBAIBFhYmbFVhdgcBBhwtVThNX01cQGlGMBUBLExzQniZWjs3FB07NT1PQBwoBwgqCQIHEg0gKCAUIQG2ux0NGVo8Wm2Laxg2RTcpBAUfWxsCASlBVlsvQHpfOqF8XZBBNwEBWkRIcyAWKMkaIgcQGBEBAz8rAyYjAQIAAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAEANQFFAaYCagAGAAAbATMTIycHNnx3fYE4NwFFAST+3LOzAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAAAEADGAAEAAAAAAAEACAASAAEAAAAAAAIABwArAAEAAAAAAAMAFQBfAAEAAAAAAAQACACHAAEAAAAAAAUAIgDWAAEAAAAAAAYADwEZAAEAAAAAABAACAE7AAEAAAAAABEABwFUAAMAAQQJAAEAEAAAAAMAAQQJAAIADgAbAAMAAQQJAAMAKgAzAAMAAQQJAAQAEAB1AAMAAQQJAAUARACQAAMAAQQJAAYAHgD5AAMAAQQJABAAEAEpAAMAAQQJABEADgFEAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAADEALgAwADAAMgA7AFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAAAxLjAwMjtWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFYAZQByAHMAaQBvAG4AIAAxAC4AMAAwADIAOwBGAG8AbgB0AHMAZQBsAGYAIABNAGEAawBlAHIAIAAzAC4AMwAuADAAAFZlcnNpb24gMS4wMDI7Rm9udHNlbGYgTWFrZXIgMy4zLjAAAFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAABWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAAAAAAgAAAAAAAP+DADIAAAAAAAAAAAAAAAAAAAAAAAAAAABOAAAAAQACAQIBAwADAAQABgAHAAgACQANABMAFAAVABYAFwAYABkAGgAbABwAIwAkACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0AQQBEAEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0ArAEECWNvbnRyb2xMRgljb250cm9sQ1IKc29mdGh5cGhlbgAAAAAAAAH//wACAAEAAAAMAAAAFgAAAAIAAQABAE0AAQAEAAAAAgAAAAAAAQAAAAoALAAuAAJERkxUAA5sYXRuABgABAAAAAD//wAAAAQAAAAA//8AAAAAAAAAAQAAAAoAMAA+AAJERkxUAA5sYXRuABoABAAAAAD//wABAAAABAAAAAD//wABAAAAAWtlcm4ACAAAAAEAAAABAAQAAgAAAAEACAABKd4ABAAAAEYAlgEwAd4CjAM2A+AEegUsBWYGDAa+B3AIHgjQCYIKNAriC4gMAgx0DOYNZA3mDlQOyg88D54QEBCGEQARchHsEmIS1BOWFAwUghTwFWIV1BaiFxQXkhgEGMYZdBomGtQbfhwYHL4dYB3+HpgfPh/oIJYhPCHmIpQjRiPsJJolSCXuJpQnQifoKJIpRAAmAAn/8QAK//sADP/7AA3/+wAO//sAD//7ABD/+wAR//sAEv/7ABP/+wAU//sAFf/xABb/8QAZ//sAHf/2AB7/+wAf//sAIP/xACH/+wAi//sAI//7ACT/+wAl//EAJv/2ACf/8QAo//sAKf/2ACr/+wAr//sALP/sAC3/7AAu/+IAL//dADD/9gAx/+wAMv/7ADP/+wA0//YAKwAG//EACP/nAAn/4gAK/9MAC//iAAz/9gAN/+IADv/sAA//4gAQ/9gAEf/iABL/1QAT//EAFP/nABX/8QAW/9gAMf/TADL/pgAz//MANP/nADX/8QA2//EAN//7ADj/7gA5//YAOv/7ADv/2AA8//EAPf/2AD7/9gA///EAQP/sAEH/+wBC/+wAQ//xAET/7ABF/+wARv/2AEf/3QBI/90ASf/EAEr/zgBL//YAKwAG//YAB//2AAn/3QAL/+wADP/sAA3/8QAO//YAD//sABD/8QAR/+wAEv/iABP/5wAU/+wAFf/dABb/7AAX/78AMf/YADL/sAAz/+IANP/iADX/8QA2/+cAN//xADj/3QA5/+wAOv/2ADv/4gA8//EAPf/xAD7/8QA///YAQP/YAEH/9gBC/+cAQ//sAET/7ABF/+wARv/xAEf/zgBI/9MASf/OAEr/zgBL/+wAKgAG//YAB//iAAj/4gAK/+IADP/dAA3/ugAO/+IAD//iABD/5wAR/+IAEv/dABP/yQAU/90AFf+mABb/0wAx/5gAMv/YADP/4gA0/9MANf/xADb/7AA3/+wAOP/iADn/7AA6//EAO//dADz/5wA9/+wAPv/sAD//5wBA/9gAQf/sAEL/zgBD/+wARP/YAEX/tQBG/90AR/+hAEj/oQBJ/8QASv+DAEv/7AAqAAb/8QAH/90ACP/YAAn/oQAL/8kADP/iAA3/sAAO/+cAD//YABD/4gAR/90AEv/bABP/4gAU/+IAFf/TABb/5wAg/+QAMf/nADL/3AAz//QANP/rADX/9AA2//IAN//4ADj/8AA5//QAOv/1ADv/7AA8/+oAPf/7AD7/9wA///IAQP/tAEH/+wBC/+IAQ//2AET/4wBF/7YARv/vAEf/pgBK/6MAS//yACYAB//TAAj/8QAK/84ADP/dAA3/9gAO//EAD//dABD/pgAR/8kAEv+6ABP/7AAU/90AFf/OADH/xAAy/5IAM//sADT/3QA1/+cANv/xADf/9gA4/90AO/9WADz/5wA9//EAPv/sAD//5wBA/84AQf/dAEL/0wBD/+cARP/nAEX/5wBG/+cAR//dAEj/2ABJ/7oASv/JAEv/4gAsAAb/+wAH//sACP/xAAn/zgAK/+cAC//dAAz/9gAN/9gADv/tAA//7AAQ/+kAEf/rABL/3QAT/90AFP/hABX/3QAW/90AMf/nADL/vwAz/+cANP/nADX/8QA2//EAN//sADj/5wA5//YAOv/2ADv/4gA8//EAPf/2AD7/+wA///sAQP/2AEH/+wBC/+wAQ//7AET/7ABF/9MARv/7AEf/yQBI/84ASf+wAEr/xABL/+cADgAG//sACf/xAAv/7AAN//sADv/7AA8AAAAR//EAEv/0ABP/9gAU//EAFf/xABb/7AAx//YAQP/2ACkABv/7AAf/9gAI//sACf/iAAr/5wAL/+wADP/vAA3/3QAO//sAD//qABD/8QAR/+wAEv/nABP/8QAU/+cAFf/iABb/7AAx/+cAMv/vADP//AA0/+cANf/7ADb//gA4//EAOf/8ADr//AA7/+kAPP/6AD3//QA+//4AP//7AEL/6gBD//0ARP/2AEX/7ABG//EAR//YAEj/4gBJ/+wASv/LAEv//AAsAAb/+wAH//EACP/2AAn/0wAK/+IAC//JAAz/5wAN/90ADv/iAA//7AAQ/+cAEf/sABL/3QAT/9MAFP/iABX/zgAW/+cAMf/YADL/xAAz/+wANP/dADX/6AA2//EAN//xADj/4wA5//EAOv/2ADv/7AA8/+wAPf/sAD7/9gA//+wAQP/iAEH/8QBC/90AQ//nAET/5wBF/8QARv/mAEf/xABI/8kASf+1AEr/rQBL/+IALAAG//sAB//7AAj/9gAJ/9MACv/2AAv/ugAM/+kADf/dAA7/9gAP/+wAEP/2ABH/8AAS//EAE//2ABT/5wAV/9gAFv/sADH/vwAy/9UAM//eADT/3wA1//EANv/xADf/9gA4/+IAOf/xADr/9gA7/+wAPP/xAD3/9gA+//EAP//2AED/2ABB//EAQv/nAEP/9gBE/+cARf/TAEb/8QBH/9gASP/YAEn/xgBK/78AS//xACsABv/7AAf/9gAI/+wACf/TAAr/5wAL/90ADP/lAA3/zgAO/90AD//dABD/7AAR/+IAEv/iABP/2AAU/+IAFf/JABb/5wAx/90AMv/EADP/6wA0/+EANf/wADb/8AA4/9wAOf/dADr/7AA7/9gAPP/sAD3/5wA+/+wAP//iAED/0wBB/+IAQv/YAEP/4gBE/84ARf/JAEb/4gBH/8kASP/OAEn/vwBK/8kAS//TACwABv/7AAf/3wAI/+cACf+wAAr/4wAL/8kADP/dAA3/xwAO/+cAD//dABD/7AAR/+cAEv/iABP/yQAU/9cAFf+/ABb/4gAa/+kAMf/YADL/uwAz/+EANP/dADb/6wA3//MAOP/lADn/8QA6//IAO//eADz/5wA9/+4APv/zAD//8ABA/+IAQf/2AEL/6gBD//YARP/kAEX/zABG/+8AR/+0AEj/uwBJ/64ASv+vAEv/5QAsAAb/+wAH/90ACP/nAAn/4gAK/9MAC//nAAz/3QAN//YADv/eAA//3QAQ/7AAEf/OABL/sAAT//sAFP/dABX/0wAW/9MAMf/iADL/iAAz//YANP/OADX/9gA2//EAN//xADj/0wA5//YAOv/zADv/gAA8//EAPf/7AD7/+wA///YAQP/OAEH/7gBC/84AQ//2AET/2ABF//sARv/2AEf/5wBI/+cASf/TAEr/4gBL/+wALAAG//sAB//2AAj/8QAJ/9gACv/nAAv/3QAM/+IADf/dAA7/4gAP/+IAEP/nABH/5wAS/9gAE//YABT/3QAV/84AFv/sADH/5wAy/78AM//nADT/2AA1/+cANv/nADf/7AA4/90AOf/sADr/7AA7/+cAPP/sAD3/8QA+/+wAP//xAED/4gBB//EAQv/dAEP/5wBE/+IARf/YAEb/5wBH/78ASP/HAEn/sABK/7UAS//dACsABv/xAAf/8QAI/+IACf/dAAr/0wAL/+IADP/iAA3/3QAO/+cAD//dABD/zgAR/9MAEv/EABP/0wAU/84AFv/dADH/4gAy/6EAM//jADT/3QA1/+wANv/sADf/5wA4/90AOf/nADr/8QA7/78APP/xAD3/9gA+/+wAP//nAED/3QBB/+cAQv/nAEP/5wBE/+IARf/OAEb/3QBH/8QASP/JAEn/lwBK/7oAS//YACkABv/sAAf/0wAI/90ACf/OAAr/3QAM/90ADf/EAA7/5wAP/9gAEP/YABH/3QAS/9MAE//YABT/4gAV/90AMf/sADL/wAAz/+8ANP/kADX/6wA2//AAN//2ADj/5AA5//EAOv/uADv/1gA8//QAPf/2AD7/8QA///AAQP/dAEH/7ABD/+gARP/YAEX/1QBG/+wAR/+3AEj/wwBJ/7UASv+wAEv/5gAeAAf/zgAi/+4AI//5ACT/7wAy/9AAM//pADT/sQA1/+sANv/nADf/5gA4/7oAOf/vADr/9wA7/9AAPP/sAD3/6wA+/+YAP//sAED/uwBB/+kAQv+7AEP/5ABE/9QARf+6AEb/0ABH/34ASP+SAEn/zQBK/5sAS//nABwAF//RACT//wAy/9EAM//uADT/5wA1/+8ANv/3ADf/7gA4/+gAOf/3ADr/+wA7/9oAPP/vAD3/9wA+/+4AP//vAED/4QBB//cAQv/nAEP/7wBE/+4ARf/QAEb/9wBH/8EASP/MAEn/wwBK/7sAS//nABwAF//QABv/+QAy/8EAM//zADT/6wA1//sANv/zADf/+wA4/+8AOf/zADr//gA7/+EAPP/vAD3/9wA+//kAP//3AED/4gBB//kAQv/jAEP/8wBE/+YARf/VAEb/+QBH/84ASP/JAEn/twBK/8EAS//rAB8ABv/7ABL/3wAX/8kAJf/5ACv/7wAy/7oAM//zADT/6wA1/+8ANv/uADf/8wA4/+oAOf/vADr/7wA7/9QAPP/5AD3//gA+//EAP//vAED/4wBB//MAQv/mAEP/7gBE/+cARf/XAEb/6wBH/8kASP/JAEn/twBK/7cAS//nACAABv/7ACQAAgAl/+8AJ//5AC3//gAv//4AMv/oADP//QA0/+sANf/7ADb/+gA3//sAOP/jADn/9wA6//oAO//kADz//wA9//0APv/+AD8AAABA/+gAQf/7AEL/6ABD//sARP/sAEX/8QBG//sAR//qAEj/6wBJ/+cASv/qAEv/+QAbAAb/+wAl/+8AMv+5ADP/+wA0/+8ANf/7ADb/+wA3//0AOP/vADn/+wA6AAAAO/+7ADz//gA9//4APv/7AED/7ABB//4AQv/nAEP/+QBE//kARf/7AEb/+QBH//MASP/rAEn/4gBK/+8AS//7AB0ABv/2ABf/zgAl/+8AMv+3ADP/9wA0/+sANf/3ADb/8QA3//kAOP/uADn/8wA6//sAO//YADz/8wA9/+4APv/3AD//8wBA/+MAQf/3AEL/6QBD/+8ARP/nAEX/1ABG/+8AR//JAEj/zABJ/6YASv/JAEv/3AAcAAb/+wAX//MAJf/7ADL/6wAz//4ANP/uADX/+wA2//4AN//+ADj/8wA5//0AOv/+ADv/7gA8//4APf/+AD7/+wA///4AQP/uAEL/9wBD//4ARP/+AEX/+QBG//4AR//uAEj/9wBJ/+4ASv/zAEv//gAYAAb/+wAx//YAMv/rADP//wA0//MANf//ADYAAQA3//8AOP/zADv/6AA8//4APf/+AD4AAQBA/+4AQf//AEL/8wBD//4ARP/4AEX//QBH/+wASP/3AEn/7ABK//EASwABABwABv/2ABf/4QAy/8oAM//9ADT/+QA1//4ANv/7ADf//gA4//MAOf/+ADr//wA7/+EAPP/7AD3//gA+//4AP//+AED/7wBB//4AQv/zAEP//gBE//sARf/7AEb//gBH/+8ASP/5AEn/2gBK//oAS//+AB0ABv/nABf/5wAx/7AAMv/hADP/7gA0/7QANf/rADb/5wA3/+4AOP+sADn/6wA6//kAO/+3ADz/6gA9/+8APv/nAD//5wBA/6wAQf/uAEL/rgBD/+cARP+8AEX/3ABG/9oAR//cAEj/0QBJ/9oASv/RAEv/7wAeAAb/9gAX//cAI//9ADH/vwAy/+4AM//5ADT/2gA1//4ANv/3ADf/+wA4/9oAOf/3ADr/+wA7/+cAPP/7AD3/+QA+//cAP//5AED/1ABB//sAQv/cAEP/9wBE/+8ARf/JAEb/6wBH/8QASP++AEn/5wBK/8EAS//+ABwAF//7ADH/7AAy/+QAM//+ADT/7gA1//4ANgAAADf//QA4//cAOf/7ADr//gA7/+4APP/+AD3//gA+//0AP//7AED/7wBB//4AQv/uAEP//gBE//cARf/7AEb/+QBH/+gASP/vAEn/6wBK/+gAS//+AB4ABv/7ABf/8wAa//4AHf/3ACX/9wAq//4AMf/2ADL/5AAz//0ANP/zADX/+wA2//4AN//+ADj/+QA7/+4APf/+AD7/+wA///4AQP/2AEH/+gBC/+4AQ//7AET/+QBF//sARv/+AEf/8wBI/+8ASf/zAEr/6wBL//4AHQAG//EAJP/3ADH/7AAy/7sAM//sADT/4wA1/+8ANv/vADf/9wA4/+QAOf/qADr/9wA7/98APP/vAD3/9wA+/+sAP//uAED/4wBB/+4AQv/mAEP/7wBE/+IARf/VAEb/7gBH/8MASP/GAEn/uwBK/7oAS//fABwABv/sACT//gAy/54AM//rADT/6gA1//EANv/rADf/9wA4/+MAOf/oADr/9wA7/64APP/sAD3/8QA+/+wAP//sAED/4QBB//MAQv/oAEP/5ABE/9gARf/kAEb/7gBH/9EASP/QAEn/uwBK/8QAS//zADAAF//3ABj//wAZ/+kAGv//ABv//QAc//4AHf/pAB7/+wAf//8AIP/iACH//gAi//8AI//+ACT//wAl/+IAJ//uACj//gAp/+cAKv/hACv/+QAs/8MALf/QAC7/5AAv/8wAMP//ADL/4QAz//4ANP/jADX/9wA3//kAOP/fADn/9wA7/+IAPP/5AD3/+gA+//EAP//6AED/2gBB/+8AQv/aAET/7wBF/9cARv/qAEf/xgBI/7sASf/qAEr/tABL//sAHQAG/+cAF//oACT/+gAy/+IAM//xADT/zAA1/+8ANv/sADf/+gA4/8wAOf/3ADr/8wA7/8kAPP/uAD3/7wA+/+wAP//rAED/yQBB//cAQv/MAEP/+ABE/9QARf/KAEb/2gBH/8EASP/EAEn/4gBK/7cAS//vAB0ABv/xABv/+QAl/+4AMv+8ADP/7wA0/9wANf/zADb/6AA3//cAOP/hADn/5gA6//MAO//aADz/6QA9//MAPv/pAD//6wBA/+MAQf/3AEL/2gBD/+kARP/rAEX/1ABG/+kAR//JAEj/zABJ/7QASv+7AEv/5wAbAAb/9gAy/6YAM//9ADT/0wA1//oANv/+ADf//QA4/9UAOf/3ADr//wA7/7kAPP/6AD3//gA+//sAP//7AED/0ABB//oAQv/XAEP/+QBE/+IARf/zAEb/9wBH/+8ASP/vAEn/6gBK/+cAS//6ABwABv/7ACQAAgAy/9UAM//7ADT/7wA1//cANv/9ADf//wA4/+4AOf/7ADr//wA7/+sAPP/+AD3//gA+//0AP//6AED/7gBB//sAQv/sAEP/+wBE/+8ARf/7AEb//QBH/+8ASP/qAEn/3wBK//gAS//+ABwABv/nABf/lQAy/4IAM//3ADT/wQA1/+kANv/nADf/+gA4/8QAOf/oADr/6wA7/5UAPP/uAD3/+wA+//cAP//vAED/wQBB/+8AQv/DAEP/5wBE/84ARf/uAEb/7gBH/+kASP/pAEn/zgBK/+4AS//7ADMABv/sABf/owAY//kAGf/XABr//gAb//4AHP/5AB3/0AAe//gAIP+tACH/8wAi//4AJP/+ACX/0AAm//kAJ//MACj//gAp/9oAKv/+ACv//gAs/+MALf/zAC7/3AAv//cAMP/7ADL/jwAz/+oANP/CADX/7wA2/+oAN//3ADj/xgA5/+sAOv/6ADv/qgA8/+sAPf/7AD7/7wA//+8AQP++AEH/7gBC/8MAQ//qAET/1QBF/+sARv/pAEf/6ABI/+cASf/iAEr/2gBL/+4AHAAG/+cAF//hADL/1AAz/+sANP+wADX/6wA2/+QAN//jADj/qgA5/+cAOv/jADv/ugA8/+cAPf/vAD7/2gA//+kAQP+uAEH/7wBC/64AQ//kAET/uwBF/9oARv/aAEf/zABI/84ASf/TAEr/zQBL/+sAHwAG/+IAF/+lACP//gAk//sAL//uADL/hwAz/+8ANP+sADX/+AA2/9wAN//6ADj/uQA5/+4AOv/vADv/hAA8/+gAPf/pAD7/5wA//+YAQP+wAEH/6QBC/7oAQ//vAET/zgBF/+gARv/oAEf/2gBI/+YASf/QAEr/4gBL/+kAHAAG//sAF//+ADL/5wAz//sANP/kADX/+wA2//8AN//7ADj/4QA5//4AOv//ADv/6wA8//sAPf/+AD7//gA///sAQP/hAEH/+wBC/9oAQ//+AET/7wBF//sARv/6AEf/6QBI//kASf/rAEr/6QBL//sAMAAG/+wAB//YAAj/3QAJ/9MACv+/AAv/yQAM/+IADf/YAA7/7AAP/9MAEP/JABH/5wAS/+IAE//OABT/4gAV/+wAFv/nACD/WwAh/+wAIv/xACP/8QAk//YAJf/xADL/oQAz/+wANP/nADX/7AA2//sAN//2ADj/9gA5//sAO/+PADz/7AA9//YAPv/sAD//8QBA/+IAQf/nAEL/7ABD/+IARP/JAEX/zgBG/+cAR/+/AEj/xABJ/5IASv+/AEv/4gArAAb/9gAI/8QACf+cAAr/zAAL/5QADP+6AA3/xAAO/+oAD//BABD/zgAR/78AEv+7ABP/2AAU/78AFf+mABcAAgAk/+cAMf+mADL/2AAz/+cANP+7ADX/5gA2//MAN//zADj/sQA5/+oAOv/rADz/6AA9/+gAPv/mAD//5wBA/7oAQf/4AEL/twBD/+gARP/OAEX/sQBG/88AR/+EAEj/lwBJ/9AASv+NAEv/9wAsAAb/9gAH/+oACP/nAAn/xAAK/+gAC//TAAz/3QAN/9gADv/lAA//5wAQ/+IAEf/aABL/3AAT/9MAFP/bABX/xAAk//EAMf/YADL/zQAz/+wANP/kADX/9wA2//MAN//9ADj/4wA5//cAOv/3ADv/5gA8//4APf/9AD7/7gA//+4AQP/kAEH/+QBC/+YAQ//vAET/6QBF/9oARv/vAEf/zgBI/88ASf/QAEr/uQBL//kAKwAG//YAB//qAAj/7AAJ/9gACv/uAAv/4gAM/+IADf/dAA7/9AAP/+IAEP/eABH/5gAS/+IAE//TABT/3QAV/90AJP/2ADH/7AAy/74AM//uADT/3wA1//oANv/xADj/5wA5/+8AOv/5ADv/2AA8/+0APf/9AD7/8wA///EAQP/rAEH/+ABC/+QAQ//3AET/5gBF/9AARv/zAEf/xgBI/80ASf++AEr/twBL/+gAKgAH//EACP/xAAn/0wAK/+YAC//YAAz/5wAN/9gADv/oAA//5wAQ/+IAEf/iABP/2AAU/90AFf/dACT/+wAx/+wAMv+7ADP/9wA0/+QANf/rADb/5wA3//EAOP/kADn/+QA6//YAO//aADz/9wA9//4APv/uAD//8QBA/+cAQf/vAEL/4wBD/+sARP/cAEX/0ABG/+sAR//CAEj/xABJ/7QASv+6AEv/6AAmAAf/9gAI//EACf/sAAr/9gAM/+cADv/6AA//8QAQ//EAEf/vABL/4QAT//EAFP/iABX/5wAy/+kAM//9ADT/5wA1//sANv/9ADf//gA4/+sAOf/+ADoAAQA7/+gAPP/9AD3/9wA+//0AP//9AED/6wBBAAEAQv/pAEP/+QBE/+wARgACAEf/6QBI/+8ASf/nAEr/6wBL//sAKQAH//sACP/xAAn/5wAK/+4AC//2AAz/4gAN//sADv/1AA//8QAQ/90AEf/kABL/4gAT/+wAFP/YABX/3QAx//YAMv+5ADP/+AA0/+MANf/3ADb/+AA3//kAOP/iADn/+gA6//0AO//OADz//QA9//4APv/5AD///ABA/+YAQv/jAEP/9wBE/+YARf/vAEb//gBH/+cASP/vAEn/0QBK/+YAS//9ACgAB//2AAj/4gAJ/90ACv/sAAv/4gAM/+gADf/iAA7/9QAP/+gAEP/dABH/4AAS/+YAE//OABT/4gAV/90AJP/7ADH/9gAy/8EAM//vADT/3wA2//QAN//4ADj/4wA5/+kAOv/6ADv/0QA8/+YAPf/zAD7/6QA///EAQP/qAEL/3ABD/+gARP/fAEb/+ABH/7sASP+7AEn/rwBK/68AS//jACcACP/xAAn/7AAK//gADP/2AA7/9wAP//YAEP/xABH/5wAS/+cAE//xABT/7AAV/+UAMf/2ADL/6AAz//kANP/qADX/+wA2//oAN//7ADj/6wA5//cAOv//ADv/4wA8//sAPf/+AD7/+wA///oAQP/sAEH/+gBC/+MAQ//5AET/7wBF/+oARv/7AEf/4wBI/+wASf/jAEr/6gBL//4AJgAH//sACP/7AAn/5wAK//oADP/2AA7/9gAP//YAEP/xABH/8QAS//IAE//xABT/5wAV//EAMv/nADP/+wA0//EANf/9ADb//gA3//4AOP/uADn/+wA6//4AO//oAD0AAAA+//sAP//+AED/7wBB//4AQv/qAEP//wBE//EARf/3AEb/+wBH/+YASP/3AEn/2gBK/+QAS//7ACkAB//2AAj/9gAJ/90ACv/yAAz/8QAO//EAD//wABD/6gAR/+wAEv/mABP/9AAU/+wAFf/rABf/zgAx//YAMv/OADP/7wA0/+oANf/5ADb//gA3//0AOP/oADn/+QA6//0AO//YADz//gA9//8APv/6AD//+QBA/+4AQf/5AEL/4wBD//gARP/qAEX/+QBG//oAR//pAEj/6QBJ/9UASv/rAEv/+gAqAAf/sgAI/8kACf+wAAr/ugAL/7UADP+1AA3/3QAO/+QAD/+6ABD/sgAR/7UAEv+xABP/4gAU/6sAFf+mADH/lwAy/9oAM//jADT/qwA1/+IANv/iADf/4wA4/5oAOf/XADr/7gA7/7QAPP/kAD3/6wA+/+4AP//mAED/rQBB/+8AQv+qAEP/6gBE/74ARf/XAEb/2gBH/9AASP/SAEn/1QBK/80AS//qACsAB//nAAj/8QAJ/6YACv/sAAv/nAAM/90ADf+6AA7/9gAP/+IAEP/sABH/3QAS/9oAE//sABT/3QAV/8QAJP/+ADH/pgAy/+sAM//vADT/ygA1//0ANv/zADf/+wA4/9MAOf/vADr/+wA7/9gAPP/3AD3/9wA+//EAP//7AED/1QBB//cAQv/PAEP/8wBE/+YARf+7AEb/5wBH/7UASP/JAEn/2gBK/6UAS//zACkAB//2AAn/7AAK//kAC//sAAz/9gAO//oAD//2ABD/7AAR/+cAEv/vABP/9gAU//EAFf/sABcAAQAx/+YAMv/pADP/+QA0/+oANf/zADb/+wA3//oAOP/nADn/9wA6//4AO//uADz/+QA9//oAPv/7AD//+QBA/+8AQf/3AEL/6QBD//oARP/sAEX/8wBG//gAR//pAEj/6QBJ/+MASv/nAEv//QAqAAf/9gAI//sACf/sAAr/9wAL/+wADP/7AA7/+gAP//EAEP/2ABH/7AAS//EAE//2ABT/9gAV/+QAFwABADH/8QAy/+kAM//3ADT/6QA1//kANv/5ADf/+QA4/+8AOf/6ADr//gA7/+8APP/7AD3/+gA+//oAP//4AED/7wBB//sAQv/rAEP//QBE/+8ARf/3AEb/+gBH/+4ASP/rAEn/4QBK/+wAS//5ACsAB//xAAj/4gAJ/9gACv/sAAv/2AAM//YADf/iAA7/8QAP/90AEP/iABH/0wAS/+IAE//JABT/4gAV/94AJP/7ADH/3QAy/7QAM//pADT/4QA1/+wANv/vADf/6gA4/+IAOf/qADr/+gA7/9oAPP/pAD3/6wA+/+wAP//pAED/4QBB/+sAQv/cAEP/6wBE/+IARf/JAEb/7gBH/7wASP/BAEn/pgBK/7UAS//kACwAB//iAAj/5wAJ/+IACv/OAAv/2AAM/+cADf/nAA7/8AAP/90AEP+6ABH/xAAS/9cAE//XABT/2AAV/9gAG//3ACT/+wAx/+IAMv+gADP/6QA0/+MANf/mADb/7wA3/+sAOP/aADn/6AA6//YAO/+xADz/6wA9/+4APv/oAD//7wBA/9oAQf/oAEL/1wBD/+MARP/aAEX/2ABG/+cAR//PAEj/yQBJ/7kASv/BAEv/6AApAAf/8QAI/+wACf/OAAr/6gAL/84ADP/nAA3/2AAO//YAD//fABD/4gAR/9gAEv/lABP/5wAU/+IAFf/YADH/4gAy/+cAM//3ADT/2gA1//gANv/5ADf/+wA4/9wAOf/3ADr//gA7/+MAPP/3AD3//QA+//cAP//3AED/1QBC/9UAQ//9AET/6QBF/+EARv/pAEf/ugBI/8QASf/aAEr/wgBL//sAKwAH/8kACP/YAAn/xAAK/9MAC/+/AAz/yQAN/9gADv/nAA//xAAQ/7oAEf+1ABL/wQAT/9gAFP+6ABX/vwAk//sAMf+/ADL/2gAz/+gANP/KADX/6QA2/+kAN//oADj/xgA5/+QAOv/nADv/uQA8/+wAPf/uAD7/6QA//+cAQP/GAEH/7ABC/8kAQ//mAET/2ABF/84ARv/VAEf/wQBI/7wASf/GAEr/tABL/+8AKwAH//EACP/2AAn/yQAK/+oAC//TAAz/3QAN/+cADv/sAA//4gAQ/+IAEf/YABL/3wAT/90AFP/dABX/2AAk//sAMf/nADL/xgAz//MANP/iADX/7wA2/+4AN//3ADj/4wA5/+kAOv/vADv/1wA8/+4APf/zAD7/6gA//+0AQP/kAEH/9wBC/98AQ//qAET/5wBF/9AARv/vAEf/yQBI/9AASf/PAEr/xABL/+8AKQAH/+cACP/sAAn/5wAK/+kAC//dAAz/2AAO/+wAD//XABD/qwAR/8kAEv/AABP/9gAU/9MAFf/OADH/2AAy/7AAM//5ADT/2gA1//0ANv/6ADf//gA4/98AOf/3ADr//QA7/8YAPP/7AD3//gA+//gAP//4AED/1QBB//0AQv/VAEP/+ABE/+MARf/zAEb/+QBH/+4ASP/zAEn/4gBK/+cAS//zACkACP/2AAn/5wAK//QAC//sAAz/+wAN//4ADv/2AA//5QAQ/+wAEf/nABL/8wAT//EAFP/nABX/3QAx/+QAMv/KADP/+QA0/+wANf/6ADb/+gA3//sAOP/vADn/+gA6AAAAO//hADz//wA9//0APv/5AD///gBA/+wAQf/7AEL/7ABD//sARP/vAEX/9wBG//sAR//zAEj/6gBJ/+EASv/jAEv/+wArAAf/zgAI/84ACf/YAAr/ygAL/9gADP/JAA3/+wAO/9kAD//JABD/ogAR/7oAEv+5ABP/5wAU/8QAFf+9ACT/+wAx/7oAMv+FADP/+wA0/7sANf/qADb/6wA3/+wAOP++ADn/5gA6/+8AO/+iADz/6AA9/+oAPv/sAD//7wBA/8MAQf/mAEL/uwBD/+YARP/KAEX/6QBG/+8AR//jAEj/3wBJ/9MASv/hAEv/6wApAAf/zgAI/84ACf/TAAv/2AAM/84ADv/eAA//xAAQ/7AAEf/TABL/sQAT/+wAFP/FABX/yQAk//sAMf/JADL/lQAz//MANP/BADX/+QA2//MAN//3ADj/xgA5//sAOv/3ADv/pQA8/+8APf/+AD7/7gA//+oAQP/DAEH/7gBC/8QAQ//vAET/0ABF/+4ARv/uAEf/6QBI/+QASf/aAEr/5gBL//cAKgAH/8QACP/OAAn/pgAL/7oADP+rAA3/3QAO/+cAD/+5ABD/twAR/8QAEv+zABP/0wAU/7AAFf+cACT/+wAx/6EAMv/aADP/4wA0/7cANf/4ADb/4wA3//0AOP+3ADn/7gA6/+8AO/+7ADz/7gA9//EAPv/jAD//6ABA/7oAQf/zAEL/uQBD/+sARP/OAEX/3wBG/+EAR//aAEj/2ABJ/9gASv/MAEv/7gAsAAf/yQAI/84ACf/JAAr/wgAL/8kADP/JAA3//gAO/8kAD/+6ABD/jQAR/7oAEv+gABP/4gAU/7UAFf+6AB7/8QAk//sAMf+1ADL/lwAz/+8ANP+7ADX/5gA2/+4AN//uADj/uQA5/+gAOv/3ADv/hAA8/+8APf/sAD7/7AA//+oAQP+6AEH/7ABC/7kAQ//pAET/ygBF/+8ARv/vAEf/6ABI/+kASf/fAEr/5ABL//EAJgAH//YACf/iAAr/7AAL/+cADP/iAA3//wAO//UAD//nABD/7AAR/+IAEv/gABP/7AAU/90AFf/TADH/4gAy/+sAM//+ADT/6AA1//4ANgAEADf//wA4/9wAOf/6ADv/5gA8//8APf//AD///QBA/+MAQf//AEMAAABE/+8ARf/4AEb/+wBH//cASP/rAEn/6QBK/+kAS//9AAIAAQAGAEsAAAAAAAAAAQAAAADUGBYRAAAAANmXsTQAAAAA2ZexNA==";
class Fn extends mt {
  constructor() {
    super(...arguments), this.moduleName = "Vegemite";
  }
  svgPreview(e, t) {
    return this.svgElement(e, t);
  }
  svgPrint(e, t) {
    return this.svgElement(e, t);
  }
  svgElement(e, t) {
    const A = Ct(fn), n = e !== "" ? ((D) => D.charAt(0).toUpperCase() + D.substr(1).toLowerCase())(e) : "", i = A.getPath(n, 0, 72, 72), s = i.toSVG(2), o = i.getBoundingBox(), r = o.x2 - o.x1, c = i.toPathData(3), B = () => {
      const D = v("g");
      D.classList.add("module-text-group");
      const Q = v("defs");
      D.appendChild(Q), Q.appendChild(IA(0, 2, 2, "shadow"));
      const p = v("path");
      p.setAttribute("d", c), p.setAttribute("stroke", "black"), p.setAttribute("stroke-width", "3"), Q.appendChild(p);
      const m = v("g");
      m.classList.add("module-layer0"), D.appendChild(m), m.setAttribute("filter", "url(#shadow)"), m.innerHTML = p.outerHTML;
      const I = v("g");
      I.classList.add("module-layer1"), D.appendChild(I), I.setAttribute("stroke-width", "3"), I.setAttribute("stroke", "rgb(45,41,38)"), I.setAttribute("fill", "rgb(45,41,38)"), I.setAttribute("transform", "translate(0.5,0)"), I.innerHTML = s;
      const F = v("g");
      F.classList.add("module-layer2"), D.appendChild(F), F.setAttribute("fill", "rgb(255,209,0)"), F.setAttribute("transform", "translate(1,-0.1)"), F.innerHTML = s;
      const y = v("g");
      return y.classList.add("module-layer3"), D.appendChild(y), y.setAttribute("fill", "white"), y.innerHTML = s, new Dt(D).transform(([N, S]) => [N, S + (r / 2 - N) ** 2 / (r * 6)]), D;
    }, l = v("g");
    l.classList.add("module-root");
    const d = v("defs");
    l.appendChild(d);
    const C = v("g");
    C.classList.add("module-bounds"), l.appendChild(C);
    const w = Qt(t.height, t.width);
    w.setAttribute("opacity", "0"), C.appendChild(w);
    const h = v("g");
    h.classList.add("module-text-enclosure"), l.appendChild(h);
    const u = B();
    h.appendChild(u);
    const E = wt(c);
    return pt(h, E, t.height, t.width, 0.35, 0.65), fA(l.outerHTML);
  }
}
async function FA(g) {
  if (g === "Favourites")
    return new pn();
  if (g === "Maltesers") {
    const e = _("https://assets.spiff.com.au/public/modules/img/MaltesersBackground.svg"), t = _("https://assets.spiff.com.au/public/modules/img/MaltesersBackgroundShort.svg"), A = await Promise.all([e, t]);
    return new In(A[0], A[1]);
  }
  if (g === "Vegemite")
    return new Fn();
  throw new b(`Failed to resolve Module, Module ${g} not found`);
}
var Ve = /* @__PURE__ */ ((g) => (g.Error = "Error", g.Warning = "Warning", g.Info = "Info", g))(Ve || {});
const yn = 1e3;
class bt extends BA {
  constructor(e) {
    super(), this.createdAt = /* @__PURE__ */ new Date(), this.update = e;
  }
  async execute() {
    await this.update(), await new Promise((e) => {
      window.setTimeout(() => {
        e();
      }, yn);
    });
  }
}
class Mn {
  constructor(e, t, A, a, n, i, s, o, r, c, B, l, d, C = !1, w, h = !1, u = !1, E = !1) {
    this.workflowStatePromiseQueue = new dA(1), this.initialized = !1, this.readOnly = !1, this.isReloadedTransaction = !1, this.singleVariantsRenderable = !1, this.stepTags = {}, this.renderLayouts = () => {
      var p;
      if (!this.previewService)
        return;
      const D = this.getCommandContext().getAllLayouts(), Q = (p = this.getLayoutPreviewService()) == null ? void 0 : p.getAll();
      if (Q)
        for (const [, m] of Q)
          m.render(D);
    }, this.experience = e, this.client = t, this.updateTransaction = s, this.commandContext = i, this.reloadedState = d, this.transaction = o, this.readOnly = C, this.singleVariantsRenderable = u, this.confirmedDesign = !1, this.editedSteps = {}, this.informationResults = [], this.mandatorySteps = {}, this.pendingUpdates = [], this.selectionCost = 0, this.workflow = A, this.stepSpecificServices = {}, this.profanityFilter = a, this.pollers = [], this.allScenes = [], this.layouts = n, this.product = r, this.previewService = B, this.modelContainer = w, this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, this.validationErrors = { steps: /* @__PURE__ */ new Map() }, this.confirmCallbacks = [], this.editedCallbacks = [], this.elementsCallbacks = [], this.informationResultCallbacks = [], this.initCallbacks = [], this.mandatoryCallbacks = [], this.makingAdjustmentsCallback = [], this.metadataCallbacks = [], this.selectionCallbacks = [], this.stepSpecificStorageCallbacks = {}, this.storageCallbacks = [], this.validationCallbacks = [], this.currentAdjustingStepId = "", this.renderableContextService = l, this.isReloadedTransaction = h, this.stepTags = c, E && (this.workflowStatePromiseQueue.enabled = !1), this.initializationPromise = this.initializeDefaultWorkflowState(A), this.initializationPromise.then(() => {
      this.initialized = !0;
    }), this.initializationPromise.catch((D) => {
      throw console.error(D), this.initialized = !1, new Error("Workflow initialization failed due to an error. See console.");
    }), this.initializationPromise.finally(
      () => this.getCommandContext().registerStateCallback(() => {
        this.updateStateWithServer(), this.renderLayouts();
      })
    );
  }
  async initializeDefaultWorkflowState(e) {
    const t = () => {
      var c, B;
      const s = this.workflow.finalizeStepConfig;
      if (!s)
        return;
      const o = s.lookAtAnimation, r = s.modelAnimation;
      o && ((c = this.previewService) == null || c.executeCameraAnimation(o)), r && ((B = this.modelContainer) == null || B.executeAnimation(r));
    };
    this.reloadedState && this.reloadedState.serializableWorkflow.steps.forEach((s) => {
      this.storage[s.stepName] = s.storage || {};
    }), this.allScenes = await za(e);
    const a = ce(this.allScenes, this.stepSelections).map((s) => s.silentSteps).flat(), { stepElements: n, commands: i } = await this.stepElementsForIntroducedSilentSteps(a, !!this.reloadedState);
    this.commandContext.apply(new k(i), !0), this.stepElements = { ...this.stepElements, ...n }, await this.ensureStepsAreLoaded(), !this.isReloadedTransaction && this.updateStateWithServer(), this.renderLayouts(), this.reloadedState && t();
  }
  getWorkflowExperience() {
    return this.experience;
  }
  getClient() {
    return this.client;
  }
  setWorkflowStateSyncEnabled(e) {
    this.workflowStatePromiseQueue.enabled = e;
  }
  getProduct() {
    return this.product;
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  isInitialized() {
    return this.initialized;
  }
  addConfirmCallback(e) {
    e(this.confirmedDesign), this.confirmCallbacks.push(e);
  }
  addEditedCallback(e) {
    e(this.editedSteps), this.editedCallbacks.push(e);
  }
  addElementsCallback(e) {
    e(this.stepElements), this.elementsCallbacks.push(e);
  }
  addInformationResultCallback(e) {
    e(this.informationResults), this.informationResultCallbacks.push(e);
  }
  addInitCallback(e) {
    e(this.stepInitialised), this.initCallbacks.push(e);
  }
  addMandatoryCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  addMetadataCallback(e) {
    e(this.stepMetadata), this.metadataCallbacks.push(e);
  }
  async addSelectionCallback(e) {
    e({
      selectionCost: this.selectionCost,
      selections: this.stepSelections,
      traversableScenes: await this.traversableScenes()
    }), this.selectionCallbacks.push(e);
  }
  addStepSpecificStorageCallback(e, t) {
    Object.keys(this.storage).includes(t) || (this.storage[t] = {}), e(this.storage[t]), Object.keys(this.stepSpecificStorageCallbacks).includes(t) || (this.stepSpecificStorageCallbacks[t] = []), this.stepSpecificStorageCallbacks[t].push(e);
  }
  /**
   * @deprecated Any call to this causes all renderable steps to re-render even if they don't care about change.
   */
  addStorageCallback(e) {
    e(this.storage), this.storageCallbacks.push(e);
  }
  addMakingAdjustmentsCallback(e) {
    e(this.currentAdjustingStepId), this.makingAdjustmentsCallback.push(e);
  }
  addPoller(e) {
    this.pollers.push(e);
  }
  addValidationCallback(e) {
    this.validationCallbacks.push(e), e(this.validationErrors);
  }
  getLayouts() {
    return this.layouts;
  }
  getAllLayoutData() {
    return this.commandContext.getAllLayouts().map((e) => e.layoutState);
  }
  getLayoutPreviewService() {
    return this.renderableContextService;
  }
  getInformationResults() {
    return this.informationResults;
  }
  getPreviewService() {
    return this.previewService;
  }
  getProfanities() {
    return this.profanityFilter;
  }
  getCommandContext() {
    return this.commandContext;
  }
  getRegionElements(e) {
    return this.stepElements[e] || [];
  }
  getStepSpecificServices(e) {
    return this.stepSpecificServices[e];
  }
  getTransaction() {
    return this.transaction;
  }
  getTransactionCustomer() {
    return this.ownerCustomer;
  }
  setTransactionCustomer(e) {
    this.ownerCustomer = e;
  }
  setTransactionCustomerDetails(e) {
    this.ownerCustomer = { ...this.ownerCustomer, emailAddress: e.email };
  }
  getModelContainer() {
    return this.modelContainer;
  }
  setModelContainer(e) {
    (!e || this.previewService && this.previewService.getAllModels().includes(e)) && (this.modelContainer = e, e && e.metadata && e.metadata instanceof Map && this.modelContainer.metadata.set("workflowManager", this));
  }
  /**
   * An internal helper for setting changes on the transaction.
   * @param transaction The updated transaction details.
   * @returns void
   */
  setTransaction(e) {
    this.transaction = e;
  }
  getWorkflow() {
    return this.workflow;
  }
  getCommandDispatcher() {
    return (e) => this.commandContext.apply(e, !this.initialized);
  }
  getWorkflowSelections() {
    const e = {};
    return this.workflow.steps.forEach((t) => {
      const A = this.stepSelections[t.stepName];
      A && A.selectedVariants && A.selectedVariants.length > 0 && (e[t.stepName] = {
        selections: A.selectedVariants
      });
    }), e;
  }
  getStepSelections() {
    return this.stepSelections;
  }
  markStepsAsInitialised(e) {
    const t = { ...this.stepInitialised };
    e.forEach((A) => {
      t[A] = !0;
    }), this.stepInitialised = t, this.onInitChange();
  }
  getUpdatesPending() {
    return this.pendingUpdates.length > 0;
  }
  markUpdateCompleted(e) {
    this.pendingUpdates = this.pendingUpdates.filter((t) => t !== e);
  }
  markUpdatePending() {
    const e = J();
    return this.pendingUpdates = [...this.pendingUpdates, e], e;
  }
  setEditedStatus(e, t) {
    this.editedSteps = { ...this.editedSteps, [e]: t }, this.onEditedChange();
  }
  setInformationResults(e) {
    this.informationResults = [...e], this.onInformationResultChange();
  }
  setCurrentAdjustingStepId(e) {
    this.currentAdjustingStepId = e, this.onMakingAdjustmentsChange();
  }
  setMandatoryFulfilled(e, t) {
    this.mandatorySteps[e] !== t && (this.mandatorySteps = { ...this.mandatorySteps, [e]: t }, this.setInformationResults([]), this.onMandatoryChange());
  }
  setStepError(e, t, A) {
    let a = !1;
    if (!this.validationErrors.steps.has(e) && A)
      a = !0, this.validationErrors.steps.set(e, /* @__PURE__ */ new Map([[t, A]]));
    else if (this.validationErrors.steps.has(e)) {
      const n = this.validationErrors.steps.get(e);
      A && A !== n.get(t) ? (a = !0, n.set(t, A)) : A || (a = !0, n.delete(t), n.size === 0 && this.validationErrors.steps.delete(e));
    }
    a && this.onValidationChange();
  }
  getStepErrors(e) {
    return this.validationErrors.steps.get(e);
  }
  getValidationErrors() {
    return this.validationErrors;
  }
  toggleDesignConfirmed() {
    this.confirmedDesign = !this.confirmedDesign, this.onConfirmChange();
  }
  toggleMakingAdjustmentsCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  async injectIntoPreviewService(e, t) {
    if (this.modelContainer)
      throw new Error("You must eject from the preview service before injecting again.");
    if (this.previewService = e, !this.getProduct().modelUrl || !this.previewService)
      return;
    const A = e.loadModel(
      {
        model: this.getProduct().modelUrl,
        contextService: this.getLayoutPreviewService()
      },
      { refocusCamera: t }
    );
    this.setModelContainer(A), ce(this.allScenes, this.stepSelections).filter((i) => i).map((i) => i.renderableSteps).flat().filter((i) => i.type === M.Model || i.type === M.Material).forEach((i) => {
      var r, c, B;
      if (!((r = i.option) != null && r.id)) {
        console.error(`Failed to read option id from step: ${i.stepName}`);
        return;
      }
      const s = ((c = this.stepSelections[i.stepName]) == null ? void 0 : c.selectedVariants) || [];
      if (s.length === 0)
        return;
      const o = s[0];
      if (i.type === M.Model) {
        if (!this.modelContainer)
          throw new b(
            "We should always have a model container when injecting a preview!"
          );
        const l = (B = o.asset) == null ? void 0 : B.fileLink;
        if (!l) {
          console.error(`Failed to read model url from variant: ${o.id} for step: ${i.stepName}`);
          return;
        }
        const d = i.data;
        this.modelContainer.applyModelVariant(
          i.stepName,
          {
            model: l,
            contextService: this.getLayoutPreviewService()
          },
          d.replaceProductModel || !1
        );
      } else {
        const l = o.material;
        if (!l) {
          console.error(`Failed to read material from variant: ${o.id} for step: ${i.stepName}`);
          return;
        }
        i.data.targetMaterials.forEach((C) => {
          if (!this.modelContainer)
            throw new b(
              "We should always have a model container when injecting a preview!"
            );
          this.modelContainer.applyMaterialVariant(C, i.option.id, l);
        });
      }
    }), await A.getInitializationPromise(), this.renderLayouts();
  }
  ejectFromPreviewService() {
    if (this.modelContainer) {
      if (!this.modelContainer.dispose)
        throw new Error("This feature is not supported in the current preview service.");
      this.modelContainer.dispose(), this.modelContainer = void 0;
    }
    this.previewService = void 0;
  }
  updateStorage(e, t) {
    const A = {
      ...this.storage,
      [e]: { ...this.storage[e], ...t }
    };
    if (!eA(A, this.storage)) {
      this.storage = A;
      const a = new Yt(this.constructSerializableWorkflow());
      this.commandContext.apply(a, !0), this.onStepSpecificStorageChange(e), this.onStorageChange();
    }
  }
  constructSerializableWorkflow() {
    const e = [];
    return this.allScenes.forEach((t) => {
      t.renderableSteps.forEach((A) => {
        var n, i;
        const a = { stepName: A.stepName };
        a.storage = this.storage[A.stepName], a.selectedVariants = (i = (n = this.stepSelections[A.stepName]) == null ? void 0 : n.selectedVariants) == null ? void 0 : i.map(
          (s) => ({ id: s.id, priceModifier: s.priceModifier })
        ), e.push(a);
      });
    }), { steps: e };
  }
  updateStateWithServer() {
    if (this.readOnly)
      return;
    const e = this.serialize();
    this.workflowStatePromiseQueue.enqueue(
      new bt(async () => {
        await new Promise((t) => {
          setTimeout(() => {
            t();
          }, 1);
        }), await this.updateTransaction({
          variables: {
            id: this.transaction.id,
            workflowState: e.transaction
          }
        });
      })
    );
  }
  async updateStateWithServerImmediate() {
    if (this.readOnly)
      return;
    const e = this.serialize();
    return new bt(async () => {
      await this.updateTransaction({
        variables: {
          id: this.transaction.id,
          workflowState: e.transaction
        }
      });
    }).execute();
  }
  serialize() {
    const e = this.getCommandContext().getState();
    if (!e)
      throw new b("Attempted to serialize state before it was initialized.");
    return { transaction: JSON.stringify(this.dehydrateState(ge(e.transaction))) };
  }
  dehydrateState(e) {
    var t;
    for (const A of Object.values(e.layouts).map((a) => a.elements).flat())
      A.type === "illustration" && (delete A.cachedObjectURL, A.src && delete A.svg), A.type === "frame" && ((t = A.pattern) == null || delete t.svg);
    return e;
  }
  async outstandingRequestsPromise() {
    return this.workflowStatePromiseQueue.finalize();
  }
  updateMetadata(e, t) {
    this.stepMetadata = {
      ...this.stepMetadata,
      [e]: { ...this.stepMetadata[e], ...t }
    }, this.onMetadataChange();
  }
  removeElements(e) {
    const t = (A, a) => Object.keys(A).reduce((n, i) => {
      const s = [...A[i] || []];
      return a.forEach((o) => {
        const r = s.findIndex((c) => c.id === o.id);
        r > -1 && s.splice(r, 1);
      }), n[i] = s, n;
    }, {});
    this.stepElements = t(this.stepElements, e);
  }
  getInvalidCanvasRegions() {
    return this.workflow.steps.reduce((e, t) => (ae(t, this.stepSelections) || this.stepElements[t.stepName] && this.stepElements[t.stepName].forEach(
      (A) => e.push(A)
    ), e), []);
  }
  getInvalidModelVariants() {
    return this.workflow.steps.reduce((e, t) => (t.type === M.Model && !ae(t, this.stepSelections) && e.push(t.stepName), e), []);
  }
  async stepElementsForIntroducedSilentSteps(e, t) {
    const A = this.product;
    if (!A)
      return Promise.resolve({ stepElements: {}, commands: [] });
    const a = async (r, c, B) => {
      if (r.type === M.SilentIllustration) {
        const l = await new kt(r, c).trigger();
        return { step: r, results: l };
      } else if (r.type === M.ProductOverlay) {
        const l = await new kt(
          r,
          c,
          B
        ).trigger();
        return { step: r, results: l };
      }
      return Promise.reject("Unknown silent step. This is a bug");
    }, n = e.filter(
      (r) => !this.stepInitialised[r.stepName]
    ), i = {
      stepElements: {},
      commands: []
    }, s = [];
    for (const r of n)
      this.markStepsAsInitialised([r.stepName]), t || s.push(a(r, this.layouts, A));
    const o = await Promise.all(s);
    for (const r of o)
      i.stepElements[r.step.stepName] = r.results.map((c) => c.regionElement), i.commands = [...i.commands, ...r.results.map((c) => c.command)];
    return i;
  }
  getStepStorage(e) {
    return this.storage[e];
  }
  getMetadata(e) {
    return this.stepMetadata[e];
  }
  getWorkflowMetadata() {
    return this.stepMetadata;
  }
  getStepTags(e) {
    return this.stepTags[e] || [];
  }
  /**
   * @deprecated Simply run serializedSteps.find((step) => step.stepName === stepName) instead.
   */
  getSerializedStep(e, t) {
    return t.find((A) => A.stepName === e);
  }
  async updateTransactionShareActions() {
    const e = await this.client.getShareActionsForTransaction(this.transaction.id);
    this.transaction.transactionShareActions = e;
  }
  async updateTransactionStakeholders() {
    var t;
    const e = await x.getShadowGraphqlClient().query({
      query: La,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.transaction.id
      }
    });
    !((t = e == null ? void 0 : e.data) != null && t.transactions) || e.data.transactions.length !== 1 ? (this.transaction.currentStakeholder = void 0, this.transaction.stakeholders = void 0) : (this.transaction.stakeholders = e.data.transactions[0].stakeholders, this.transaction.currentStakeholder = e.data.transactions[0].currentStakeholder);
  }
  async reset() {
    this.commandContext.getAllLayouts().forEach(
      (t) => t.layoutState.elements.forEach((A) => {
        this.getCommandDispatcher()(new ne(A.id));
      })
    ), this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, await this.ensureStepsAreLoaded();
  }
  async setSelectionsAndElements(e, t, A, a) {
    var p;
    const n = this.stepSelections;
    this.stepSelections = {
      ...this.stepSelections,
      [e]: { selectedVariants: t }
    }, this.selectionCost = Object.values(this.stepSelections).reduce((m, I) => m + I.selectedVariants.map((F) => F.priceModifier || 0).reduce((F, y) => F + y, 0), 0), this.workflow.steps.forEach((m) => {
      ae(m, this.stepSelections) || (this.stepInitialised[m.stepName] = !1, delete this.stepMetadata[m.stepName], delete this.stepSelections[m.stepName], delete this.storage[m.stepName]);
    });
    const i = this.allScenes, s = ce(i, n), o = ce(i, this.stepSelections), r = s.map((m) => m.silentSteps).flat(), B = o.map((m) => m.silentSteps).flat().filter(
      (m) => !r.some((I) => I.stepName === m.stepName)
    );
    r.forEach((m) => {
      ae(m, this.stepSelections) || (this.stepInitialised[m.stepName] = !1);
    });
    const l = this.getInvalidCanvasRegions(), { stepElements: d, commands: C } = await this.stepElementsForIntroducedSilentSteps(B, !1);
    this.stepElements = {
      ...this.stepElements,
      ...d,
      [e]: A
    }, this.removeElements(l);
    const w = this.workflow.steps.find((m) => m.stepName === e);
    if ((w == null ? void 0 : w.type) === M.Frame) {
      const m = this.getStepSpecificServices(e);
      (p = m == null ? void 0 : m.frameService) == null || p.setTargetElements(A.map((I) => I.id));
    }
    const h = l.map((m) => new ne(m.id)), u = new Yt(this.constructSerializableWorkflow()), E = [...C, ...h, u];
    E.length > 0 && this.commandContext.apply(new k(E), !0), await this.ensureStepsAreLoaded(), this.onElementsChange();
    const D = this.getInvalidModelVariants(), Q = this.modelContainer;
    if (Q) {
      const m = D.map(
        (I) => Q.applyModelVariant(
          I,
          {
            contextService: this.getLayoutPreviewService()
          },
          !1
        )
      );
      await Promise.all(m);
    }
    await this.onSelectionChange(), a && await a();
  }
  async ensureStepsAreLoaded() {
    const t = ce(this.allScenes, this.stepSelections).map((o) => o.renderableSteps), A = [], a = t.flat();
    for (const o of a)
      if (!this.stepInitialised[o.stepName])
        switch (this.stepInitialised[o.stepName] = !0, o.type) {
          case M.DigitalContent:
            A.push(
              wA.init(
                o,
                this,
                this.reloadedState
              )
            );
            break;
          case M.Frame:
            {
              const r = new Xa(o.data.forceImageCover);
              r.connectWorkflowManager(this, o.stepName), this.stepSpecificServices[o.stepName] = {
                frameService: r
              }, A.push(
                Ae.init(o, this, this.reloadedState)
              );
            }
            break;
          case M.Illustration:
            A.push(
              Ne.init(o, this, this.reloadedState)
            );
            break;
          case M.Material:
            A.push(
              hA.init(o, this, this.reloadedState)
            );
            break;
          case M.Model:
            A.push(EA.init(o, this, this.reloadedState));
            break;
          case M.Module:
            this.stepSpecificServices[o.stepName] = {
              module: await FA(o.data.module)
            }, A.push(
              uA.init(o, this, this.reloadedState)
            );
            break;
          case M.Picture:
            A.push(
              mA.init(o, this, this.reloadedState)
            );
            break;
          case M.Question:
            A.push(
              QA.init(o, this, this.reloadedState)
            );
            break;
          case M.Shape:
            A.push(Ee.init(o, this, this.reloadedState));
            break;
          case M.Text:
            A.push(j.init(o, this, this.reloadedState));
            break;
        }
    const n = (await Promise.allSettled(A)).map((o) => {
      if (o.status === "rejected")
        throw new Error(`Step initialization failed: ${o.reason}`);
      return o.value;
    }), i = n.filter((o) => !!o && !!o.command).map((o) => o.command), s = n.filter((o) => !!o && !!o.followup).map((o) => o.followup);
    i && i.length > 0 && this.commandContext.apply(new k(i), !0);
    for (const o of s)
      await o();
    s.length > 0 && await this.ensureStepsAreLoaded(), this.onInitChange();
  }
  onConfirmChange() {
    this.confirmCallbacks.forEach((e) => e(this.confirmedDesign));
  }
  onEditedChange() {
    this.editedCallbacks.forEach((e) => e(this.editedSteps));
  }
  onElementsChange() {
    this.elementsCallbacks.forEach((e) => e(this.stepElements));
  }
  onInformationResultChange() {
    this.informationResultCallbacks.forEach((e) => e(this.informationResults));
  }
  onInitChange() {
    this.initCallbacks.forEach((e) => e(this.stepInitialised));
  }
  onMakingAdjustmentsChange() {
    this.makingAdjustmentsCallback.forEach((e) => {
      e(this.currentAdjustingStepId);
    });
  }
  onMandatoryChange() {
    this.mandatoryCallbacks.forEach((e) => e(this.mandatorySteps));
  }
  onMetadataChange() {
    this.metadataCallbacks.forEach((e) => {
      e(this.stepMetadata);
    });
  }
  async onSelectionChange() {
    const e = await this.traversableScenes();
    for (const t of this.selectionCallbacks)
      t({
        selectionCost: this.selectionCost,
        selections: this.stepSelections,
        traversableScenes: e
      });
  }
  onStepSpecificStorageChange(e) {
    Object.keys(this.stepSpecificStorageCallbacks).includes(e) || (this.stepSpecificStorageCallbacks[e] = []), this.stepSpecificStorageCallbacks[e].forEach((t) => t(this.storage[e]));
  }
  onStorageChange() {
    this.storageCallbacks.forEach((e) => e(this.storage));
  }
  onValidationChange() {
    this.validationCallbacks.forEach((e) => e(this.validationErrors));
  }
  traversableScenes() {
    return Va(this.allScenes, this.stepSelections, this.singleVariantsRenderable);
  }
}
class Z {
  constructor(e) {
    this.variantData = e;
  }
  getType() {
    var e;
    return (e = this.variantData.asset) == null ? void 0 : e.type;
  }
  /**
   * @returns The unique identifier for the variant.
   */
  getId() {
    return this.variantData.id;
  }
  /**
   * @returns The configured name of the variant. Generally a human readable value.
   */
  getName() {
    return this.variantData.name;
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   */
  getPriceFormatted(e, t) {
    return this.variantData.priceModifier.toLocaleString(e || "en-US", {
      style: "currency",
      currency: "USD",
      ...t
    });
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   *          Presented in subunits of the currency of the option. For example, if the option is configured to use USD, the price modifier will be in cents.
   */
  getPrice() {
    return this.variantData.priceModifier;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAsset() {
    var e, t, A;
    return (A = (t = (e = this.variantData.asset) == null ? void 0 : e.versions) == null ? void 0 : t.find((a) => a.name === "cdn")) == null ? void 0 : A.link;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAssetResource() {
    return this.variantData.asset;
  }
  /**
   * @returns The URL for a thumbnail resource configured on this variant.
   */
  getThumbnail() {
    var A, a, n, i;
    const e = (n = (a = (A = this.variantData.thumbnail) == null ? void 0 : A.versions) == null ? void 0 : a.find((s) => s.name === "thumbnail")) == null ? void 0 : n.link, t = (i = this.variantData.thumbnail) == null ? void 0 : i.fileLink;
    return e || t;
  }
  /**
   * @returns When this variant is configured to have a color, this will return the hex value for that color.
   */
  getColor() {
    return this.variantData.color;
  }
  /**
   * @returns True when the variant is the default for its containing option. False otherwise.
   */
  isDefault() {
    return !!this.variantData.default;
  }
  /**
   * @returns The underlying variant resource. Generally not needed but made available just incase.
   */
  getResource() {
    return this.variantData;
  }
  /**
   * @returns True when the variant is enabled. False otherwise.
   */
  isEnabled() {
    return this.variantData.enabled;
  }
}
const yA = class rt {
  constructor(e, t, A) {
    this.manager = e, this.step = t, this.tags = A;
  }
  /**
   * Set the current update state of this step. All step handles pointing to this step will
   * see this value.
   * @param value The new value
   */
  setUpdateState(e) {
    rt.updateState.set(`${this.step.stepName}-${this.manager.getTransaction().id}`, e);
  }
  /**
   * @returns Gets the current update state of this step. All step handles for this step will see this value.
   */
  getUpdateState() {
    return !!rt.updateState.get(`${this.step.stepName}-${this.manager.getTransaction().id}`);
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    const t = this.manager.getWorkflowSelections()[this.step.stepName], A = t == null ? void 0 : t.selections[0];
    if (A)
      return new Z(A);
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  getAvailableVariants() {
    var t, A;
    return (((A = (t = this.step.option) == null ? void 0 : t.variants) == null ? void 0 : A.filter((a) => a.enabled)) || []).map((a) => new Z(a));
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  getAllVariants() {
    var t;
    return (((t = this.step.option) == null ? void 0 : t.variants) || []).map((A) => new Z(A));
  }
  /**
   * @returns A unique identifier for this step within the workflow.
   */
  getId() {
    return this.step.stepName;
  }
  /**
   * @returns The name of the step
   */
  getName() {
    return this.step.stepTitle;
  }
  /**
   * @returns A message that can accompany the step name in UI components. Used to describe the purpose of the step in more detail.
   */
  getHelpText() {
    return this.step.helpText;
  }
  /**
   * @returns The type of the step handle.
   */
  getType() {
    return this.step.type;
  }
  /**
   * @returns The underlying data for this step. Favor using the step handle methods instead of this.
   */
  getRaw() {
    return this.step;
  }
  /**
   * @returns Returns all of the tags that are present on this step.
   */
  getTags() {
    return this.tags;
  }
  /**
   * @param tag The tag to check for.
   * @returns True if the step has the specified tag, false otherwise.
   */
  hasTag(e) {
    return this.tags.includes(e) || !1;
  }
  /**
   * @returns True if the step is required to be filled by the customer. False otherwise.
   */
  getMandatory() {
    return this.step.mandatory || !1;
  }
  /**
   * @param type The AspectType to fetch the value for.
   * @returns A boolean indicating whether this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   */
  getOverrideGlobalPropertyConfiguration(e) {
    var A;
    return (((A = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : A.overrideGlobalConfigurations) ?? {})[e.toString()] ?? !1;
  }
  /**
   * Sets whether or not this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   * @param type The AspectType to override.
   */
  setOverrideGlobalPropertyConfiguration(e, t) {
    var a;
    const A = ((a = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : a.overrideGlobalConfigurations) ?? {};
    this.manager.updateStorage(this.step.stepName, {
      overrideGlobalConfigurations: { ...A, [e.toString()]: t }
    });
  }
  /**
   * Retrieves the identifiers of all of the configured aspects for the specified Global Property Configuration.
   * @param configurationId The ID of the Global Property Configuration. You can usually find this with `bundle.getGlobalPropertyConfiguration()?.id`
   * @returns An array of strings matching the keys of all the Global Property Aspects in the Configuration that this step is configured to use.
   */
  getGlobalPropertyAspects(e) {
    var t;
    return ((t = this.step.globalPropertyAspectConfigurations) == null ? void 0 : t.filter((A) => A.globalPropertyConfigurationId === e && A.aspectName).map((A) => A.aspectName)) ?? [];
  }
  /**
   * Fires any configured animations on the 3D preview for this step.
   * This includes camera & model animations. If the preview is unavailable
   * this function will do nothing.
   */
  executeAnimations() {
    const e = this.manager.getPreviewService(), t = this.manager.getModelContainer(), A = this.step.data.modelAnimation, a = this.step.data.lookAtAnimation;
    e ? a && e.executeCameraAnimation(a) : console.warn("No preview service available, cannot execute camera animations."), t ? A && t.executeAnimation(A) : console.warn("No model container available, cannot execute model animations.");
  }
};
yA.updateState = /* @__PURE__ */ new Map();
let X = yA;
class Sn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  /**
   * Allows for select a vector from the available vectors configured on this steps base option.
   * @param variant The new vector variant to use for this step.
   * @returns A promise that can be awaited to know when the new vector asset has been updated on the design.
   */
  async selectVariant(e) {
    if (!this.getUpdateState() && this.getCurrentVariant() !== e)
      return Ne.selectVariant(
        this.step,
        e.getResource(),
        this.manager.getRegionElements(this.step.stepName) || [],
        (t) => this.setUpdateState(t),
        this.manager
      );
  }
  /**
   * Get colors for the illustration.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    const e = this.manager.getRegionElements(this.step.stepName) || [];
    if (e.length !== 0)
      try {
        return Re(e[0].id, this.manager.getAllLayoutData()).colors;
      } catch (t) {
        console.error(t);
      }
  }
  /**
   * Set color for the illustration.
   */
  setColor(e, t) {
    const A = /* @__PURE__ */ new Map();
    return A.set(e, t), Ne.changeColors(
      this.step,
      this.manager.getRegionElements(this.step.stepName),
      this.manager,
      () => this.manager.getCommandContext().getAllLayouts(),
      A
    );
  }
  async getColorOption() {
    return this.step.data.colorOption;
  }
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? Ne.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
}
class Yn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  selectVariant(e) {
    return hA.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
}
class Pn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  selectVariant(e) {
    return EA.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
}
class xn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  /**
   * Allows the user to select an image variant from the available variants configured on this steps base option.
   * @param variant The new image variant to use.
   * @returns A promise that can be awaited to ensure the new image asset has been updated on the design.
   */
  selectVariant(e) {
    return mA.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
}
class Nn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  async selectVariant(e) {
    if (!e.getId())
      throw new Error("Unable to select variant with a null ID");
    await QA.selectVariant(this.step, e.getId(), this.manager);
  }
  /**
   * The way that this step expects to be rendered.
   */
  getDisplayType() {
    var e;
    return this.step.data.displayType || ((e = this.step.option) == null ? void 0 : e.displayType);
  }
}
class vn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  selectVariant(e) {
    const t = e.getResource();
    return Ee.selectVariant(
      this.step,
      {
        fill: t.color,
        stroke: t.color,
        variant: t
      },
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Sets the color of the shape.
   * @param color The color option to use.
   * @returns A promise resolving when the color has changed in the design.
   * @deprecated The shape step can now pass through colors returned by getColors via selectVariant. Please swap setColor for selectVariant.
   */
  setColor(e) {
    return Ee.selectVariant(
      this.step,
      e,
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Get available colors for the shape.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    return Ee.availableColours(this.step);
  }
  /**
   * Allows for setting a custom color when the custom variant is selected. Will
   * throw when a non-custom variant is selected.
   */
  setCustomColor(e) {
    var t, A;
    return ((t = this.getCurrentVariant()) == null ? void 0 : t.getColor()) !== "#custom" && console.warn(`setting custom color for step ${this.step.stepName} but color is ${(A = this.getCurrentVariant()) == null ? void 0 : A.getColor()}`), Ee.setCustomColor(e, this.step, this.manager);
  }
  getCustomColor() {
    var t, A, a;
    ((t = this.getCurrentVariant()) == null ? void 0 : t.getColor()) !== "#custom" && console.warn(`setting custom color for step ${this.step.stepName} but color is ${(A = this.getCurrentVariant()) == null ? void 0 : A.getColor()}`);
    const e = (a = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : a.colour;
    if (!e)
      throw new Error(`Color not available on step ${this.step.stepName}. Set a default on the workflow to fix this.`);
    return e;
  }
}
class Rn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  /**
   * Allows for select a font from the available fonts configured on this steps base option.
   * @param variant The font variant to use.
   */
  async selectVariant(e) {
    j.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => {
        if (t)
          this.manager.setInformationResults([
            ...this.manager.getInformationResults(),
            {
              message: "An issue has occurred with text",
              messageType: Ve.Error,
              stepID: this.step.stepName
            }
          ]);
        else {
          const A = this.manager.getInformationResults().filter((a) => a.stepID !== this.step.stepName);
          this.manager.setInformationResults(A);
        }
      },
      () => {
      }
    );
  }
  /**
   * @returns A list of colors that can be used to fill the text.
   */
  getAvailableFillColors() {
    return this.step.data.colorPickerEnabled ? j.availableFillColors(this.step) : [];
  }
  /**
   * Changes the fill of text related to this step to the new fill value.
   * @param fill A new fill value to use.
   */
  async setFillColor(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await j.changeFillColor(this.step, e, t, this.manager);
  }
  /**
   * Gets the color currently applied to the element.
   */
  getFillColor() {
    var e;
    return ((e = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : e.color) || "#000000";
  }
  getAvailableFillImages() {
    return j.availableFillImages(this.step);
  }
  async setFillImage(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await j.changeFillImage(this.step, e, t, this.manager);
  }
  getFillImage() {
    var e;
    return (e = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : e.fillImage;
  }
  getAlignment() {
    const e = j.findLayoutElements(this.manager, this.step);
    return e == null ? void 0 : e[0].align;
  }
  setAlignment(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    j.changeAlignment(this.step, e, t, this.manager);
  }
  /**
   * When true & the step has replaceable text configured the user will be
   * abled to edit the entire text string including the non-replaceable text.
   * @param shouldCustomizeAll When true the user can configure the entire text string.
   */
  setFullTextCustomization(e) {
    var i;
    const t = ((i = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : i.inputText) || "", A = this.step.data.replaceableText !== void 0 ? this.step.data.replaceableText.replace("{{}}", t) : t, a = e ? A : this.step.data.defaultText;
    return this.manager.updateStorage(this.step.stepName, {
      customiseAllText: e,
      text: a,
      defaultCleared: !1
    }), this.setText(a);
  }
  /**
   * Changes the text value of text related to this step to a new value.
   * @param userInput Input from the user.
   */
  setText(e) {
    var B;
    const t = {
      input: e,
      helperData: {}
    }, A = j.findLayoutElements(this.manager, this.step), a = j.filterUnsupportedCharacters(e, (B = A[0]) == null ? void 0 : B.fontData);
    !!this.step.data && !!this.step.data.maxLength && a.length > this.step.data.maxLength || (t.input = a);
    const i = A.length <= 0, s = i ? { inputText: a, text: a } : { inputText: a };
    if (this.manager.updateStorage(this.step.stepName, s), this.manager.updateMetadata(this.step.stepName, {
      text: a
    }), i)
      return t;
    const { command: o, errorData: r, helperData: c } = j.updateInputText(
      a,
      A,
      this.step,
      this.manager
    );
    return o && this.manager.getCommandDispatcher()(o), t.helperData = c, t.errorData = r, t;
  }
  /**
   * Gets the text currently applied to the elements of this step.
   */
  getText() {
    var t;
    const e = this.step.data.defaultText;
    return ((t = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : t.text) || e || "";
  }
  isReplaceable() {
    return this.step.data.userCanReplaceText;
  }
  /**
   * @returns True if the step allows new lines in the text input.
   */
  newLinesSupported() {
    return this.step.data.allowNewlines || !1;
  }
  /**
   * Inform the step that now is the time to
   * clear default text if it should do so.
   * Returns a text change rwsult if a clear occurred.
   */
  clearDefaultTextIfNecessary() {
    const e = this.manager.getStepStorage(this.step.stepName);
    if (!(e != null && e.defaultCleared) && this.step.data.deleteDefaultOnFocus) {
      const t = this.setText("");
      this.manager.updateStorage(this.step.stepName, { defaultCleared: !0, inputText: "" });
      const A = j.findLayoutElements(this.manager, this.step);
      return j.updateInputText("", A, this.step, this.manager), t;
    }
  }
  hasColorPicker() {
    return this.step.data.colorPickerEnabled;
  }
  getRegions() {
    return this.step.data.regions;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = this.getText();
    return e - t.length;
  }
  setCustomColor(e) {
    throw new Error("Custom color support is not yet available on text. Check back soon.");
  }
  getCustomColor() {
    throw new Error("Custom color support is not yet available on text. Check back soon.");
  }
}
class Hn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  async selectVariant() {
  }
  /**
   * The way that this step expects to be rendered.
   */
  getContent() {
    return this.step.data.content;
  }
}
class kn extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  async selectVariant() {
  }
  /**
   * Returns a preview URL used to show the generated QR code in your UI.
   */
  getPreviewURL() {
    var e;
    return ((e = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : e.videoUrl) || "";
  }
  /**
   * Turns an asset into a QR code that can be used to access the content.
   * @param asset The asset to use for the QR code.
   * @returns The final URL string for the QR code.
   */
  async selectVideo(e) {
    return wA.regenerateQRCode(
      this.manager.getRegionElements(this.step.stepName),
      e.key,
      this.manager,
      this.step
    );
  }
}
class Un extends X {
  constructor(e, t, A) {
    super(e, t, A);
  }
  async selectVariant() {
    console.info("Text Modules don't support variants.");
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = this.getText();
    return e - t.length;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  getText() {
    var e;
    return ((e = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : e.text) || "";
  }
  setText(e) {
    uA.changeText(this.step, e, this.manager, "", (t) => {
      if (t)
        this.manager.setInformationResults([
          ...this.manager.getInformationResults(),
          {
            message: t,
            messageType: Ve.Error,
            stepID: this.step.stepName
          }
        ]);
      else {
        const A = this.manager.getInformationResults().filter((a) => a.stepID !== this.step.stepName);
        this.manager.setInformationResults(A);
      }
    });
  }
}
class ye {
  static get(e, t) {
    switch (t.type) {
      case M.DigitalContent:
        return new kn(e, t, e.getStepTags(t.stepName));
      case M.Information:
        return new Hn(e, t, e.getStepTags(t.stepName));
      case M.Question:
        return new Nn(e, t, e.getStepTags(t.stepName));
      case M.Text:
        return new Rn(e, t, e.getStepTags(t.stepName));
      case M.Illustration:
        return new Sn(e, t, e.getStepTags(t.stepName));
      case M.Picture:
        return new xn(e, t, e.getStepTags(t.stepName));
      case M.Shape:
        return new vn(e, t, e.getStepTags(t.stepName));
      case M.Material:
        return new Yn(e, t, e.getStepTags(t.stepName));
      case M.Model:
        return new Pn(e, t, e.getStepTags(t.stepName));
      case M.Frame:
        return new rs(e, t, e.getStepTags(t.stepName));
      case M.Module:
        return new Un(e, t, e.getStepTags(t.stepName));
      default:
        throw new b(`Step type ${t.type} not yet supported in Core SDK`);
    }
  }
}
const MA = f`
    fragment CreateDesignTransaction on Transaction {
        id
        designName
        externalCartProductId
        externalCartProductVariantId
        externalDesignProductId
        externalDesignProductVariantId
        lastSyncedAt
        quantity
        previewImageLink
        priceModifierTotal
        workflowViewerLink
        workflowViewerReadOnlyLink
        integrationProduct {
            id
            additionalExternalProductId
            additionalExternalVariantId
        }
        designExternalVariants {
            id
            externalProductId
            externalProductVariantId
        }
    }
`, Gn = f`
    ${MA}
    mutation CreateDesign(
        $name: String!
        $layouts: [LayoutInput]!
        $workflowId: String!
        $transactionId: String!
        $previewImage: String
        $useThreeDimPreview: Boolean
        $metadata: [MetadataInput]
        $selectedVariants: [SelectedVariantInput]
    ) {
        designCreate(
            name: $name
            layouts: $layouts
            workflowId: $workflowId
            transactionId: $transactionId
            previewImage: $previewImage
            useThreeDimPreview: $useThreeDimPreview
            metadata: $metadata
            selectedVariants: $selectedVariants
        ) {
            id
            sku
            transaction {
                ...CreateDesignTransaction
            }
            processExecution {
                id
            }
        }
    }
`, bn = f`
    ${MA}
    mutation CreateDesigns($inputs: [DesignCreateInput]!) {
        designCreateMany(inputs: $inputs) {
            id
            sku
            transaction {
                ...CreateDesignTransaction
            }
            processExecution {
                id
            }
        }
    }
`;
function Te(g) {
  const e = JSON.parse(atob(g.split(".")[1])).exp;
  return Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) >= e;
}
const Jn = async (g) => {
  var i, s;
  const t = ((i = Object.entries(localStorage).find(([o, r]) => o.startsWith("CognitoIdentityServiceProvider") && o.endsWith("idToken"))) == null ? void 0 : i[0]) || "", A = localStorage.getItem(t), a = {};
  return A && !Te(A) && (a.Authorization = `Bearer ${A}`), (s = (await x.getShadowGraphqlClient().mutate({
    mutation: Gn,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      name: g.name,
      layouts: g.layouts,
      workflowId: g.workflowId,
      transactionId: g.transactionId,
      previewImage: g.previewImage,
      useThreeDimPreview: g.useThreeDimPreview,
      metadata: g.metadata,
      selectedVariants: g.selectedVariants
    },
    context: {
      headers: a
    }
  })).data) == null ? void 0 : s.designCreate;
}, Tn = async (g) => {
  var i, s;
  const t = ((i = Object.entries(localStorage).find(([o, r]) => o.startsWith("CognitoIdentityServiceProvider") && o.endsWith("idToken"))) == null ? void 0 : i[0]) || "", A = localStorage.getItem(t), a = {};
  return A && !Te(A) && (a.Authorization = `Bearer ${A}`), (s = (await x.getShadowGraphqlClient().mutate({
    mutation: bn,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      inputs: g.map((o) => ({
        name: o.name,
        layouts: o.layouts,
        workflowId: o.workflowId,
        transactionId: o.transactionId,
        previewImage: o.previewImage,
        useThreeDimPreview: o.useThreeDimPreview,
        metadata: o.metadata,
        selectedVariants: o.selectedVariants
      }))
    },
    context: {
      headers: a
    }
  })).data) == null ? void 0 : s.designCreateMany;
}, ct = (g, e, t) => {
  const A = (n) => {
    const i = {};
    if (n.type === "Frame") {
      const s = g[n.stepName], o = n.data;
      if (!s || !s.image || o.hideImageInCart && t)
        return i;
      i[`${n.stepTitle} image`] = s.image;
    }
    if (n.type === "Illustration") {
      const s = g[n.stepName], o = n.data;
      if (!s || o.hideColorsInCart && t || !s.colors)
        return i;
      if (s.colors.length > 0) {
        const r = s.colors.join(", ").toUpperCase();
        i[`${n.stepTitle} colors`] = r;
      }
    }
    if (n.type === "Module") {
      const s = g[n.stepName], o = n.data;
      if (!s || s.text === void 0 || s.text === null || o.hideTextInCart && t)
        return i;
      i[`${n.stepTitle} text`] = s.text;
    }
    if (n.type === "Text") {
      const s = g[n.stepName];
      if (!s)
        return i;
      const o = n.data;
      (!o.hideTextInCart || !t && s.text !== void 0 && s.text !== null) && (i[`${n.stepTitle} text`] = s.text), s.color && (!o.hideColorInCart || !t) && (i[`${n.stepTitle} color`] = s.color);
    }
    return i;
  }, a = {};
  return e.steps.forEach((n) => {
    Object.assign(a, A(n));
  }), a;
}, On = (g, e, t, A) => {
  const a = {};
  let n = {};
  t ? n = ct(t, e, !1) : A && (n = A);
  const s = e.steps.map((o) => o.stepTitle).filter((o, r, c) => c.indexOf(o) == r);
  for (const o of s) {
    if (Object.keys(g).includes(o)) {
      const r = g[o], c = e.steps.find((B) => B.stepTitle === o);
      a[`${c == null ? void 0 : c.stepTitle} selection`] = {
        value: r[0].name,
        priceModifier: r[0].priceModifier
      };
    }
    for (const r of Object.keys(n))
      [`${o} color`, `${o} colors`, `${o} text`, `${o} image`].includes(r) && (a[r] = {
        value: n[r],
        priceModifier: 0
      });
  }
  return a;
}, SA = (g, e, t, A, a, n, i, s) => {
  var C, w;
  const o = e.basePrice || 0, r = g.priceModifierTotal || 0, c = On(A, t, void 0, n), l = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(g.id), d = {
    additionalExternalProductId: (C = g.integrationProduct) == null ? void 0 : C.additionalExternalProductId,
    additionalExternalVariantId: (w = g.integrationProduct) == null ? void 0 : w.additionalExternalVariantId,
    baseCost: o,
    designExternalVariants: g.designExternalVariants,
    designProductId: g.externalDesignProductId,
    designProductVariantId: g.externalDesignProductVariantId,
    event: "onComplete",
    exportedData: c,
    externalCartProductId: g.externalCartProductId,
    externalCartProductVariantId: g.externalCartProductVariantId,
    lineItemImageUrl: i || "",
    optionsCost: r,
    processExecutionId: s,
    quantity: g.quantity,
    transactionId: g.id,
    transactionOwnerId: l,
    weight: e.weight,
    workflowViewerLink: g.workflowViewerLink || "",
    workflowViewerReadOnlyLink: g.workflowViewerReadOnlyLink || ""
  };
  return n && (d.metadata = n), A && (d.selectedVariants = A), a && (d.sku = a), d;
}, YA = async (g, e, t, A, a, n, i, s, o, r) => {
  var F;
  await (async () => {
    var R;
    if (r !== void 0)
      return r;
    await g.outstandingRequestsPromise();
    const Y = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(a.id), S = await x.getShadowGraphqlClient().query({
      query: gA,
      variables: { ids: [a.id] },
      fetchPolicy: "no-cache",
      errorPolicy: "all",
      context: {
        transactionOwnerId: Y
      }
    }), T = (R = S.data) == null ? void 0 : R.transactions[0].workflowState;
    return S.errors ? (S.errors.forEach((W) => {
      S.errors && console.log("Server Error:", W.message);
    }), null) : T ?? null;
  })() || (console.warn("State mismatch detected. Uploading known state explicitly"), console.warn("State Object:", JSON.stringify(A())), await g.updateStateWithServerImmediate(A), console.log("Server state is undefined @ Workflow completion"));
  const l = g.getPreviewService(), d = (F = e == null ? void 0 : e.finalizeStepConfig) == null ? void 0 : F.lookAtAnimation, C = l && e.showModelOnFinishStep && !!d, w = o && ct(o, e, !0), h = o && ct(o, e, !1), u = async (y) => {
    const Y = {};
    let N = 0;
    if (Object.keys(n).length > 0)
      for (const S of Object.keys(n)) {
        const T = n[S], R = e.steps.find((W) => W.stepName === S);
        for (let W = 0; W < T.selections.length; ++W) {
          const O = T.selections[W];
          if (R && (!y || R.option && (R.option.variants || []).length > 1 && !R.data.hideSelectionInCart && !R.data.hideSelectionsInCart)) {
            const ee = R.stepTitle;
            Y[ee] ? Y[ee].push({
              id: O.id || "",
              name: O.name,
              priceModifier: O.priceModifier
            }) : Y[ee] = [
              {
                id: O.id || "",
                name: O.name,
                priceModifier: O.priceModifier
              }
            ];
          }
          N += O.priceModifier;
        }
      }
    return [Y, N];
  }, [E] = await u(!0), D = Object.fromEntries(
    Object.keys(E).map((y) => [y, E[y].map((Y) => Y.id)])
  ), [Q] = await u(!1), p = Object.fromEntries(
    Object.keys(Q).map((y) => [
      y,
      Q[y].map((Y) => Y.id)
    ])
  );
  let m = await s(C, a.id);
  if (m) {
    const y = await (await fetch(m)).blob();
    m = (await U.uploadAsset(
      { name: `${a.id}-preview-image.png`, blob: y },
      At.Image,
      !0,
      !1
    )).fileLink;
  }
  return {
    designDetails: (() => {
      const y = {
        name: i,
        layouts: t.map((Y) => ({
          index: Y.index,
          panelId: Y.panelId
        })),
        workflowId: e.id,
        transactionId: a.id,
        useThreeDimPreview: !!C,
        previewImage: m
      };
      if (h) {
        const Y = [];
        for (const [N, S] of Object.entries(h))
          Y.push({ key: N, value: S });
        y.metadata = Y;
      }
      if (D) {
        const Y = [];
        for (const [N, S] of Object.entries(p))
          Y.push({ key: N, ids: S });
        y.selectedVariants = Y;
      }
      return y;
    })(),
    cartSelectionsWithPrices: E,
    cartMetadata: w
  };
}, Ln = async (g, e, t, A, a, n, i, s, o, r, c) => {
  var u, E;
  o("workflow.steps.finish.finalize.buildingLayouts");
  const { designDetails: B, cartSelectionsWithPrices: l, cartMetadata: d } = await YA(
    g,
    e,
    t,
    A,
    n,
    i,
    s,
    r,
    c
  );
  o("workflow.steps.finish.finalize.creatingDesign");
  const C = await Jn(B), w = (u = C == null ? void 0 : C.transaction) == null ? void 0 : u.previewImageLink;
  if (!(C != null && C.transaction))
    throw new Error("Failed to create design");
  o("workflow.steps.finish.finalize.updatingTransaction");
  const h = C.transaction;
  return SA(
    h,
    a,
    e,
    l,
    C == null ? void 0 : C.sku,
    d,
    w,
    (E = C == null ? void 0 : C.processExecution) == null ? void 0 : E.id
  );
}, zn = async (g, e, t) => {
  e("workflow.steps.finish.finalize.buildingLayouts"), await Promise.all(
    g.map(async (s) => {
      await s.workflowManager.outstandingRequestsPromise();
    })
  );
  const a = await (async () => {
    var r;
    const o = await x.getShadowGraphqlClient().query({
      query: gA,
      variables: { ids: g.map((c) => c.transaction.id) },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    });
    return o.errors ? (o.errors.forEach((c) => {
      o.errors && console.log("Server Error:", c.message);
    }), null) : (r = o.data) != null && r.transactions ? o.data.transactions.map((c) => c.workflowState ?? null) : null;
  })(), n = await Promise.all(
    g.map(async (s, o) => await YA(
      s.workflowManager,
      s.workflow,
      s.layouts,
      s.getReducerState,
      s.transaction,
      s.workflowSelections,
      s.designName,
      t ?? (() => Promise.resolve(void 0)),
      s.workflowMetadata,
      a ? a[o] : void 0
    ))
  );
  e("workflow.steps.finish.finalize.creatingDesign");
  const i = await Tn(n.map((s) => s.designDetails));
  if (!i)
    throw new Error("Failed to create designs");
  return e("workflow.steps.finish.finalize.updatingTransaction"), i.map((s, o) => {
    var l;
    const r = g[o], c = n[o], B = s.transaction;
    return SA(
      B,
      r.product,
      r.workflow,
      c.cartSelectionsWithPrices,
      s.sku,
      c.cartMetadata,
      //lineItemImageLink,
      void 0,
      (l = s.processExecution) == null ? void 0 : l.id
    );
  });
};
class Kn {
  constructor() {
    this.localPersistenceKey = "designTransactions", this.storageMethod = "Local", this.designSavedListeners = [];
  }
  /**
   * @param func The function to call when a design is saved.
   */
  attachSaveListener(e) {
    this.designSavedListeners.push(e);
  }
  /**
   * @param func The function to remove from the list of listeners.
   */
  detachSaveListener(e) {
    this.designSavedListeners = this.designSavedListeners.filter((t) => t !== e);
  }
  /**
   * Gets the currently persisted designs.
   */
  async getSavedDesigns() {
    if (this.storageMethod === "Local") {
      const e = P.get(this.localPersistenceKey);
      return e ? JSON.parse(e) : [];
    }
    throw new b("Unexpected storage method requested");
  }
  /**
   * Search for a transaction that has been saved.
   * @param transactionId The id to search for.
   * @returns The transaction for the given id provided it has been saved. undefined if it doesn't exist.
   */
  async getSavedDesignByTransaction(e) {
    return (await this.getSavedDesigns()).find((A) => A.transactionId === e);
  }
  /**
   * Saves a design to storage.
   * @param design The design to save.
   */
  async addDesign(e) {
    const A = (await this.getSavedDesigns()).filter((a) => a.transactionId !== e.transactionId);
    A.unshift(e), await this.setDesigns(A), this.designSavedListeners.forEach((a) => a(e));
  }
  /**
   * Change the user's name of the given saved design.
   */
  async renameDesign(e, t) {
    const A = await this.getSavedDesigns(), a = A.find((n) => n.transactionId === e);
    if (!a)
      throw new Error(`No saved design for transaction ${e}.`);
    a.title = t, await this.setDesigns(A);
  }
  /**
   * Removes a given design from storage.
   * @param transactionId
   */
  async removeDesign(e) {
    const t = await this.getSavedDesigns();
    await this.setDesigns(t.filter((A) => A.transactionId !== e));
  }
  async setDesigns(e) {
    if (this.storageMethod === "Local") {
      P.set(this.localPersistenceKey, JSON.stringify(e));
      return;
    }
    throw new b("Unexpected storage method requested");
  }
}
const $e = new Kn(), jn = f`
    mutation AddTransactionStakeholder($id: String!, $type: String!, $details: CustomerDetailsInput!) {
        transactionAddStakeholder(id: $id, details: $details, type: $type) {
            id
            stakeholders {
                id
                type
                customer {
                    id
                    emailAddress
                }
            }
        }
    }
`;
var Vn = /* @__PURE__ */ ((g) => (g.QuantityChanged = "QuantityChanged", g.PriceBreakChanged = "PriceBreakChanged", g))(Vn || {});
class Me {
  constructor(e, t) {
    var a;
    if (this.cachedStepHandles = /* @__PURE__ */ new Map(), this.currentPriceBreak = 1, this.renderableScenes = [], this.renderableSceneCallbacks = [], this.eventCallbacks = /* @__PURE__ */ new Map(), this.debouncedSavedDesignUpdate = _t(async () => {
      await $e.getSavedDesignByTransaction(
        this.getWorkflowManager().getTransaction().id
      ) && this.save();
    }, 2500), this.getCanvasObjectURLAsync = async (n) => new Promise((i, s) => {
      try {
        n.toBlob((o) => {
          if (o) {
            const r = URL.createObjectURL(o);
            i(r);
          }
        });
      } catch (o) {
        s(o);
      }
    }), !t.workflow)
      throw new Error("No Workflow ID provided.");
    this.client = e;
    const A = t.layouts;
    this.commandContext = new $A(), this.commandContext.initialize(A, t.reloadedState), this.isReadOnly = t.transaction.isOrdered || !!t.readOnly, this.workflowManager = new Mn(
      this,
      e,
      t.workflow,
      ((a = t.product.profanities) == null ? void 0 : a.map((n) => n.word)) || [],
      A,
      this.commandContext,
      (n) => {
        try {
          this.debouncedSavedDesignUpdate();
        } catch {
          console.error("Failed to update saved design details.");
        }
        return t.stateMutationFunc(n);
      },
      t.transaction,
      t.product,
      t.stepTags || {},
      t.previewService,
      t.renderableContextService,
      t.reloadedState,
      t.readOnly,
      t.modelContainer,
      t.isReloadedTransaction,
      t.singleVariantsRenderable,
      t.delayWorkflowStateSync
    ), this.workflowManager.addSelectionCallback((n) => {
      const i = n.traversableScenes.map((s) => {
        const o = s.renderableSteps.map((r) => r.stepName);
        return {
          id: s.name,
          title: s.title,
          renderableSteps: o,
          workflowScene: s
        };
      });
      this.renderableScenes = i, this.renderableSceneCallbacks.forEach((s) => s(i));
    }), this.currentPriceBreak = this.priceBreakToBeApplied();
  }
  getBundle() {
    return this.bundle;
  }
  setBundle(e) {
    this.bundle = e;
  }
  getClient() {
    return this.client;
  }
  getIsReadOnly() {
    return this.isReadOnly;
  }
  getCommandContext() {
    return this.commandContext;
  }
  getWorkflowManager() {
    return this.workflowManager;
  }
  async createPreviewImage(e, t) {
    var E, D;
    const A = this.workflowManager.getWorkflow(), a = (E = A == null ? void 0 : A.finalizeStepConfig) == null ? void 0 : E.lookAtAnimation;
    if (e) {
      if (!a)
        throw new Error("Failed to generate cart preview image!");
      return await ((D = this.workflowManager.getPreviewService()) == null ? void 0 : D.renderSceneScreenshot(t ?? 512, a)) || "";
    }
    let n = 2048;
    t && t <= 2048 && (n = t);
    const i = He(n, n), s = this.commandContext.getAllLayouts(), o = A.defaultPreviewPanelIndex || 0, r = A.panels[o], c = s.find((Q) => {
      var p;
      return ((p = Q.layoutState) == null ? void 0 : p.layout.panelId) === (r == null ? void 0 : r.name);
    }) || s[0], B = c.layoutState.layout.previewRegion ? {
      x: c.layoutState.layout.previewRegion.left,
      y: c.layoutState.layout.previewRegion.top,
      width: c.layoutState.layout.previewRegion.width,
      height: c.layoutState.layout.previewRegion.height
    } : {
      x: 0,
      y: 0,
      width: c.layoutState.layout.width,
      height: c.layoutState.layout.height
    }, l = this.commandContext.getLayoutById(c.layoutState.layout.id), d = i.getContext("2d");
    if (!d)
      throw new je("Failed to obtain 2D context for preview image creation");
    const C = zt(l.layoutState.layout, l.layoutState.elements, {
      renderingConfiguration: {
        purpose: Kt.Print,
        region: { left: B.x, top: B.y, width: B.width, height: B.height }
      }
    }), w = jt(C);
    await (await $t.from(d, w, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: He,
      createImage: Vt,
      DOMParser: Wt(),
      fetch: gt
    })).render();
    const u = await this.getCanvasObjectURLAsync(i);
    return i.toDataURL(u);
  }
  getStepById(e) {
    const t = this.getWorkflowManager().getWorkflow().steps.find((n) => n.stepName === e);
    if (!t || !this.stepHasHandle(t))
      return;
    const A = this.cachedStepHandles.get(t.stepName);
    if (A)
      return A;
    const a = ye.get(this.getWorkflowManager(), t);
    return this.cachedStepHandles.set(t.stepName, a), a;
  }
  getSteps() {
    return this.getScenes().flatMap((e) => this.getStepsByScene(e));
  }
  getStepsConditionallyActive() {
    return this.getScenes().flatMap(
      (e) => this.getStepsByScene(e).filter(
        (t) => ae(t.getRaw(), this.getWorkflowManager().getStepSelections())
      )
    );
  }
  getScenes() {
    return this.getWorkflowManager().getWorkflow().stepGroups.map((t) => ({
      id: t.id,
      name: t.name,
      stepIds: t.stepNames
    }));
  }
  getSelectionPriceSubunits(e) {
    const t = this.getWorkflowManager().getWorkflowSelections();
    let A = 0;
    return Object.values(t).forEach((a) => {
      A += a.selections.reduce((n, i) => n + (i.priceModifier || 0), 0);
    }), this.getPriceSubUnitsAfterPriceBreaks(A, e);
  }
  getBasePriceSubunits(e, t) {
    const A = this.getPriceSubUnitsAfterPriceBreaks(
      this.getWorkflowManager().getProduct().basePrice || 0,
      t
    );
    if (e) {
      const a = this.getAdditionalProductPriceSubunits(t) || 0;
      return A + a;
    }
    return A;
  }
  getAdditionalProductPriceSubunits(e) {
    var A;
    const t = this.getWorkflowManager().getTransaction().integrationProduct;
    if ((A = t == null ? void 0 : t.additionalIntegrationProduct) != null && A.product) {
      const a = t.additionalIntegrationProduct.product.basePrice || 0;
      return this.getPriceSubUnitsAfterPriceBreaks(a, e);
    }
  }
  getTotalPriceSubunits(e) {
    return this.getBasePriceSubunits(!1, e) + this.getSelectionPriceSubunits(e);
  }
  getPriceSubUnitsAfterPriceBreaks(e, t) {
    const A = t ? 1 : this.priceBreakToBeApplied(), a = e * A;
    return Math.ceil(a);
  }
  priceBreakToBeApplied() {
    const e = (this.getWorkflowManager().getProduct().priceBreaks || []).sort(
      (a, n) => -(a.minQty - n.minQty)
    ), A = [...this.getMatchingExperiencesFromBundle(), this].reduce((a, n) => a + n.getQuantity(), 0);
    for (const a of e)
      if (a.minQty <= A)
        return a.percentage;
    return 1;
  }
  checkForPriceBreakChanges() {
    const e = this.priceBreakToBeApplied();
    this.currentPriceBreak !== e && (this.updatePriceBreak(e), this.getMatchingExperiencesFromBundle().forEach(
      (t) => t.updatePriceBreak(e)
    ));
  }
  getMatchingExperiencesFromBundle() {
    var e;
    return (((e = this.bundle) == null ? void 0 : e.getWorkflowExperiences()) || []).filter(
      (t) => t.getWorkflowManager().getTransaction().id !== this.getWorkflowManager().getTransaction().id && t.getWorkflowManager().getProduct().id === this.getWorkflowManager().getProduct().id
    );
  }
  updatePriceBreak(e) {
    this.currentPriceBreak = e, this.callEvent(
      "PriceBreakChanged"
      /* PriceBreakChanged */
    );
  }
  async copySelectionsViaGlobalConfiguration(e, t, A) {
    const a = await e.getGlobalProperties(), n = A == null ? void 0 : A.map((r) => r.getId()), i = this.getSteps().filter((r) => n === void 0 || n.includes(r.getId())), s = t.getSteps(), o = (r) => a.find((c) => c.getRawProperty().name === r.aspectName);
    i.forEach((r) => {
      const c = /* @__PURE__ */ new Set(), B = r.getRaw().globalPropertyAspectConfigurations;
      B !== void 0 && (B.forEach((l) => c.add(JSON.stringify(l))), s.forEach((l) => {
        const d = l.getRaw().globalPropertyAspectConfigurations;
        d !== void 0 && d.forEach((C) => {
          const w = o(C), h = c.has(JSON.stringify(C));
          if (h && (w == null ? void 0 : w.getType()) === "Option") {
            const u = l.getCurrentVariant();
            if (!u)
              return;
            r.selectVariant(u), c.delete(JSON.stringify(C));
          } else if (h && (w == null ? void 0 : w.getType()) === "Text") {
            const u = l.getText();
            r.setText(u), c.delete(JSON.stringify(C));
          }
        });
      }));
    });
  }
  getStepByName(e) {
    const t = this.getWorkflowManager().getWorkflow().steps.find((A) => A.stepTitle === e);
    if (!(!t || !this.stepHasHandle(t)))
      return ye.get(this.getWorkflowManager(), t);
  }
  getStepsByType(e) {
    return this.getWorkflowManager().getWorkflow().steps.filter((t) => t.type === e).map((t) => ye.get(this.getWorkflowManager(), t));
  }
  getStepsByScene(e) {
    if (!this.getWorkflowManager().getWorkflow().stepGroups.find((A) => A.name === e.name))
      throw new Error(
        "Given scene is not present on workflow! Be careful when persisting scenes that you only use them with the relevant workflow."
      );
    return e.stepIds.map(
      (A) => this.getWorkflowManager().getWorkflow().steps.find((a) => a.stepName === A)
    ).filter((A) => this.stepHasHandle(A)).map((A) => ye.get(this.getWorkflowManager(), A));
  }
  async attachCustomerDetails(e) {
    return this.assignCustomerDetails({ emailAddress: e.email });
  }
  async assignCustomerDetails(e) {
    var i, s, o;
    const A = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(this.getWorkflowManager().getTransaction().id), n = (o = (s = (i = (await x.getShadowGraphqlClient().mutate({
      mutation: jn,
      variables: {
        id: this.getWorkflowManager().getTransaction().id,
        details: e,
        type: "Owner"
      },
      context: {
        transactionOwnerId: A
      }
    })).data) == null ? void 0 : i.transactionAddStakeholder) == null ? void 0 : s.stakeholders) == null ? void 0 : o.find(
      (r) => {
        var c;
        return ((c = r.customer) == null ? void 0 : c.emailAddress) === e.emailAddress;
      }
    );
    if (n != null && n.customer) {
      this.getWorkflowManager().setTransactionCustomer(n.customer);
      const r = P.getMap("transactionCustomerIds") || /* @__PURE__ */ new Map();
      r.set(this.getWorkflowManager().getTransaction().id, n.customer.id), P.setMap("transactionCustomerIds", r);
    }
  }
  attachRenderableSceneListener(e) {
    this.renderableSceneCallbacks.push(e), e(this.renderableScenes);
  }
  detachRenderableSceneListener(e) {
    this.renderableSceneCallbacks = this.renderableSceneCallbacks.filter((t) => t !== e);
  }
  async save(e) {
    if (!this.getCommandContext().getState())
      throw new b("State undefined!");
    const a = {
      title: await (async () => {
        var o;
        if (e)
          return e;
        const n = this.getWorkflowManager().getTransaction().id, s = (o = (await $e.getSavedDesigns()).find((r) => r.transactionId === n)) == null ? void 0 : o.title;
        return s || "My design";
      })(),
      thumbnail: await this.createPreviewImage(!1, 256),
      transactionId: this.getWorkflowManager().getTransaction().id,
      productId: this.getWorkflowManager().getProduct().id,
      integrationProductId: this.getWorkflowManager().getTransaction().integrationProduct.id,
      workflowName: this.getWorkflowManager().getWorkflow().name,
      workflowId: this.getWorkflowManager().getWorkflow().id,
      lastEdited: /* @__PURE__ */ new Date()
    };
    return await $e.addDesign(a), a;
  }
  async copy() {
    var s;
    const e = ge(this.getCommandContext().getState());
    if (!e)
      throw new b("Internal state is undefined! Cannot copy experience!");
    const t = JSON.stringify(e.transaction), A = this.getWorkflowManager().getWorkflow(), a = new ss({}), n = (s = this.getWorkflowManager().getTransaction().integrationProduct) == null ? void 0 : s.id;
    if (!n)
      throw new b("Integration product id is undefined!");
    return await a.initFromIntegrationProduct(n), await a.getWorkflowExperience(A.id, t, void 0);
  }
  async onDesignFinished(e, t = !0) {
    return Ln(
      this.workflowManager,
      this.workflowManager.getWorkflow(),
      this.workflowManager.getLayouts(),
      () => this.commandContext.getState(),
      // Handle case where undefined (create a default state)
      this.workflowManager.getProduct(),
      this.workflowManager.getTransaction(),
      this.workflowManager.getWorkflowSelections(),
      this.workflowManager.getWorkflow().name,
      e || (() => {
      }),
      (A) => t ? this.createPreviewImage(A, 1024) : Promise.resolve(void 0),
      this.workflowManager.getWorkflowMetadata()
    );
  }
  /**
   * @param step The step to test against.
   * @returns Returns true when a valid handle is implemented for a given step type. Certain steps don't support handles, such as silent illustrations.
   */
  stepHasHandle(e) {
    return e.type !== M.SilentIllustration && e.type !== M.ProductOverlay;
  }
  getExportedData() {
    var a;
    const e = /* @__PURE__ */ new Map(), t = this.getWorkflowManager().getWorkflowMetadata(), A = this.getWorkflowManager().getWorkflowSelections();
    return Object.keys(t).forEach((n) => {
      const i = this.workflowManager.getWorkflow().steps.find((o) => o.stepName === n);
      if (!i)
        return;
      e.has(i.stepTitle) || e.set(i.stepTitle, {});
      const s = t[n];
      Object.keys(s).forEach((o) => {
        e.get(i.stepTitle)[o] = s[o];
      });
    }), (a = Object.keys(A)) == null || a.forEach((n) => {
      const i = this.workflowManager.getWorkflow().steps.find((s) => s.stepName === n);
      i && (e.has(i.stepTitle) || e.set(i.stepTitle, {}), e.get(i.stepTitle).selection = A[n].selections[0].name);
    }), e;
  }
  getQuantity() {
    return this.getWorkflowManager().getTransaction().quantity || 1;
  }
  async setQuantity(e) {
    if (e < 1)
      throw new RangeError("WorkflowExperience quantity must be greater than zero.");
    if (this.isReadOnly)
      throw new Error("Cannot update quantity on a read-only WorkflowExperience");
    this.getWorkflowManager().getTransaction().quantity = e, this.callEvent(
      "QuantityChanged"
      /* QuantityChanged */
    ), this.checkForPriceBreakChanges();
    const t = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), A = this.getWorkflowManager().getTransaction(), a = t.get(A.id) || void 0;
    await x.getShadowGraphqlClient().mutate({
      mutation: ba,
      variables: {
        id: A.id,
        quantity: e
      },
      context: {
        transactionOwnerId: a
      }
    });
  }
  addEventListener(e, t) {
    const A = this.eventCallbacks.get(e) || [];
    A.push(t), this.eventCallbacks.set(e, A);
  }
  removeEventListener(e, t) {
    const A = this.eventCallbacks.get(e) || [];
    this.eventCallbacks.set(
      e,
      A.filter((a) => a !== t)
    );
  }
  callEvent(e) {
    (this.eventCallbacks.get(e) || []).forEach((t) => t(this));
  }
}
const Wn = [
  "altGlyph",
  "circle",
  "ellipse",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "textPath",
  "tref",
  "tspan"
], Xn = async (g, e, t) => {
  const A = e.data, a = t.data.baseUrl, n = A.assetUrl.replace("localhost", "localstack"), i = a.slice(0, 4) === "http" ? "" : "https://", s = new URL(i + a);
  s.searchParams.append("video", Pt(JSON.stringify([{ href: n }]))), s.pathname = s.pathname + (s.pathname.slice(-1) === "/" ? "" : "/");
  const o = s.toString(), c = `data:image/svg+xml;base64,${Pt(await tA(o, { type: "svg" }))}`, B = (d) => {
    const C = g.find((h) => h.panelId === d.panelId);
    if (!C)
      throw new z(d);
    const w = J();
    return new L(
      {
        id: w,
        src: c,
        type: G.Image,
        y: d.top,
        x: d.left,
        width: d.width,
        height: d.height,
        rotation: 0
      },
      C
    );
  }, l = t.data.regions;
  try {
    return l.map(B);
  } catch (d) {
    return console.error(d), [];
  }
}, qn = async (g, e, t, A) => {
  const a = t.data, n = a.assetUrl, i = await nt(n);
  try {
    const s = _A(a, A.option);
    s && (e[A.stepName] = { selectedVariants: [s] });
    const o = async (r) => {
      var w;
      const c = await ea(
        r || {
          width: 1,
          height: 1
        },
        (w = s == null ? void 0 : s.asset) == null ? void 0 : w.fileLink
      ), B = await lt(c), l = J(), d = g.find((h) => h.panelId === r.panelId);
      if (!d)
        throw new z(r);
      const C = Bt(i, B, {
        scale: a.scale,
        left: a.x,
        top: a.y
      });
      return [
        new L(
          {
            id: l,
            path: B.path,
            dataWidth: B.width,
            dataHeight: B.height,
            type: G.Frame,
            forceImageCover: A.data.forceImageCover,
            x: r.left,
            y: r.top,
            width: r.width,
            height: r.height,
            layer: r.layer,
            layerIndex: r.layerIndex,
            rotation: r.rotation,
            scaleX: r.width / B.width,
            scaleY: r.height / B.height,
            pattern: void 0
          },
          d
        ),
        new Lt(l, i, C)
      ];
    };
    return (await Promise.all(A.data.regions.map((r) => o(r)))).flat();
  } catch (s) {
    return console.error(s), [];
  }
}, Zn = async (g, e, t, A) => {
  var p, m;
  const a = t.data, n = A.option;
  if (!n)
    return console.error(`No option for step ${A.stepName}.`), [];
  const i = ((p = n.variants) == null ? void 0 : p.find((I) => I.id === a.illustrationVariantId)) || ze(n);
  if (!i)
    return console.error(`No variant with ID: ${a.illustrationVariantId}`), [];
  if (!i.asset)
    return console.error(`No asset for variant with ID: ${a.illustrationVariantId}`), [];
  e[A.stepName] = { selectedVariants: [i] };
  const s = (m = i.asset) == null ? void 0 : m.fileLink;
  if (!s)
    return console.error(`No asset link for variant with ID: ${a.illustrationVariantId}`), [];
  const o = await _(s, !0), r = /<svg.*?<\/svg>/s, c = o.match(r) || [], B = (c == null ? void 0 : c.length) > 0 ? c[0] : "", C = Xt().parseFromString(B, "image/svg+xml").firstElementChild;
  if (!C)
    return console.error("Failed to read SVG."), [];
  qt(C);
  const w = {};
  ta(C, (I) => {
    Wn.includes(I.tagName) && !I.attributes.getNamedItem("fill") && I.setAttribute("fill", "#000000");
    const F = I.attributes.getNamedItem("fill");
    if (F && F.value !== "none") {
      const Y = F.value, S = `spiff-fill-${Y.replace(/\W/g, "")}`;
      I.classList.add(S), w[S] = { browserValue: Y };
    }
    const y = I.attributes.getNamedItem("stroke");
    if (y && y.value !== "none") {
      const Y = y.value, S = `spiff-stroke-${Y.replace(/\W/g, "")}`;
      I.classList.add(S), w[S] = { browserValue: Y };
    }
  });
  const u = Zt().serializeToString(C), E = a.colors;
  if (E) {
    for (const [I, F] of Object.entries(w))
      for (const y of Object.keys(E))
        if (F.browserValue === y) {
          w[I] = { browserValue: E[y] };
          break;
        }
  }
  const D = (I) => {
    const F = g.find((Y) => Y.panelId === I.panelId);
    if (!F)
      throw new z(I);
    const y = J();
    return new L(
      {
        colors: w,
        id: y,
        svg: u,
        type: G.Illustration,
        y: I.top,
        x: I.left,
        rotation: I.rotation,
        width: I.width,
        height: I.height,
        layer: I.layer,
        layerIndex: I.layerIndex,
        immutable: I.immutable
      },
      F
    );
  }, Q = A.data.regions;
  try {
    return Q.map(D);
  } catch (I) {
    return console.error(I), [];
  }
}, $n = async (g, e, t) => {
  const A = await FA(t.data.module), a = e.data, n = (s, o) => {
    const r = g.find((B) => B.panelId === o.panelId);
    if (!r)
      throw new z(o);
    const c = J();
    return new L(
      {
        colors: {},
        id: c,
        svg: s,
        type: G.Illustration,
        y: o.top,
        x: o.left,
        rotation: o.rotation,
        width: o.width,
        height: o.height,
        layer: o.layer,
        layerIndex: o.layerIndex
      },
      r
    );
  }, i = t.data.regions;
  try {
    return i.map(
      (s) => n(A.svgPrint(a.text, s), s)
    );
  } catch (s) {
    return console.error(s), [];
  }
}, _n = async (g, e, t, A) => {
  var c, B;
  const a = t.data, n = A.option;
  if (!n)
    return console.error(`No option for step ${A.stepName}.`), [];
  const i = ((c = n.variants) == null ? void 0 : c.find((l) => l.id === a.pictureVariantId)) || ze(n);
  if (!i)
    return console.error(`No variant with ID: ${a.pictureVariantId}`), [];
  if (!i.asset)
    return console.error(`No asset for variant with ID: ${a.pictureVariantId}`), [];
  e[A.stepName] = { selectedVariants: [i] };
  const s = (B = i.asset) == null ? void 0 : B.fileLink;
  if (!s)
    return console.error(`No asset link for variant with ID: ${a.pictureVariantId}`), [];
  const o = (l) => {
    const d = g.find((w) => w.panelId === l.panelId);
    if (!d)
      throw new z(l);
    const C = J();
    return new L(
      {
        id: C,
        src: s,
        type: G.Image,
        y: l.top,
        x: l.left,
        rotation: l.rotation,
        width: l.width,
        height: l.height,
        layer: l.layer,
        layerIndex: l.layerIndex,
        immutable: l.immutable,
        preserveAspectRatio: "none"
      },
      d
    );
  }, r = A.data.regions;
  try {
    return r.map(o);
  } catch (l) {
    return console.error(l), [];
  }
}, ei = async (g, e, t, A) => {
  var r;
  const a = t.data, n = A.option;
  if (!n)
    return console.error(`No option for step ${A.stepName}.`), [];
  const i = ((r = n.variants) == null ? void 0 : r.find((c) => c.id === a.colorVariantId)) || ze(n);
  if (!i)
    return console.error(`No variant with ID: ${a.colorVariantId}`), [];
  e[A.stepName] = { selectedVariants: [i] };
  const s = (c) => {
    const B = g.find((h) => h.panelId === c.panelId);
    if (!B)
      throw new z(c);
    const l = `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            preserveAspectRatio="none"
            version="1.1"
            width="1"
            height="1"
            viewBox="0 0 1 1"
        >
            <rect
                x="0"
                y="0"
                width="1"
                height="1"
                class="spiff-fill-shape"
                fill="${i == null ? void 0 : i.color}"
            />
        </svg>
        `, C = { "spiff-fill-shape": { browserValue: i.color || "#000000" } }, w = J();
    return new L(
      {
        colors: C,
        id: w,
        svg: l,
        type: G.Illustration,
        y: c.top,
        x: c.left,
        rotation: c.rotation,
        width: c.width,
        height: c.height,
        layer: c.layer,
        layerIndex: c.layerIndex,
        immutable: c.immutable
      },
      B
    );
  }, o = A.data.regions;
  try {
    return o.map(s);
  } catch (c) {
    return console.error(c), [];
  }
}, ti = async (g, e, t) => {
  const A = [], n = (() => {
    var r, c;
    return e.type === M.ProductOverlay ? t || ((r = e.data.asset) == null ? void 0 : r.fileLink) || "" : ((c = e.data.asset) == null ? void 0 : c.fileLink) || "";
  })(), s = (() => n.endsWith(".jpeg") || n.endsWith(".jpg") || n.endsWith(".png") ? G.Image : n.endsWith(".svg") ? G.Illustration : G.Illustration)(), o = e.data.regions;
  if (s === "image")
    try {
      o.forEach((r) => {
        const c = g.find((l) => l.panelId === r.panelId);
        if (!c)
          throw new z(r);
        const B = {
          id: J(),
          src: n,
          type: s,
          y: r.top,
          x: r.left,
          width: r.width,
          height: r.height,
          layer: r.layer,
          layerIndex: r.layerIndex,
          productOverlay: e.type === M.ProductOverlay ? !0 : void 0,
          scaleX: 1,
          scaleY: 1,
          rotation: r.rotation,
          excludeFromExport: e.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        A.push(new L(B, c));
      });
    } catch (r) {
      console.error(r);
    }
  else {
    const r = await _(n, !0), c = (B) => {
      const l = /<svg.*?<\/svg>/s, d = B.match(l) || [], C = (d == null ? void 0 : d.length) > 0 ? d[0] : "", u = Xt().parseFromString(C, "image/svg+xml").firstElementChild;
      if (!u)
        throw new he("Failed to read SVG.");
      return qt(u), Zt().serializeToString(u);
    };
    o.forEach((B) => {
      const l = g.find((C) => C.panelId === B.panelId);
      if (!l)
        throw new z(B);
      const d = {
        id: J(),
        src: n,
        asset_key: n,
        svg: c(r),
        colors: {},
        type: s,
        y: B.top,
        x: B.left,
        width: B.width,
        height: B.height,
        layer: B.layer,
        layerIndex: B.layerIndex,
        scaleX: 1,
        scaleY: 1,
        rotation: B.rotation,
        productOverlay: e.type === M.ProductOverlay ? !0 : void 0,
        excludeFromExport: e.data.excludeFromPrint
      };
      A.push(new L(d, l));
    });
  }
  return A;
}, Ai = async (g, e, t, A) => {
  const a = [], n = t.data, i = 30, s = (h) => h.vertical ? "center" : h.textAlign || "center", o = () => {
    var D;
    const h = A.option;
    if (!h)
      return;
    const u = ((D = h.variants) == null ? void 0 : D.find((Q) => Q.id === n.fontVariantId)) || ze(h);
    if (!u || !u.asset)
      return;
    e[A.stepName] = { selectedVariants: [u] };
    const E = u.asset.fileLink;
    if (E)
      return E;
  }, c = await (async () => {
    const h = o();
    if (!h)
      return;
    const u = await dt(h);
    return {
      assetUrl: h,
      name: u.names.fullName.en
    };
  })(), B = (A.data.replaceableText ? A.data.replaceableText.replace("{{}}", n.text) : n.text) || "", l = it(B, {
    vertical: A.data.vertical,
    uppercase: A.data.uppercase
  }), d = async (h) => {
    const u = h.colorOption;
    if (!u)
      return;
    const E = V.getDefaultVariant(u);
    return E == null ? void 0 : E.color;
  }, C = n.color || await d(A.data), w = A.data.regions;
  for (const h of w) {
    const u = g.find((D) => D.panelId === h.panelId);
    if (!u)
      continue;
    const E = {
      stepName: t.name,
      id: J(),
      align: s(A.data),
      curved: A.data.curved,
      fill: n.color || C || "#000000",
      fontData: c,
      fontSize: A.data.size || i,
      height: h.height,
      layer: h.layer,
      layerIndex: h.layerIndex,
      paths: A.data.paths,
      rotation: h.rotation,
      text: l,
      type: G.Textbox,
      vertical: A.data.vertical,
      verticalAlign: A.data.verticalAlign || "middle",
      width: h.width,
      x: h.left,
      y: h.top
    };
    if (c) {
      const [D, Q] = xe(
        A.data.size || i,
        c,
        h,
        [
          it(l, {
            vertical: A.data.vertical,
            uppercase: A.data.uppercase
          })
        ],
        {
          size: A.data.size,
          minSize: A.data.minSize,
          maxSize: A.data.maxSize
        }
      );
      a.push(
        new L(
          {
            ...E,
            fontSize: D,
            text: E.curved ? E.text : (Q || []).join(`
`)
          },
          u
        )
      );
    } else
      a.push(new L(E, u));
  }
  return a;
}, ai = (g, e) => g.conditions ? g.conditions.every((t) => {
  const A = e[t.targetStepName];
  if (A && A.selectedVariants) {
    const a = A.selectedVariants;
    return t.requiredVariantSelections.some(
      (n) => a.find((i) => i.id === n) !== void 0
    );
  }
  return !1;
}) : !0, ni = async (g, e, t, A) => {
  const a = [], n = {};
  for (const i of g) {
    const s = e.steps.find((o) => o.stepName === i.name);
    if (s)
      switch (s.type) {
        case M.DigitalContent:
          a.push(
            ...await Xn(t, i, s)
          );
          break;
        case M.Frame:
        case M.Photo:
          a.push(
            ...await qn(t, n, i, s)
          );
          break;
        case M.Illustration:
          a.push(
            ...await Zn(
              t,
              n,
              i,
              s
            )
          );
          break;
        case M.Module:
          a.push(...await $n(t, i, s));
          break;
        case M.Picture:
          a.push(
            ...await _n(t, n, i, s)
          );
          break;
        case M.Shape:
          a.push(
            ...await ei(t, n, i, s)
          );
          break;
        case M.Text:
          a.push(
            ...await Ai(t, n, i, s)
          );
          break;
      }
  }
  for (const i of e.steps)
    i.type !== M.SilentIllustration && i.type !== M.ProductOverlay || ai(i, n) && a.push(
      ...await ti(t, i, A)
    );
  return a;
};
class Se {
  constructor(e) {
    this.handleCompleteRender = null;
    const t = /* @__PURE__ */ new Map();
    e.forEach(
      (A) => t.set(
        A.id,
        new oi(A.id, A.name, this, { width: A.width, height: A.height })
      )
    ), this.layouts = t;
  }
  setCompleteRenderCallback(e) {
    this.handleCompleteRender = e, e(Array.from(this.layouts.values()));
  }
  onCompleteRender() {
    this.handleCompleteRender && this.handleCompleteRender(Array.from(this.layouts.values()));
  }
  getAll() {
    return this.layouts;
  }
}
const ii = () => new Promise((g, e) => {
  try {
    const A = He().getContext("webgl2");
    g(!!A);
  } catch {
    g(!1);
  }
}), si = ii();
class oi {
  constructor(e, t, A, a) {
    this.hasSetStaticContext = !1, this.interactiveDirty = !1, this.staticCtxDirty = !1, this.lastRequestedRenderArguments = void 0, this.lastCompletedStaticRender = void 0, this.renderQueue = new dA(2), this.id = e, this.name = t, this.service = A, this.panelSize = a;
  }
  getID() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  getPanelSize() {
    return this.panelSize;
  }
  getStaticContext() {
    return this.textureCtx;
  }
  /**
   * Register canvas to be rendered to.
   */
  setStaticContext(e) {
    this.textureCtx = e, this.lastRequestedRenderArguments && this.render(this.lastRequestedRenderArguments);
  }
  getStaticContextDirty() {
    return this.staticCtxDirty;
  }
  setStaticContextDirty(e) {
    this.staticCtxDirty = e;
  }
  getInteractiveCanvasDirty() {
    return this.interactiveDirty;
  }
  setInteractiveCanvasDirty(e) {
    this.interactiveDirty = e;
  }
  markLastCompletedStaticRender() {
    this.lastCompletedStaticRender = Date.now(), this.service.onCompleteRender();
  }
  /**
   * Returns a timestamp for the last time that this canvas rendered to its dynamic texture in the
   * form of Date.now(). If this panel has never rendered undefined will be returned.
   */
  getLastCompletedStaticRender() {
    return this.lastCompletedStaticRender;
  }
  /**
   * Actions to perform when a static render event is fired for this canvas.
   */
  async render(e) {
    const t = ge(e);
    this.lastRequestedRenderArguments = t;
    const A = this.getStaticContext();
    if (!A) {
      this.markLastCompletedStaticRender(), this.setStaticContextDirty(!1);
      return;
    }
    this.renderQueue.enqueue(
      new ri(
        this.getID(),
        A,
        await si,
        () => {
          this.markLastCompletedStaticRender(), this.setStaticContextDirty(!0);
        },
        t
      )
    );
  }
}
class ri extends BA {
  // TODO: Do we need to pass this whole array in?
  constructor(e, t, A, a, n) {
    super(), this.layoutId = e, this.ctx = t, this.nonPOTSupport = A, this.onRender = a, this.layouts = n;
  }
  /**
   * Returns the resolution expected for generated textures.
   * FIXME: This is reimplemented from the preview package. Can we find a way to remove this duplication.
   */
  getDynamicTextureResolution() {
    return this.getIsMobile() || !this.offscreenRenderingSupported() ? {
      width: 1024,
      height: 1024
    } : {
      width: 2048,
      height: 2048
    };
  }
  getIsMobile() {
    return window.innerWidth <= 480;
  }
  /**
   * Returns true when multithreaded rendering is supported.
   */
  offscreenRenderingSupported() {
    return navigator.userAgent.includes("SamsungBrowser") ? !1 : !!window.Worker && !!window.OffscreenCanvas;
  }
  resizeFit(e, t = 4096) {
    const A = t / e.width, a = t / e.height, n = Math.min(A, a);
    return n > 1 ? e : { width: e.width * n, height: e.height * n };
  }
  /**
   * Render the internally stored layout to the canvas.
   * NOTE: This function is performance critical code. Please throughly test any changes to
   * ensure performance isn't lost and that rendering behavior is preserved when modifying this logic.
   * The aim is to have this code rendering in less than 16.66ms (60fps) on modern hardware. This is
   * a loose target but should be kept in mind when making changes.
   */
  async execute() {
    const e = this.layouts.find((d) => d.layoutState.layout.id === this.layoutId);
    if (!e)
      return;
    const t = e.layoutState.elements || [], A = e.layoutState.layout.width, a = e.layoutState.layout.height, n = A === 1 || a === 1 ? { width: 1, height: 1 } : this.getDynamicTextureResolution(), i = n.width, s = n.height;
    let o, r;
    if (this.nonPOTSupport) {
      const d = i / s;
      A / a < d ? (o = i, r = a * (i / A)) : (o = A * (s / a), r = s);
      const w = this.resizeFit({ width: o, height: r });
      o = w.width, r = w.height;
    } else
      o = n.width, r = n.height;
    const c = zt(e.layoutState.layout, t, {
      renderingConfiguration: { purpose: Kt.ThreeD }
    }), B = jt(c), l = await $t.from(this.ctx, B, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !this.nonPOTSupport,
      ignoreAnimation: !0,
      ignoreClear: !0,
      ignoreMouse: !0,
      enableRedraw: !1,
      createCanvas: He,
      createImage: Vt,
      DOMParser: Wt(),
      fetch: gt
    });
    l.resize(o, r), await l.render(), this.onRender();
  }
}
const Fs = (g, e) => {
  const t = [];
  return g.forEach((A) => {
    const a = e.steps.find((n) => n.stepName === A.stepName);
    (a == null ? void 0 : a.type) === M.Text && A.stepAspectType === "Text" && t.push({
      name: a.stepName,
      data: {
        text: A.value
      }
    });
  }), t;
}, ys = async (g, e, t, A) => {
  let a = {
    serializableWorkflow: { steps: [] },
    layouts: {}
  };
  a = new k(t.map((o) => new Aa(o))).apply(a);
  const i = await ni(g, e, t, A);
  return new k(i).apply(a);
}, ci = f`
    ${Be}
    fragment ProductFields on Product {
        id
        basePrice
        enabled
        imageUrl
        integrationProducts {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            integration {
                id
                enabled
                externalIntegrationId
                type
                isCurrent
            }
        }
        modelUrl
        name
        description
        overlayImageUrl
        preloadImageUrl
        sku
        skuCode
        workflows {
            id
            index
            friendlyName
            isPresent
            workflowName
            imageUrl
        }
        productTags {
            id
            name
        }
    }
`, PA = f`
    ${ci}
    fragment ProductCollectionProductFields on ProductCollectionProduct {
        id
        productId
        workflowId
        product {
            ...ProductFields
        }
    }
`, We = (g) => f`
    ${g ? PA : ""}
    fragment ProductCollectionFields on ProductCollection {
        id
        name
        description
        image {
            key
            name
            fileLink
        }
        globalPropertyConfiguration {
            id
            aspects {
                name
                type
                title
                description
                entityId
                conditions {
                    targetAspectName
                    action
                    requiredVariantSelections
                }
            }
        }
        ${g ? "productCollectionProducts { ...ProductCollectionProductFields }" : ""}
        transformCollection {
            id
            name
            transforms {
                id
                name
                position {
                    x
                    y
                    z
                }
                rotation {
                    x
                    y
                    z
                }
                scale {
                    x
                    y
                    z
                }
            }
        }
    }
`, gi = (g) => f`
    ${We(g)}
    query GetBundle($id: String!) {
        bundles(ids: [$id]) {
            id
            bundleStateData
            metadata {
                key
                value
            }
            name
            partner {
                id
            }
            productCollection {
                ...ProductCollectionFields
            }
            transactions {
                id
            }
        }
    }
`, li = f`
    query GetBundleStakeholders($id: String!) {
        bundles(ids: [$id]) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, Bi = f`
    query GetBundlesForCustomer($id: String!) {
        customers(ids: [$id]) {
            bundleStakeholders {
                id
                type
                bundle {
                    id
                    name
                    createdAt
                    metadata {
                        key
                        value
                    }
                    partner {
                        id
                    }
                }
            }
        }
    }
`, di = f`
    ${PA}
    query GetProductCollectionProducts($id: String!, $productIds: [String!]) {
        productCollections(ids: [$id], productIds: $productIds) {
            id
            productCollectionProducts {
                ...ProductCollectionProductFields
            }
        }
    }
`, Ci = (g) => f`
    ${We(g)}
    mutation CreateBundle(
        $collectionId: String
        $initialMetadata: [MetadataInput!]
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
    ) {
        bundleCreate(
            collectionId: $collectionId
            metadata: $initialMetadata
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
        ) {
            id
            bundleOwnerId
            metadata {
                key
                value
            }
            name
            partner {
                id
            }
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, wi = (g) => f`
    ${We(g)}
    mutation DuplicateBundle(
        $id: String!
        $template: Boolean
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
        $duplicateTransactions: Boolean
    ) {
        bundleDuplicate(
            id: $id
            template: $template
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
            duplicateTransactions: $duplicateTransactions
        ) {
            id
            bundleOwnerId
            metadata {
                key
                value
            }
            name
            partner {
                id
            }
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, hi = f`
    mutation UpdateBundle($id: String!, $name: String, $metadata: [MetadataInput!], $bundleStateData: String) {
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, Ei = f`
    mutation BundleAddTransaction($id: String!, $transactionId: String!) {
        bundleAddTransaction(id: $id, transactionId: $transactionId) {
            id
        }
    }
`, ui = f`
    mutation BundleAddTransactions($id: String!, $transactionIds: [String!]!, $transactionOwnerIds: [String!]) {
        bundleAddTransactions(id: $id, transactionIds: $transactionIds, transactionOwnerIds: $transactionOwnerIds) {
            id
        }
    }
`, mi = f`
    mutation BundleRemoveTransaction(
        $id: String!
        $transactionId: String!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransaction(id: $id, transactionId: $transactionId) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, Qi = f`
    mutation BundleRemoveTransactions(
        $id: String!
        $transactionIds: [String!]!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransactions(id: $id, transactionIds: $transactionIds) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, pi = f`
    mutation BundleAddStakeholder($id: String!, $details: CustomerDetailsInput!, $type: String!) {
        bundleAddStakeholder(id: $id, details: $details, type: $type) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, Di = f`
    mutation BundleAddStakeholder($id: String!, $emailAddress: String!) {
        bundleRemoveStakeholder(id: $id, emailAddress: $emailAddress) {
            id
        }
    }
`, Ii = f`
    mutation BundleUpdateStakeholders($id: String!, $input: [BundleStakeholderInput!]!) {
        bundleUpdateStakeholders(id: $id, input: $input) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, fi = f`
    mutation BundleUpdateTransactionOrder($id: String!, $transactionIds: [String!]!) {
        bundleUpdateTransactionOrder(id: $id, transactionIds: $transactionIds) {
            id
        }
    }
`, Fi = (g) => f`
    ${We(g)}
    mutation BundleAssignProductCollection($id: String!, $productCollectionId: String!) {
        bundleAssignProductCollection(id: $id, collectionId: $productCollectionId) {
            id
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, yi = (g) => f`
    query CustomerBundlesFeed($id: String!, $limit: Int!, $offset: Int!, $template: Boolean, $templateStatus: BundleTemplateStatus) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: $template, templateStatus: $templateStatus) {
            items {
                id
                name
                template
                templateStatus
                productCollection {
                    id
                    name
                    description
                    image {
                        key
                        name
                        fileLink
                    }
                }
                ${g ? "metadata { key, value }" : ""}
            }
            total
        }
    }
`;
class Mi {
  constructor(e) {
    this.handleCache = {}, this.bundle = e;
  }
  /**
   * Gets a handle for the given global property. Fetches from cache if available.
   * @param property The property to get a handle for.
   * @returns A promise resolving to the handle.
   */
  async getHandle(e) {
    if (this.handleCache[e.name])
      return this.handleCache[e.name];
    const t = await this.createHandle(e);
    return this.handleCache[e.name] = t, t;
  }
  /**
   * Gets a list of handles for all global properties. Fetches from cache if available.
   * @returns A promise resolving to the handles.
   */
  async getHandles() {
    var t;
    if (!((t = this.bundle.getProductCollection()) != null && t.getResource().globalPropertyConfiguration))
      return [];
    const e = this.bundle.getProductCollection().getResource().globalPropertyConfiguration;
    return Promise.all(e.aspects.map((A) => this.getHandle(A)));
  }
  /**
   * Applies the global state to all handles, if the state is set.
   * @param handles The handles to apply the state to.
   * @param state
   * @returns
   */
  applyConditionsFromState(e, t) {
    return t ? e.filter((A) => this.aspectConditionsSatisfied(A.getRawProperty(), t)) : e;
  }
  aspectConditionsSatisfied(e, t) {
    return !e.conditions || e.conditions.length === 0 ? !0 : e.conditions.some((A) => {
      const a = t.aspects.find((n) => n.name === A.targetAspectName);
      return a ? A.requiredVariantSelections.some((n) => n === a.value) : !1;
    });
  }
  async createHandle(e) {
    switch (e.type) {
      case $.FileUpload:
        return new Si(this.bundle, e);
      case $.ColorOption:
        return new Jt(
          this.bundle,
          e,
          e.entityId ? await V.getOption(e.entityId) : void 0
        );
      case $.Option: {
        const t = e.entityId ? await V.getOption(e.entityId) : void 0;
        return (t == null ? void 0 : t.type) === "Color" ? new Jt(this.bundle, e, t) : new xA(this.bundle, e, t);
      }
      case $.Text:
        return new Yi(this.bundle, e);
      default:
        throw new Error("Unhandled Global Property Aspect Type");
    }
  }
}
class It {
  constructor(e, t) {
    this.bundle = e, this.property = t;
  }
  /**
   * @returns The name of the global property. This is the key used to store the property in the state.
   */
  getName() {
    return this.property.name;
  }
  /**
   * @returns A human friendly title.
   */
  getTitle() {
    return this.property.title;
  }
  /**
   * @returns A human friendly description.
   */
  getDescription() {
    return this.property.description;
  }
  /**
   * @returns The type of the global property. Use this to determine how to render the property.
   */
  getType() {
    return this.property.type;
  }
  /**
   * @returns The underlying property data object.
   */
  getRawProperty() {
    return this.property;
  }
  /**
   * Returns all steps that share this property.
   * @param targetExperiences Optionally filter the steps to only those in the given experiences.
   */
  getSharedSteps(e) {
    return (e ?? this.bundle.getWorkflowExperiences()).flatMap(
      (a) => a.getStepsConditionallyActive().filter((n) => {
        var i;
        return n.getOverrideGlobalPropertyConfiguration(this.property.type) ? !1 : (i = n.getRaw().globalPropertyAspectConfigurations) == null ? void 0 : i.some(
          (s) => {
            var o, r;
            return s.globalPropertyConfigurationId === ((r = (o = this.bundle.getProductCollection()) == null ? void 0 : o.getResource().globalPropertyConfiguration) == null ? void 0 : r.id) && s.aspectName === this.property.name;
          }
        );
      })
    );
  }
  getStateValue() {
    return this.bundle.getGlobalPropertyStateManager().getAspect(this.property.name);
  }
}
class Si extends It {
  constructor(e, t) {
    super(e, t);
  }
  /**
   * Select an image to be used for all shared steps.
   * @param asset The asset to use.
   * @returns A promise resolving when all affected steps have been updated.
   */
  async selectImage(e) {
    const t = this.bundle.getGlobalPropertyStateManager();
    await Promise.all([
      t.setAspect(this.property.name, e.key, {
        ...t.getAspectStorage(this.property.name) || {},
        originalAssetKey: e.key,
        backgroundRemovedAssetKey: void 0,
        useOriginalAsset: void 0
      }),
      this.applyImageSelection(e)
    ]);
  }
  async canUseBackgroundRemover() {
    return this.bundle.getClient().canUseAddon(ut.BackgroundRemover);
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset to all shared steps. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImage(e = !0) {
    if (!await this.canUseBackgroundRemover())
      throw new Error(
        "The current Integration does not have access to the Background Remover. Please call canUseBackgroundRemover to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const A = this.bundle.getGlobalPropertyStateManager(), a = await U.removeBackgroundFromAsset(t), i = {
      ...A.getAspectStorage(this.property.name),
      backgroundRemovedAssetKey: a.key,
      useOriginalAsset: !e
    }, o = [e ? A.setAspect(this.property.name, a.key, i) : A.setAspectStorage(this.property.name, i)];
    return e && o.push(this.applyImageSelection(a, void 0, !1, !1)), await Promise.all(o), this.updateSharedStepStorage(i), a;
  }
  /**
   * Returns `true` if the state has an image assigned, otherwise `false`.
   */
  hasImage() {
    return !!this.getStateValue();
  }
  /**
   * Retrieves the current image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getImage() {
    const e = this.getStateValue();
    if (e)
      return U.getLocalOrFromServer(e);
  }
  /**
   * Retrieves the original, unmodified image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getOriginalImage() {
    const e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e != null && e.originalAssetKey)
      return U.getLocalOrFromServer(e.originalAssetKey);
  }
  /**
   * Retrieves the version of the image selection that has the background removed, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getBackgroundRemovedImage() {
    const e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e != null && e.backgroundRemovedAssetKey)
      return U.getLocalOrFromServer(e.backgroundRemovedAssetKey);
  }
  getUseOriginalImage() {
    var e;
    return ((e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)) == null ? void 0 : e.useOriginalAsset) ?? !1;
  }
  async setUseOriginalImage(e) {
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must select an image before calling setUseOriginalImage");
    const A = this.bundle.getGlobalPropertyStateManager(), a = A.getAspectStorage(this.property.name);
    if ((a == null ? void 0 : a.useOriginalAsset) === e)
      return;
    const n = {
      ...a,
      useOriginalAsset: e
    }, i = e ? a == null ? void 0 : a.originalAssetKey : a == null ? void 0 : a.backgroundRemovedAssetKey, s = [A.setAspect(this.property.name, i || "", n)];
    if (e)
      s.push(this.applyImageSelection(t, void 0, !1, !1));
    else {
      const o = async () => {
        const r = await this.getBackgroundRemovedImage();
        if (!r)
          throw new Error(
            "You must call removeBackgroundFromImage before attempting to use that version of the image."
          );
        this.applyImageSelection(r, void 0, !1, !1);
      };
      s.push(o());
    }
    this.updateSharedStepStorage(n);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t)
      return;
    const A = await U.getLocalOrFromServer(t);
    if (!A)
      return;
    const a = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    await this.applyImageSelection(A, e, !1, !0), a ? this.updateSharedStepStorage({ ...a }) : (this.updateSharedStepStorage({ originalAssetKey: t }), await this.bundle.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { originalAssetKey: t }));
  }
  async applyImageSelection(e, t, A = !0, a = !0) {
    const i = this.getSharedSteps(t).map((s) => {
      const o = s;
      if (o.getFrameService())
        return o.selectImage(e, A, a);
    });
    await Promise.all(i);
  }
  updateSharedStepStorage(e) {
    this.bundle.getWorkflowExperiences().forEach(
      (A) => A.getSteps().forEach((a) => {
        var i;
        if (a.getOverrideGlobalPropertyConfiguration(this.property.type))
          return;
        ((i = a.getRaw().globalPropertyAspectConfigurations) == null ? void 0 : i.some(
          (s) => {
            var o, r;
            return s.globalPropertyConfigurationId === ((r = (o = this.bundle.getProductCollection()) == null ? void 0 : o.getResource().globalPropertyConfiguration) == null ? void 0 : r.id) && s.aspectName === this.property.name;
          }
        )) && A.getWorkflowManager().updateStorage(a.getId(), { framePatternData: e });
      })
    );
  }
}
class Yi extends It {
  constructor(e, t) {
    super(e, t);
  }
  /**
   * Gets the current text
   */
  getText() {
    const e = this.getStateValue();
    return e || "";
  }
  /**
   * Set the text.
   */
  async setText(e) {
    await Promise.all([
      this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e),
      this.applyTextSelection(e)
    ]);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t)
      return Promise.resolve();
    await this.applyTextSelection(t, e);
  }
  async applyTextSelection(e, t) {
    const a = this.getSharedSteps(t).map((n) => {
      n.setText(e);
    });
    await Promise.all(a);
  }
}
class xA extends It {
  constructor(e, t, A) {
    super(e, t), this.optionResource = A;
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    var t, A;
    if (!this.optionResource)
      return;
    const e = this.getStateValue();
    if (e) {
      const a = (A = this.optionResource.variants) == null ? void 0 : A.find((n) => n.id === e);
      return a ? new Z(a) : void 0;
    } else {
      const a = (t = this.optionResource.variants) == null ? void 0 : t.find(
        (n) => {
          var i, s;
          return n.id === ((s = (i = this.optionResource) == null ? void 0 : i.defaultVariant) == null ? void 0 : s.id);
        }
      );
      return a ? new Z(a) : void 0;
    }
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  getAvailableVariants() {
    var t, A;
    return (((A = (t = this.optionResource) == null ? void 0 : t.variants) == null ? void 0 : A.filter((a) => a.enabled)) || []).map((a) => new Z(a));
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  getAllVariants() {
    var t;
    return (((t = this.optionResource) == null ? void 0 : t.variants) || []).map((A) => new Z(A));
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e) {
    await Promise.all([
      this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId()),
      this.applyVariantSelection(e)
    ]);
  }
  async applyGlobalState(e) {
    var a, n;
    const t = this.getStateValue();
    if (!t)
      return Promise.resolve();
    const A = (n = (a = this.optionResource) == null ? void 0 : a.variants) == null ? void 0 : n.find((i) => i.id === t);
    return A ? this.applyVariantSelection(new Z(A), e) : Promise.resolve();
  }
  async applyVariantSelection(e, t) {
    const a = this.getSharedSteps(t).map((n) => n.selectVariant(e));
    await Promise.all(a);
  }
}
class Jt extends xA {
  constructor(e, t, A) {
    super(e, t, A);
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e) {
    await Promise.all([
      this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId()),
      this.applyColorVariant(e)
    ]);
  }
  async applyGlobalState(e) {
    var n, i, s;
    const t = this.getStateValue();
    if (!t)
      return Promise.resolve();
    const A = (i = (n = this.optionResource) == null ? void 0 : n.variants) == null ? void 0 : i.find((o) => o.id === t);
    if (!A)
      return Promise.resolve();
    await this.applyColorVariant(new Z(A), e);
    const a = (s = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)) == null ? void 0 : s.customColor;
    a && this.setCustomColor(a);
  }
  async applyColorVariant(e, t) {
    const a = this.getSharedSteps(t).map((n) => {
      switch (n.getType()) {
        case M.Shape:
          return n.selectVariant(e);
        case M.Text:
          return n.setFillColor({
            fill: e.getColor(),
            stroke: e.getColor(),
            variant: e.getResource()
          });
      }
    });
    await Promise.all(a);
  }
  /**
   * Sets a custom color on the global state.
   */
  setCustomColor(e) {
    this.getSharedSteps().forEach((A) => A.setCustomColor(e)), this.bundle.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { customColor: e });
  }
  /**
   * Gets the custom color used by the global state.
   */
  getCustomColor() {
    var e, t;
    return ((e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)) == null ? void 0 : e.customColor) || ((t = this.getCurrentVariant()) == null ? void 0 : t.getColor()) || "#ffffff";
  }
}
const ft = f`
    fragment GlobalPropertyStateAspectFields on GlobalPropertyStateAspect {
        name
        value
        type
        storage {
            ... on GlobalPropertyStateColorOptionStorage {
                customColor
            }
            ... on GlobalPropertyStateFileUploadStorage {
                originalAssetKey
                backgroundRemovedAssetKey
                useOriginalAsset
            }
        }
    }
`, Pi = f`
    ${ft}
    mutation CreateGlobalPropertyState($bundleId: String!) {
        globalPropertyStateCreate(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, xi = f`
    ${ft}
    mutation UpdateGlobalPropertyState($id: String!, $aspects: [GlobalPropertyStateAspectInput]!) {
        globalPropertyStateUpdate(id: $id, aspects: $aspects) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, Ni = f`
    ${ft}
    query GetGlobalPropertyState($bundleId: String!) {
        globalPropertyState(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`;
class vi {
  constructor(e, t, A, a, n) {
    this.bundleId = e, this.bundleOwnerId = t, this.configuration = A, this.bundleOptions = n, this.initPromise = this.getOrCreateGlobalPropertyState().then((i) => {
      this.globalPropertyState = i;
    }), this.onGlobalPropertyStateChange = a;
  }
  setBundleOptions(e) {
    this.bundleOptions = e;
  }
  getBundleOptions() {
    return this.bundleOptions;
  }
  setConfiguration(e) {
    this.configuration = e;
  }
  getInitializationPromise() {
    return this.initPromise;
  }
  getGlobalPropertyState() {
    return this.globalPropertyState;
  }
  async setGlobalPropertyState(e) {
    this.globalPropertyState || await this.initPromise;
    const t = ge(this.globalPropertyState);
    this.globalPropertyState = { ...e, id: t.id }, await this.updateGlobalPropertyState(), await this.onGlobalPropertyStateChange(t, this.globalPropertyState);
  }
  getAspect(e) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const t = this.globalPropertyState.aspects.find((A) => A.name === e);
    if (t)
      return t.value;
  }
  getAspectStorage(e) {
    var t;
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    return (t = this.globalPropertyState.aspects.find((A) => A.name === e)) == null ? void 0 : t.storage;
  }
  async setAspect(e, t, A) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const a = this.configuration.aspects.find((s) => s.name === e);
    if (!a)
      throw new Error(`Failed to find configuration aspect with name: ${e}`);
    const n = ge(this.globalPropertyState), i = this.globalPropertyState.aspects.find((s) => s.name === e);
    i ? (i.value = t, i.type = a.type, A !== void 0 && (i.storage = A !== null ? A : void 0)) : this.globalPropertyState.aspects.push({
      name: e,
      value: t,
      type: a.type,
      storage: A !== null ? A : void 0
    }), await this.updateGlobalPropertyState(), await this.onGlobalPropertyStateChange(n, this.globalPropertyState);
  }
  async setAspectStorage(e, t) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const A = this.configuration.aspects.find((i) => i.name === e);
    if (!A)
      throw new Error(`Failed to find configuration aspect with name: ${e}`);
    const a = ge(this.globalPropertyState), n = this.globalPropertyState.aspects.find((i) => i.name === e);
    n ? (n.storage = t !== null ? t : void 0, n.type = A.type) : this.globalPropertyState.aspects.push({
      name: e,
      value: "",
      type: A.type,
      storage: t !== null ? t : void 0
    }), await this.updateGlobalPropertyState(), await this.onGlobalPropertyStateChange(a, this.globalPropertyState);
  }
  async updateGlobalPropertyState() {
    var t, A;
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const e = await x.getShadowGraphqlClient().mutate({
      mutation: xi,
      variables: {
        id: this.globalPropertyState.id,
        aspects: this.globalPropertyState.aspects.map((a) => {
          let n = a.type && a.storage ? {} : void 0;
          if (n)
            switch (a.type) {
              case $.FileUpload: {
                n.fileUpload = a.storage;
                break;
              }
              case $.Option: {
                n.option = a.storage;
                break;
              }
              case $.ColorOption: {
                n = a.storage;
                break;
              }
            }
          return {
            name: a.name,
            value: a.value,
            type: a.type,
            storage: n
          };
        })
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...(t = this.bundleOptions) == null ? void 0 : t.additionalHeaders
        }
      }
    });
    if ((A = e.data) != null && A.globalPropertyStateUpdate)
      this.globalPropertyState = e.data.globalPropertyStateUpdate;
    else
      throw new Error("Unable to update global property state");
  }
  async getOrCreateGlobalPropertyState() {
    var A, a, n;
    const e = await x.getShadowGraphqlClient().query({
      query: Ni,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        bundleId: this.bundleId
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...(A = this.bundleOptions) == null ? void 0 : A.additionalHeaders
        }
      }
    });
    if (e.data.globalPropertyState && e.data.globalPropertyState.id)
      return e.data.globalPropertyState;
    const t = await x.getShadowGraphqlClient().mutate({
      mutation: Pi,
      variables: {
        bundleId: this.bundleId
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...(a = this.bundleOptions) == null ? void 0 : a.additionalHeaders
        }
      }
    });
    if ((n = t.data) != null && n.globalPropertyStateCreate && t.data.globalPropertyStateCreate.id)
      return t.data.globalPropertyStateCreate;
    throw new Error(`Unable to create global property state for bundle: ${this.bundleId}`);
  }
}
class Ri {
  constructor(e) {
    this.setState(e);
  }
  setState(e) {
    e && (this.state = JSON.parse(e));
  }
  applyStateToWorkflowExperience(e) {
    var i;
    if (!this.state || !((i = e == null ? void 0 : e.getWorkflowManager()) != null && i.getModelContainer()))
      return;
    const t = this.state.transactions.find(
      (s) => s.transactionId === e.getWorkflowManager().getTransaction().id
    );
    if (!t)
      return;
    const A = this.getTransformToApply(t);
    if (!A)
      return;
    const a = this.flipTransform(
      A,
      e.getWorkflowManager().getPreviewService()
    ), n = e.getWorkflowManager().getModelContainer();
    n.position = a.position, n.rotation = a.rotation, n.scale = a.scale;
  }
  getTransformToApply(e) {
    return e.activeTransform && e.transforms ? e.transforms[e.activeTransform] : e.transform;
  }
  updateWorkflowExperienceTransform(e, t, A) {
    const a = e.getWorkflowManager().getTransaction().id;
    this.state ? this.state.transactions || (this.state.transactions = []) : this.state = {
      transactions: []
    };
    const n = this.state.transactions.find((i) => i.transactionId === a);
    n ? (n.transforms || (n.transforms = {}), n.transforms[t] = A) : this.state.transactions.push({
      transactionId: a,
      activeTransform: t,
      transforms: { [t]: A }
    });
  }
  activateWorkflowExperienceTransform(e, t) {
    var o, r;
    if (!((o = e == null ? void 0 : e.getWorkflowManager()) != null && o.getModelContainer()) || !this.state)
      return;
    const A = e.getWorkflowManager().getTransaction().id, a = this.state.transactions.find((c) => c.transactionId === A), n = (r = a == null ? void 0 : a.transforms) == null ? void 0 : r[t];
    if (!n)
      return;
    const i = this.flipTransform(
      n,
      e.getWorkflowManager().getPreviewService()
    ), s = e.getWorkflowManager().getModelContainer();
    s.position = i.position, s.rotation = i.rotation, s.scale = i.scale, a.activeTransform = t;
  }
  removeStateForTransaction(e) {
    if (!this.state || !this.state.transactions)
      return;
    const t = this.state.transactions.findIndex((A) => A.transactionId === e);
    t !== -1 && this.state.transactions.splice(t, 1);
  }
  getSerializedState() {
    if (this.state)
      return JSON.stringify(this.state);
  }
  flipTransform(e, t) {
    return t && t.flipTransform ? t.flipTransform(
      e.position,
      {
        x: e.rotation.x * Math.PI / 180,
        y: e.rotation.y * Math.PI / 180,
        z: e.rotation.z * Math.PI / 180
      },
      e.scale
    ) : {
      position: e.position,
      rotation: {
        x: e.rotation.x * Math.PI / 180,
        y: e.rotation.y * Math.PI / 180,
        z: e.rotation.z * Math.PI / 180
      },
      scale: e.scale
    };
  }
}
class Hi {
  constructor(e) {
    this.fullFetched = !1, this.collection = e;
  }
  /**
   * The ID of the product collection.
   */
  getId() {
    return this.collection.id;
  }
  /**
   * The name of the collection.
   */
  getName() {
    return this.collection.name;
  }
  /**
   * The description of the collection.
   */
  getDescription() {
    return this.collection.description || "";
  }
  /**
   * The image of the collection.
   */
  getImage() {
    return this.collection.image;
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  getProducts() {
    if (!this.collection.productCollectionProducts)
      throw new Error("Failed to find products on collection. Ensure you fetch them first!");
    return this.collection.productCollectionProducts.map((e) => new _e(e));
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  async fetchProducts(e) {
    if (this.fullFetched)
      return this.collection.productCollectionProducts.map((A) => new _e(A));
    const t = await x.getShadowGraphqlClient().query({
      query: di,
      variables: {
        id: this.getId(),
        productIds: e
      },
      errorPolicy: "all",
      fetchPolicy: "no-cache"
    });
    return e || (this.fullFetched = !0), this.collection.productCollectionProducts = t.data.productCollections[0].productCollectionProducts || [], this.collection.productCollectionProducts.map((A) => new _e(A));
  }
  getTransformCollection() {
    if (this.collection.transformCollection)
      return new ki(this.collection.transformCollection);
  }
  /**
   * The raw collection resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.collection;
  }
}
class _e {
  constructor(e) {
    this.product = e.product, this.productResource = e;
  }
  /**
   * The ID of the product in SpiffCommerce.
   * @returns
   */
  getId() {
    return this.product.id;
  }
  /**
   * The name of the product. Human readable.
   */
  getName() {
    return this.product.name;
  }
  /**
   * A helper function for getting integrations
   * @param type The type of integration you want.
   * @param externalId An external integration ID to further filter by. Otherwise we return the first encountered.
   * @returns The integration if found. Throws an error if not found as this data is typically a neccesity.
   */
  getIntegrationByType(e, t) {
    const a = (this.product.integrationProducts || []).find((n) => {
      var r, c, B;
      const i = (r = n.integration) == null ? void 0 : r.type, s = ((c = n.integration) == null ? void 0 : c.type) === e, o = t ? ((B = n.integration) == null ? void 0 : B.externalIntegrationId) === t : !0;
      return i && s && o;
    });
    if (!a)
      throw new Error(
        "Failed to find requested integration type on product. This is generally due to a configuration error"
      );
    return a;
  }
  getCurrentIntegration() {
    const t = (this.product.integrationProducts || []).find((A) => {
      var a;
      return (a = A.integration) == null ? void 0 : a.isCurrent;
    });
    if (!t)
      throw new Error(
        `Product: ${this.productResource.id} is not linked to this current integration. This is generally due to a configuration error.`
      );
    return t;
  }
  /**
   * A helper function for pulling the default workflow.
   */
  getDefaultWorkflow() {
    const e = this.product.workflows || [];
    if (e.length === 0)
      throw new H(
        "No workflows on configured product. Ensure at least 1 workflow is assigned to this product."
      );
    const t = this.productResource.workflowId;
    if (t) {
      const A = e.find((a) => a.workflowName === t);
      if (A)
        return new Oe(A);
    }
    throw new H(
      "Called getDefaultWorkflow() before fetching collection products. Use collection.fetchProducts() first to ensure the data is available."
    );
  }
  /**
   * @returns All workflows associated with this Product.
   */
  getAllWorkflows() {
    if ((this.product.workflows || []).length === 0)
      throw new H(
        "No workflows on configured product. Ensure at least 1 workflow is assigned to this product."
      );
    return this.product.workflows.sort((t, A) => (t.index ?? 0) - (A.index ?? 0)).map((t) => new Oe(t));
  }
  /**
   * A list of all integrations this product is connected to.
   */
  getIntegrations() {
    return this.product.integrationProducts || [];
  }
  /**
   * The raw product resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.product;
  }
  /**
   * Gets the base price of the product. Optionally include additional product pricing.
   * @param includeAdditionalProduct Optionally include additional product pricing. You must provide at least one of the fields on this object.
   * @returns
   */
  getBasePrice(e) {
    var a, n, i, s;
    const t = this.product.basePrice || 0;
    if (!e)
      return t;
    if (!e.integrationType && !e.externalId && !e.integrationId)
      throw new Error(
        "You must provide at least one of the following fields on the includeAdditionalProduct object: integrationType, externalId, integrationId"
      );
    let A;
    return e.integrationId ? A = (a = this.product.integrationProducts) == null ? void 0 : a.find(
      (o) => {
        var r;
        return ((r = o.integration) == null ? void 0 : r.id) === e.integrationId;
      }
    ) : e.externalId ? A = (n = this.product.integrationProducts) == null ? void 0 : n.find(
      (o) => {
        var r;
        return ((r = o.integration) == null ? void 0 : r.externalIntegrationId) === e.externalId;
      }
    ) : A = (i = this.product.integrationProducts) == null ? void 0 : i.find(
      (o) => {
        var r;
        return ((r = o.integration) == null ? void 0 : r.type) === e.integrationType;
      }
    ), (s = A == null ? void 0 : A.additionalIntegrationProduct) != null && s.product ? t + (A.additionalIntegrationProduct.product.basePrice || 0) : t;
  }
}
class Oe {
  constructor(e) {
    this.workflow = e;
  }
  /**
   * @returns The ID of this workflow, to be used when starting an experience.
   */
  getId() {
    return this.workflow.workflowName;
  }
  /**
   * @returns The name of the workflow.
   */
  getName() {
    return this.workflow.friendlyName;
  }
  /**
   * An image to be used to display this workflow in a UI to the customer.
   * @returns A resource URL.
   */
  getThumbnail() {
    return this.workflow.imageUrl;
  }
}
class ki {
  constructor(e) {
    this.collection = e;
  }
  /**
   * @returns The ID of the transform collection.
   */
  getId() {
    return this.collection.id;
  }
  /**
   * @returns The name of the transform collection.
   */
  getName() {
    return this.collection.name;
  }
  /**
   * @returns The transforms in this collection.
   */
  getTransforms() {
    return this.collection.transforms.map((e) => new Ui(e));
  }
}
class Ui {
  constructor(e) {
    this.transform = e;
  }
  /**
   * @returns The ID of the transform.
   */
  getId() {
    return this.transform.id;
  }
  /**
   * @returns The name of the transform.
   */
  getName() {
    return this.transform.name;
  }
  /**
   * @returns The transformation to be used to place the object.
   */
  get() {
    return {
      position: this.transform.position,
      rotation: this.transform.rotation,
      scale: this.transform.scale
    };
  }
}
class et {
  constructor(e, t, A, a, n, i) {
    var s, o, r;
    this.eventListeners = /* @__PURE__ */ new Map(), this.workflowExperiences = [], this.client = e, this.id = t.id, this.name = t.name || "", this.ownerId = n, this.metadata = new Map(((s = t.metadata) == null ? void 0 : s.map((c) => [c.key, c.value])) || []), this.productCollection = t.productCollection, this.bundleStateManager = new Ri(t.bundleStateData), this.globalPropertyStateManager = new vi(
      this.id,
      this.ownerId,
      (o = this.productCollection) == null ? void 0 : o.globalPropertyConfiguration,
      this.checkConditionalHandlesChanged.bind(this),
      i
    ), this.globalPropertyHandleService = new Mi(this), this.setPreviewService(A), this.initializationPromise = Promise.all([
      this.loadExistingWorkflowExperiences(((r = t.transactions) == null ? void 0 : r.map((c) => c.id)) || [], a),
      this.globalPropertyStateManager.getInitializationPromise()
    ]), this.initializationPromise.catch((c) => {
      console.error(`Bundle initialization failed: ${c}`);
    });
  }
  setBundleOptions(e) {
    this.globalPropertyStateManager.setBundleOptions(e);
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  addEventListener(e, t) {
    this.eventListeners.set(e, [...this.eventListeners.get(e) || [], t]);
  }
  removeEventListener(e, t) {
    const A = this.eventListeners.get(e) || [], a = A.indexOf(t);
    a > -1 && A.splice(a, 1);
  }
  getClient() {
    return this.client;
  }
  getId() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  setName(e) {
    return this.name = e, this.updateBundle();
  }
  getMetadata() {
    return new Map(this.metadata);
  }
  setMetadata(e) {
    return this.metadata = new Map(e), this.updateBundle();
  }
  setNameAndMetadata(e, t) {
    return this.name = e, this.metadata = new Map(t), this.updateBundle();
  }
  hasGlobalProperties() {
    var e;
    return !!((e = this.productCollection) != null && e.globalPropertyConfiguration);
  }
  getGlobalPropertyConfiguration() {
    var e;
    return (e = this.productCollection) == null ? void 0 : e.globalPropertyConfiguration;
  }
  async getGlobalProperties() {
    return this.globalPropertyHandleService.applyConditionsFromState(
      await this.globalPropertyHandleService.getHandles(),
      this.getGlobalPropertyStateManager().getGlobalPropertyState()
    );
  }
  getGlobalPropertyStateManager() {
    return this.globalPropertyStateManager;
  }
  async getGlobalPropertyTotalSubunits() {
    return (await this.globalPropertyHandleService.getHandles()).filter((A) => A.getType() === $.Option).map((A) => {
      var a;
      return ((a = A.getCurrentVariant()) == null ? void 0 : a.getPrice()) || 0;
    }).reduce((A, a) => A + a, 0);
  }
  getTotalSubunits() {
    return this.workflowExperiences.map((e) => e.getTotalPriceSubunits()).reduce((e, t) => e + t, 0);
  }
  getProductCollection() {
    return this.productCollection ? new Hi(this.productCollection) : void 0;
  }
  async addWorkflowExperience(e) {
    e.setBundle(this), await this.appendWorkflowExperience(e), await this.injectExperienceIntoPreviewService(e), await e.getWorkflowManager().getInitializationPromise();
    const t = await this.getGlobalProperties();
    for (const A of t)
      await A.applyGlobalState([e]);
  }
  async addWorkflowExperiences(e) {
    const t = e.map((s) => s.getWorkflowManager().getTransaction().id), A = t.map(
      (s) => this.workflowExperiences.find((o) => o.getWorkflowManager().getTransaction().id === s)
    );
    if (A.some((s) => !!s))
      throw new Error(
        "Unable to add transaction to bundle - Already Exists: " + A.filter((s) => !!s).map((s) => s == null ? void 0 : s.getWorkflowManager().getTransaction().id).join(", ")
      );
    const a = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), n = t.map((s) => a.get(s));
    await x.getShadowGraphqlClient().mutate({
      mutation: ui,
      variables: {
        id: this.id,
        transactionIds: t,
        transactionOwnerIds: n
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }).catch((s) => {
      console.error(s);
    }), this.workflowExperiences.push(...e);
    const i = async () => {
      for (const o of e)
        o.setBundle(this), await this.injectExperienceIntoPreviewService(o);
      await Promise.all(e.map((o) => o.getWorkflowManager().getInitializationPromise()));
      const s = await this.getGlobalProperties();
      for (const o of s)
        await o.applyGlobalState(e);
    };
    await Promise.all([this.updateTransactionOrder(), i()]), this.workflowExperiences.forEach((s) => s.checkForPriceBreakChanges());
  }
  async appendWorkflowExperience(e, t = !0) {
    const A = e.getWorkflowManager().getTransaction().id;
    if (this.workflowExperiences.find(
      (s) => s.getWorkflowManager().getTransaction().id === A
    ))
      throw new Error("Unable to add transaction to bundle - Already Exists!");
    const i = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(A);
    await x.getShadowGraphqlClient().mutate({
      mutation: Ei,
      variables: {
        id: this.id,
        transactionId: A
      },
      context: {
        bundleOwnerId: this.ownerId,
        transactionOwnerId: i
      }
    }), t && (this.workflowExperiences.push(e), this.workflowExperiences.forEach((s) => s.checkForPriceBreakChanges()));
  }
  async removeWorkflowExperience(e) {
    const t = this.workflowExperiences.indexOf(e);
    await this.removeTransaction(t, this.workflowExperiences[t].getWorkflowManager().getTransaction());
  }
  async removeWorkflowExperiences(e) {
    await this.removeTransactions(e.map((t) => t.getWorkflowManager().getTransaction()));
  }
  async removeWorkflowExperienceByTransaction(e) {
    const t = this.workflowExperiences.findIndex(
      (A) => A.getWorkflowManager().getTransaction().id === e.id
    );
    await this.removeTransaction(t, e);
  }
  async removeWorkflowExperiencesByTransactions(e) {
    await this.removeTransactions(e);
  }
  async removeTransaction(e, t, A = !0) {
    if (e > -1) {
      const a = this.workflowExperiences.find(
        (n) => n.getWorkflowManager().getTransaction().id === t.id
      );
      a.setBundle(void 0), this.previewService && a.getWorkflowManager().ejectFromPreviewService(), this.bundleStateManager.removeStateForTransaction(t.id), await x.getShadowGraphqlClient().mutate({
        mutation: mi,
        variables: {
          id: this.id,
          transactionId: t.id,
          name: this.name,
          metadata: Array.from(this.metadata.entries()).map(([n, i]) => ({ key: n, value: i })),
          bundleStateData: this.bundleStateManager.getSerializedState()
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      }), A && (this.workflowExperiences.splice(e, 1), this.workflowExperiences.forEach((n) => n.checkForPriceBreakChanges()), a.checkForPriceBreakChanges(), await this.updateTransactionOrder());
    } else
      throw new Error("Unable to remove workflow experience from bundle - Not Found! - " + t.id);
  }
  async removeTransactions(e) {
    const t = e.map(
      (a) => this.workflowExperiences.findIndex((n) => n.getWorkflowManager().getTransaction().id === a.id)
    );
    if (t.some((a) => a === -1))
      throw new Error(
        "Unable to remove workflow experience from bundle - The following aren't included in the bundle: " + e.filter((a, n) => t[n] === -1).map((a) => a.id).join(", ")
      );
    const A = e.map(
      (a) => this.workflowExperiences.splice(
        this.workflowExperiences.findIndex((n) => n.getWorkflowManager().getTransaction().id === a.id),
        1
      )[0]
    );
    A.forEach((a) => a.setBundle(void 0)), [...this.workflowExperiences, ...A].forEach(
      (a) => a.checkForPriceBreakChanges()
    ), this.previewService && A.forEach((a) => a.getWorkflowManager().ejectFromPreviewService()), e.forEach((a) => this.bundleStateManager.removeStateForTransaction(a.id)), await x.getShadowGraphqlClient().mutate({
      mutation: Qi,
      variables: {
        id: this.id,
        transactionIds: e.map((a) => a.id),
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([a, n]) => ({ key: a, value: n })),
        bundleStateData: this.bundleStateManager.getSerializedState()
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), await this.updateTransactionOrder();
  }
  async insertWorkflowExperience(e, t) {
    await this.appendWorkflowExperience(e, !1), this.workflowExperiences.splice(t, 0, e), await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(e);
        const A = await this.getGlobalProperties();
        await Promise.all(A.map((a) => a.applyGlobalState([e])));
      })()
    ]);
  }
  async replaceWorkflowExperience(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length)
      throw new Error("Unable to replace workflow experience in bundle - Index out of range!");
    const A = this.workflowExperiences[e];
    if (A.getWorkflowManager().getTransaction().id === t.getWorkflowManager().getTransaction().id)
      throw new Error("Unable to replace workflow experience in bundle - Same transaction!");
    await Promise.all([
      this.removeTransaction(e, A.getWorkflowManager().getTransaction(), !1),
      this.appendWorkflowExperience(t, !1)
    ]), this.workflowExperiences[e] = t, await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(t);
        const a = await this.getGlobalProperties();
        await Promise.all(a.map((n) => n.applyGlobalState([t])));
      })()
    ]);
  }
  async swapWorkflowExperiences(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length || t < 0 || t >= this.workflowExperiences.length)
      throw new Error("Unable to swap workflow experiences in bundle - Index out of range!");
    if (e === t)
      return;
    const A = this.workflowExperiences[e];
    this.workflowExperiences[e] = this.workflowExperiences[t], this.workflowExperiences[t] = A, await this.updateTransactionOrder();
  }
  getWorkflowExperiences() {
    return [...this.workflowExperiences];
  }
  async sortWorkflowExperiences(e) {
    this.workflowExperiences = this.workflowExperiences.sort(e), await this.updateTransactionOrder();
  }
  getWorkflowExperienceCount() {
    return this.workflowExperiences.length;
  }
  async addStakeholder(e, t) {
    var n;
    const A = await x.getShadowGraphqlClient().mutate({
      mutation: pi,
      variables: {
        id: this.id,
        details: e,
        type: t || Ge.Owner
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!((n = A.data) != null && n.bundleAddStakeholder))
      throw new Error("Bundle not found!");
    const a = A.data.bundleAddStakeholder.bundleStakeholders || [];
    this.storeStakeholderCustomers(a);
  }
  async removeStakeholder(e) {
    var A;
    if (!((A = (await x.getShadowGraphqlClient().mutate({
      mutation: Di,
      variables: {
        id: this.id,
        emailAddress: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data) != null && A.bundleRemoveStakeholder))
      throw new Error("Bundle not found!");
  }
  async updateStakeholders(e) {
    var a;
    const t = await x.getShadowGraphqlClient().mutate({
      mutation: Ii,
      variables: {
        id: this.id,
        input: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!((a = t.data) != null && a.bundleUpdateStakeholders))
      throw new Error("Bundle not found!");
    const A = t.data.bundleUpdateStakeholders.bundleStakeholders || [];
    this.storeStakeholderCustomers(A);
  }
  async getAllStakeholders() {
    const e = await x.getShadowGraphqlClient().query({
      query: li,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!e.data.bundles || e.data.bundles.length === 0)
      throw new Error("Bundle not found!");
    const t = e.data.bundles[0].bundleStakeholders || [];
    return this.storeStakeholderCustomers(t), t;
  }
  storeStakeholderCustomers(e) {
    e.forEach((t) => {
      t.customer && this.client.storeCustomer(t.customer);
    });
  }
  async finish(e, t) {
    const A = await zn(
      this.workflowExperiences.map((a) => ({
        workflowManager: a.getWorkflowManager(),
        workflow: a.getWorkflowManager().getWorkflow(),
        layouts: a.getWorkflowManager().getLayouts(),
        getReducerState: () => a.getCommandContext().getState(),
        product: a.getWorkflowManager().getProduct(),
        transaction: a.getWorkflowManager().getTransaction(),
        workflowSelections: a.getWorkflowManager().getWorkflowSelections(),
        designName: a.getWorkflowManager().getWorkflow().name,
        workflowMetadata: a.getWorkflowManager().getWorkflowMetadata()
      })),
      e ?? (() => {
      }),
      t ? (a, n) => {
        const i = this.workflowExperiences.find(
          (s) => s.getWorkflowManager().getTransaction().id === n
        );
        return i ? t(i) : (console.warn(
          "SpiffCommerce - Bundle create design - Unable to find experience for transaction: " + n
        ), Promise.resolve(void 0));
      } : void 0
    );
    return {
      bundleId: this.id,
      items: A,
      bundleOwnerId: this.ownerId
    };
  }
  getPreviewService() {
    return this.previewService;
  }
  async setPreviewService(e) {
    if (this.workflowExperiences && this.workflowExperiences.length > 0 && (this.workflowExperiences.forEach((t) => t.getWorkflowManager().ejectFromPreviewService()), e))
      for (const t of this.workflowExperiences)
        await this.injectExperienceIntoPreviewService(t);
    e && e.registerModelLoadEventListener && e.registerModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService && this.previewService !== e && this.previewService.unregisterModelLoadEventListener && this.previewService.unregisterModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService = e;
  }
  updateWorkflowExperienceTransform(e, t, A) {
    return this.bundleStateManager.updateWorkflowExperienceTransform(e, t, A), this.updateBundle();
  }
  activateWorkflowExperienceTransform(e, t) {
    return this.bundleStateManager.activateWorkflowExperienceTransform(e, t), this.updateBundle();
  }
  async assignProductCollection(e) {
    var A, a;
    const t = await x.getShadowGraphqlClient().mutate({
      mutation: Fi(
        ((A = this.globalPropertyStateManager.getBundleOptions()) == null ? void 0 : A.eagerFetchProducts) ?? !1
      ),
      variables: {
        id: this.id,
        productCollectionId: e ?? ""
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    (a = t.data) != null && a.bundleAssignProductCollection.productCollection && (this.productCollection = t.data.bundleAssignProductCollection.productCollection, this.globalPropertyStateManager.setConfiguration(
      t.data.bundleAssignProductCollection.productCollection.globalPropertyConfiguration
    ));
  }
  onModelLoadEvent(e) {
    e.eventType === "unload" || !e.modelContainer || (e.modelContainer.registerMaterialSelectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !0)), e.modelContainer.registerMaterialDeselectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !1)));
  }
  onModelSelectedEvent(e, t) {
    if (e && e.metadata && e.metadata instanceof Map && e.metadata.has("workflowManager")) {
      const a = e.metadata.get("workflowManager").getTransaction(), n = this.workflowExperiences.find(
        (i) => i.getWorkflowManager().getTransaction().id === a.id
      );
      n && this.fireEvent(t ? "workflow-experience-hover-enter" : "workflow-experience-hover-exit", {
        workflowExperience: n
      });
    }
  }
  async injectExperienceIntoPreviewService(e) {
    if (this.previewService) {
      const t = e.getWorkflowManager().injectIntoPreviewService(this.previewService);
      try {
        this.bundleStateManager.applyStateToWorkflowExperience(e);
      } catch (A) {
        console.error(`Unable to apply state to workflow experience: ${A}`);
      }
      await t;
    }
  }
  async loadExistingWorkflowExperiences(e, t) {
    if (e.length === 0)
      return;
    const A = await this.client.getWorkflowExperiences(
      e.map((a) => ({
        type: "transaction",
        transactionId: a
      })),
      t
    );
    if (A.forEach((a) => a.setBundle(this)), A.forEach((a) => a.checkForPriceBreakChanges()), this.workflowExperiences = A, this.previewService)
      for (const a of A)
        await this.injectExperienceIntoPreviewService(a);
  }
  async updateBundle() {
    var t;
    if (!((t = (await x.getShadowGraphqlClient().mutate({
      mutation: hi,
      variables: {
        id: this.id,
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([A, a]) => ({ key: A, value: a })),
        bundleStateData: this.bundleStateManager.getSerializedState()
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data) != null && t.bundleUpdate))
      throw new Error("Bundle not found!");
  }
  async updateTransactionOrder() {
    await x.getShadowGraphqlClient().mutate({
      mutation: fi,
      variables: {
        id: this.id,
        transactionIds: this.workflowExperiences.map((e) => e.getWorkflowManager().getTransaction().id)
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  async checkConditionalHandlesChanged(e, t) {
    const A = await this.globalPropertyHandleService.getHandles(), a = this.globalPropertyHandleService.applyConditionsFromState(A, e), n = this.globalPropertyHandleService.applyConditionsFromState(A, t);
    if ((() => {
      if (a.length !== n.length)
        return !0;
      for (let s = 0; s < a.length; s++)
        if (a[s].getName() !== n[s].getName())
          return !0;
      return !1;
    })()) {
      this.fireEvent("conditional-global-properties-changed", {
        globalProperties: n
      });
      const s = n.filter((o) => !a.includes(o));
      await Promise.all(s.map((o) => o.applyGlobalState()));
    }
  }
  fireEvent(e, t) {
    (this.eventListeners.get(e) || []).forEach(
      (a) => a({
        bundle: this,
        event: e,
        data: t
      })
    );
  }
}
const Gi = f`
    mutation processFlowCreate($processFlowId: String!, $inputs: [String]!) {
        processExecutionCreate(processFlowId: $processFlowId, inputs: $inputs) {
            id
        }
    }
`;
class bi {
  /**
   *
   * @param id
   * @param inputs
   * @param options
   * @returns
   */
  async execute(e, t, A) {
    var B, l, d;
    const n = (l = (B = (await x.getShadowGraphqlClient().mutate({
      mutation: Gi,
      variables: {
        processFlowId: e,
        inputs: [...t.map((C) => C.getValueForTransmission())]
      }
    })).data) == null ? void 0 : B.processExecutionCreate) == null ? void 0 : l.id;
    if (!n)
      throw new Error("Failed to create process execution.");
    function i(C) {
      return new Promise((w) => {
        setTimeout(w, C);
      });
    }
    let s = !1, o = 0, r, c;
    for (; !s; ) {
      r = await x.getShadowGraphqlClient().query({
        query: f`
                    query getProcessFlowExecution($ids: [String]!) {
                        processExecutions(ids: $ids) {
                            id
                            completedAt
                            failedAt
                            nodes {
                                id
                                type
                                artifacts
                            }
                        }
                    }
                `,
        variables: {
          ids: [n]
        }
      });
      const C = (d = r.data) == null ? void 0 : d.processExecutions[0];
      if (!r || !C)
        throw new Error("Failed to retrieve server response for execution.");
      if (C.failedAt)
        throw new Error(
          "Execution has failed to complete. See Automation > FLows in Flight on partner account on SpiffCommerce Hub."
        );
      if (C.completedAt) {
        s = !0, c = new Ji(C);
        break;
      }
      o += 1;
      const w = A != null && A.repeats ? A == null ? void 0 : A.repeats : 5;
      if (o >= w)
        throw new Error("Maximum wait time exceeded for execution result.");
      await i(A != null && A.sleepTime ? Math.max(A.sleepTime, 500) : 2e3);
    }
    if (!c)
      throw new Error("Failed to retrieve server response for execution.");
    return Promise.resolve(c);
  }
}
class Ji {
  constructor(e) {
    this.execution = e;
  }
  /**
   * @returns The raw response from the server.
   */
  getRaw() {
    return this.execution;
  }
  /**
   * @returns The nodes contained within the execution.
   */
  getNodes() {
    return this.execution.nodes.map((e) => new Ye(e));
  }
  /**
   * @param type The type of node to return.
   * @returns A list of nodes matching the requested type.
   */
  getNodesByType(e) {
    return this.execution.nodes.filter((t) => t.type === e).map((t) => new Ye(t));
  }
  /**
   * @returns A list of input nodes that exist in this execution.
   */
  getInputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "StartTerminal"
      /* StartTerminal */
    ).map((e) => new Ye(e));
  }
  /**
   * @returns A list of out put nodes that exist in this execution.
   */
  getOutputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "EndTerminal"
      /* EndTerminal */
    ).map((e) => new Ye(e));
  }
  /**
   * @returns A date object representing the point in time this execution completed.
   */
  getCompletedAt() {
    if (this.execution.completedAt)
      return new Date(this.execution.completedAt);
  }
  /**
   * @returns A date object representing the point in time this execution failed.
   */
  getFailedAt() {
    if (this.execution.failedAt)
      return new Date(this.execution.failedAt);
  }
}
class Ye {
  constructor(e) {
    this.node = e;
  }
  getId() {
    return this.node.id;
  }
  getType() {
    return this.node.type;
  }
  getArtifacts() {
    return new Map(Object.entries(JSON.parse(this.node.artifacts).value));
  }
  getArtifactByName(e) {
    return this.getArtifacts().get(e);
  }
}
class Ft {
  constructor(e) {
    this.value = e;
  }
  getRaw() {
    return this.value;
  }
  getValueForTransmission() {
    const e = this.value;
    return e.startsWith("[") ? JSON.stringify(JSON.parse(e)) : e;
  }
}
var Ti = /* @__PURE__ */ ((g) => (g.Transaction = "Transaction", g.Bundle = "Bundle", g.Product = "Product", g.Variant = "Variant", g.Option = "Option", g.LineItem = "LineItem", g.Asset = "Asset", g))(Ti || {});
class Ms extends Ft {
  constructor(e) {
    super(`"${e}"`);
  }
}
class NA extends Ft {
  constructor(e, t) {
    if (t !== "Asset" && !NA.validUUID(e))
      throw new Error("Invalid ID, must be a valid v4 UUID. https://www.uuidgenerator.net/");
    super(`{"isSpiffObject": true, "id": "${e}", "type": "${t}"}`);
  }
  static validUUID(e) {
    return e.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
  }
}
class Ss extends Ft {
  constructor(e) {
    super(`[${e.map((t) => t.getRaw()).join(",")}]`);
  }
}
class Tt {
  constructor(e) {
    this.integrationProduct = e;
  }
  getId() {
    return this.integrationProduct.id;
  }
  getResource() {
    return this.integrationProduct;
  }
  getBasePrice() {
    var A;
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.basePrice || 0, t = (A = this.integrationProduct) == null ? void 0 : A.additionalIntegrationProduct;
    if (!t)
      return e;
    if (t && !t.product)
      throw new Error("An additional integration product was found, but it does not have a product");
    return e + (t.product.basePrice || 0);
  }
  getDefaultWorkflow() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return new Oe(e[0]);
  }
  getAllWorkflows() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return e.sort((t, A) => (t.index ?? 0) - (A.index ?? 0)).map((t) => new Oe(t));
  }
}
const Oi = f`
    query GetCustomer($emailAddress: String!) {
        customer(emailAddress: $emailAddress) {
            id
            emailAddress
            partner {
                id
            }
        }
    }
`, Li = f`
    mutation CustomerCreate($details: CustomerDetailsInput!) {
        customerCreate(details: $details) {
            id
            emailAddress
            partner {
                id
            }
        }
    }
`, zi = f`
    mutation CustomerAuthenticate($loginToken: String!) {
        customerAuthenticate(loginToken: $loginToken) {
            id
            emailAddress
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
            partner {
                id
            }
        }
    }
`, Ki = f`
    mutation CustomerGenerateVerificationCode($emailAddress: String!) {
        customerGenerateVerificationCode(emailAddress: $emailAddress)
    }
`, ji = f`
    mutation CustomerVerifyCode($emailAddress: String!, $verificationCode: String!) {
        customerVerifyCode(emailAddress: $emailAddress, verificationCode: $verificationCode) {
            id
            emailAddress
            loginToken
            partner {
                id
            }
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
        }
    }
`, Vi = f`
    query CustomerMetafields($id: String!) {
        metafields(entityId: $id) {
            id
            createdAt
            updatedAt
            entityId
            value
            metafieldConfiguration {
                id
                createdAt
                updatedAt
                entityType
                metafieldType
                name
            }
        }
    }
`, Wi = f`
    fragment RegionFields on Region {
        width
        top
        left
        height
        layer
        layerIndex
        rotation
        panelId
        immutable
        adjustmentBoundary {
            width
            x
            y
            height
        }
    }
`, Xi = f`
    fragment LookAtAnimationFields on LookAtAnimation {
        latDeg
        lonDeg
        radius
        target {
            x
            y
            z
        }
    }
`, qi = f`
    fragment RenderingPipelineConfigurationFields on RenderingPipelineConfiguration {
        antiAliasing {
            samples
            fxaaEnabled
        }
        bloom {
            enabled
            kernel
            scale
            threshold
            weight
        }
        chromaticAberration {
            enabled
            aberrationAmount
            direction {
                x
                y
            }
            radialIntensity
        }
        colorCurves {
            enabled
            globalDensity
            globalExposure
            globalHue
            globalSaturation
            highlightsDensity
            highlightsExposure
            highlightsHue
            highlightsSaturation
            midtonesDensity
            midtonesExposure
            midtonesHue
            midtonesSaturation
            shadowsDensity
            shadowsExposure
            shadowsHue
            shadowsSaturation
        }
        depthOfField {
            enabled
            blurLevel
            focusDistance
            focalLength
            fStop
            lensSize
        }
        grain {
            enabled
            animated
            intensity
        }
        misc {
            contrast
            exposure
            toneMappingEnabled
            toneMappingType
        }
        sharpen {
            enabled
            colorAmount
            edgeAmount
        }
        vignette {
            enabled
            blendMode
            cameraFov
            center {
                x
                y
            }
            colorRgba {
                r
                g
                b
                a
            }
            colorHex
            stretch
            weight
        }
    }
`, Zi = f`
    fragment ModelAnimationFields on ModelAnimation {
        from
        to
        loop
        name
    }
`, $i = (g) => f`
        ${De(g)}
        ${Et}
        ${sA}
        ${Wi}
        ${Xi}
        ${qi}
        ${Zi}
        query GetWorkflows($ids: [String!]!) {
            workflows(ids: $ids) {
                partner {
                    termsMarkdown
                }
                allowProofDownload
                defaultPreviewPanelIndex
                finalizeStepConfig {
                    termsMarkdown
                    lookAtAnimation {
                        ...LookAtAnimationFields
                    }
                    modelAnimation {
                        ...ModelAnimationFields
                    }
                }
                globalPreviewConfig {
                    autoRotation
                    backgroundColor
                    backgroundImage
                    clearColor
                    disableActionBar
                    disableAutomaticOrientation
                    emissiveGlowIntensity
                    enableAR
                    environmentFile
                    environmentIntensity
                    environmentRotationY
                    idleTimeBeforeRotation
                    lowerAlphaLimitDeg
                    lowerBetaLimitDeg
                    maxZoomOverride
                    minZoomOverride
                    noPan
                    upperAlphaLimitDeg
                    upperBetaLimitDeg
                    renderingPipelineConfiguration {
                        ...RenderingPipelineConfigurationFields
                    }
                }
                id
                introduction
                name
                overrideTheme {
                    id
                    configuration
                    name
                    primaryColor
                    secondaryColor
                    textColor
                    themeLayout {
                        id
                        name
                    }
                    fontAsset {
                        ...AssetFields
                    }
                }
                panels {
                    editableArea {
                        height
                        width
                        x
                        y
                    }
                    height
                    width
                    index
                    name
                    useEditableArea
                    transparentBackground
                    previewRegion {
                        ...RegionFields
                    }
                }
                previewAsset {
                    ...AssetFields
                }
                showModelOnFinishStep
                showPlusInVariantPrices
                showPricing
                skuCode
                stepGroups {
                    name
                    stepNames
                }
                steps {
                    stepName
                    type
                    tags
                    globalPropertyAspectConfigurations {
                        aspectName
                        globalPropertyConfigurationId
                    }
                    option {
                        ...OptionFields
                    }
                    stepTitle
                    helpText
                    mandatory
                    silent
                    conditions {
                        requiredVariantSelections
                        targetStepName
                        action
                    }
                    data {
                        __typename
                        ... on InformationStepData {
                            content
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on DigitalContentStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            baseUrl
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on FrameStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionFields
                            }
                            colorPickerEnabled
                            initialZoomLevel
                            disablePlaceholder
                            displayImageOnFinishStep
                            displaySelectionOnFinishStep
                            forceImageCover
                            hideImageInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxColors
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            overlayImageKey
                            overlayImageUrl
                            placeholderImageKey
                            placeholderImageUrl
                            regions {
                                ...RegionFields
                            }
                            whitelistedExtensions
                        }
                        ... on IllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionFields
                            }
                            colorPickerEnabled
                            displayColorsOnFinishStep
                            displaySelectionOnFinishStep
                            hideColorsInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on MaterialStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            targetMaterials
                        }
                        ... on ModelStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            replaceProductModel
                        }
                        ... on ModuleStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displayTextOnFinishStep
                            hideTextInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            module
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on PictureStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on ProductOverlayStepData {
                            regions {
                                ...RegionFields
                            }
                            overlayType
                        }
                        ... on QuestionStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowMultipleSelections
                            displaySelectionsOnFinishStep
                            displayType
                            hideSelectionsInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on ShapeStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            excludeFromPrint
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on SilentIllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            asset {
                                ...AssetFields
                            }
                            excludeFromPrint
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on TextStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowNewlines
                            colorOption {
                                ...OptionFields
                            }
                            colorPickerEnabled
                            curved
                            defaultText
                            deleteDefaultOnFocus
                            displayColorOnFinishStep
                            displayImageFillOnFinishStep
                            displaySelectionOnFinishStep
                            displayTextOnFinishStep
                            hideColorInCart
                            hideImageFillInCart
                            hideSelectionInCart
                            hideTextInCart
                            imageFillOption {
                                ...OptionFields
                            }
                            imageFillScale
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            maxSize
                            minSize
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            paths
                            regions {
                                ...RegionFields
                            }
                            replaceableText
                            size
                            textAlign
                            uppercase
                            userCanReplaceText
                            vertical
                            verticalAlign
                        }
                    }
                }
            }
        }
    `, _i = f`
    query GetTransactionForPartner($id: String!) {
        transactions(ids: [$id]) {
            id
            bundle {
                id
            }
            customLogoLink
            isOrdered
            product {
                id
                partner {
                    id
                }
            }
        }
    }
`, es = f`
    ${De(!1)}
    query GetWorkflowForTheme($id: String!) {
        workflow(id: $id) {
            id
            overrideTheme {
                id
                configuration
                name
                primaryColor
                secondaryColor
                textColor
                themeLayout {
                    id
                    name
                }
                fontAsset {
                    ...AssetFields
                }
            }
        }
    }
`, ts = f`
    fragment TagFields on Tag {
        id
        name
    }
`, As = f`
    ${ts}
    query GetManyTags($entityIds: [String!]!) {
        tagsMany(entityIds: $entityIds) {
            ...TagFields
        }
    }
`, re = async (g) => {
  var e;
  for (const t in g.layouts) {
    const A = g.layouts[t].elements.filter(
      (n) => n.type === G.Illustration
    );
    for (let n = 0; n < A.length; ++n) {
      const i = A[n];
      i.src && i.svg && (i.cachedObjectURL = await ve(i.svg));
    }
    const a = g.layouts[t].elements.filter((n) => n.type === G.Textbox);
    for (let n = 0; n < a.length; ++n) {
      const i = a[n];
      (e = i.fontData) != null && e.assetUrl && await dt(i.fontData.assetUrl);
    }
  }
}, as = async (g, e) => {
  var a;
  const t = await x.getShadowGraphqlClient().query({
    query: $i(((a = e == null ? void 0 : e.assets) == null ? void 0 : a.metadata) || !1),
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      ids: g
    }
  }), A = t.data.workflows;
  if (A === void 0 || A.length !== g.length)
    throw new Error(`Unable to read workflows: ${t.errors ?? "Length mismatch in response"}`);
  return A.forEach((n) => {
    n.steps.forEach((i) => {
      var s, o, r;
      delete i.data.__typename, (s = i.option) != null && s.id && ((o = i.option.defaultVariant) != null && o.asset && U.cacheAsset(i.option.defaultVariant.asset), i.option.colorProfile && U.cacheAsset(i.option.colorProfile), (r = i.option.variants) == null || r.forEach((c) => {
        c.asset && U.cacheAsset(c.asset), c.thumbnail && U.cacheAsset(c.thumbnail), c.material && U.cacheMaterial(c.material);
      }), me.set({ id: i.option.id }, Promise.resolve(i.option)));
    }), n.finalizeStepConfig || (n.finalizeStepConfig = {}), n.finalizeStepConfig.termsMarkdown = n.partner.termsMarkdown;
  }), A;
}, ns = async (g, e) => {
  const A = (await e).find((a) => a.id === g);
  if (!A)
    throw new Error(`Workflow not found: ${g}`);
  return A;
}, vA = async (g, e) => {
  const t = g.map((s) => me.get({ id: s, options: e })), A = g.filter((s, o) => t[o] === void 0);
  if (A.length === 0)
    return Promise.all(t);
  const a = as(A, e), n = A.map(
    (s) => me.set({ id: s, options: e }, ns(s, a))
  ), i = t.filter((s) => s !== void 0);
  return await Promise.all(i.concat(n));
}, Pe = async (g, e) => (await vA([g], e))[0], is = (g) => g.sort((e, t) => e.index - t.index).map((e) => ({
  id: J(),
  panelId: e.name,
  name: e.name,
  index: e.index,
  createdAt: /* @__PURE__ */ new Date(),
  updatedAt: /* @__PURE__ */ new Date(),
  transparentBackground: e.transparentBackground,
  height: e.height,
  width: e.width,
  previewRegion: e.previewRegion,
  useEditableArea: e.useEditableArea,
  editableArea: e.editableArea
})), tt = (g, e) => {
  const t = g.workflowState, A = t ? JSON.parse(t) : void 0;
  return A ? Object.values(A.layouts).map((a) => a.layout) : is(e.panels);
};
class ss {
  constructor(e) {
    this.activeIntegration = void 0, this.updateTransactionState = async (t) => {
      try {
        return x.getShadowGraphqlClient().mutate({
          ...t,
          mutation: Ua
        });
      } catch (A) {
        throw console.error(A), new H("Critical - Unable to synchronize workflow state with server.");
      }
    }, this.initialized = !1, this.options = e, this.options.applicationKey && ca(this.options.applicationKey), console.debug("------------------------"), console.debug("Spiff Commerce Core SDK"), console.debug("Version: 22.13.4"), console.debug(`Application Key Provided: ${!!this.options.applicationKey}`), console.debug("------------------------");
  }
  /** @deprecated Use `configure` instead */
  configureUrls(e, t, A) {
    q.setHubUrl(e), q.setServerUrl(t), q.setServicesApiUrl(A), this.options.applicationKey && this.getIntegration();
  }
  configure(e) {
    q.setHubUrl(e.hubUrl), q.setServerUrl(e.serverUrl), q.setServicesApiUrl(e.servicesApiUrl), this.marketplaceThemeInstallId = e.marketplaceThemeInstallId, this.marketplaceThemeInstallConfigurationId = e.marketplaceThemeInstallConfigurationId, e.bearerAuthenticationToken && la(e.bearerAuthenticationToken), this.options.applicationKey && this.getIntegration();
  }
  /**
   * @returns The asset manager allows for common operations related to assets
   * and the Spiff Commerce platform.
   */
  getAssetManager() {
    return U;
  }
  getCurrencyCode() {
    if (this.currencyCode === void 0)
      throw new Error("No currency code set.");
    return this.currencyCode;
  }
  getFlowService() {
    if (!ga())
      throw new Error("Application key required to use Flow Service.");
    return new bi();
  }
  async getIntegration() {
    if (this.activeIntegration)
      return this.activeIntegration;
    if (!this.options.applicationKey)
      throw new Error("Cannot get current Integration without specifying an Application Key.");
    const e = async () => (await x.getShadowGraphqlClient().query({
      query: Ra,
      errorPolicy: "all",
      fetchPolicy: "no-cache"
    })).data.currentIntegration;
    return this.activeIntegration = e(), this.activeIntegration;
  }
  async canUseAddon(e) {
    var t;
    try {
      return ((t = (await this.getIntegration()).partner.activeAddons) == null ? void 0 : t.includes(e)) ?? !1;
    } catch (A) {
      return console.error(A), !1;
    }
  }
  // TODO: Authentication functions should probably be moved to a separate class.
  /**
   * Attempts to load persisted authentication information from local storage, and authenticate with the Spiff Commerce API.
   * @param bundleId The ID of the bundle you intend to load.
   * @returns An object containing the success status of the authentication attempt, and the type of stakeholder when successful.
   */
  async authenticateBundleFromLocalStorage(e) {
    var a, n;
    const t = P.getMap("bundleOwnerIds");
    if (t != null && t.has(e))
      return Promise.resolve({ success: !0, stakeholderType: Ge.Owner });
    const A = P.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    if (A.has(e)) {
      const i = A.get(e), o = (P.getMap("partnerCustomerIds") || /* @__PURE__ */ new Map()).get(i);
      if (o && await this.authenticateCustomerId(o)) {
        const c = (n = (a = this.customer) == null ? void 0 : a.bundleStakeholders) == null ? void 0 : n.find(
          (B) => {
            var l;
            return ((l = B.bundle) == null ? void 0 : l.id) === e;
          }
        );
        if (c)
          return Promise.resolve({
            success: !0,
            stakeholderType: c.type
          });
      }
    }
    return Promise.resolve({ success: !1 });
  }
  /**
   * Attempts to load persisted authentication information from local storage, and authenticate with the Spiff Commerce API.
   * @param transactionId The ID of the transaction that the user is attempting to load.
   * @returns An object containing the following:
   * - `customLogoLink`: A link to a custom logo to display in the header.
   * - `transactionReadOnly`: Whether or not the transaction is read-only. Shadow will not accept any changes to the transaction if this is set to true.
   * - `stakeholderType`: The type of stakeholder that the user is authenticated as.
   * - `success`: Whether or not the authentication was successful.
   * @throws An error if the transaction is not found.
   */
  async authenticateTransactionFromLocalStorage(e) {
    var c, B, l, d, C, w;
    const t = x.getShadowGraphqlClient(), A = await t.query({
      query: _i,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: e
      }
    });
    if (!A.data.transactions || A.data.transactions.length === 0)
      throw new Error(`Transaction not found: ${e}`);
    const a = A.data.transactions[0];
    if (!((B = (c = a.product) == null ? void 0 : c.partner) == null ? void 0 : B.id))
      throw new Error(`Unable to read transaction: ${e}`);
    if (a.isOrdered)
      return Promise.resolve({ success: !1, transactionReadOnly: !0 });
    const i = P.getMap("transactionOwnerIds");
    if (i != null && i.has(e))
      return Promise.resolve({ success: !0, stakeholderType: Ge.Owner });
    const s = P.getMap("transactionCustomerIds");
    if (s != null && s.has(e)) {
      const h = s.get(e);
      if (h && await this.authenticateCustomerId(h)) {
        const E = ((d = (l = this.customer) == null ? void 0 : l.bundleStakeholders) == null ? void 0 : d.find(
          (D) => {
            var Q, p;
            return (p = (Q = D.bundle) == null ? void 0 : Q.transactions) == null ? void 0 : p.some((m) => m.id === e);
          }
        )) || ((w = (C = this.customer) == null ? void 0 : C.stakeholders) == null ? void 0 : w.find(
          (D) => {
            var Q;
            return ((Q = D.transaction) == null ? void 0 : Q.id) === e;
          }
        ));
        if (E)
          return Promise.resolve({
            success: !0,
            stakeholderType: E.type
          });
      }
    }
    const r = (await t.query({
      query: es,
      errorPolicy: "all",
      variables: {
        id: a.workflowId
      }
    })).data.workflow;
    if (!r)
      throw new Error(`Unable to read workflow: ${a.workflowId}`);
    return Promise.resolve({
      success: !1,
      theme: r.overrideTheme,
      customLogoLink: a.customLogoLink
    });
  }
  clearCustomer() {
    this.customer = void 0;
  }
  clearCustomerForTransaction(e) {
    const t = P.getMap("transactionCustomerIds");
    t != null && t.has(e) && (t.delete(e), P.setMap("transactionCustomerIds", t));
  }
  getStakeholderTypeForTransaction(e) {
    var A, a;
    const t = (a = (A = this.customer) == null ? void 0 : A.stakeholders) == null ? void 0 : a.find(
      (n) => {
        var i;
        return ((i = n.transaction) == null ? void 0 : i.id) === e;
      }
    );
    if (t)
      return t.type;
  }
  async getOrCreateCustomer(e) {
    var i;
    this.customer = void 0;
    const t = x.getShadowGraphqlClient(), a = (await t.query({
      query: Oi,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e
      }
    })).data.customer;
    if (!a.id) {
      const o = (i = (await t.mutate({
        mutation: Li,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          details: {
            emailAddress: e
          }
        }
      })).data) == null ? void 0 : i.customerCreate;
      if (!o)
        throw new Error("Unable to create customer.");
      return this.storeCustomer(o), this.customer = o, {
        customer: o,
        isAuthenticated: !1
      };
    }
    this.storeCustomer(a);
    const n = await this.authenticateCustomerId(a.id);
    return {
      customer: this.customer || a,
      isAuthenticated: n
    };
  }
  getCustomer() {
    return this.customer;
  }
  async authenticateCustomerId(e) {
    var s;
    const t = x.getShadowGraphqlClient(), A = P.getMap("customerTokens");
    if (!(A != null && A.has(e)))
      return !1;
    const a = A.get(e);
    if (!a)
      return !1;
    const i = (s = (await t.mutate({
      mutation: zi,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        loginToken: a
      }
    })).data) == null ? void 0 : s.customerAuthenticate;
    return i ? (this.storeCustomer(i), vt(a), this.customer = i, !0) : !1;
  }
  /**
   * Generates a verification code for the given email address.
   * @param emailAddress The email address to generate a verification code for. The user will be sent an email with the verification code.
   */
  async generateVerificationCode(e) {
    await x.getShadowGraphqlClient().mutate({
      mutation: Ki,
      variables: {
        emailAddress: e
      }
    });
  }
  /**
   * Verifies the given email address with the given verification code.
   * @param emailAddress The email address to verify.
   * @param verificationCode The verification code to verify the email address with.
   * @returns True if the verification was successful, false otherwise.
   */
  async verifyCode(e, t) {
    var n, i;
    const a = (n = (await x.getShadowGraphqlClient().mutate({
      mutation: ji,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e,
        verificationCode: t
      }
    })).data) == null ? void 0 : n.customerVerifyCode;
    if (a != null && a.loginToken) {
      if (!((i = a.partner) != null && i.id))
        throw new Error(`Unable to find customer: ${e}`);
      const s = P.getMap("customerTokens") || /* @__PURE__ */ new Map();
      return s.set(a.id, a.loginToken), P.setMap("customerTokens", s), this.storeCustomer(a), vt(a.loginToken), this.customer = {
        ...a,
        loginToken: void 0
      }, !0;
    }
    return !1;
  }
  async getCustomerMetafields() {
    var t;
    if (!((t = this.customer) != null && t.id))
      throw new Error("Customer must be logged in before calling this function.");
    return (await x.getShadowGraphqlClient().query({
      query: Vi,
      fetchPolicy: "no-cache",
      variables: {
        id: this.customer.id
      }
    })).data.metafields;
  }
  /**
   * @param collectionId Optional: The id of the product collection that the bundle can use.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getNewBundle(e, t, A) {
    var r, c, B, l, d;
    const n = (B = (await x.getShadowGraphqlClient().mutate({
      mutation: Ci(((c = (r = A == null ? void 0 : A.graphql) == null ? void 0 : r.productCollection) == null ? void 0 : c.eagerFetchProducts) || !1),
      variables: {
        collectionId: e,
        initialMetadata: t ? Object.entries(t).map((C, w) => ({ key: C[0], value: C[1] })) : void 0,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
      },
      fetchPolicy: "no-cache"
    })).data) == null ? void 0 : B.bundleCreate;
    if (!(n != null && n.id))
      throw new Error("Unable to create bundle");
    const i = P.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    i.set(n.id, n.partner.id), P.setMap("bundlePartnerIds", i);
    const s = P.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    s.set(n.id, n.bundleOwnerId), P.setMap("bundleOwnerIds", s);
    const o = new et(this, n, void 0, void 0, n.bundleOwnerId, {
      eagerFetchProducts: (d = (l = A == null ? void 0 : A.graphql) == null ? void 0 : l.productCollection) == null ? void 0 : d.eagerFetchProducts
    });
    return await o.getInitializationPromise(), o;
  }
  /**
   * Retrieves an existing bundle from the API, by id.
   * @param bundleId The id of the bundle to retrieve.
   * @param previewService Optional: A reference to an existing preview service to use. This can be assigned manually later.
   * @param graphqlOptions Optional: Options to configure loading the workflow.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getExistingBundle(e, t, A, a) {
    var h, u, E, D, Q, p, m, I, F, y, Y;
    const n = P.getMap("bundleOwnerIds"), i = n == null ? void 0 : n.get(e), o = ((h = Object.entries(localStorage).find(([N, S]) => N.startsWith("CognitoIdentityServiceProvider") && N.endsWith("idToken"))) == null ? void 0 : h[0]) || "", r = localStorage.getItem(o), c = {};
    r && !Te(r) && (c.Authorization = `Bearer ${r}`);
    const B = {
      bundleOwnerId: i,
      ...c,
      ...(u = a == null ? void 0 : a.graphql) == null ? void 0 : u.additionalHeaders
    }, l = await x.getShadowGraphqlClient().query({
      query: gi(((D = (E = a == null ? void 0 : a.graphql) == null ? void 0 : E.productCollection) == null ? void 0 : D.eagerFetchProducts) || !1),
      variables: {
        id: e
      },
      fetchPolicy: "no-cache",
      context: {
        headers: B
      }
    });
    if (!((Q = l.data) != null && Q.bundles) || ((p = l.data) == null ? void 0 : p.bundles.length) === 0 || !((m = l.data) != null && m.bundles[0]))
      throw new Error(`Unable to find bundle: ${e}`);
    const d = (I = l.data) == null ? void 0 : I.bundles[0], C = P.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    C.set(d.id, d.partner.id), P.setMap("bundlePartnerIds", C);
    const w = new et(this, d, t, A, i, {
      additionalHeaders: (F = a == null ? void 0 : a.graphql) == null ? void 0 : F.additionalHeaders,
      eagerFetchProducts: (Y = (y = a == null ? void 0 : a.graphql) == null ? void 0 : y.productCollection) == null ? void 0 : Y.eagerFetchProducts
    });
    return await w.getInitializationPromise(), w;
  }
  /**
   * @param bundleId The id of the bundle to copy. The current context must have write access to the this bundle in order to duplicate it.
   * @param template Optional: Whether to mark the new bundle as a template. Default is false.
   * @param duplicateTransactions Optional: Whether to also duplicate the original bundle's transactions. Default is true.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async duplicateBundle(e, t, A, a) {
    var h, u, E, D, Q, p, m, I;
    const n = (h = P.getMap("bundleOwnerIds")) == null ? void 0 : h.get(e), s = ((u = Object.entries(localStorage).find(([F, y]) => F.startsWith("CognitoIdentityServiceProvider") && F.endsWith("idToken"))) == null ? void 0 : u[0]) || "", o = localStorage.getItem(s), r = {};
    o && !Te(o) && (r.Authorization = `Bearer ${o}`);
    const c = {
      bundleOwnerId: n,
      ...r,
      ...(E = a == null ? void 0 : a.graphql) == null ? void 0 : E.additionalHeaders
    }, l = (p = (await x.getShadowGraphqlClient().mutate({
      mutation: wi(((Q = (D = a == null ? void 0 : a.graphql) == null ? void 0 : D.productCollection) == null ? void 0 : Q.eagerFetchProducts) || !1),
      variables: {
        id: e,
        template: t,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId,
        duplicateTransactions: A
      },
      context: {
        headers: c
      },
      fetchPolicy: "no-cache"
    })).data) == null ? void 0 : p.bundleDuplicate;
    if (!(l != null && l.id))
      throw new Error("Unable to duplicate bundle");
    const d = P.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    d.set(l.id, l.partner.id), P.setMap("bundlePartnerIds", d);
    const C = P.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    C.set(l.id, l.bundleOwnerId), P.setMap("bundleOwnerIds", C);
    const w = new et(this, l, void 0, void 0, l.bundleOwnerId, {
      eagerFetchProducts: (I = (m = a == null ? void 0 : a.graphql) == null ? void 0 : m.productCollection) == null ? void 0 : I.eagerFetchProducts
    });
    return await w.getInitializationPromise(), w;
  }
  /**
   * Fetches information about the currently authenticated customer's bundles.
   * NOTE: This does not initialize a bundle for active use.
   * You must call either `getExistingBundle` or `duplicateBundle` to actually interact with a bundle.
   * @param options Options to configure the request.
   * @returns A promise that resolves with an object containing:
   * `items` - The bundles that matched the request.
   * `total` - The total number of bundles on the server that match this query.
   */
  async getBundlesForCustomer(e) {
    var n;
    if (!((n = this.customer) != null && n.id))
      throw new Error("Customer not authenticated.");
    const { includeMetadata: t, ...A } = e;
    return (await x.getShadowGraphqlClient().query({
      query: yi(t ?? !1),
      variables: {
        ...A,
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    })).data.customerBundlesFeed;
  }
  /**
   * Retrieves all existing bundle stakeholders from the API, for the currently authenticated customer.
   * @returns An array of bundle stakeholders.
   */
  async getBundleStakeholders() {
    var n;
    if (!this.customer)
      throw new Error("Customer not authenticated.");
    const e = await x.getShadowGraphqlClient().query({
      query: Bi,
      variables: {
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    });
    if (!((n = e.data) != null && n.customers) || e.data.customers.length === 0)
      throw new Error("Unable to find customer.");
    const A = e.data.customers[0].bundleStakeholders || [], a = P.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    return A.forEach((i) => {
      var s, o;
      (s = i.bundle) != null && s.id && ((o = i.bundle.partner) != null && o.id) && a.set(i.bundle.id, i.bundle.partner.id);
    }), P.setMap("bundlePartnerIds", a), A;
  }
  async getStepTags(e) {
    const t = x.getShadowGraphqlClient();
    let A = {};
    const a = e.steps.map((i) => `${e.id}_${i.stepName}`), n = await t.query({
      query: As,
      fetchPolicy: "no-cache",
      variables: { entityIds: a }
    });
    for (const [i, s] of e.steps.entries()) {
      const o = n.data.tagsMany[i];
      A = {
        ...A,
        [s.stepName]: o.map((r) => r.name)
      };
    }
    return A;
  }
  /**
   * Creates a new instance of WorkflowExperience. A high level wrapper for workflows.
   * @param workflowId The id of the workflow to be run. Deprecated: Provide options instead.
   * @param workflowState An existing workflow state if available. Deprecated: Provide options instead.
   * @param previewServiceConstructor A function called during initialization. Takes a class implementing ThreeDPreviewService in return.
   * @param options Options to configure loading the transaction and workflow.
   * @returns A workflow experience configured as requested.
   */
  async getWorkflowExperience(e, t, A, a) {
    var l, d, C, w, h;
    if (!a)
      return await this.getWorkflowExperienceDeprecated(e, t, A);
    const n = async () => {
      var E, D, Q;
      const u = x.getShadowGraphqlClient();
      if (a.type === "transaction") {
        const { transactionId: p, readOnly: m } = a, I = await u.query({
          query: fe,
          variables: {
            ids: [p]
          },
          errorPolicy: "all",
          fetchPolicy: "no-cache"
        });
        if (!((E = I.data) != null && E.transactions) || I.data.transactions.length === 0)
          throw new H("Existing transaction not found.");
        const F = (D = I.data) == null ? void 0 : D.transactions[0];
        if (!F.workflowId)
          throw new H("Existing transaction has no workflow ID.");
        const y = await Pe(F.workflowId);
        if (!F.product)
          throw new H("Failed to load transaction, product not available.");
        !this.activeIntegration && ((Q = F.integrationProduct) != null && Q.integration) && (this.activeIntegration = Promise.resolve(F.integrationProduct.integration));
        const Y = await this.getStepTags(y);
        return { transaction: F, workflow: y, stepTags: Y, readOnly: m };
      }
      if (a.type === "integration" || a.type === "external") {
        const p = async () => {
          const Y = a.type === "integration" ? { integrationProductId: a.integrationProductId } : {
            externalIntegrationId: a.externalIntegrationId,
            externalProductId: a.externalProductId
          }, N = await u.mutate({
            mutation: Ht,
            variables: {
              ...Y,
              workflowId: a.workflowId,
              designName: a.designName,
              claim: !0,
              marketplaceThemeInstallId: this.marketplaceThemeInstallId,
              marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
            },
            errorPolicy: "all",
            fetchPolicy: "no-cache",
            // TODO: this should be changed to required once the API is updated. Should this also be moved to server.ts?
            context: this.options.applicationKey ? { headers: { "X-Application-Key": this.options.applicationKey } } : void 0
          });
          if (!N.data || !N.data.transactionCreate)
            throw new H("Failed to create transaction!");
          const S = N.data.transactionCreate;
          if (!S.product)
            throw new H("Failed to create transaction, product not available.");
          return S;
        }, m = Pe(a.workflowId, a == null ? void 0 : a.graphql), [I, F] = await Promise.all([p(), m]), y = await this.getStepTags(F);
        return { transaction: I, workflow: F, stepTags: y };
      }
      throw new H("No workflow ID provided.");
    }, { transaction: i, workflow: s, stepTags: o, readOnly: r } = await n();
    this.currencyCode = (l = i.product.partner) == null ? void 0 : l.currencyCode;
    const c = {
      product: i.product,
      transaction: i,
      stepTags: o,
      layouts: [],
      singleVariantsRenderable: (d = a == null ? void 0 : a.workflowConfiguration) == null ? void 0 : d.singleVariantsRenderable,
      stateMutationFunc: r ? async () => {
        throw new b("State mutation is forbidden in read only mode!");
      } : async (u) => {
        const D = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(i.id) || void 0;
        return this.updateTransactionState({ ...u, context: { transactionOwnerId: D } });
      },
      readOnly: r,
      workflow: s
    };
    if (a.type === "transaction" && i.workflowState) {
      const u = JSON.parse(i.workflowState);
      c.layouts = Object.values(u.layouts).map((E) => E.layout), await se(u), await re(u), c.reloadedState = u;
    } else if (!r && a.workflowState) {
      const u = JSON.parse(a.workflowState);
      c.layouts = Object.values(u.layouts).map((E) => E.layout), await se(u), await re(u), c.reloadedState = u;
    } else
      c.layouts = tt(
        c.transaction,
        c.workflow
      );
    if (c.renderableContextService = new Se(
      c.layouts
    ), a.previewService ? (c.previewService = a.previewService, (C = c.product) != null && C.modelUrl && (c.modelContainer = c.previewService.loadModel({
      model: c.product.modelUrl,
      contextService: c.renderableContextService
    }))) : (c.previewService = A && A(s), (w = c.product) != null && w.modelUrl && (c.modelContainer = (h = c.previewService) == null ? void 0 : h.loadModel({
      model: c.product.modelUrl,
      contextService: c.renderableContextService
    }))), a.type !== "transaction") {
      const u = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map();
      u.set(i.id, i.transactionOwnerId), P.setMap("transactionOwnerIds", u);
    } else
      c.isReloadedTransaction = !0;
    this.initialized = !0, this.experienceOptions = c;
    const B = new Me(this, c);
    return await B.getWorkflowManager().getInitializationPromise(), a.type !== "transaction" && this.customer && await B.attachCustomerDetails({ email: this.customer.emailAddress }), B;
  }
  /**
   * Gets multiple workflow experiences at once.
   * @param optionsArray An array of options to configure loading the transactions and workflows.
   * NOTE: The `previewService` field on the option is currently unsupported in this function, as loading multiple models at once will likely cause performance issues.
   * @param graphqlOptions Options to configure loading the workflows.
   * @returns An array of workflow experiences configured as requested.
   */
  async getWorkflowExperiences(e, t) {
    if (e.length === 0)
      throw new H("No options provided!");
    const A = x.getShadowGraphqlClient(), a = async (p) => {
      var y, Y, N;
      if (p.length === 0)
        return [];
      const m = p.map((S) => S.option.transactionId), I = await A.query({
        query: fe,
        variables: {
          ids: m
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache"
      }), F = I.data.transactions;
      if (F.length !== p.length) {
        const S = ((Y = (y = I.errors) == null ? void 0 : y[0]) == null ? void 0 : Y.message) || "Unknown error";
        throw new H(`Not all transactions were found: ${S}`);
      }
      return !this.activeIntegration && ((N = F[0].integrationProduct) != null && N.integration) && (this.activeIntegration = Promise.resolve(F[0].integrationProduct.integration)), F.map((S, T) => {
        var R;
        return {
          transaction: S,
          workflowId: S.workflowId,
          readOnly: ((R = p.find((W) => W.option.transactionId === S.id)) == null ? void 0 : R.option.readOnly) ?? !1,
          index: p[T].index
        };
      });
    }, n = async (p) => {
      var F, y, Y;
      if (p.length === 0)
        return [];
      const m = await A.mutate({
        mutation: Ha,
        variables: {
          inputs: p.map((N) => ({
            integrationProductId: N.option.type === "integration" ? N.option.integrationProductId : void 0,
            externalIntegrationId: N.option.type === "external" ? N.option.externalIntegrationId : void 0,
            externalProductId: N.option.type === "external" ? N.option.externalProductId : void 0,
            workflowId: N.option.workflowId,
            designName: N.option.designName,
            claim: !0
          })),
          marketplaceThemeInstallId: this.marketplaceThemeInstallId,
          marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache"
      }), I = (F = m.data) == null ? void 0 : F.transactionCreateMany;
      if (!I || I.length === 0) {
        const N = ((Y = (y = m.errors) == null ? void 0 : y[0]) == null ? void 0 : Y.message) || "Unknown error";
        throw new H(`Failed to create transactions: ${N}`);
      }
      return I.map((N, S) => ({
        transaction: N,
        workflowId: N.workflowId,
        readOnly: !1,
        index: p[S].index
      }));
    }, i = e.map((p, m) => ({ option: p, index: m })), s = i.filter((p) => p.option.type === "transaction"), o = i.filter(
      (p) => p.option.type === "integration" || p.option.type === "external"
    ), r = xt(s, 10), c = xt(o, 10), B = (await Promise.all([
      ...r.map(a),
      ...c.map(n)
    ])).flat(), l = [...new Set(B.map((p) => p.workflowId))], d = await vA(l, t), C = new Map(d.map((p) => [p.id, p])), w = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), h = B.map(async (p) => {
      var W;
      const { transaction: m, workflowId: I, readOnly: F, index: y } = p, Y = C.get(I), N = await this.getStepTags(Y), S = e[y];
      !w.get(m.id) && m.transactionOwnerId && w.set(m.id, m.transactionOwnerId);
      const T = w.get(m.id) || void 0, R = {
        product: m.product,
        transaction: m,
        stepTags: N,
        layouts: [],
        singleVariantsRenderable: (W = S == null ? void 0 : S.workflowConfiguration) == null ? void 0 : W.singleVariantsRenderable,
        stateMutationFunc: F ? async () => {
          throw new b("State mutation is forbidden in read only mode!");
        } : async (O) => this.updateTransactionState({ ...O, context: { transactionOwnerId: T } }),
        readOnly: F,
        workflow: Y,
        isReloadedTransaction: S.type === "transaction"
      };
      if (S.type === "transaction" && m.workflowState) {
        const O = JSON.parse(m.workflowState);
        R.layouts = Object.values(O.layouts || {}).map((ee) => ee.layout), await se(O), await re(O), R.reloadedState = O;
      } else if (!F && S.workflowState) {
        const O = JSON.parse(S.workflowState);
        R.layouts = Object.values(O.layouts || {}).map((ee) => ee.layout), await se(O), await re(O), R.reloadedState = O;
      } else
        R.layouts = tt(
          R.transaction,
          R.workflow
        );
      return R.renderableContextService = new Se(
        R.layouts
      ), R.delayWorkflowStateSync = !0, this.initialized = !0, this.experienceOptions = R, { experienceOptions: R, index: y, options: S };
    }), u = await Promise.all(h);
    P.setMap("transactionOwnerIds", w);
    const D = u.sort((p, m) => p.index - m.index).map(async (p) => {
      const { experienceOptions: m, options: I } = p, F = new Me(this, m);
      return await F.getWorkflowManager().getInitializationPromise(), I.type !== "transaction" && this.customer && await F.attachCustomerDetails({ email: this.customer.emailAddress }), F;
    }), Q = await Promise.all(D);
    return Q.forEach((p) => p.getWorkflowManager().setWorkflowStateSyncEnabled(!0)), Q;
  }
  /**
   * Initialize the client from an integration product.
   * @param integrationProductId The integration product to use.
   * @deprecated Use getWorkflowExperience to initialize the experience.
   */
  async initFromIntegrationProduct(e) {
    var i;
    if (e === "")
      throw new H("No integration product ID provided.");
    const A = await x.getShadowGraphqlClient().mutate({
      mutation: Ht,
      variables: {
        integrationProductId: e,
        claim: !0,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
      },
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      // TODO: this should be changed to required once the API is updated. Should this also be moved to server.ts?
      context: this.options.applicationKey ? { headers: { "X-Application-Key": this.options.applicationKey } } : void 0
    });
    if (!A.data || !A.data.transactionCreate)
      throw new H("Failed to create transaction!");
    const a = A.data.transactionCreate;
    if (!a.product)
      throw new H("Failed to create transaction, product not available.");
    this.currencyCode = (i = a.product.partner) == null ? void 0 : i.currencyCode;
    const n = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map();
    n.set(a.id, a.transactionOwnerId), P.setMap("transactionOwnerIds", n), this.experienceOptions = {
      product: a.product,
      transaction: a,
      layouts: [],
      stateMutationFunc: async (s) => this.updateTransactionState({
        ...s,
        context: { transactionOwnerId: a.transactionOwnerId }
      })
    }, this.initialized = !0;
  }
  /**
   * Initialize the client from an existing transaction.
   * @param transactionId The id of the transaction
   * @returns A promise resolving at initialization completion.
   * @deprecated Use getWorkflowExperience to initialize the experience.
   */
  async initFromTransaction(e, t = !1) {
    var s, o, r, c;
    if (e === "")
      throw new H("No transaction ID provided.");
    const A = x.getShadowGraphqlClient(), a = async () => {
      var d, C;
      const l = (d = (await A.query({
        query: fe,
        variables: { ids: [e] },
        fetchPolicy: "no-cache",
        errorPolicy: "all"
      })).data) == null ? void 0 : d.transactions[0];
      if (!l)
        throw new H("Failed to read transaction.");
      if (!l.product)
        throw new H("Failed to load transaction, product not available.");
      this.currencyCode = (C = l.product.partner) == null ? void 0 : C.currencyCode, this.experienceOptions = {
        product: l.product,
        transaction: l,
        layouts: [],
        stateMutationFunc: async () => {
          throw new b("State mutation is forbidden in read only mode!");
        },
        readOnly: t
      }, this.initialized = !0;
    };
    if (t)
      return await a();
    const n = P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), i = n.get(e);
    if (i) {
      const l = (s = (await A.query({
        query: fe,
        variables: {
          ids: [e]
        },
        errorPolicy: "all"
      })).data) == null ? void 0 : s.transactions[0];
      if (!l)
        throw new H("Failed to read transaction.");
      if (!l.product)
        throw new H("Failed to load transaction, product not available.");
      this.currencyCode = (o = l.product.partner) == null ? void 0 : o.currencyCode, this.experienceOptions = {
        product: l.product,
        transaction: l,
        layouts: [],
        stateMutationFunc: async (d) => this.updateTransactionState({ ...d, context: { transactionOwnerId: i } }),
        readOnly: t
      }, this.initialized = !0;
      return;
    }
    try {
      const l = (r = (await A.mutate({
        mutation: ka,
        variables: { id: e },
        errorPolicy: "all"
      })).data) == null ? void 0 : r.transactionClaim;
      if (!l)
        throw new H("Failed to read transaction.");
      if (!l.product)
        throw new H("Failed to load transaction, product not available.");
      this.currencyCode = (c = l.product.partner) == null ? void 0 : c.currencyCode, l.transactionOwnerId && (n.set(l.id, l.transactionOwnerId), P.setMap("transactionOwnerIds", n)), this.experienceOptions = {
        product: l.product,
        transaction: l,
        layouts: [],
        stateMutationFunc: async (d) => this.updateTransactionState({
          ...d,
          context: { transactionOwnerId: l.transactionOwnerId }
        }),
        readOnly: t
      }, this.initialized = !0;
    } catch {
      throw new H("Attempted to access a transaction that isn't available.");
    }
  }
  /**
   * @deprecated Remove when the initFrom functions are removed.
   */
  async getWorkflowExperienceDeprecated(e, t, A) {
    var a, n, i, s;
    if (!this.initialized || !this.experienceOptions)
      throw new H("Cannot launch experience: Not initialized.");
    if (this.experienceOptions.transaction.workflowId) {
      const o = await Pe(this.experienceOptions.transaction.workflowId);
      if (this.experienceOptions.workflow = o, this.experienceOptions.transaction.workflowState) {
        const c = JSON.parse(this.experienceOptions.transaction.workflowState);
        this.experienceOptions.layouts = Object.values(c.layouts).map((B) => B.layout), await se(c), await re(c), this.experienceOptions.reloadedState = c;
      }
      this.experienceOptions.previewService = A && A(o), this.experienceOptions.renderableContextService = new Se(this.experienceOptions.layouts), (a = this.experienceOptions.product) != null && a.modelUrl && (this.experienceOptions.modelContainer = (n = this.experienceOptions.previewService) == null ? void 0 : n.loadModel({
        model: this.experienceOptions.product.modelUrl,
        contextService: this.experienceOptions.renderableContextService
      }));
      const r = new Me(this, this.experienceOptions);
      return await r.getWorkflowManager().getInitializationPromise(), r;
    }
    if (e) {
      const r = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(this.experienceOptions.transaction.id), c = x.getShadowGraphqlClient().mutate({
        mutation: Ga,
        variables: {
          workflowId: e,
          id: this.experienceOptions.transaction.id
        },
        context: {
          transactionOwnerId: r
        }
      }), B = Pe(e);
      if (await Promise.all([c, B]), this.experienceOptions.workflow = await B, t) {
        const d = JSON.parse(t);
        this.experienceOptions.layouts = Object.values(d.layouts).map((C) => C.layout), await se(d), await re(d), this.experienceOptions.reloadedState = d;
      } else
        this.experienceOptions.layouts = tt(
          this.experienceOptions.transaction,
          this.experienceOptions.workflow
        );
      this.experienceOptions.previewService = A && A(await B), this.experienceOptions.renderableContextService = new Se(this.experienceOptions.layouts), (i = this.experienceOptions.product) != null && i.modelUrl && (this.experienceOptions.modelContainer = (s = this.experienceOptions.previewService) == null ? void 0 : s.loadModel({
        model: this.experienceOptions.product.modelUrl,
        contextService: this.experienceOptions.renderableContextService
      }));
      const l = new Me(this, this.experienceOptions);
      return await l.getWorkflowManager().getInitializationPromise(), l;
    }
    throw new H("No workflow ID provided.");
  }
  /**
   * @deprecated The value this returns will be changed whenever `getWorkflowExperience()` is called. Use `workflowExperience.getWorkflowManager().getPreviewService()` instead.
   * @returns The preview service that was provided during construction.
   */
  getPreviewService() {
    var e;
    return (e = this.experienceOptions) == null ? void 0 : e.previewService;
  }
  /**
   * @deprecated The value this returns will be changed whenever `getWorkflowExperience()` is called. Use `WorkflowManager.getProduct()` instead.
   * @returns The product associated with this client.
   */
  getProduct() {
    if (!this.initialized || !this.experienceOptions)
      throw new H("Cannot get product: Not initialized.");
    return this.experienceOptions.product;
  }
  /**
   * @deprecated The value this returns will be changed whenever `getWorkflowExperience()` is called. Use `WorkflowManager.getTransaction()` instead.
   * @returns The transaction associated with this client.
   */
  getTransaction() {
    if (!this.initialized || !this.experienceOptions)
      throw new H("Cannot get transaction: Not initialized.");
    return this.experienceOptions.transaction;
  }
  storeCustomer(e) {
    const t = P.getMap("partnerCustomerIds") || /* @__PURE__ */ new Map();
    t.set(e.partner.id, e.id), P.setMap("partnerCustomerIds", t);
  }
  async getIntegrationProductById(e) {
    var n, i;
    const a = (n = (await x.getShadowGraphqlClient().query({
      query: Ta,
      variables: {
        ids: [e]
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data) == null ? void 0 : n.integrationProducts;
    if (!a || a.length === 0 || !((i = a[0]) != null && i.id))
      throw new Error("Integration product not found.");
    return new Tt(a[0]);
  }
  async getIntegrationProductFromExternalIds(e, t) {
    var i;
    const n = (i = (await x.getShadowGraphqlClient().query({
      query: Oa,
      variables: {
        externalProductId: t,
        externalIntegrationId: e
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data) == null ? void 0 : i.integrationProductFromExternalIds;
    if (!(n != null && n.id))
      throw new Error("Integration product not found.");
    return new Tt(n);
  }
  async getIntegrationProduct(e) {
    return e.type === "integration" ? this.getIntegrationProductById(e.integrationProductId) : this.getIntegrationProductFromExternalIds(e.externalIntegrationId, e.externalProductId);
  }
  async getShareActionsForTransaction(e) {
    const A = (P.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(e) || void 0, a = await x.getShadowGraphqlClient().query({
      query: Ja,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: e
      },
      context: {
        transactionOwnerId: A
      }
    });
    if (!a.data.transactions || a.data.transactions.length !== 1)
      throw new Error(`Failed to fetch share actions for transaction: ${e}`);
    return a.data.transactions[0].transactionShareActions;
  }
}
class Ys {
  getClient() {
    return this.client ?? {};
  }
  getWorkflowExperience() {
    return {};
  }
  setClient(e) {
    this.client = e;
  }
  getInitializationPromise() {
    return Promise.resolve();
  }
  isInitialized() {
    return !0;
  }
  getInformationResults() {
    return [];
  }
  async reset() {
  }
  updateStateWithServer(e) {
  }
  async outstandingRequestsPromise() {
  }
  async updateStateWithServerImmediate(e) {
  }
  addPoller(e) {
  }
  addConfirmCallback(e) {
  }
  addEditedCallback(e) {
  }
  addElementsCallback(e) {
  }
  addInformationResultCallback(e) {
  }
  addInitCallback(e) {
  }
  addMakingAdjustmentsCallback(e) {
  }
  addMandatoryCallback(e) {
  }
  addMetadataCallback(e) {
  }
  addSelectionCallback(e) {
  }
  addStepSpecificStorageCallback(e, t) {
  }
  addStorageCallback(e) {
  }
  getCommandDispatcher() {
    return (e) => {
    };
  }
  getLayouts() {
    return [];
  }
  getLayoutPreviewService() {
    return {
      getAll: () => /* @__PURE__ */ new Map()
    };
  }
  getPreviewService() {
  }
  getModelContainer() {
  }
  getProfanities() {
    return [];
  }
  getRegionElements(e) {
    return [];
  }
  getSerializedStep(e, t) {
  }
  getStepSpecificServices(e) {
  }
  getTransaction() {
    return {
      id: ""
    };
  }
  getTransactionCustomer() {
  }
  setTransactionCustomer() {
  }
  setTransactionCustomerDetails() {
  }
  getWorkflow() {
    return {
      id: "",
      name: "",
      panels: [],
      steps: [],
      showModelOnFinishStep: !1,
      allowProofDownload: !1,
      introduction: "",
      stepGroups: []
    };
  }
  markStepsAsInitialised(e) {
  }
  markUpdateCompleted(e) {
  }
  markUpdatePending() {
    return "123";
  }
  getWorkflowSelections() {
    return {};
  }
  getStepSelections() {
    return {};
  }
  setCurrentAdjustingStepId(e) {
  }
  setEditedStatus(e, t) {
  }
  setInformationResults(e) {
  }
  setMandatoryFulfilled(e, t) {
  }
  async setSelectionsAndElements(e, t, A) {
  }
  toggleDesignConfirmed() {
  }
  updateMetadata(e, t) {
  }
  async updateStorage(e, t) {
  }
  injectIntoPreviewService(e) {
    return Promise.resolve();
  }
  ejectFromPreviewService() {
  }
  setWorkflowStateSyncEnabled(e) {
  }
  async updateTransactionShareActions() {
  }
  addValidationCallback(e) {
  }
  setStepError(e, t, A) {
  }
  getStepErrors(e) {
  }
  getValidationErrors() {
    return { steps: /* @__PURE__ */ new Map() };
  }
  async updateTransactionStakeholders() {
  }
  getStepTags(e) {
    return [];
  }
}
var os = /* @__PURE__ */ ((g) => (g.SelectFrame = "SelectFrame", g.SelectImage = "SelectImage", g.Position = "Position", g))(os || {});
class rs extends X {
  constructor(e, t, A) {
    var a;
    super(e, t, A), this.frameService = (a = this.manager.getStepSpecificServices(this.getId())) == null ? void 0 : a.frameService;
  }
  selectVariant(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    return Ae.selectVariant(
      this.step,
      e.getResource(),
      t,
      this.manager,
      (A) => this.setUpdateState(A)
    );
  }
  onFrameDataChanged(e) {
    this.frameService && this.frameService.onFrameDataChanged((t) => {
      t && e(t);
    });
  }
  /**
   * Updates the image selection inside the frame.
   * @param asset The asset to use.
   * @param storeAsOriginal Optional: Store this asset as the original, unmodified version of the image. Default: `true`.
   * @param [recalculateOffsets=true] Optional: Recalculates the offsets of the image inside the frame. Default: `true`.
   */
  async selectImage(e, t = !0, A = !0) {
    var a;
    if (await Ae.selectImage(this.step, e, this.manager, A), t) {
      const n = ((a = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : a.framePatternData) || {};
      this.manager.updateStorage(this.step.stepName, {
        framePatternData: {
          ...n,
          originalAssetKey: e.key,
          backgroundRemovedAssetKey: void 0,
          useOriginalAsset: void 0
        }
      });
    }
  }
  /**
   * Returns `true` if the Background Remover is available for the current session.
   */
  async canUseBackgroundRemover() {
    return this.manager.getClient().canUseAddon(ut.BackgroundRemover);
  }
  /**
   * Returns `true` if the Background Remover is available for the current session and if the associated frame has a user-supplied raster image.
   */
  async canRemoveBackground() {
    var e, t, A, a;
    return await this.canUseBackgroundRemover() && this.hasOriginalImageSelection() && !!((t = (e = this.frameService) == null ? void 0 : e.getImageData()) != null && t.src) && !((a = (A = this.frameService) == null ? void 0 : A.getImageData()) != null && a.svg);
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset as the current image selection. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImageSelection(e = !0) {
    var n;
    if (!await this.canUseBackgroundRemover())
      throw new Error(
        "The current Integration does not have access to the Background Remover. Please call canUseBackgroundRemover to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImageSelection();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const A = await U.removeBackgroundFromAsset(t);
    e && await Ae.selectImage(this.step, A, this.manager, !1);
    const a = ((n = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : n.framePatternData) || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        ...a,
        backgroundRemovedAssetKey: A.key,
        useOriginalAsset: !e
      }
    }), A;
  }
  changeColors(e) {
    Ae.changeColors(this.step, this.manager, e);
  }
  getImageData() {
    if (this.frameService)
      return this.frameService.getImageData();
  }
  async getColorOption() {
    return this.step.data.colorOption;
  }
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? Ae.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
  async getOriginalImageColors() {
    const e = this.getImageData();
    return e != null && e.svg ? (await Le(e.svg)).colors : void 0;
  }
  getMaxAllowedColors() {
    return this.step.data.maxColors;
  }
  getUniqueColorCount() {
    return Ae.getUniqueColorCount(this.step, this.manager);
  }
  getCurrentFrameStep(e, t, A, a) {
    return a && a.length > 1 && e === void 0 ? "SelectFrame" : t || A || this.getImageData() ? "Position" : "SelectImage";
  }
  getFrameService() {
    return this.frameService;
  }
  hasOverlayImageKey() {
    return this.step.data.overlayImageKey;
  }
  hasOverlayImageUrl() {
    return this.step.data.overlayImageUrl;
  }
  getWhitelistedExtensions() {
    return [
      ...this.step.data.whitelistedExtensions,
      ...this.step.data.whitelistedExtensions.includes(".jpg") ? [".jpeg"] : []
    ];
  }
  async getOriginalImageSelection() {
    var t, A;
    const e = (A = (t = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : t.framePatternData) == null ? void 0 : A.originalAssetKey;
    if (e)
      return U.getLocalOrFromServer(e);
  }
  async getBackgroundRemovedImageSelection() {
    var t, A;
    const e = (A = (t = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : t.framePatternData) == null ? void 0 : A.backgroundRemovedAssetKey;
    if (e)
      return U.getLocalOrFromServer(e);
  }
  hasOriginalImageSelection() {
    var e, t;
    return !!((t = (e = this.manager.getStepStorage(this.step.stepName)) == null ? void 0 : e.framePatternData) != null && t.originalAssetKey);
  }
  hasBackgroundRemovedImageSelection() {
    var e, t;
    return !!((t = (e = this.getFrameStepStorage()) == null ? void 0 : e.framePatternData) != null && t.backgroundRemovedAssetKey);
  }
  getUseOriginalImageSelection() {
    var e, t;
    return ((t = (e = this.getFrameStepStorage()) == null ? void 0 : e.framePatternData) == null ? void 0 : t.useOriginalAsset) ?? !1;
  }
  async setUseOriginalImageSelection(e) {
    var a;
    const t = ((a = this.getFrameStepStorage()) == null ? void 0 : a.framePatternData) || {};
    if (t.useOriginalAsset === e)
      return;
    const A = await this.getOriginalImageSelection();
    if (!A)
      throw new Error("You must provide an image selection before calling setUseOriginalImageSelection");
    if (e)
      await this.selectImage(A, !1, !1);
    else {
      const n = await this.getBackgroundRemovedImageSelection();
      if (!n)
        throw new Error(
          "You must call removeBackgroundFromImageSelection before attempting to apply the image."
        );
      await this.selectImage(n, !1, !1);
    }
    this.manager.updateStorage(this.step.stepName, {
      framePatternData: { ...t, useOriginalAsset: e }
    });
  }
  getFrameStepStorage() {
    return this.manager.getStepStorage(this.step.stepName);
  }
}
export {
  ut as AddonHandle,
  Ss as ArrayInput,
  Ns as AspectType,
  ie as AssetNotFoundError,
  vs as AssetType,
  Rs as BringForwardCommand,
  Hs as BringToBackCommand,
  ks as BringToFrontCommand,
  Us as CanvasCommand,
  _e as CollectionProduct,
  Jt as ColorOptionGlobalPropertyHandle,
  Gs as CommandContext,
  va as ConversionDataType,
  Na as ConversionLocation,
  bs as CreateElementCommand,
  Js as CreateLayoutCommand,
  Ts as DeleteElementCommand,
  kn as DigitalContentStepHandle,
  Si as FileUploadGlobalPropertyHandle,
  Ye as FlowExecutionNodeResult,
  Ji as FlowExecutionResult,
  bi as FlowService,
  Os as FontAlignmentCommand,
  Ls as FontColorCommand,
  zs as FontSizeCommand,
  Ks as FontSourceCommand,
  Xa as FrameService,
  os as FrameStep,
  rs as FrameStepHandle,
  It as GlobalPropertyHandle,
  js as GroupCommand,
  Sn as IllustrationStepHandle,
  Ve as InformationMessageType,
  Hn as InformationStepHandle,
  Tt as IntegrationProduct,
  Pa as IntegrationType,
  Vs as LayoutElementFactory,
  Ws as LayoutElementType,
  z as LayoutNotFoundError,
  Yn as MaterialStepHandle,
  Ue as MisconfigurationError,
  Ys as MockWorkflowManager,
  Pn as ModelStepHandle,
  Un as ModuleStepHandle,
  Xs as MoveCommand,
  NA as ObjectInput,
  Ti as ObjectInputType,
  xA as OptionGlobalPropertyHandle,
  ke as OptionNotFoundError,
  he as ParseError,
  xn as PictureStepHandle,
  xa as ProductCameraRig,
  Hi as ProductCollection,
  Oe as ProductWorkflow,
  me as PromiseCache,
  dA as PromiseQueue,
  Nn as QuestionStepHandle,
  BA as QueueablePromise,
  qs as ResizeCommand,
  ue as ResourceNotFoundError,
  Zs as RotateCommand,
  $s as SendBackwardsCommand,
  vn as ShapeStepHandle,
  ss as SpiffCommerceClient,
  Ge as StakeholderType,
  _s as StepAspectType,
  X as StepHandle,
  eo as StepType,
  to as TextChangeCommand,
  Yi as TextGlobalPropertyHandle,
  Ms as TextInput,
  Rn as TextStepHandle,
  Ya as TransactionShareActionType,
  Ui as Transform,
  ki as TransformCollection,
  b as UnhandledBehaviorError,
  Ao as UnitOfMeasurement,
  ao as UpdateImageSourceCommand,
  Z as Variant,
  Vn as WorkflowExperienceEventType,
  Me as WorkflowExperienceImpl,
  U as assetService,
  tn as browserColorToHex,
  Ln as createDesign,
  no as dataUrlFromExternalUrl,
  $e as designService,
  io as determineCorrectFontSizeAndLines,
  wA as digitalContentStepService,
  so as findElement,
  fs as findPmsColors,
  oo as frameDataCache,
  Ae as frameStepService,
  ro as generate,
  ni as generateCommands,
  co as generateSVGWithUnknownColors,
  ys as generateStateFromDesignInputSteps,
  go as getAttributesFromArrayBuffer,
  lo as getAxisAlignedBoundingBox,
  Wa as getBoundedOffsets,
  Bo as getFrameData,
  Co as getSvgElement,
  Pe as getWorkflow,
  vA as getWorkflows,
  x as graphQlManager,
  Ne as illustrationStepService,
  wo as loadFont,
  Is as matchHexToPms,
  hA as materialStepService,
  EA as modelStepService,
  uA as moduleStepService,
  V as optionService,
  ho as patternImageDataCache,
  P as persistenceService,
  mA as pictureStepService,
  Ds as pmsToRgb,
  QA as questionStepService,
  Eo as registerFetchImplementation,
  uo as registerWindowImplementation,
  mo as rehydrateSerializedLayout,
  $a as rgbToPms,
  la as setBearerAuthenticationToken,
  Qo as setCanvasModule,
  Ee as shapeStepService,
  qa as shortenUrl,
  q as spiffCoreConfiguration,
  Fs as stepAspectValuesToDesignInputSteps,
  po as svgToDataUrl,
  j as textStepService,
  Bn as toast
};
